import * as z from "react";
import u, { useRef as Le, cloneElement as _i, forwardRef as fo, useState as de, useImperativeHandle as A0, useEffect as lt, useMemo as Qe, useContext as xe, useLayoutEffect as md, Component as $u, memo as yd, useCallback as Nd } from "react";
import { Input as vo, InputNumber as zd, Button as ta, Typography as ra, Checkbox as j0, Radio as gr, Select as e0, DatePicker as Zu, Steps as Yu, Progress as Hu, Row as _d, Col as Id, Collapse as Xl, Form as mr, Tooltip as x0, Tabs as Wu, Drawer as Dd, Space as sn, Upload as Mo, message as Jl, Dropdown as na, Menu as ec, Tag as go, notification as t0, Empty as i1, ConfigProvider as aa, Layout as ia, Breadcrumb as po, Table as ho, Modal as mo, Switch as Cd, Card as oa, TreeSelect as Ed, Popconfirm as bd, Skeleton as Ad, Avatar as Bu, Badge as jd, List as qu, Mentions as tc } from "antd";
import { Affix as XA, Alert as JA, Anchor as ej, AutoComplete as tj, BackTop as rj, Calendar as nj, Carousel as aj, Cascader as ij, Collapse as oj, ConfigProvider as lj, Descriptions as cj, Divider as uj, Dropdown as sj, Empty as dj, Grid as fj, Image as vj, Mentions as Mj, Menu as gj, PageHeader as pj, Pagination as hj, Popover as mj, Rate as yj, Result as Nj, Segmented as zj, Slider as _j, Spin as Ij, Statistic as Dj, TimePicker as Cj, Timeline as Ej, Transfer as bj, Tree as Aj, Upload as jj, message as xj, notification as wj, theme as Oj, version as Tj } from "antd";
import Y from "classnames";
import xd, { LockOutlined as Gu, DeleteOutlined as Qr, PlusOutlined as w0, DownOutlined as Ku, MessageFilled as wd, MessageOutlined as Od, CheckOutlined as yo, InfoCircleOutlined as Td, CloseOutlined as Sd, CloseCircleOutlined as la, PlusCircleOutlined as Bn, FileOutlined as No, Loading3QuartersOutlined as Xu, EllipsisOutlined as Ld, ExclamationCircleOutlined as O0, EditOutlined as T0, ReloadOutlined as Ju, UploadOutlined as es, CloudUploadOutlined as kd, FieldTimeOutlined as Pd, LeftOutlined as Rd, MoreOutlined as zo, SearchOutlined as Qd, QuestionCircleOutlined as ts, PushpinOutlined as Vd, CopyOutlined as Ud, UserOutlined as Fd, HolderOutlined as $d, RightCircleOutlined as Zd, LinkOutlined as Yd, SendOutlined as Hd } from "@ant-design/icons";
export * from "@ant-design/icons";
import { nanoid as Wd } from "nanoid";
import Bd from "moment";
import * as qd from "react-dom";
import Sr from "react-dom";
import { useUpdateEffect as rc } from "ahooks";
import rs from "lodash.isequal";
import Gd from "react-virtualized-auto-sizer";
import { FixedSizeList as Kd } from "react-window";
import ns from "lodash.uniqueid";
import { wrapGrid as Xd } from "animate-css-grid";
import Jd from "rc-steps";
import ef from "lodash.range";
import tf from "lodash.groupby";
import { default as kj } from "pretty-bytes";
const rf = "_input_mcqsp_5", v0 = {
  input: rf,
  "input-roundCorners--large": "_input-roundCorners--large_mcqsp_13",
  "input-roundCorners--medium": "_input-roundCorners--medium_mcqsp_16",
  "input-roundCorners--base": "_input-roundCorners--base_mcqsp_19"
}, Lr = ({ roundCorners: e, className: t, ...r }) => /* @__PURE__ */ u.createElement(vo, {
  ...r,
  className: Y(
    v0.input,
    { [v0[`input-roundCorners--${e}`]]: e },
    t
  )
}), nf = ({ className: e, ...t }) => /* @__PURE__ */ u.createElement(vo.Password, {
  ...t,
  prefix: /* @__PURE__ */ u.createElement(Gu, null),
  className: Y(v0.input, v0["input-roundCorners--medium"], e)
}), _o = Lr;
_o.Password = nf;
const af = "_textarea_1ubmx_5", nc = {
  textarea: af,
  "textarea-roundCorners": "_textarea-roundCorners_1ubmx_19"
};
var jr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function of(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function yr(e) {
  var t = e.default;
  if (typeof t == "function") {
    var r = function() {
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var ca = {}, le = { exports: {} }, ct = { exports: {} };
(function(e) {
  function t(r) {
    return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ct);
(function(e) {
  var t = ct.exports.default;
  function r(a) {
    if (typeof WeakMap != "function")
      return null;
    var i = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
    return (r = function(c) {
      return c ? o : i;
    })(a);
  }
  function n(a, i) {
    if (!i && a && a.__esModule)
      return a;
    if (a === null || t(a) !== "object" && typeof a != "function")
      return {
        default: a
      };
    var o = r(i);
    if (o && o.has(a))
      return o.get(a);
    var l = {}, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var s in a)
      if (s !== "default" && Object.prototype.hasOwnProperty.call(a, s)) {
        var d = c ? Object.getOwnPropertyDescriptor(a, s) : null;
        d && (d.get || d.set) ? Object.defineProperty(l, s, d) : l[s] = a[s];
      }
    return l.default = a, o && o.set(a, l), l;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(le);
var X = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(X);
var gt = { exports: {} }, as = { exports: {} };
(function(e) {
  function t(r) {
    if (Array.isArray(r))
      return r;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(as);
var is = { exports: {} };
(function(e) {
  function t(r, n) {
    var a = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
    if (a != null) {
      var i = [], o = !0, l = !1, c, s;
      try {
        for (a = a.call(r); !(o = (c = a.next()).done) && (i.push(c.value), !(n && i.length === n)); o = !0)
          ;
      } catch (d) {
        l = !0, s = d;
      } finally {
        try {
          !o && a.return != null && a.return();
        } finally {
          if (l)
            throw s;
        }
      }
      return i;
    }
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(is);
var Io = { exports: {} }, Do = { exports: {} };
(function(e) {
  function t(r, n) {
    (n == null || n > r.length) && (n = r.length);
    for (var a = 0, i = new Array(n); a < n; a++)
      i[a] = r[a];
    return i;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Do);
(function(e) {
  var t = Do.exports;
  function r(n, a) {
    if (!!n) {
      if (typeof n == "string")
        return t(n, a);
      var i = Object.prototype.toString.call(n).slice(8, -1);
      if (i === "Object" && n.constructor && (i = n.constructor.name), i === "Map" || i === "Set")
        return Array.from(n);
      if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))
        return t(n, a);
    }
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Io);
var os = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(os);
(function(e) {
  var t = as.exports, r = is.exports, n = Io.exports, a = os.exports;
  function i(o, l) {
    return t(o) || r(o, l) || n(o, l) || a();
  }
  e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
})(gt);
var Co = {}, lf = le.exports.default;
Object.defineProperty(Co, "__esModule", {
  value: !0
});
Co.default = cf;
var ac = lf(u);
function cf(e) {
  var t = ac.useRef();
  t.current = e;
  var r = ac.useCallback(function() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return (n = t.current) === null || n === void 0 ? void 0 : n.call.apply(n, [t].concat(i));
  }, []);
  return r;
}
var hr = {}, Vr = {};
Object.defineProperty(Vr, "__esModule", {
  value: !0
});
Vr.default = uf;
function uf() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var sf = X.exports.default, df = le.exports.default;
Object.defineProperty(hr, "__esModule", {
  value: !0
});
hr.useLayoutUpdateEffect = hr.default = void 0;
var o1 = df(u), ff = sf(Vr), l1 = process.env.NODE_ENV !== "test" && (0, ff.default)() ? o1.useLayoutEffect : o1.useEffect, vf = l1;
hr.default = vf;
var Mf = function(t, r) {
  var n = o1.useRef(!0);
  l1(function() {
    if (!n.current)
      return t();
  }, r), l1(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
};
hr.useLayoutUpdateEffect = Mf;
var Eo = {}, gf = le.exports.default, pf = X.exports.default;
Object.defineProperty(Eo, "__esModule", {
  value: !0
});
Eo.default = mf;
var hf = pf(gt.exports), Ii = gf(u);
function mf(e) {
  var t = Ii.useRef(!1), r = Ii.useState(e), n = (0, hf.default)(r, 2), a = n[0], i = n[1];
  Ii.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function o(l, c) {
    c && t.current || i(l);
  }
  return [a, o];
}
var ls = le.exports.default, bo = X.exports.default;
Object.defineProperty(ca, "__esModule", {
  value: !0
});
var Ao = ca.default = zf, za = bo(gt.exports), yf = ls(u), ic = bo(Co), oc = ls(hr), Nf = bo(Eo), Jt;
(function(e) {
  e[e.INNER = 0] = "INNER", e[e.PROP = 1] = "PROP";
})(Jt || (Jt = {}));
function Di(e) {
  return e !== void 0;
}
function zf(e, t) {
  var r = t || {}, n = r.defaultValue, a = r.value, i = r.onChange, o = r.postState, l = (0, Nf.default)(function() {
    var p = void 0, h;
    return Di(a) ? (p = a, h = Jt.PROP) : Di(n) ? (p = typeof n == "function" ? n() : n, h = Jt.PROP) : (p = typeof e == "function" ? e() : e, h = Jt.INNER), [p, h, p];
  }), c = (0, za.default)(l, 2), s = c[0], d = c[1], M = Di(a) ? a : s[0], f = o ? o(M) : M;
  (0, oc.useLayoutUpdateEffect)(function() {
    d(function(p) {
      var h = (0, za.default)(p, 1), y = h[0];
      return [a, Jt.PROP, y];
    });
  }, [a]);
  var v = yf.useRef(), g = (0, ic.default)(function(p, h) {
    d(function(y) {
      var N = (0, za.default)(y, 3), I = N[0], D = N[1], A = N[2], k = typeof p == "function" ? p(I) : p;
      if (k === I)
        return y;
      var L = D === Jt.INNER && v.current !== A ? A : I;
      return [k, Jt.INNER, L];
    }, h);
  }), m = (0, ic.default)(i);
  return (0, oc.default)(function() {
    var p = (0, za.default)(s, 3), h = p[0], y = p[1], N = p[2];
    h !== N && y === Jt.INNER && (m(h, N), v.current = N);
  }, [s]), [f, g];
}
function je(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function Pe() {
  return Pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Pe.apply(this, arguments);
}
function Ve(e) {
  return Ve = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ve(e);
}
function lc(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function H(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? lc(Object(r), !0).forEach(function(n) {
      je(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lc(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function cs(e) {
  if (Array.isArray(e))
    return e;
}
function _f(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, l;
    try {
      for (r = r.call(e); !(a = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); a = !0)
        ;
    } catch (c) {
      i = !0, l = c;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i)
          throw l;
      }
    }
    return n;
  }
}
function c1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function jo(e, t) {
  if (!!e) {
    if (typeof e == "string")
      return c1(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return c1(e, t);
  }
}
function us() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pe(e, t) {
  return cs(e) || _f(e, t) || jo(e, t) || us();
}
function If(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
function Wt(e, t) {
  if (e == null)
    return {};
  var r = If(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && (!Object.prototype.propertyIsEnumerable.call(e, n) || (r[n] = e[n]));
  }
  return r;
}
function Be(e, t) {
  Df(e) && (e = "100%");
  var r = Cf(e);
  return e = t === 360 ? e : Math.min(t, Math.max(0, parseFloat(e))), r && (e = parseInt(String(e * t), 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : (t === 360 ? e = (e < 0 ? e % t + t : e % t) / parseFloat(String(t)) : e = e % t / parseFloat(String(t)), e);
}
function _a(e) {
  return Math.min(1, Math.max(0, e));
}
function Df(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Cf(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function ss(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function xr(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Lt(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function ds(e, t, r) {
  return {
    r: Be(e, 255) * 255,
    g: Be(t, 255) * 255,
    b: Be(r, 255) * 255
  };
}
function u1(e, t, r) {
  e = Be(e, 255), t = Be(t, 255), r = Be(r, 255);
  var n = Math.max(e, t, r), a = Math.min(e, t, r), i = 0, o = 0, l = (n + a) / 2;
  if (n === a)
    o = 0, i = 0;
  else {
    var c = n - a;
    switch (o = l > 0.5 ? c / (2 - n - a) : c / (n + a), n) {
      case e:
        i = (t - r) / c + (t < r ? 6 : 0);
        break;
      case t:
        i = (r - e) / c + 2;
        break;
      case r:
        i = (e - t) / c + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: o, l };
}
function Ci(e, t, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + (t - e) * (6 * r) : r < 1 / 2 ? t : r < 2 / 3 ? e + (t - e) * (2 / 3 - r) * 6 : e;
}
function fs(e, t, r) {
  var n, a, i;
  if (e = Be(e, 360), t = Be(t, 100), r = Be(r, 100), t === 0)
    a = r, i = r, n = r;
  else {
    var o = r < 0.5 ? r * (1 + t) : r + t - r * t, l = 2 * r - o;
    n = Ci(l, o, e + 1 / 3), a = Ci(l, o, e), i = Ci(l, o, e - 1 / 3);
  }
  return { r: n * 255, g: a * 255, b: i * 255 };
}
function M0(e, t, r) {
  e = Be(e, 255), t = Be(t, 255), r = Be(r, 255);
  var n = Math.max(e, t, r), a = Math.min(e, t, r), i = 0, o = n, l = n - a, c = n === 0 ? 0 : l / n;
  if (n === a)
    i = 0;
  else {
    switch (n) {
      case e:
        i = (t - r) / l + (t < r ? 6 : 0);
        break;
      case t:
        i = (r - e) / l + 2;
        break;
      case r:
        i = (e - t) / l + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: c, v: o };
}
function vs(e, t, r) {
  e = Be(e, 360) * 6, t = Be(t, 100), r = Be(r, 100);
  var n = Math.floor(e), a = e - n, i = r * (1 - t), o = r * (1 - a * t), l = r * (1 - (1 - a) * t), c = n % 6, s = [r, o, i, i, l, r][c], d = [l, r, r, o, i, i][c], M = [i, i, l, r, r, o][c];
  return { r: s * 255, g: d * 255, b: M * 255 };
}
function g0(e, t, r, n) {
  var a = [
    Lt(Math.round(e).toString(16)),
    Lt(Math.round(t).toString(16)),
    Lt(Math.round(r).toString(16))
  ];
  return n && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function Ms(e, t, r, n, a) {
  var i = [
    Lt(Math.round(e).toString(16)),
    Lt(Math.round(t).toString(16)),
    Lt(Math.round(r).toString(16)),
    Lt(xo(n))
  ];
  return a && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function s1(e, t, r, n) {
  var a = [
    Lt(xo(n)),
    Lt(Math.round(e).toString(16)),
    Lt(Math.round(t).toString(16)),
    Lt(Math.round(r).toString(16))
  ];
  return a.join("");
}
function xo(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function d1(e) {
  return ot(e) / 255;
}
function ot(e) {
  return parseInt(e, 16);
}
function gs(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var p0 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Ar(e) {
  var t = { r: 0, g: 0, b: 0 }, r = 1, n = null, a = null, i = null, o = !1, l = !1;
  return typeof e == "string" && (e = ps(e)), typeof e == "object" && ($t(e.r) && $t(e.g) && $t(e.b) ? (t = ds(e.r, e.g, e.b), o = !0, l = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : $t(e.h) && $t(e.s) && $t(e.v) ? (n = xr(e.s), a = xr(e.v), t = vs(e.h, n, a), o = !0, l = "hsv") : $t(e.h) && $t(e.s) && $t(e.l) && (n = xr(e.s), i = xr(e.l), t = fs(e.h, n, i), o = !0, l = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (r = e.a)), r = ss(r), {
    ok: o,
    format: e.format || l,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: r
  };
}
var Ef = "[-\\+]?\\d+%?", bf = "[-\\+]?\\d*\\.\\d+%?", vr = "(?:".concat(bf, ")|(?:").concat(Ef, ")"), Ei = "[\\s|\\(]+(".concat(vr, ")[,|\\s]+(").concat(vr, ")[,|\\s]+(").concat(vr, ")\\s*\\)?"), bi = "[\\s|\\(]+(".concat(vr, ")[,|\\s]+(").concat(vr, ")[,|\\s]+(").concat(vr, ")[,|\\s]+(").concat(vr, ")\\s*\\)?"), Tt = {
  CSS_UNIT: new RegExp(vr),
  rgb: new RegExp("rgb" + Ei),
  rgba: new RegExp("rgba" + bi),
  hsl: new RegExp("hsl" + Ei),
  hsla: new RegExp("hsla" + bi),
  hsv: new RegExp("hsv" + Ei),
  hsva: new RegExp("hsva" + bi),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function ps(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var t = !1;
  if (p0[e])
    e = p0[e], t = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var r = Tt.rgb.exec(e);
  return r ? { r: r[1], g: r[2], b: r[3] } : (r = Tt.rgba.exec(e), r ? { r: r[1], g: r[2], b: r[3], a: r[4] } : (r = Tt.hsl.exec(e), r ? { h: r[1], s: r[2], l: r[3] } : (r = Tt.hsla.exec(e), r ? { h: r[1], s: r[2], l: r[3], a: r[4] } : (r = Tt.hsv.exec(e), r ? { h: r[1], s: r[2], v: r[3] } : (r = Tt.hsva.exec(e), r ? { h: r[1], s: r[2], v: r[3], a: r[4] } : (r = Tt.hex8.exec(e), r ? {
    r: ot(r[1]),
    g: ot(r[2]),
    b: ot(r[3]),
    a: d1(r[4]),
    format: t ? "name" : "hex8"
  } : (r = Tt.hex6.exec(e), r ? {
    r: ot(r[1]),
    g: ot(r[2]),
    b: ot(r[3]),
    format: t ? "name" : "hex"
  } : (r = Tt.hex4.exec(e), r ? {
    r: ot(r[1] + r[1]),
    g: ot(r[2] + r[2]),
    b: ot(r[3] + r[3]),
    a: d1(r[4] + r[4]),
    format: t ? "name" : "hex8"
  } : (r = Tt.hex3.exec(e), r ? {
    r: ot(r[1] + r[1]),
    g: ot(r[2] + r[2]),
    b: ot(r[3] + r[3]),
    format: t ? "name" : "hex"
  } : !1)))))))));
}
function $t(e) {
  return Boolean(Tt.CSS_UNIT.exec(String(e)));
}
var Pt = function() {
  function e(t, r) {
    t === void 0 && (t = ""), r === void 0 && (r = {});
    var n;
    if (t instanceof e)
      return t;
    typeof t == "number" && (t = gs(t)), this.originalInput = t;
    var a = Ar(t);
    this.originalInput = t, this.r = a.r, this.g = a.g, this.b = a.b, this.a = a.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = r.format) !== null && n !== void 0 ? n : a.format, this.gradientType = r.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = a.ok;
  }
  return e.prototype.isDark = function() {
    return this.getBrightness() < 128;
  }, e.prototype.isLight = function() {
    return !this.isDark();
  }, e.prototype.getBrightness = function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  }, e.prototype.getLuminance = function() {
    var t = this.toRgb(), r, n, a, i = t.r / 255, o = t.g / 255, l = t.b / 255;
    return i <= 0.03928 ? r = i / 12.92 : r = Math.pow((i + 0.055) / 1.055, 2.4), o <= 0.03928 ? n = o / 12.92 : n = Math.pow((o + 0.055) / 1.055, 2.4), l <= 0.03928 ? a = l / 12.92 : a = Math.pow((l + 0.055) / 1.055, 2.4), 0.2126 * r + 0.7152 * n + 0.0722 * a;
  }, e.prototype.getAlpha = function() {
    return this.a;
  }, e.prototype.setAlpha = function(t) {
    return this.a = ss(t), this.roundA = Math.round(100 * this.a) / 100, this;
  }, e.prototype.toHsv = function() {
    var t = M0(this.r, this.g, this.b);
    return { h: t.h * 360, s: t.s, v: t.v, a: this.a };
  }, e.prototype.toHsvString = function() {
    var t = M0(this.r, this.g, this.b), r = Math.round(t.h * 360), n = Math.round(t.s * 100), a = Math.round(t.v * 100);
    return this.a === 1 ? "hsv(".concat(r, ", ").concat(n, "%, ").concat(a, "%)") : "hsva(".concat(r, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
  }, e.prototype.toHsl = function() {
    var t = u1(this.r, this.g, this.b);
    return { h: t.h * 360, s: t.s, l: t.l, a: this.a };
  }, e.prototype.toHslString = function() {
    var t = u1(this.r, this.g, this.b), r = Math.round(t.h * 360), n = Math.round(t.s * 100), a = Math.round(t.l * 100);
    return this.a === 1 ? "hsl(".concat(r, ", ").concat(n, "%, ").concat(a, "%)") : "hsla(".concat(r, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
  }, e.prototype.toHex = function(t) {
    return t === void 0 && (t = !1), g0(this.r, this.g, this.b, t);
  }, e.prototype.toHexString = function(t) {
    return t === void 0 && (t = !1), "#" + this.toHex(t);
  }, e.prototype.toHex8 = function(t) {
    return t === void 0 && (t = !1), Ms(this.r, this.g, this.b, this.a, t);
  }, e.prototype.toHex8String = function(t) {
    return t === void 0 && (t = !1), "#" + this.toHex8(t);
  }, e.prototype.toRgb = function() {
    return {
      r: Math.round(this.r),
      g: Math.round(this.g),
      b: Math.round(this.b),
      a: this.a
    };
  }, e.prototype.toRgbString = function() {
    var t = Math.round(this.r), r = Math.round(this.g), n = Math.round(this.b);
    return this.a === 1 ? "rgb(".concat(t, ", ").concat(r, ", ").concat(n, ")") : "rgba(".concat(t, ", ").concat(r, ", ").concat(n, ", ").concat(this.roundA, ")");
  }, e.prototype.toPercentageRgb = function() {
    var t = function(r) {
      return "".concat(Math.round(Be(r, 255) * 100), "%");
    };
    return {
      r: t(this.r),
      g: t(this.g),
      b: t(this.b),
      a: this.a
    };
  }, e.prototype.toPercentageRgbString = function() {
    var t = function(r) {
      return Math.round(Be(r, 255) * 100);
    };
    return this.a === 1 ? "rgb(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%)") : "rgba(".concat(t(this.r), "%, ").concat(t(this.g), "%, ").concat(t(this.b), "%, ").concat(this.roundA, ")");
  }, e.prototype.toName = function() {
    if (this.a === 0)
      return "transparent";
    if (this.a < 1)
      return !1;
    for (var t = "#" + g0(this.r, this.g, this.b, !1), r = 0, n = Object.entries(p0); r < n.length; r++) {
      var a = n[r], i = a[0], o = a[1];
      if (t === o)
        return i;
    }
    return !1;
  }, e.prototype.toString = function(t) {
    var r = Boolean(t);
    t = t != null ? t : this.format;
    var n = !1, a = this.a < 1 && this.a >= 0, i = !r && a && (t.startsWith("hex") || t === "name");
    return i ? t === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (n = this.toRgbString()), t === "prgb" && (n = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (n = this.toHexString()), t === "hex3" && (n = this.toHexString(!0)), t === "hex4" && (n = this.toHex8String(!0)), t === "hex8" && (n = this.toHex8String()), t === "name" && (n = this.toName()), t === "hsl" && (n = this.toHslString()), t === "hsv" && (n = this.toHsvString()), n || this.toHexString());
  }, e.prototype.toNumber = function() {
    return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
  }, e.prototype.clone = function() {
    return new e(this.toString());
  }, e.prototype.lighten = function(t) {
    t === void 0 && (t = 10);
    var r = this.toHsl();
    return r.l += t / 100, r.l = _a(r.l), new e(r);
  }, e.prototype.brighten = function(t) {
    t === void 0 && (t = 10);
    var r = this.toRgb();
    return r.r = Math.max(0, Math.min(255, r.r - Math.round(255 * -(t / 100)))), r.g = Math.max(0, Math.min(255, r.g - Math.round(255 * -(t / 100)))), r.b = Math.max(0, Math.min(255, r.b - Math.round(255 * -(t / 100)))), new e(r);
  }, e.prototype.darken = function(t) {
    t === void 0 && (t = 10);
    var r = this.toHsl();
    return r.l -= t / 100, r.l = _a(r.l), new e(r);
  }, e.prototype.tint = function(t) {
    return t === void 0 && (t = 10), this.mix("white", t);
  }, e.prototype.shade = function(t) {
    return t === void 0 && (t = 10), this.mix("black", t);
  }, e.prototype.desaturate = function(t) {
    t === void 0 && (t = 10);
    var r = this.toHsl();
    return r.s -= t / 100, r.s = _a(r.s), new e(r);
  }, e.prototype.saturate = function(t) {
    t === void 0 && (t = 10);
    var r = this.toHsl();
    return r.s += t / 100, r.s = _a(r.s), new e(r);
  }, e.prototype.greyscale = function() {
    return this.desaturate(100);
  }, e.prototype.spin = function(t) {
    var r = this.toHsl(), n = (r.h + t) % 360;
    return r.h = n < 0 ? 360 + n : n, new e(r);
  }, e.prototype.mix = function(t, r) {
    r === void 0 && (r = 50);
    var n = this.toRgb(), a = new e(t).toRgb(), i = r / 100, o = {
      r: (a.r - n.r) * i + n.r,
      g: (a.g - n.g) * i + n.g,
      b: (a.b - n.b) * i + n.b,
      a: (a.a - n.a) * i + n.a
    };
    return new e(o);
  }, e.prototype.analogous = function(t, r) {
    t === void 0 && (t = 6), r === void 0 && (r = 30);
    var n = this.toHsl(), a = 360 / r, i = [this];
    for (n.h = (n.h - (a * t >> 1) + 720) % 360; --t; )
      n.h = (n.h + a) % 360, i.push(new e(n));
    return i;
  }, e.prototype.complement = function() {
    var t = this.toHsl();
    return t.h = (t.h + 180) % 360, new e(t);
  }, e.prototype.monochromatic = function(t) {
    t === void 0 && (t = 6);
    for (var r = this.toHsv(), n = r.h, a = r.s, i = r.v, o = [], l = 1 / t; t--; )
      o.push(new e({ h: n, s: a, v: i })), i = (i + l) % 1;
    return o;
  }, e.prototype.splitcomplement = function() {
    var t = this.toHsl(), r = t.h;
    return [
      this,
      new e({ h: (r + 72) % 360, s: t.s, l: t.l }),
      new e({ h: (r + 216) % 360, s: t.s, l: t.l })
    ];
  }, e.prototype.onBackground = function(t) {
    var r = this.toRgb(), n = new e(t).toRgb();
    return new e({
      r: n.r + (r.r - n.r) * r.a,
      g: n.g + (r.g - n.g) * r.a,
      b: n.b + (r.b - n.b) * r.a
    });
  }, e.prototype.triad = function() {
    return this.polyad(3);
  }, e.prototype.tetrad = function() {
    return this.polyad(4);
  }, e.prototype.polyad = function(t) {
    for (var r = this.toHsl(), n = r.h, a = [this], i = 360 / t, o = 1; o < t; o++)
      a.push(new e({ h: (n + o * i) % 360, s: r.s, l: r.l }));
    return a;
  }, e.prototype.equals = function(t) {
    return this.toRgbString() === new e(t).toRgbString();
  }, e;
}();
function cc(e, t) {
  return e === void 0 && (e = ""), t === void 0 && (t = {}), new Pt(e, t);
}
function wo(e, t) {
  var r = new Pt(e), n = new Pt(t);
  return (Math.max(r.getLuminance(), n.getLuminance()) + 0.05) / (Math.min(r.getLuminance(), n.getLuminance()) + 0.05);
}
function hs(e, t, r) {
  var n, a;
  r === void 0 && (r = { level: "AA", size: "small" });
  var i = wo(e, t);
  switch (((n = r.level) !== null && n !== void 0 ? n : "AA") + ((a = r.size) !== null && a !== void 0 ? a : "small")) {
    case "AAsmall":
    case "AAAlarge":
      return i >= 4.5;
    case "AAlarge":
      return i >= 3;
    case "AAAsmall":
      return i >= 7;
    default:
      return !1;
  }
}
function ms(e, t, r) {
  r === void 0 && (r = { includeFallbackColors: !1, level: "AA", size: "small" });
  for (var n = null, a = 0, i = r.includeFallbackColors, o = r.level, l = r.size, c = 0, s = t; c < s.length; c++) {
    var d = s[c], M = wo(e, d);
    M > a && (a = M, n = new Pt(d));
  }
  return hs(e, n, { level: o, size: l }) || !i ? n : (r.includeFallbackColors = !1, ms(e, ["#fff", "#000"], r));
}
function Af(e, t) {
  var r = new Pt(e), n = "#" + s1(r.r, r.g, r.b, r.a), a = n, i = r.gradientType ? "GradientType = 1, " : "";
  if (t) {
    var o = new Pt(t);
    a = "#" + s1(o.r, o.g, o.b, o.a);
  }
  return "progid:DXImageTransform.Microsoft.gradient(".concat(i, "startColorstr=").concat(n, ",endColorstr=").concat(a, ")");
}
function jf(e, t) {
  var r = {
    r: xr(e.r),
    g: xr(e.g),
    b: xr(e.b)
  };
  return e.a !== void 0 && (r.a = Number(e.a)), new Pt(r, t);
}
function xf() {
  return new Pt({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
}
function ys(e) {
  if (e === void 0 && (e = {}), e.count !== void 0 && e.count !== null) {
    var t = e.count, r = [];
    for (e.count = void 0; t > r.length; )
      e.count = null, e.seed && (e.seed += 1), r.push(ys(e));
    return e.count = t, r;
  }
  var n = wf(e.hue, e.seed), a = Of(n, e), i = Tf(n, a, e), o = { h: n, s: a, v: i };
  return e.alpha !== void 0 && (o.a = e.alpha), new Pt(o);
}
function wf(e, t) {
  var r = Lf(e), n = h0(r, t);
  return n < 0 && (n = 360 + n), n;
}
function Of(e, t) {
  if (t.hue === "monochrome")
    return 0;
  if (t.luminosity === "random")
    return h0([0, 100], t.seed);
  var r = Ns(e).saturationRange, n = r[0], a = r[1];
  switch (t.luminosity) {
    case "bright":
      n = 55;
      break;
    case "dark":
      n = a - 10;
      break;
    case "light":
      a = 55;
      break;
  }
  return h0([n, a], t.seed);
}
function Tf(e, t, r) {
  var n = Sf(e, t), a = 100;
  switch (r.luminosity) {
    case "dark":
      a = n + 20;
      break;
    case "light":
      n = (a + n) / 2;
      break;
    case "random":
      n = 0, a = 100;
      break;
  }
  return h0([n, a], r.seed);
}
function Sf(e, t) {
  for (var r = Ns(e).lowerBounds, n = 0; n < r.length - 1; n++) {
    var a = r[n][0], i = r[n][1], o = r[n + 1][0], l = r[n + 1][1];
    if (t >= a && t <= o) {
      var c = (l - i) / (o - a), s = i - c * a;
      return c * t + s;
    }
  }
  return 0;
}
function Lf(e) {
  var t = parseInt(e, 10);
  if (!Number.isNaN(t) && t < 360 && t > 0)
    return [t, t];
  if (typeof e == "string") {
    var r = Oo.find(function(o) {
      return o.name === e;
    });
    if (r) {
      var n = zs(r);
      if (n.hueRange)
        return n.hueRange;
    }
    var a = new Pt(e);
    if (a.isValid) {
      var i = a.toHsv().h;
      return [i, i];
    }
  }
  return [0, 360];
}
function Ns(e) {
  e >= 334 && e <= 360 && (e -= 360);
  for (var t = 0, r = Oo; t < r.length; t++) {
    var n = r[t], a = zs(n);
    if (a.hueRange && e >= a.hueRange[0] && e <= a.hueRange[1])
      return a;
  }
  throw Error("Color not found");
}
function h0(e, t) {
  if (t === void 0)
    return Math.floor(e[0] + Math.random() * (e[1] + 1 - e[0]));
  var r = e[1] || 1, n = e[0] || 0;
  t = (t * 9301 + 49297) % 233280;
  var a = t / 233280;
  return Math.floor(n + a * (r - n));
}
function zs(e) {
  var t = e.lowerBounds[0][0], r = e.lowerBounds[e.lowerBounds.length - 1][0], n = e.lowerBounds[e.lowerBounds.length - 1][1], a = e.lowerBounds[0][1];
  return {
    name: e.name,
    hueRange: e.hueRange,
    lowerBounds: e.lowerBounds,
    saturationRange: [t, r],
    brightnessRange: [n, a]
  };
}
var Oo = [
  {
    name: "monochrome",
    hueRange: null,
    lowerBounds: [
      [0, 0],
      [100, 0]
    ]
  },
  {
    name: "red",
    hueRange: [-26, 18],
    lowerBounds: [
      [20, 100],
      [30, 92],
      [40, 89],
      [50, 85],
      [60, 78],
      [70, 70],
      [80, 60],
      [90, 55],
      [100, 50]
    ]
  },
  {
    name: "orange",
    hueRange: [19, 46],
    lowerBounds: [
      [20, 100],
      [30, 93],
      [40, 88],
      [50, 86],
      [60, 85],
      [70, 70],
      [100, 70]
    ]
  },
  {
    name: "yellow",
    hueRange: [47, 62],
    lowerBounds: [
      [25, 100],
      [40, 94],
      [50, 89],
      [60, 86],
      [70, 84],
      [80, 82],
      [90, 80],
      [100, 75]
    ]
  },
  {
    name: "green",
    hueRange: [63, 178],
    lowerBounds: [
      [30, 100],
      [40, 90],
      [50, 85],
      [60, 81],
      [70, 74],
      [80, 64],
      [90, 50],
      [100, 40]
    ]
  },
  {
    name: "blue",
    hueRange: [179, 257],
    lowerBounds: [
      [20, 100],
      [30, 86],
      [40, 80],
      [50, 74],
      [60, 60],
      [70, 52],
      [80, 44],
      [90, 39],
      [100, 35]
    ]
  },
  {
    name: "purple",
    hueRange: [258, 282],
    lowerBounds: [
      [20, 100],
      [30, 87],
      [40, 79],
      [50, 70],
      [60, 65],
      [70, 59],
      [80, 52],
      [90, 45],
      [100, 42]
    ]
  },
  {
    name: "pink",
    hueRange: [283, 334],
    lowerBounds: [
      [20, 100],
      [30, 90],
      [40, 86],
      [60, 84],
      [80, 80],
      [90, 75],
      [100, 73]
    ]
  }
];
const kf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cc,
  TinyColor: Pt,
  tinycolor: cc,
  names: p0,
  readability: wo,
  isReadable: hs,
  mostReadable: ms,
  toMsFilter: Af,
  fromRatio: jf,
  legacyRandom: xf,
  inputToRGB: Ar,
  stringInputToObject: ps,
  isValidCSSUnit: $t,
  random: ys,
  bounds: Oo,
  rgbToRgb: ds,
  rgbToHsl: u1,
  hslToRgb: fs,
  rgbToHsv: M0,
  hsvToRgb: vs,
  rgbToHex: g0,
  rgbaToHex: Ms,
  rgbaToArgbHex: s1,
  convertDecimalToHex: xo,
  convertHexToDecimal: d1,
  parseIntFromHex: ot,
  numberInputToObject: gs
}, Symbol.toStringTag, { value: "Module" }));
var Ia = 2, uc = 0.16, Pf = 0.05, Rf = 0.05, Qf = 0.15, _s = 5, Is = 4, Vf = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function sc(e) {
  var t = e.r, r = e.g, n = e.b, a = M0(t, r, n);
  return {
    h: a.h * 360,
    s: a.s,
    v: a.v
  };
}
function Da(e) {
  var t = e.r, r = e.g, n = e.b;
  return "#".concat(g0(t, r, n, !1));
}
function Uf(e, t, r) {
  var n = r / 100, a = {
    r: (t.r - e.r) * n + e.r,
    g: (t.g - e.g) * n + e.g,
    b: (t.b - e.b) * n + e.b
  };
  return a;
}
function dc(e, t, r) {
  var n;
  return Math.round(e.h) >= 60 && Math.round(e.h) <= 240 ? n = r ? Math.round(e.h) - Ia * t : Math.round(e.h) + Ia * t : n = r ? Math.round(e.h) + Ia * t : Math.round(e.h) - Ia * t, n < 0 ? n += 360 : n >= 360 && (n -= 360), n;
}
function fc(e, t, r) {
  if (e.h === 0 && e.s === 0)
    return e.s;
  var n;
  return r ? n = e.s - uc * t : t === Is ? n = e.s + uc : n = e.s + Pf * t, n > 1 && (n = 1), r && t === _s && n > 0.1 && (n = 0.1), n < 0.06 && (n = 0.06), Number(n.toFixed(2));
}
function vc(e, t, r) {
  var n;
  return r ? n = e.v + Rf * t : n = e.v - Qf * t, n > 1 && (n = 1), Number(n.toFixed(2));
}
function f1(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [], n = Ar(e), a = _s; a > 0; a -= 1) {
    var i = sc(n), o = Da(Ar({
      h: dc(i, a, !0),
      s: fc(i, a, !0),
      v: vc(i, a, !0)
    }));
    r.push(o);
  }
  r.push(Da(n));
  for (var l = 1; l <= Is; l += 1) {
    var c = sc(n), s = Da(Ar({
      h: dc(c, l),
      s: fc(c, l),
      v: vc(c, l)
    }));
    r.push(s);
  }
  return t.theme === "dark" ? Vf.map(function(d) {
    var M = d.index, f = d.opacity, v = Da(Uf(Ar(t.backgroundColor || "#141414"), Ar(r[M]), f * 100));
    return v;
  }) : r;
}
var r0 = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
}, qe = {}, n0 = {};
Object.keys(r0).forEach(function(e) {
  qe[e] = f1(r0[e]), qe[e].primary = qe[e][5], n0[e] = f1(r0[e], {
    theme: "dark",
    backgroundColor: "#141414"
  }), n0[e].primary = n0[e][5];
});
var Ff = qe.red, $f = qe.volcano, Zf = qe.gold, Yf = qe.orange, Hf = qe.yellow, Wf = qe.lime, Bf = qe.green, qf = qe.cyan, Gf = qe.blue, Kf = qe.geekblue, Xf = qe.purple, Jf = qe.magenta, e6 = qe.grey;
const t6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  blue: Gf,
  cyan: qf,
  geekblue: Kf,
  generate: f1,
  gold: Zf,
  green: Bf,
  grey: e6,
  lime: Wf,
  magenta: Jf,
  orange: Yf,
  presetDarkPalettes: n0,
  presetPalettes: qe,
  presetPrimaryColors: r0,
  purple: Xf,
  red: Ff,
  volcano: $f,
  yellow: Hf
}, Symbol.toStringTag, { value: "Module" }));
var Mc = {};
function v1(e, t) {
  process.env.NODE_ENV !== "production" && !e && console !== void 0 && console.error("Warning: ".concat(t));
}
function r6(e, t, r) {
  !t && !Mc[r] && (e(!1, r), Mc[r] = !0);
}
function vt(e, t) {
  r6(v1, e, t);
}
function ua() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function a0(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var r = t; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
function i0(e) {
  return !!(e.addonBefore || e.addonAfter);
}
function Ds(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
function gc(e, t, r, n) {
  if (!!r) {
    var a = t;
    if (t.type === "click") {
      var i = e.cloneNode(!0);
      a = Object.create(t, {
        target: {
          value: i
        },
        currentTarget: {
          value: i
        }
      }), i.value = "", r(a);
      return;
    }
    if (n !== void 0) {
      a = Object.create(t, {
        target: {
          value: e
        },
        currentTarget: {
          value: e
        }
      }), e.value = n, r(a);
      return;
    }
    r(a);
  }
}
function n6(e, t) {
  if (!!e) {
    e.focus(t);
    var r = t || {}, n = r.cursor;
    if (n) {
      var a = e.value.length;
      switch (n) {
        case "start":
          e.setSelectionRange(0, 0);
          break;
        case "end":
          e.setSelectionRange(a, a);
          break;
        default:
          e.setSelectionRange(0, a);
      }
    }
  }
}
function pc(e) {
  return typeof e > "u" || e === null ? "" : String(e);
}
var Cs = function(t) {
  var r = t.inputElement, n = t.prefixCls, a = t.prefix, i = t.suffix, o = t.addonBefore, l = t.addonAfter, c = t.className, s = t.style, d = t.affixWrapperClassName, M = t.groupClassName, f = t.wrapperClassName, v = t.disabled, g = t.readOnly, m = t.focused, p = t.triggerFocus, h = t.allowClear, y = t.value, N = t.handleReset, I = t.hidden, D = Le(null), A = function(R) {
    var V;
    (V = D.current) !== null && V !== void 0 && V.contains(R.target) && (p == null || p());
  }, k = function() {
    var R;
    if (!h)
      return null;
    var V = !v && !g && y, Q = "".concat(n, "-clear-icon"), x = Ve(h) === "object" && h !== null && h !== void 0 && h.clearIcon ? h.clearIcon : "\u2716";
    return /* @__PURE__ */ u.createElement("span", {
      onClick: N,
      onMouseDown: function(U) {
        return U.preventDefault();
      },
      className: Y(Q, (R = {}, je(R, "".concat(Q, "-hidden"), !V), je(R, "".concat(Q, "-has-suffix"), !!i), R)),
      role: "button",
      tabIndex: -1
    }, x);
  }, L = /* @__PURE__ */ _i(r, {
    value: y,
    hidden: I
  });
  if (Ds(t)) {
    var T, C = "".concat(n, "-affix-wrapper"), j = Y(C, (T = {}, je(T, "".concat(C, "-disabled"), v), je(T, "".concat(C, "-focused"), m), je(T, "".concat(C, "-readonly"), g), je(T, "".concat(C, "-input-with-clear-btn"), i && h && y), T), !i0(t) && c, d), w = (i || h) && /* @__PURE__ */ u.createElement("span", {
      className: "".concat(n, "-suffix")
    }, k(), i);
    L = /* @__PURE__ */ u.createElement("span", {
      className: j,
      style: s,
      hidden: !i0(t) && I,
      onClick: A,
      ref: D
    }, a && /* @__PURE__ */ u.createElement("span", {
      className: "".concat(n, "-prefix")
    }, a), /* @__PURE__ */ _i(r, {
      style: null,
      value: y,
      hidden: null
    }), w);
  }
  if (i0(t)) {
    var E = "".concat(n, "-group"), _ = "".concat(E, "-addon"), b = Y("".concat(n, "-wrapper"), E, f), O = Y("".concat(n, "-group-wrapper"), c, M);
    return /* @__PURE__ */ u.createElement("span", {
      className: O,
      style: s,
      hidden: I
    }, /* @__PURE__ */ u.createElement("span", {
      className: b
    }, o && /* @__PURE__ */ u.createElement("span", {
      className: _
    }, o), /* @__PURE__ */ _i(L, {
      style: null,
      hidden: null
    }), l && /* @__PURE__ */ u.createElement("span", {
      className: _
    }, l)));
  }
  return L;
};
function a6(e) {
  if (Array.isArray(e))
    return c1(e);
}
function Es(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function i6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Me(e) {
  return a6(e) || Es(e) || jo(e) || i6();
}
function o6(e, t) {
  var r = H({}, e);
  return Array.isArray(t) && t.forEach(function(n) {
    delete r[n];
  }), r;
}
function hc(e) {
  var t = z.useRef();
  t.current = e;
  var r = z.useCallback(function() {
    for (var n, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return (n = t.current) === null || n === void 0 ? void 0 : n.call.apply(n, [t].concat(i));
  }, []);
  return r;
}
var kr = process.env.NODE_ENV !== "test" && ua() ? z.useLayoutEffect : z.useEffect, l6 = function(t, r) {
  var n = z.useRef(!0);
  kr(function() {
    if (!n.current)
      return t();
  }, r), kr(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
};
function tn(e) {
  var t = z.useRef(!1), r = z.useState(e), n = pe(r, 2), a = n[0], i = n[1];
  z.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []);
  function o(l, c) {
    c && t.current || i(l);
  }
  return [a, o];
}
var er;
(function(e) {
  e[e.INNER = 0] = "INNER", e[e.PROP = 1] = "PROP";
})(er || (er = {}));
function Ai(e) {
  return e !== void 0;
}
function bs(e, t) {
  var r = t || {}, n = r.defaultValue, a = r.value, i = r.onChange, o = r.postState, l = tn(function() {
    var p = void 0, h;
    return Ai(a) ? (p = a, h = er.PROP) : Ai(n) ? (p = typeof n == "function" ? n() : n, h = er.PROP) : (p = typeof e == "function" ? e() : e, h = er.INNER), [p, h, p];
  }), c = pe(l, 2), s = c[0], d = c[1], M = Ai(a) ? a : s[0], f = o ? o(M) : M;
  l6(function() {
    d(function(p) {
      var h = pe(p, 1), y = h[0];
      return [a, er.PROP, y];
    });
  }, [a]);
  var v = z.useRef(), g = hc(function(p, h) {
    d(function(y) {
      var N = pe(y, 3), I = N[0], D = N[1], A = N[2], k = typeof p == "function" ? p(I) : p;
      if (k === I)
        return y;
      var L = D === er.INNER && v.current !== A ? A : I;
      return [k, er.INNER, L];
    }, h);
  }), m = hc(i);
  return kr(function() {
    var p = pe(s, 3), h = p[0], y = p[1], N = p[2];
    h !== N && y === er.INNER && (m(h, N), v.current = N);
  }, [s]), [f, g];
}
var c6 = ["autoComplete", "onChange", "onFocus", "onBlur", "onPressEnter", "onKeyDown", "prefixCls", "disabled", "htmlSize", "className", "maxLength", "suffix", "showCount", "type", "inputClassName"], u6 = /* @__PURE__ */ fo(function(e, t) {
  var r = e.autoComplete, n = e.onChange, a = e.onFocus, i = e.onBlur, o = e.onPressEnter, l = e.onKeyDown, c = e.prefixCls, s = c === void 0 ? "rc-input" : c, d = e.disabled, M = e.htmlSize, f = e.className, v = e.maxLength, g = e.suffix, m = e.showCount, p = e.type, h = p === void 0 ? "text" : p, y = e.inputClassName, N = Wt(e, c6), I = bs(e.defaultValue, {
    value: e.value
  }), D = pe(I, 2), A = D[0], k = D[1], L = de(!1), T = pe(L, 2), C = T[0], j = T[1], w = Le(null), E = function(P) {
    w.current && n6(w.current, P);
  };
  A0(t, function() {
    return {
      focus: E,
      blur: function() {
        var P;
        (P = w.current) === null || P === void 0 || P.blur();
      },
      setSelectionRange: function(P, U, F) {
        var $;
        ($ = w.current) === null || $ === void 0 || $.setSelectionRange(P, U, F);
      },
      select: function() {
        var P;
        (P = w.current) === null || P === void 0 || P.select();
      },
      input: w.current
    };
  }), lt(function() {
    j(function(x) {
      return x && d ? !1 : x;
    });
  }, [d]);
  var _ = function(P) {
    e.value === void 0 && k(P.target.value), w.current && gc(w.current, P, n);
  }, b = function(P) {
    o && P.key === "Enter" && o(P), l == null || l(P);
  }, O = function(P) {
    j(!0), a == null || a(P);
  }, S = function(P) {
    j(!1), i == null || i(P);
  }, R = function(P) {
    k(""), E(), w.current && gc(w.current, P, n);
  }, V = function() {
    var P = o6(e, [
      "prefixCls",
      "onPressEnter",
      "addonBefore",
      "addonAfter",
      "prefix",
      "suffix",
      "allowClear",
      "defaultValue",
      "showCount",
      "affixWrapperClassName",
      "groupClassName",
      "inputClassName",
      "wrapperClassName",
      "htmlSize"
    ]);
    return /* @__PURE__ */ u.createElement("input", Pe({
      autoComplete: r
    }, P, {
      onChange: _,
      onFocus: O,
      onBlur: S,
      onKeyDown: b,
      className: Y(s, je({}, "".concat(s, "-disabled"), d), y, !i0(e) && !Ds(e) && f),
      ref: w,
      size: M,
      type: h
    }));
  }, Q = function() {
    var P = Number(v) > 0;
    if (g || m) {
      var U = pc(A), F = Me(U).length, $ = Ve(m) === "object" ? m.formatter({
        value: U,
        count: F,
        maxLength: v
      }) : "".concat(F).concat(P ? " / ".concat(v) : "");
      return /* @__PURE__ */ u.createElement(u.Fragment, null, !!m && /* @__PURE__ */ u.createElement("span", {
        className: Y("".concat(s, "-show-count-suffix"), je({}, "".concat(s, "-show-count-has-suffix"), !!g))
      }, $), g);
    }
    return null;
  };
  return /* @__PURE__ */ u.createElement(Cs, Pe({}, N, {
    prefixCls: s,
    className: f,
    inputElement: V(),
    handleReset: R,
    value: pc(A),
    focused: C,
    triggerFocus: E,
    suffix: Q(),
    disabled: d
  }));
});
const s6 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseInput: Cs,
  default: u6
}, Symbol.toStringTag, { value: "Module" }));
var sa = { exports: {} }, Ie = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mc;
function d6() {
  if (mc)
    return Ie;
  mc = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, M = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, h = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function N(D) {
    if (typeof D == "object" && D !== null) {
      var A = D.$$typeof;
      switch (A) {
        case t:
          switch (D = D.type, D) {
            case c:
            case s:
            case n:
            case i:
            case a:
            case M:
              return D;
            default:
              switch (D = D && D.$$typeof, D) {
                case l:
                case d:
                case g:
                case v:
                case o:
                  return D;
                default:
                  return A;
              }
          }
        case r:
          return A;
      }
    }
  }
  function I(D) {
    return N(D) === s;
  }
  return Ie.AsyncMode = c, Ie.ConcurrentMode = s, Ie.ContextConsumer = l, Ie.ContextProvider = o, Ie.Element = t, Ie.ForwardRef = d, Ie.Fragment = n, Ie.Lazy = g, Ie.Memo = v, Ie.Portal = r, Ie.Profiler = i, Ie.StrictMode = a, Ie.Suspense = M, Ie.isAsyncMode = function(D) {
    return I(D) || N(D) === c;
  }, Ie.isConcurrentMode = I, Ie.isContextConsumer = function(D) {
    return N(D) === l;
  }, Ie.isContextProvider = function(D) {
    return N(D) === o;
  }, Ie.isElement = function(D) {
    return typeof D == "object" && D !== null && D.$$typeof === t;
  }, Ie.isForwardRef = function(D) {
    return N(D) === d;
  }, Ie.isFragment = function(D) {
    return N(D) === n;
  }, Ie.isLazy = function(D) {
    return N(D) === g;
  }, Ie.isMemo = function(D) {
    return N(D) === v;
  }, Ie.isPortal = function(D) {
    return N(D) === r;
  }, Ie.isProfiler = function(D) {
    return N(D) === i;
  }, Ie.isStrictMode = function(D) {
    return N(D) === a;
  }, Ie.isSuspense = function(D) {
    return N(D) === M;
  }, Ie.isValidElementType = function(D) {
    return typeof D == "string" || typeof D == "function" || D === n || D === s || D === i || D === a || D === M || D === f || typeof D == "object" && D !== null && (D.$$typeof === g || D.$$typeof === v || D.$$typeof === o || D.$$typeof === l || D.$$typeof === d || D.$$typeof === p || D.$$typeof === h || D.$$typeof === y || D.$$typeof === m);
  }, Ie.typeOf = N, Ie;
}
var De = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yc;
function f6() {
  return yc || (yc = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, M = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, p = e ? Symbol.for("react.fundamental") : 60117, h = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function N(Z) {
      return typeof Z == "string" || typeof Z == "function" || Z === n || Z === s || Z === i || Z === a || Z === M || Z === f || typeof Z == "object" && Z !== null && (Z.$$typeof === g || Z.$$typeof === v || Z.$$typeof === o || Z.$$typeof === l || Z.$$typeof === d || Z.$$typeof === p || Z.$$typeof === h || Z.$$typeof === y || Z.$$typeof === m);
    }
    function I(Z) {
      if (typeof Z == "object" && Z !== null) {
        var K = Z.$$typeof;
        switch (K) {
          case t:
            var ee = Z.type;
            switch (ee) {
              case c:
              case s:
              case n:
              case i:
              case a:
              case M:
                return ee;
              default:
                var ce = ee && ee.$$typeof;
                switch (ce) {
                  case l:
                  case d:
                  case g:
                  case v:
                  case o:
                    return ce;
                  default:
                    return K;
                }
            }
          case r:
            return K;
        }
      }
    }
    var D = c, A = s, k = l, L = o, T = t, C = d, j = n, w = g, E = v, _ = r, b = i, O = a, S = M, R = !1;
    function V(Z) {
      return R || (R = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Q(Z) || I(Z) === c;
    }
    function Q(Z) {
      return I(Z) === s;
    }
    function x(Z) {
      return I(Z) === l;
    }
    function P(Z) {
      return I(Z) === o;
    }
    function U(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === t;
    }
    function F(Z) {
      return I(Z) === d;
    }
    function $(Z) {
      return I(Z) === n;
    }
    function W(Z) {
      return I(Z) === g;
    }
    function te(Z) {
      return I(Z) === v;
    }
    function J(Z) {
      return I(Z) === r;
    }
    function q(Z) {
      return I(Z) === i;
    }
    function B(Z) {
      return I(Z) === a;
    }
    function G(Z) {
      return I(Z) === M;
    }
    De.AsyncMode = D, De.ConcurrentMode = A, De.ContextConsumer = k, De.ContextProvider = L, De.Element = T, De.ForwardRef = C, De.Fragment = j, De.Lazy = w, De.Memo = E, De.Portal = _, De.Profiler = b, De.StrictMode = O, De.Suspense = S, De.isAsyncMode = V, De.isConcurrentMode = Q, De.isContextConsumer = x, De.isContextProvider = P, De.isElement = U, De.isForwardRef = F, De.isFragment = $, De.isLazy = W, De.isMemo = te, De.isPortal = J, De.isProfiler = q, De.isStrictMode = B, De.isSuspense = G, De.isValidElementType = N, De.typeOf = I;
  }()), De;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = d6() : e.exports = f6();
})(sa);
function As(e, t) {
  typeof e == "function" ? e(t) : Ve(e) === "object" && e && "current" in e && (e.current = t);
}
function To() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = t.filter(function(a) {
    return a;
  });
  return n.length <= 1 ? n[0] : function(a) {
    t.forEach(function(i) {
      As(i, a);
    });
  };
}
function So(e) {
  var t, r, n = sa.exports.isMemo(e) ? e.type.type : e.type;
  return !(typeof n == "function" && !(!((t = n.prototype) === null || t === void 0) && t.render) || typeof e == "function" && !(!((r = e.prototype) === null || r === void 0) && r.render));
}
function Bt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Nc(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function qt(e, t, r) {
  return t && Nc(e.prototype, t), r && Nc(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Lo(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function M1(e, t) {
  return M1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, M1(e, t);
}
function Nr(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && M1(e, t);
}
function m0(e) {
  return m0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, m0(e);
}
function v6() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function M6(e, t) {
  if (t && (Ve(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Lo(e);
}
function zr(e) {
  var t = v6();
  return function() {
    var n = m0(e), a;
    if (t) {
      var i = m0(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return M6(this, a);
  };
}
function y0(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return u.Children.forEach(e, function(n) {
    n == null && !t.keepEmpty || (Array.isArray(n) ? r = r.concat(y0(n)) : sa.exports.isFragment(n) && n.props ? r = r.concat(y0(n.props.children, t)) : r.push(n));
  }), r;
}
var wr = "RC_FORM_INTERNAL_HOOKS", Ee = function() {
  vt(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, Pr = /* @__PURE__ */ z.createContext({
  getFieldValue: Ee,
  getFieldsValue: Ee,
  getFieldError: Ee,
  getFieldWarning: Ee,
  getFieldsError: Ee,
  isFieldsTouched: Ee,
  isFieldTouched: Ee,
  isFieldValidating: Ee,
  isFieldsValidating: Ee,
  resetFields: Ee,
  setFields: Ee,
  setFieldValue: Ee,
  setFieldsValue: Ee,
  validateFields: Ee,
  submit: Ee,
  getInternalHooks: function() {
    return Ee(), {
      dispatch: Ee,
      initEntityValue: Ee,
      registerField: Ee,
      useSubscribe: Ee,
      setInitialValues: Ee,
      destroyForm: Ee,
      setCallbacks: Ee,
      registerWatch: Ee,
      getFields: Ee,
      setValidateMessages: Ee,
      setPreserve: Ee,
      getInitialValue: Ee
    };
  }
});
function g1(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function tt() {
  tt = function() {
    return e;
  };
  var e = {}, t = Object.prototype, r = t.hasOwnProperty, n = typeof Symbol == "function" ? Symbol : {}, a = n.iterator || "@@iterator", i = n.asyncIterator || "@@asyncIterator", o = n.toStringTag || "@@toStringTag";
  function l(C, j, w) {
    return Object.defineProperty(C, j, {
      value: w,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), C[j];
  }
  try {
    l({}, "");
  } catch {
    l = function(w, E, _) {
      return w[E] = _;
    };
  }
  function c(C, j, w, E) {
    var _ = j && j.prototype instanceof M ? j : M, b = Object.create(_.prototype), O = new k(E || []);
    return b._invoke = function(S, R, V) {
      var Q = "suspendedStart";
      return function(x, P) {
        if (Q === "executing")
          throw new Error("Generator is already running");
        if (Q === "completed") {
          if (x === "throw")
            throw P;
          return T();
        }
        for (V.method = x, V.arg = P; ; ) {
          var U = V.delegate;
          if (U) {
            var F = I(U, V);
            if (F) {
              if (F === d)
                continue;
              return F;
            }
          }
          if (V.method === "next")
            V.sent = V._sent = V.arg;
          else if (V.method === "throw") {
            if (Q === "suspendedStart")
              throw Q = "completed", V.arg;
            V.dispatchException(V.arg);
          } else
            V.method === "return" && V.abrupt("return", V.arg);
          Q = "executing";
          var $ = s(S, R, V);
          if ($.type === "normal") {
            if (Q = V.done ? "completed" : "suspendedYield", $.arg === d)
              continue;
            return {
              value: $.arg,
              done: V.done
            };
          }
          $.type === "throw" && (Q = "completed", V.method = "throw", V.arg = $.arg);
        }
      };
    }(C, w, O), b;
  }
  function s(C, j, w) {
    try {
      return {
        type: "normal",
        arg: C.call(j, w)
      };
    } catch (E) {
      return {
        type: "throw",
        arg: E
      };
    }
  }
  e.wrap = c;
  var d = {};
  function M() {
  }
  function f() {
  }
  function v() {
  }
  var g = {};
  l(g, a, function() {
    return this;
  });
  var m = Object.getPrototypeOf, p = m && m(m(L([])));
  p && p !== t && r.call(p, a) && (g = p);
  var h = v.prototype = M.prototype = Object.create(g);
  function y(C) {
    ["next", "throw", "return"].forEach(function(j) {
      l(C, j, function(w) {
        return this._invoke(j, w);
      });
    });
  }
  function N(C, j) {
    function w(_, b, O, S) {
      var R = s(C[_], C, b);
      if (R.type !== "throw") {
        var V = R.arg, Q = V.value;
        return Q && Ve(Q) == "object" && r.call(Q, "__await") ? j.resolve(Q.__await).then(function(x) {
          w("next", x, O, S);
        }, function(x) {
          w("throw", x, O, S);
        }) : j.resolve(Q).then(function(x) {
          V.value = x, O(V);
        }, function(x) {
          return w("throw", x, O, S);
        });
      }
      S(R.arg);
    }
    var E;
    this._invoke = function(_, b) {
      function O() {
        return new j(function(S, R) {
          w(_, b, S, R);
        });
      }
      return E = E ? E.then(O, O) : O();
    };
  }
  function I(C, j) {
    var w = C.iterator[j.method];
    if (w === void 0) {
      if (j.delegate = null, j.method === "throw") {
        if (C.iterator.return && (j.method = "return", j.arg = void 0, I(C, j), j.method === "throw"))
          return d;
        j.method = "throw", j.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return d;
    }
    var E = s(w, C.iterator, j.arg);
    if (E.type === "throw")
      return j.method = "throw", j.arg = E.arg, j.delegate = null, d;
    var _ = E.arg;
    return _ ? _.done ? (j[C.resultName] = _.value, j.next = C.nextLoc, j.method !== "return" && (j.method = "next", j.arg = void 0), j.delegate = null, d) : _ : (j.method = "throw", j.arg = new TypeError("iterator result is not an object"), j.delegate = null, d);
  }
  function D(C) {
    var j = {
      tryLoc: C[0]
    };
    1 in C && (j.catchLoc = C[1]), 2 in C && (j.finallyLoc = C[2], j.afterLoc = C[3]), this.tryEntries.push(j);
  }
  function A(C) {
    var j = C.completion || {};
    j.type = "normal", delete j.arg, C.completion = j;
  }
  function k(C) {
    this.tryEntries = [{
      tryLoc: "root"
    }], C.forEach(D, this), this.reset(!0);
  }
  function L(C) {
    if (C) {
      var j = C[a];
      if (j)
        return j.call(C);
      if (typeof C.next == "function")
        return C;
      if (!isNaN(C.length)) {
        var w = -1, E = function _() {
          for (; ++w < C.length; )
            if (r.call(C, w))
              return _.value = C[w], _.done = !1, _;
          return _.value = void 0, _.done = !0, _;
        };
        return E.next = E;
      }
    }
    return {
      next: T
    };
  }
  function T() {
    return {
      value: void 0,
      done: !0
    };
  }
  return f.prototype = v, l(h, "constructor", v), l(v, "constructor", f), f.displayName = l(v, o, "GeneratorFunction"), e.isGeneratorFunction = function(C) {
    var j = typeof C == "function" && C.constructor;
    return !!j && (j === f || (j.displayName || j.name) === "GeneratorFunction");
  }, e.mark = function(C) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(C, v) : (C.__proto__ = v, l(C, o, "GeneratorFunction")), C.prototype = Object.create(h), C;
  }, e.awrap = function(C) {
    return {
      __await: C
    };
  }, y(N.prototype), l(N.prototype, i, function() {
    return this;
  }), e.AsyncIterator = N, e.async = function(C, j, w, E, _) {
    _ === void 0 && (_ = Promise);
    var b = new N(c(C, j, w, E), _);
    return e.isGeneratorFunction(j) ? b : b.next().then(function(O) {
      return O.done ? O.value : b.next();
    });
  }, y(h), l(h, o, "Generator"), l(h, a, function() {
    return this;
  }), l(h, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(C) {
    var j = [];
    for (var w in C)
      j.push(w);
    return j.reverse(), function E() {
      for (; j.length; ) {
        var _ = j.pop();
        if (_ in C)
          return E.value = _, E.done = !1, E;
      }
      return E.done = !0, E;
    };
  }, e.values = L, k.prototype = {
    constructor: k,
    reset: function(j) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(A), !j)
        for (var w in this)
          w.charAt(0) === "t" && r.call(this, w) && !isNaN(+w.slice(1)) && (this[w] = void 0);
    },
    stop: function() {
      this.done = !0;
      var j = this.tryEntries[0].completion;
      if (j.type === "throw")
        throw j.arg;
      return this.rval;
    },
    dispatchException: function(j) {
      if (this.done)
        throw j;
      var w = this;
      function E(V, Q) {
        return O.type = "throw", O.arg = j, w.next = V, Q && (w.method = "next", w.arg = void 0), !!Q;
      }
      for (var _ = this.tryEntries.length - 1; _ >= 0; --_) {
        var b = this.tryEntries[_], O = b.completion;
        if (b.tryLoc === "root")
          return E("end");
        if (b.tryLoc <= this.prev) {
          var S = r.call(b, "catchLoc"), R = r.call(b, "finallyLoc");
          if (S && R) {
            if (this.prev < b.catchLoc)
              return E(b.catchLoc, !0);
            if (this.prev < b.finallyLoc)
              return E(b.finallyLoc);
          } else if (S) {
            if (this.prev < b.catchLoc)
              return E(b.catchLoc, !0);
          } else {
            if (!R)
              throw new Error("try statement without catch or finally");
            if (this.prev < b.finallyLoc)
              return E(b.finallyLoc);
          }
        }
      }
    },
    abrupt: function(j, w) {
      for (var E = this.tryEntries.length - 1; E >= 0; --E) {
        var _ = this.tryEntries[E];
        if (_.tryLoc <= this.prev && r.call(_, "finallyLoc") && this.prev < _.finallyLoc) {
          var b = _;
          break;
        }
      }
      b && (j === "break" || j === "continue") && b.tryLoc <= w && w <= b.finallyLoc && (b = null);
      var O = b ? b.completion : {};
      return O.type = j, O.arg = w, b ? (this.method = "next", this.next = b.finallyLoc, d) : this.complete(O);
    },
    complete: function(j, w) {
      if (j.type === "throw")
        throw j.arg;
      return j.type === "break" || j.type === "continue" ? this.next = j.arg : j.type === "return" ? (this.rval = this.arg = j.arg, this.method = "return", this.next = "end") : j.type === "normal" && w && (this.next = w), d;
    },
    finish: function(j) {
      for (var w = this.tryEntries.length - 1; w >= 0; --w) {
        var E = this.tryEntries[w];
        if (E.finallyLoc === j)
          return this.complete(E.completion, E.afterLoc), A(E), d;
      }
    },
    catch: function(j) {
      for (var w = this.tryEntries.length - 1; w >= 0; --w) {
        var E = this.tryEntries[w];
        if (E.tryLoc === j) {
          var _ = E.completion;
          if (_.type === "throw") {
            var b = _.arg;
            A(E);
          }
          return b;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(j, w, E) {
      return this.delegate = {
        iterator: L(j),
        resultName: w,
        nextLoc: E
      }, this.method === "next" && (this.arg = void 0), d;
    }
  }, e;
}
function zc(e, t, r, n, a, i, o) {
  try {
    var l = e[i](o), c = l.value;
  } catch (s) {
    r(s);
    return;
  }
  l.done ? t(c) : Promise.resolve(c).then(n, a);
}
function Ur(e) {
  return function() {
    var t = this, r = arguments;
    return new Promise(function(n, a) {
      var i = e.apply(t, r);
      function o(c) {
        zc(i, n, a, o, l, "next", c);
      }
      function l(c) {
        zc(i, n, a, o, l, "throw", c);
      }
      o(void 0);
    });
  };
}
function Or() {
  return Or = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Or.apply(this, arguments);
}
function g6(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, qn(e, t);
}
function p1(e) {
  return p1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, p1(e);
}
function qn(e, t) {
  return qn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, qn(e, t);
}
function p6() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function o0(e, t, r) {
  return p6() ? o0 = Reflect.construct.bind() : o0 = function(a, i, o) {
    var l = [null];
    l.push.apply(l, i);
    var c = Function.bind.apply(a, l), s = new c();
    return o && qn(s, o.prototype), s;
  }, o0.apply(null, arguments);
}
function h6(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function h1(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return h1 = function(n) {
    if (n === null || !h6(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(n))
        return t.get(n);
      t.set(n, a);
    }
    function a() {
      return o0(n, arguments, p1(this).constructor);
    }
    return a.prototype = Object.create(n.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), qn(a, n);
  }, h1(e);
}
var m6 = /%[sdj%]/g, js = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (js = function(t, r) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && r.every(function(n) {
    return typeof n == "string";
  }) && console.warn(t, r);
});
function m1(e) {
  if (!e || !e.length)
    return null;
  var t = {};
  return e.forEach(function(r) {
    var n = r.field;
    t[n] = t[n] || [], t[n].push(r);
  }), t;
}
function Mt(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var a = 0, i = r.length;
  if (typeof e == "function")
    return e.apply(null, r);
  if (typeof e == "string") {
    var o = e.replace(m6, function(l) {
      if (l === "%%")
        return "%";
      if (a >= i)
        return l;
      switch (l) {
        case "%s":
          return String(r[a++]);
        case "%d":
          return Number(r[a++]);
        case "%j":
          try {
            return JSON.stringify(r[a++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return l;
      }
    });
    return o;
  }
  return e;
}
function y6(e) {
  return e === "string" || e === "url" || e === "hex" || e === "email" || e === "date" || e === "pattern";
}
function $e(e, t) {
  return !!(e == null || t === "array" && Array.isArray(e) && !e.length || y6(t) && typeof e == "string" && !e);
}
function N6(e, t, r) {
  var n = [], a = 0, i = e.length;
  function o(l) {
    n.push.apply(n, l || []), a++, a === i && r(n);
  }
  e.forEach(function(l) {
    t(l, o);
  });
}
function _c(e, t, r) {
  var n = 0, a = e.length;
  function i(o) {
    if (o && o.length) {
      r(o);
      return;
    }
    var l = n;
    n = n + 1, l < a ? t(e[l], i) : r([]);
  }
  i([]);
}
function z6(e) {
  var t = [];
  return Object.keys(e).forEach(function(r) {
    t.push.apply(t, e[r] || []);
  }), t;
}
var Ic = /* @__PURE__ */ function(e) {
  g6(t, e);
  function t(r, n) {
    var a;
    return a = e.call(this, "Async Validation Error") || this, a.errors = r, a.fields = n, a;
  }
  return t;
}(/* @__PURE__ */ h1(Error));
function _6(e, t, r, n, a) {
  if (t.first) {
    var i = new Promise(function(f, v) {
      var g = function(h) {
        return n(h), h.length ? v(new Ic(h, m1(h))) : f(a);
      }, m = z6(e);
      _c(m, r, g);
    });
    return i.catch(function(f) {
      return f;
    }), i;
  }
  var o = t.firstFields === !0 ? Object.keys(e) : t.firstFields || [], l = Object.keys(e), c = l.length, s = 0, d = [], M = new Promise(function(f, v) {
    var g = function(p) {
      if (d.push.apply(d, p), s++, s === c)
        return n(d), d.length ? v(new Ic(d, m1(d))) : f(a);
    };
    l.length || (n(d), f(a)), l.forEach(function(m) {
      var p = e[m];
      o.indexOf(m) !== -1 ? _c(p, r, g) : N6(p, r, g);
    });
  });
  return M.catch(function(f) {
    return f;
  }), M;
}
function I6(e) {
  return !!(e && e.message !== void 0);
}
function D6(e, t) {
  for (var r = e, n = 0; n < t.length; n++) {
    if (r == null)
      return r;
    r = r[t[n]];
  }
  return r;
}
function Dc(e, t) {
  return function(r) {
    var n;
    return e.fullFields ? n = D6(t, e.fullFields) : n = t[r.field || e.fullField], I6(r) ? (r.field = r.field || e.fullField, r.fieldValue = n, r) : {
      message: typeof r == "function" ? r() : r,
      fieldValue: n,
      field: r.field || e.fullField
    };
  };
}
function Cc(e, t) {
  if (t) {
    for (var r in t)
      if (t.hasOwnProperty(r)) {
        var n = t[r];
        typeof n == "object" && typeof e[r] == "object" ? e[r] = Or({}, e[r], n) : e[r] = n;
      }
  }
  return e;
}
var xs = function(t, r, n, a, i, o) {
  t.required && (!n.hasOwnProperty(t.field) || $e(r, o || t.type)) && a.push(Mt(i.messages.required, t.fullField));
}, C6 = function(t, r, n, a, i) {
  (/^\s+$/.test(r) || r === "") && a.push(Mt(i.messages.whitespace, t.fullField));
}, Ca, E6 = function() {
  if (Ca)
    return Ca;
  var e = "[a-fA-F\\d:]", t = function(I) {
    return I && I.includeBoundaries ? "(?:(?<=\\s|^)(?=" + e + ")|(?<=" + e + ")(?=\\s|$))" : "";
  }, r = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", n = "[a-fA-F\\d]{1,4}", a = (`
(?:
(?:` + n + ":){7}(?:" + n + `|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:` + n + ":){6}(?:" + r + "|:" + n + `|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:` + n + ":){5}(?::" + r + "|(?::" + n + `){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:` + n + ":){4}(?:(?::" + n + "){0,1}:" + r + "|(?::" + n + `){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:` + n + ":){3}(?:(?::" + n + "){0,2}:" + r + "|(?::" + n + `){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:` + n + ":){2}(?:(?::" + n + "){0,3}:" + r + "|(?::" + n + `){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:` + n + ":){1}(?:(?::" + n + "){0,4}:" + r + "|(?::" + n + `){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::` + n + "){0,5}:" + r + "|(?::" + n + `){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`).replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), i = new RegExp("(?:^" + r + "$)|(?:^" + a + "$)"), o = new RegExp("^" + r + "$"), l = new RegExp("^" + a + "$"), c = function(I) {
    return I && I.exact ? i : new RegExp("(?:" + t(I) + r + t(I) + ")|(?:" + t(I) + a + t(I) + ")", "g");
  };
  c.v4 = function(N) {
    return N && N.exact ? o : new RegExp("" + t(N) + r + t(N), "g");
  }, c.v6 = function(N) {
    return N && N.exact ? l : new RegExp("" + t(N) + a + t(N), "g");
  };
  var s = "(?:(?:[a-z]+:)?//)", d = "(?:\\S+(?::\\S*)?@)?", M = c.v4().source, f = c.v6().source, v = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", g = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", m = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", p = "(?::\\d{2,5})?", h = '(?:[/?#][^\\s"]*)?', y = "(?:" + s + "|www\\.)" + d + "(?:localhost|" + M + "|" + f + "|" + v + g + m + ")" + p + h;
  return Ca = new RegExp("(?:^" + y + "$)", "i"), Ca;
}, Ec = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, Rn = {
  integer: function(t) {
    return Rn.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return Rn.number(t) && !Rn.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return typeof t == "object" && !Rn.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(Ec.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(E6());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(Ec.hex);
  }
}, b6 = function(t, r, n, a, i) {
  if (t.required && r === void 0) {
    xs(t, r, n, a, i);
    return;
  }
  var o = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], l = t.type;
  o.indexOf(l) > -1 ? Rn[l](r) || a.push(Mt(i.messages.types[l], t.fullField, t.type)) : l && typeof r !== t.type && a.push(Mt(i.messages.types[l], t.fullField, t.type));
}, A6 = function(t, r, n, a, i) {
  var o = typeof t.len == "number", l = typeof t.min == "number", c = typeof t.max == "number", s = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, d = r, M = null, f = typeof r == "number", v = typeof r == "string", g = Array.isArray(r);
  if (f ? M = "number" : v ? M = "string" : g && (M = "array"), !M)
    return !1;
  g && (d = r.length), v && (d = r.replace(s, "_").length), o ? d !== t.len && a.push(Mt(i.messages[M].len, t.fullField, t.len)) : l && !c && d < t.min ? a.push(Mt(i.messages[M].min, t.fullField, t.min)) : c && !l && d > t.max ? a.push(Mt(i.messages[M].max, t.fullField, t.max)) : l && c && (d < t.min || d > t.max) && a.push(Mt(i.messages[M].range, t.fullField, t.min, t.max));
}, Yr = "enum", j6 = function(t, r, n, a, i) {
  t[Yr] = Array.isArray(t[Yr]) ? t[Yr] : [], t[Yr].indexOf(r) === -1 && a.push(Mt(i.messages[Yr], t.fullField, t[Yr].join(", ")));
}, x6 = function(t, r, n, a, i) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(r) || a.push(Mt(i.messages.pattern.mismatch, t.fullField, r, t.pattern));
    else if (typeof t.pattern == "string") {
      var o = new RegExp(t.pattern);
      o.test(r) || a.push(Mt(i.messages.pattern.mismatch, t.fullField, r, t.pattern));
    }
  }
}, ge = {
  required: xs,
  whitespace: C6,
  type: b6,
  range: A6,
  enum: j6,
  pattern: x6
}, w6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r, "string") && !t.required)
      return n();
    ge.required(t, r, a, o, i, "string"), $e(r, "string") || (ge.type(t, r, a, o, i), ge.range(t, r, a, o, i), ge.pattern(t, r, a, o, i), t.whitespace === !0 && ge.whitespace(t, r, a, o, i));
  }
  n(o);
}, O6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r) && !t.required)
      return n();
    ge.required(t, r, a, o, i), r !== void 0 && ge.type(t, r, a, o, i);
  }
  n(o);
}, T6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if (r === "" && (r = void 0), $e(r) && !t.required)
      return n();
    ge.required(t, r, a, o, i), r !== void 0 && (ge.type(t, r, a, o, i), ge.range(t, r, a, o, i));
  }
  n(o);
}, S6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r) && !t.required)
      return n();
    ge.required(t, r, a, o, i), r !== void 0 && ge.type(t, r, a, o, i);
  }
  n(o);
}, L6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r) && !t.required)
      return n();
    ge.required(t, r, a, o, i), $e(r) || ge.type(t, r, a, o, i);
  }
  n(o);
}, k6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r) && !t.required)
      return n();
    ge.required(t, r, a, o, i), r !== void 0 && (ge.type(t, r, a, o, i), ge.range(t, r, a, o, i));
  }
  n(o);
}, P6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r) && !t.required)
      return n();
    ge.required(t, r, a, o, i), r !== void 0 && (ge.type(t, r, a, o, i), ge.range(t, r, a, o, i));
  }
  n(o);
}, R6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if (r == null && !t.required)
      return n();
    ge.required(t, r, a, o, i, "array"), r != null && (ge.type(t, r, a, o, i), ge.range(t, r, a, o, i));
  }
  n(o);
}, Q6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r) && !t.required)
      return n();
    ge.required(t, r, a, o, i), r !== void 0 && ge.type(t, r, a, o, i);
  }
  n(o);
}, V6 = "enum", U6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r) && !t.required)
      return n();
    ge.required(t, r, a, o, i), r !== void 0 && ge[V6](t, r, a, o, i);
  }
  n(o);
}, F6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r, "string") && !t.required)
      return n();
    ge.required(t, r, a, o, i), $e(r, "string") || ge.pattern(t, r, a, o, i);
  }
  n(o);
}, $6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r, "date") && !t.required)
      return n();
    if (ge.required(t, r, a, o, i), !$e(r, "date")) {
      var c;
      r instanceof Date ? c = r : c = new Date(r), ge.type(t, c, a, o, i), c && ge.range(t, c.getTime(), a, o, i);
    }
  }
  n(o);
}, Z6 = function(t, r, n, a, i) {
  var o = [], l = Array.isArray(r) ? "array" : typeof r;
  ge.required(t, r, a, o, i, l), n(o);
}, ji = function(t, r, n, a, i) {
  var o = t.type, l = [], c = t.required || !t.required && a.hasOwnProperty(t.field);
  if (c) {
    if ($e(r, o) && !t.required)
      return n();
    ge.required(t, r, a, l, i, o), $e(r, o) || ge.type(t, r, a, l, i);
  }
  n(l);
}, Y6 = function(t, r, n, a, i) {
  var o = [], l = t.required || !t.required && a.hasOwnProperty(t.field);
  if (l) {
    if ($e(r) && !t.required)
      return n();
    ge.required(t, r, a, o, i);
  }
  n(o);
}, $n = {
  string: w6,
  method: O6,
  number: T6,
  boolean: S6,
  regexp: L6,
  integer: k6,
  float: P6,
  array: R6,
  object: Q6,
  enum: U6,
  pattern: F6,
  date: $6,
  url: ji,
  hex: ji,
  email: ji,
  required: Z6,
  any: Y6
};
function y1() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var N1 = y1(), da = /* @__PURE__ */ function() {
  function e(r) {
    this.rules = null, this._messages = N1, this.define(r);
  }
  var t = e.prototype;
  return t.define = function(n) {
    var a = this;
    if (!n)
      throw new Error("Cannot configure a schema with no rules");
    if (typeof n != "object" || Array.isArray(n))
      throw new Error("Rules must be an object");
    this.rules = {}, Object.keys(n).forEach(function(i) {
      var o = n[i];
      a.rules[i] = Array.isArray(o) ? o : [o];
    });
  }, t.messages = function(n) {
    return n && (this._messages = Cc(y1(), n)), this._messages;
  }, t.validate = function(n, a, i) {
    var o = this;
    a === void 0 && (a = {}), i === void 0 && (i = function() {
    });
    var l = n, c = a, s = i;
    if (typeof c == "function" && (s = c, c = {}), !this.rules || Object.keys(this.rules).length === 0)
      return s && s(null, l), Promise.resolve(l);
    function d(m) {
      var p = [], h = {};
      function y(I) {
        if (Array.isArray(I)) {
          var D;
          p = (D = p).concat.apply(D, I);
        } else
          p.push(I);
      }
      for (var N = 0; N < m.length; N++)
        y(m[N]);
      p.length ? (h = m1(p), s(p, h)) : s(null, l);
    }
    if (c.messages) {
      var M = this.messages();
      M === N1 && (M = y1()), Cc(M, c.messages), c.messages = M;
    } else
      c.messages = this.messages();
    var f = {}, v = c.keys || Object.keys(this.rules);
    v.forEach(function(m) {
      var p = o.rules[m], h = l[m];
      p.forEach(function(y) {
        var N = y;
        typeof N.transform == "function" && (l === n && (l = Or({}, l)), h = l[m] = N.transform(h)), typeof N == "function" ? N = {
          validator: N
        } : N = Or({}, N), N.validator = o.getValidationMethod(N), N.validator && (N.field = m, N.fullField = N.fullField || m, N.type = o.getType(N), f[m] = f[m] || [], f[m].push({
          rule: N,
          value: h,
          source: l,
          field: m
        }));
      });
    });
    var g = {};
    return _6(f, c, function(m, p) {
      var h = m.rule, y = (h.type === "object" || h.type === "array") && (typeof h.fields == "object" || typeof h.defaultField == "object");
      y = y && (h.required || !h.required && m.value), h.field = m.field;
      function N(A, k) {
        return Or({}, k, {
          fullField: h.fullField + "." + A,
          fullFields: h.fullFields ? [].concat(h.fullFields, [A]) : [A]
        });
      }
      function I(A) {
        A === void 0 && (A = []);
        var k = Array.isArray(A) ? A : [A];
        !c.suppressWarning && k.length && e.warning("async-validator:", k), k.length && h.message !== void 0 && (k = [].concat(h.message));
        var L = k.map(Dc(h, l));
        if (c.first && L.length)
          return g[h.field] = 1, p(L);
        if (!y)
          p(L);
        else {
          if (h.required && !m.value)
            return h.message !== void 0 ? L = [].concat(h.message).map(Dc(h, l)) : c.error && (L = [c.error(h, Mt(c.messages.required, h.field))]), p(L);
          var T = {};
          h.defaultField && Object.keys(m.value).map(function(w) {
            T[w] = h.defaultField;
          }), T = Or({}, T, m.rule.fields);
          var C = {};
          Object.keys(T).forEach(function(w) {
            var E = T[w], _ = Array.isArray(E) ? E : [E];
            C[w] = _.map(N.bind(null, w));
          });
          var j = new e(C);
          j.messages(c.messages), m.rule.options && (m.rule.options.messages = c.messages, m.rule.options.error = c.error), j.validate(m.value, m.rule.options || c, function(w) {
            var E = [];
            L && L.length && E.push.apply(E, L), w && w.length && E.push.apply(E, w), p(E.length ? E : null);
          });
        }
      }
      var D;
      if (h.asyncValidator)
        D = h.asyncValidator(h, m.value, I, m.source, c);
      else if (h.validator) {
        try {
          D = h.validator(h, m.value, I, m.source, c);
        } catch (A) {
          console.error == null || console.error(A), c.suppressValidatorError || setTimeout(function() {
            throw A;
          }, 0), I(A.message);
        }
        D === !0 ? I() : D === !1 ? I(typeof h.message == "function" ? h.message(h.fullField || h.field) : h.message || (h.fullField || h.field) + " fails") : D instanceof Array ? I(D) : D instanceof Error && I(D.message);
      }
      D && D.then && D.then(function() {
        return I();
      }, function(A) {
        return I(A);
      });
    }, function(m) {
      d(m);
    }, l);
  }, t.getType = function(n) {
    if (n.type === void 0 && n.pattern instanceof RegExp && (n.type = "pattern"), typeof n.validator != "function" && n.type && !$n.hasOwnProperty(n.type))
      throw new Error(Mt("Unknown rule type %s", n.type));
    return n.type || "string";
  }, t.getValidationMethod = function(n) {
    if (typeof n.validator == "function")
      return n.validator;
    var a = Object.keys(n), i = a.indexOf("message");
    return i !== -1 && a.splice(i, 1), a.length === 1 && a[0] === "required" ? $n.required : $n[this.getType(n)] || void 0;
  }, e;
}();
da.register = function(t, r) {
  if (typeof r != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  $n[t] = r;
};
da.warning = js;
da.messages = N1;
da.validators = $n;
var dt = "'${name}' is not a valid ${type}", ws = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: dt,
    method: dt,
    array: dt,
    object: dt,
    number: dt,
    date: dt,
    boolean: dt,
    integer: dt,
    float: dt,
    regexp: dt,
    email: dt,
    url: dt,
    hex: dt
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};
function Os(e, t) {
  for (var r = e, n = 0; n < t.length; n += 1) {
    if (r == null)
      return;
    r = r[t[n]];
  }
  return r;
}
function H6(e) {
  return cs(e) || Es(e) || jo(e) || us();
}
function Ts(e, t, r, n) {
  if (!t.length)
    return r;
  var a = H6(t), i = a[0], o = a.slice(1), l;
  return !e && typeof i == "number" ? l = [] : Array.isArray(e) ? l = Me(e) : l = H({}, e), n && r === void 0 && o.length === 1 ? delete l[i][o[0]] : l[i] = Ts(l[i], o, r, n), l;
}
function W6(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  return t.length && n && r === void 0 && !Os(e, t.slice(0, -1)) ? e : Ts(e, t, r, n);
}
function S0(e) {
  return Array.isArray(e) ? q6(e) : Ve(e) === "object" && e !== null ? B6(e) : e;
}
function B6(e) {
  if (Object.getPrototypeOf(e) === Object.prototype) {
    var t = {};
    for (var r in e)
      t[r] = S0(e[r]);
    return t;
  }
  return e;
}
function q6(e) {
  return e.map(function(t) {
    return S0(t);
  });
}
function Re(e) {
  return g1(e);
}
function Mr(e, t) {
  var r = Os(e, t);
  return r;
}
function fr(e, t, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, a = W6(e, t, r, n);
  return a;
}
function bc(e, t) {
  var r = {};
  return t.forEach(function(n) {
    var a = Mr(e, n);
    r = fr(r, n, a);
  }), r;
}
function Zn(e, t) {
  return e && e.some(function(r) {
    return Ls(r, t);
  });
}
function Ac(e) {
  return Ve(e) === "object" && e !== null && Object.getPrototypeOf(e) === Object.prototype;
}
function Ss(e, t) {
  var r = Array.isArray(e) ? Me(e) : H({}, e);
  return t && Object.keys(t).forEach(function(n) {
    var a = r[n], i = t[n], o = Ac(a) && Ac(i);
    r[n] = o ? Ss(a, i || {}) : S0(i);
  }), r;
}
function l0(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return r.reduce(function(a, i) {
    return Ss(a, i);
  }, e);
}
function Ls(e, t) {
  return !e || !t || e.length !== t.length ? !1 : e.every(function(r, n) {
    return t[n] === r;
  });
}
function G6(e, t) {
  if (e === t)
    return !0;
  if (!e && t || e && !t || !e || !t || Ve(e) !== "object" || Ve(t) !== "object")
    return !1;
  var r = Object.keys(e), n = Object.keys(t), a = new Set([].concat(r, n));
  return Me(a).every(function(i) {
    var o = e[i], l = t[i];
    return typeof o == "function" && typeof l == "function" ? !0 : o === l;
  });
}
function K6(e) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && Ve(t.target) === "object" && e in t.target ? t.target[e] : t;
}
function jc(e, t, r) {
  var n = e.length;
  if (t < 0 || t >= n || r < 0 || r >= n)
    return e;
  var a = e[t], i = t - r;
  return i > 0 ? [].concat(Me(e.slice(0, r)), [a], Me(e.slice(r, t)), Me(e.slice(t + 1, n))) : i < 0 ? [].concat(Me(e.slice(0, t)), Me(e.slice(t + 1, r + 1)), [a], Me(e.slice(r + 1, n))) : e;
}
var X6 = da;
function J6(e, t) {
  return e.replace(/\$\{\w+\}/g, function(r) {
    var n = r.slice(2, -1);
    return t[n];
  });
}
var xc = "CODE_LOGIC_ERROR";
function z1(e, t, r, n, a) {
  return _1.apply(this, arguments);
}
function _1() {
  return _1 = Ur(/* @__PURE__ */ tt().mark(function e(t, r, n, a, i) {
    var o, l, c, s, d, M, f, v, g;
    return tt().wrap(function(p) {
      for (; ; )
        switch (p.prev = p.next) {
          case 0:
            return o = H({}, n), delete o.ruleIndex, o.validator && (l = o.validator, o.validator = function() {
              try {
                return l.apply(void 0, arguments);
              } catch (h) {
                return console.error(h), Promise.reject(xc);
              }
            }), c = null, o && o.type === "array" && o.defaultField && (c = o.defaultField, delete o.defaultField), s = new X6(je({}, t, [o])), d = l0({}, ws, a.validateMessages), s.messages(d), M = [], p.prev = 9, p.next = 12, Promise.resolve(s.validate(je({}, t, r), H({}, a)));
          case 12:
            p.next = 17;
            break;
          case 14:
            p.prev = 14, p.t0 = p.catch(9), p.t0.errors && (M = p.t0.errors.map(function(h, y) {
              var N = h.message, I = N === xc ? d.default : N;
              return /* @__PURE__ */ z.isValidElement(I) ? /* @__PURE__ */ z.cloneElement(I, {
                key: "error_".concat(y)
              }) : I;
            }));
          case 17:
            if (!(!M.length && c)) {
              p.next = 22;
              break;
            }
            return p.next = 20, Promise.all(r.map(function(h, y) {
              return z1("".concat(t, ".").concat(y), h, c, a, i);
            }));
          case 20:
            return f = p.sent, p.abrupt("return", f.reduce(function(h, y) {
              return [].concat(Me(h), Me(y));
            }, []));
          case 22:
            return v = H(H({}, n), {}, {
              name: t,
              enum: (n.enum || []).join(", ")
            }, i), g = M.map(function(h) {
              return typeof h == "string" ? J6(h, v) : h;
            }), p.abrupt("return", g);
          case 25:
          case "end":
            return p.stop();
        }
    }, e, null, [[9, 14]]);
  })), _1.apply(this, arguments);
}
function ev(e, t, r, n, a, i) {
  var o = e.join("."), l = r.map(function(d, M) {
    var f = d.validator, v = H(H({}, d), {}, {
      ruleIndex: M
    });
    return f && (v.validator = function(g, m, p) {
      var h = !1, y = function() {
        for (var D = arguments.length, A = new Array(D), k = 0; k < D; k++)
          A[k] = arguments[k];
        Promise.resolve().then(function() {
          vt(!h, "Your validator function has already return a promise. `callback` will be ignored."), h || p.apply(void 0, A);
        });
      }, N = f(g, m, y);
      h = N && typeof N.then == "function" && typeof N.catch == "function", vt(h, "`callback` is deprecated. Please return a promise instead."), h && N.then(function() {
        p();
      }).catch(function(I) {
        p(I || " ");
      });
    }), v;
  }).sort(function(d, M) {
    var f = d.warningOnly, v = d.ruleIndex, g = M.warningOnly, m = M.ruleIndex;
    return !!f == !!g ? v - m : f ? 1 : -1;
  }), c;
  if (a === !0)
    c = new Promise(/* @__PURE__ */ function() {
      var d = Ur(/* @__PURE__ */ tt().mark(function M(f, v) {
        var g, m, p;
        return tt().wrap(function(y) {
          for (; ; )
            switch (y.prev = y.next) {
              case 0:
                g = 0;
              case 1:
                if (!(g < l.length)) {
                  y.next = 12;
                  break;
                }
                return m = l[g], y.next = 5, z1(o, t, m, n, i);
              case 5:
                if (p = y.sent, !p.length) {
                  y.next = 9;
                  break;
                }
                return v([{
                  errors: p,
                  rule: m
                }]), y.abrupt("return");
              case 9:
                g += 1, y.next = 1;
                break;
              case 12:
                f([]);
              case 13:
              case "end":
                return y.stop();
            }
        }, M);
      }));
      return function(M, f) {
        return d.apply(this, arguments);
      };
    }());
  else {
    var s = l.map(function(d) {
      return z1(o, t, d, n, i).then(function(M) {
        return {
          errors: M,
          rule: d
        };
      });
    });
    c = (a ? rv(s) : tv(s)).then(function(d) {
      return Promise.reject(d);
    });
  }
  return c.catch(function(d) {
    return d;
  }), c;
}
function tv(e) {
  return I1.apply(this, arguments);
}
function I1() {
  return I1 = Ur(/* @__PURE__ */ tt().mark(function e(t) {
    return tt().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            return n.abrupt("return", Promise.all(t).then(function(a) {
              var i, o = (i = []).concat.apply(i, Me(a));
              return o;
            }));
          case 1:
          case "end":
            return n.stop();
        }
    }, e);
  })), I1.apply(this, arguments);
}
function rv(e) {
  return D1.apply(this, arguments);
}
function D1() {
  return D1 = Ur(/* @__PURE__ */ tt().mark(function e(t) {
    var r;
    return tt().wrap(function(a) {
      for (; ; )
        switch (a.prev = a.next) {
          case 0:
            return r = 0, a.abrupt("return", new Promise(function(i) {
              t.forEach(function(o) {
                o.then(function(l) {
                  l.errors.length && i([l]), r += 1, r === t.length && i([]);
                });
              });
            }));
          case 2:
          case "end":
            return a.stop();
        }
    }, e);
  })), D1.apply(this, arguments);
}
var nv = ["name"], Nt = [];
function wc(e, t, r, n, a, i) {
  return typeof e == "function" ? e(t, r, "source" in i ? {
    source: i.source
  } : {}) : n !== a;
}
var ko = /* @__PURE__ */ function(e) {
  Nr(r, e);
  var t = zr(r);
  function r(n) {
    var a;
    if (Bt(this, r), a = t.call(this, n), a.state = {
      resetCount: 0
    }, a.cancelRegisterFunc = null, a.mounted = !1, a.touched = !1, a.dirty = !1, a.validatePromise = null, a.prevValidating = void 0, a.errors = Nt, a.warnings = Nt, a.cancelRegister = function() {
      var c = a.props, s = c.preserve, d = c.isListField, M = c.name;
      a.cancelRegisterFunc && a.cancelRegisterFunc(d, s, Re(M)), a.cancelRegisterFunc = null;
    }, a.getNamePath = function() {
      var c = a.props, s = c.name, d = c.fieldContext, M = d.prefixName, f = M === void 0 ? [] : M;
      return s !== void 0 ? [].concat(Me(f), Me(s)) : [];
    }, a.getRules = function() {
      var c = a.props, s = c.rules, d = s === void 0 ? [] : s, M = c.fieldContext;
      return d.map(function(f) {
        return typeof f == "function" ? f(M) : f;
      });
    }, a.refresh = function() {
      !a.mounted || a.setState(function(c) {
        var s = c.resetCount;
        return {
          resetCount: s + 1
        };
      });
    }, a.triggerMetaEvent = function(c) {
      var s = a.props.onMetaChange;
      s == null || s(H(H({}, a.getMeta()), {}, {
        destroy: c
      }));
    }, a.onStoreChange = function(c, s, d) {
      var M = a.props, f = M.shouldUpdate, v = M.dependencies, g = v === void 0 ? [] : v, m = M.onReset, p = d.store, h = a.getNamePath(), y = a.getValue(c), N = a.getValue(p), I = s && Zn(s, h);
      switch (d.type === "valueUpdate" && d.source === "external" && y !== N && (a.touched = !0, a.dirty = !0, a.validatePromise = null, a.errors = Nt, a.warnings = Nt, a.triggerMetaEvent()), d.type) {
        case "reset":
          if (!s || I) {
            a.touched = !1, a.dirty = !1, a.validatePromise = null, a.errors = Nt, a.warnings = Nt, a.triggerMetaEvent(), m == null || m(), a.refresh();
            return;
          }
          break;
        case "remove": {
          if (f) {
            a.reRender();
            return;
          }
          break;
        }
        case "setField": {
          if (I) {
            var D = d.data;
            "touched" in D && (a.touched = D.touched), "validating" in D && !("originRCField" in D) && (a.validatePromise = D.validating ? Promise.resolve([]) : null), "errors" in D && (a.errors = D.errors || Nt), "warnings" in D && (a.warnings = D.warnings || Nt), a.dirty = !0, a.triggerMetaEvent(), a.reRender();
            return;
          }
          if (f && !h.length && wc(f, c, p, y, N, d)) {
            a.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var A = g.map(Re);
          if (A.some(function(k) {
            return Zn(d.relatedFields, k);
          })) {
            a.reRender();
            return;
          }
          break;
        }
        default:
          if (I || (!g.length || h.length || f) && wc(f, c, p, y, N, d)) {
            a.reRender();
            return;
          }
          break;
      }
      f === !0 && a.reRender();
    }, a.validateRules = function(c) {
      var s = a.getNamePath(), d = a.getValue(), M = Promise.resolve().then(function() {
        if (!a.mounted)
          return [];
        var f = a.props, v = f.validateFirst, g = v === void 0 ? !1 : v, m = f.messageVariables, p = c || {}, h = p.triggerName, y = a.getRules();
        h && (y = y.filter(function(I) {
          var D = I.validateTrigger;
          if (!D)
            return !0;
          var A = g1(D);
          return A.includes(h);
        }));
        var N = ev(s, d, y, c, g, m);
        return N.catch(function(I) {
          return I;
        }).then(function() {
          var I = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Nt;
          if (a.validatePromise === M) {
            var D;
            a.validatePromise = null;
            var A = [], k = [];
            (D = I.forEach) === null || D === void 0 || D.call(I, function(L) {
              var T = L.rule.warningOnly, C = L.errors, j = C === void 0 ? Nt : C;
              T ? k.push.apply(k, Me(j)) : A.push.apply(A, Me(j));
            }), a.errors = A, a.warnings = k, a.triggerMetaEvent(), a.reRender();
          }
        }), N;
      });
      return a.validatePromise = M, a.dirty = !0, a.errors = Nt, a.warnings = Nt, a.triggerMetaEvent(), a.reRender(), M;
    }, a.isFieldValidating = function() {
      return !!a.validatePromise;
    }, a.isFieldTouched = function() {
      return a.touched;
    }, a.isFieldDirty = function() {
      if (a.dirty || a.props.initialValue !== void 0)
        return !0;
      var c = a.props.fieldContext, s = c.getInternalHooks(wr), d = s.getInitialValue;
      return d(a.getNamePath()) !== void 0;
    }, a.getErrors = function() {
      return a.errors;
    }, a.getWarnings = function() {
      return a.warnings;
    }, a.isListField = function() {
      return a.props.isListField;
    }, a.isList = function() {
      return a.props.isList;
    }, a.isPreserve = function() {
      return a.props.preserve;
    }, a.getMeta = function() {
      a.prevValidating = a.isFieldValidating();
      var c = {
        touched: a.isFieldTouched(),
        validating: a.prevValidating,
        errors: a.errors,
        warnings: a.warnings,
        name: a.getNamePath()
      };
      return c;
    }, a.getOnlyChild = function(c) {
      if (typeof c == "function") {
        var s = a.getMeta();
        return H(H({}, a.getOnlyChild(c(a.getControlled(), s, a.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var d = y0(c);
      return d.length !== 1 || !/* @__PURE__ */ z.isValidElement(d[0]) ? {
        child: d,
        isFunction: !1
      } : {
        child: d[0],
        isFunction: !1
      };
    }, a.getValue = function(c) {
      var s = a.props.fieldContext.getFieldsValue, d = a.getNamePath();
      return Mr(c || s(!0), d);
    }, a.getControlled = function() {
      var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = a.props, d = s.trigger, M = s.validateTrigger, f = s.getValueFromEvent, v = s.normalize, g = s.valuePropName, m = s.getValueProps, p = s.fieldContext, h = M !== void 0 ? M : p.validateTrigger, y = a.getNamePath(), N = p.getInternalHooks, I = p.getFieldsValue, D = N(wr), A = D.dispatch, k = a.getValue(), L = m || function(w) {
        return je({}, g, w);
      }, T = c[d], C = H(H({}, c), L(k));
      C[d] = function() {
        a.touched = !0, a.dirty = !0, a.triggerMetaEvent();
        for (var w, E = arguments.length, _ = new Array(E), b = 0; b < E; b++)
          _[b] = arguments[b];
        f ? w = f.apply(void 0, _) : w = K6.apply(void 0, [g].concat(_)), v && (w = v(w, k, I(!0))), A({
          type: "updateValue",
          namePath: y,
          value: w
        }), T && T.apply(void 0, _);
      };
      var j = g1(h || []);
      return j.forEach(function(w) {
        var E = C[w];
        C[w] = function() {
          E && E.apply(void 0, arguments);
          var _ = a.props.rules;
          _ && _.length && A({
            type: "validateField",
            namePath: y,
            triggerName: w
          });
        };
      }), C;
    }, n.fieldContext) {
      var i = n.fieldContext.getInternalHooks, o = i(wr), l = o.initEntityValue;
      l(Lo(a));
    }
    return a;
  }
  return qt(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.shouldUpdate, o = a.fieldContext;
      if (this.mounted = !0, o) {
        var l = o.getInternalHooks, c = l(wr), s = c.registerField;
        this.cancelRegisterFunc = s(this);
      }
      i === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      !this.mounted || this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var a = this.state.resetCount, i = this.props.children, o = this.getOnlyChild(i), l = o.child, c = o.isFunction, s;
      return c ? s = l : /* @__PURE__ */ z.isValidElement(l) ? s = /* @__PURE__ */ z.cloneElement(l, this.getControlled(l.props)) : (vt(!l, "`children` of Field is not validate ReactElement."), s = l), /* @__PURE__ */ z.createElement(z.Fragment, {
        key: a
      }, s);
    }
  }]), r;
}(z.Component);
ko.contextType = Pr;
ko.defaultProps = {
  trigger: "onChange",
  valuePropName: "value"
};
function Po(e) {
  var t = e.name, r = Wt(e, nv), n = z.useContext(Pr), a = t !== void 0 ? Re(t) : void 0, i = "keep";
  return r.isListField || (i = "_".concat((a || []).join("_"))), process.env.NODE_ENV !== "production" && r.preserve === !1 && r.isListField && a.length <= 1 && vt(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ z.createElement(ko, Pe({
    key: i,
    name: a
  }, r, {
    fieldContext: n
  }));
}
var ks = /* @__PURE__ */ z.createContext(null), Ps = function(t) {
  var r = t.name, n = t.initialValue, a = t.children, i = t.rules, o = t.validateTrigger, l = z.useContext(Pr), c = z.useRef({
    keys: [],
    id: 0
  }), s = c.current, d = z.useMemo(function() {
    var g = Re(l.prefixName) || [];
    return [].concat(Me(g), Me(Re(r)));
  }, [l.prefixName, r]), M = z.useMemo(function() {
    return H(H({}, l), {}, {
      prefixName: d
    });
  }, [l, d]), f = z.useMemo(function() {
    return {
      getKey: function(m) {
        var p = d.length, h = m[p];
        return [s.keys[h], m.slice(p + 1)];
      }
    };
  }, [d]);
  if (typeof a != "function")
    return vt(!1, "Form.List only accepts function as children."), null;
  var v = function(m, p, h) {
    var y = h.source;
    return y === "internal" ? !1 : m !== p;
  };
  return /* @__PURE__ */ z.createElement(ks.Provider, {
    value: f
  }, /* @__PURE__ */ z.createElement(Pr.Provider, {
    value: M
  }, /* @__PURE__ */ z.createElement(Po, {
    name: [],
    shouldUpdate: v,
    rules: i,
    validateTrigger: o,
    initialValue: n,
    isList: !0
  }, function(g, m) {
    var p = g.value, h = p === void 0 ? [] : p, y = g.onChange, N = l.getFieldValue, I = function() {
      var L = N(d || []);
      return L || [];
    }, D = {
      add: function(L, T) {
        var C = I();
        T >= 0 && T <= C.length ? (s.keys = [].concat(Me(s.keys.slice(0, T)), [s.id], Me(s.keys.slice(T))), y([].concat(Me(C.slice(0, T)), [L], Me(C.slice(T))))) : (process.env.NODE_ENV !== "production" && (T < 0 || T > C.length) && vt(!1, "The second parameter of the add function should be a valid positive number."), s.keys = [].concat(Me(s.keys), [s.id]), y([].concat(Me(C), [L]))), s.id += 1;
      },
      remove: function(L) {
        var T = I(), C = new Set(Array.isArray(L) ? L : [L]);
        C.size <= 0 || (s.keys = s.keys.filter(function(j, w) {
          return !C.has(w);
        }), y(T.filter(function(j, w) {
          return !C.has(w);
        })));
      },
      move: function(L, T) {
        if (L !== T) {
          var C = I();
          L < 0 || L >= C.length || T < 0 || T >= C.length || (s.keys = jc(s.keys, L, T), y(jc(C, L, T)));
        }
      }
    }, A = h || [];
    return Array.isArray(A) || (A = [], process.env.NODE_ENV !== "production" && vt(!1, "Current value of '".concat(d.join(" > "), "' is not an array type."))), a(A.map(function(k, L) {
      var T = s.keys[L];
      return T === void 0 && (s.keys[L] = s.id, T = s.keys[L], s.id += 1), {
        name: L,
        key: T,
        isListField: !0
      };
    }), D, m);
  })));
};
function av(e) {
  var t = !1, r = e.length, n = [];
  return e.length ? new Promise(function(a, i) {
    e.forEach(function(o, l) {
      o.catch(function(c) {
        return t = !0, c;
      }).then(function(c) {
        r -= 1, n[l] = c, !(r > 0) && (t && i(n), a(n));
      });
    });
  }) : Promise.resolve([]);
}
var Rs = "__@field_split__";
function xi(e) {
  return e.map(function(t) {
    return "".concat(Ve(t), ":").concat(t);
  }).join(Rs);
}
var Hr = /* @__PURE__ */ function() {
  function e() {
    Bt(this, e), this.kvs = /* @__PURE__ */ new Map();
  }
  return qt(e, [{
    key: "set",
    value: function(r, n) {
      this.kvs.set(xi(r), n);
    }
  }, {
    key: "get",
    value: function(r) {
      return this.kvs.get(xi(r));
    }
  }, {
    key: "update",
    value: function(r, n) {
      var a = this.get(r), i = n(a);
      i ? this.set(r, i) : this.delete(r);
    }
  }, {
    key: "delete",
    value: function(r) {
      this.kvs.delete(xi(r));
    }
  }, {
    key: "map",
    value: function(r) {
      return Me(this.kvs.entries()).map(function(n) {
        var a = pe(n, 2), i = a[0], o = a[1], l = i.split(Rs);
        return r({
          key: l.map(function(c) {
            var s = c.match(/^([^:]*):(.*)$/), d = pe(s, 3), M = d[1], f = d[2];
            return M === "number" ? Number(f) : f;
          }),
          value: o
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var r = {};
      return this.map(function(n) {
        var a = n.key, i = n.value;
        return r[a.join(".")] = i, null;
      }), r;
    }
  }]), e;
}(), iv = ["name", "errors"], ov = /* @__PURE__ */ qt(function e(t) {
  var r = this;
  Bt(this, e), this.formHooked = !1, this.forceRootUpdate = void 0, this.subscribable = !0, this.store = {}, this.fieldEntities = [], this.initialValues = {}, this.callbacks = {}, this.validateMessages = null, this.preserve = null, this.lastValidatePromise = null, this.getForm = function() {
    return {
      getFieldValue: r.getFieldValue,
      getFieldsValue: r.getFieldsValue,
      getFieldError: r.getFieldError,
      getFieldWarning: r.getFieldWarning,
      getFieldsError: r.getFieldsError,
      isFieldsTouched: r.isFieldsTouched,
      isFieldTouched: r.isFieldTouched,
      isFieldValidating: r.isFieldValidating,
      isFieldsValidating: r.isFieldsValidating,
      resetFields: r.resetFields,
      setFields: r.setFields,
      setFieldValue: r.setFieldValue,
      setFieldsValue: r.setFieldsValue,
      validateFields: r.validateFields,
      submit: r.submit,
      _init: !0,
      getInternalHooks: r.getInternalHooks
    };
  }, this.getInternalHooks = function(n) {
    return n === wr ? (r.formHooked = !0, {
      dispatch: r.dispatch,
      initEntityValue: r.initEntityValue,
      registerField: r.registerField,
      useSubscribe: r.useSubscribe,
      setInitialValues: r.setInitialValues,
      destroyForm: r.destroyForm,
      setCallbacks: r.setCallbacks,
      setValidateMessages: r.setValidateMessages,
      getFields: r.getFields,
      setPreserve: r.setPreserve,
      getInitialValue: r.getInitialValue,
      registerWatch: r.registerWatch
    }) : (vt(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }, this.useSubscribe = function(n) {
    r.subscribable = n;
  }, this.prevWithoutPreserves = null, this.setInitialValues = function(n, a) {
    if (r.initialValues = n || {}, a) {
      var i, o = l0({}, n, r.store);
      (i = r.prevWithoutPreserves) === null || i === void 0 || i.map(function(l) {
        var c = l.key;
        o = fr(o, c, Mr(n, c));
      }), r.prevWithoutPreserves = null, r.updateStore(o);
    }
  }, this.destroyForm = function() {
    var n = new Hr();
    r.getFieldEntities(!0).forEach(function(a) {
      r.isMergedPreserve(a.isPreserve()) || n.set(a.getNamePath(), !0);
    }), r.prevWithoutPreserves = n;
  }, this.getInitialValue = function(n) {
    var a = Mr(r.initialValues, n);
    return n.length ? S0(a) : a;
  }, this.setCallbacks = function(n) {
    r.callbacks = n;
  }, this.setValidateMessages = function(n) {
    r.validateMessages = n;
  }, this.setPreserve = function(n) {
    r.preserve = n;
  }, this.watchList = [], this.registerWatch = function(n) {
    return r.watchList.push(n), function() {
      r.watchList = r.watchList.filter(function(a) {
        return a !== n;
      });
    };
  }, this.notifyWatch = function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (r.watchList.length) {
      var a = r.getFieldsValue();
      r.watchList.forEach(function(i) {
        i(a, n);
      });
    }
  }, this.timeoutId = null, this.warningUnhooked = function() {
    process.env.NODE_ENV !== "production" && !r.timeoutId && typeof window < "u" && (r.timeoutId = setTimeout(function() {
      r.timeoutId = null, r.formHooked || vt(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }, this.updateStore = function(n) {
    r.store = n;
  }, this.getFieldEntities = function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return n ? r.fieldEntities.filter(function(a) {
      return a.getNamePath().length;
    }) : r.fieldEntities;
  }, this.getFieldsMap = function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, a = new Hr();
    return r.getFieldEntities(n).forEach(function(i) {
      var o = i.getNamePath();
      a.set(o, i);
    }), a;
  }, this.getFieldEntitiesForNamePathList = function(n) {
    if (!n)
      return r.getFieldEntities(!0);
    var a = r.getFieldsMap(!0);
    return n.map(function(i) {
      var o = Re(i);
      return a.get(o) || {
        INVALIDATE_NAME_PATH: Re(i)
      };
    });
  }, this.getFieldsValue = function(n, a) {
    if (r.warningUnhooked(), n === !0 && !a)
      return r.store;
    var i = r.getFieldEntitiesForNamePathList(Array.isArray(n) ? n : null), o = [];
    return i.forEach(function(l) {
      var c, s = "INVALIDATE_NAME_PATH" in l ? l.INVALIDATE_NAME_PATH : l.getNamePath();
      if (!(!n && ((c = l.isListField) === null || c === void 0 ? void 0 : c.call(l))))
        if (!a)
          o.push(s);
        else {
          var d = "getMeta" in l ? l.getMeta() : null;
          a(d) && o.push(s);
        }
    }), bc(r.store, o.map(Re));
  }, this.getFieldValue = function(n) {
    r.warningUnhooked();
    var a = Re(n);
    return Mr(r.store, a);
  }, this.getFieldsError = function(n) {
    r.warningUnhooked();
    var a = r.getFieldEntitiesForNamePathList(n);
    return a.map(function(i, o) {
      return i && !("INVALIDATE_NAME_PATH" in i) ? {
        name: i.getNamePath(),
        errors: i.getErrors(),
        warnings: i.getWarnings()
      } : {
        name: Re(n[o]),
        errors: [],
        warnings: []
      };
    });
  }, this.getFieldError = function(n) {
    r.warningUnhooked();
    var a = Re(n), i = r.getFieldsError([a])[0];
    return i.errors;
  }, this.getFieldWarning = function(n) {
    r.warningUnhooked();
    var a = Re(n), i = r.getFieldsError([a])[0];
    return i.warnings;
  }, this.isFieldsTouched = function() {
    r.warningUnhooked();
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a[0], l = a[1], c, s = !1;
    a.length === 0 ? c = null : a.length === 1 ? Array.isArray(o) ? (c = o.map(Re), s = !1) : (c = null, s = o) : (c = o.map(Re), s = l);
    var d = r.getFieldEntities(!0), M = function(p) {
      return p.isFieldTouched();
    };
    if (!c)
      return s ? d.every(M) : d.some(M);
    var f = new Hr();
    c.forEach(function(m) {
      f.set(m, []);
    }), d.forEach(function(m) {
      var p = m.getNamePath();
      c.forEach(function(h) {
        h.every(function(y, N) {
          return p[N] === y;
        }) && f.update(h, function(y) {
          return [].concat(Me(y), [m]);
        });
      });
    });
    var v = function(p) {
      return p.some(M);
    }, g = f.map(function(m) {
      var p = m.value;
      return p;
    });
    return s ? g.every(v) : g.some(v);
  }, this.isFieldTouched = function(n) {
    return r.warningUnhooked(), r.isFieldsTouched([n]);
  }, this.isFieldsValidating = function(n) {
    r.warningUnhooked();
    var a = r.getFieldEntities();
    if (!n)
      return a.some(function(o) {
        return o.isFieldValidating();
      });
    var i = n.map(Re);
    return a.some(function(o) {
      var l = o.getNamePath();
      return Zn(i, l) && o.isFieldValidating();
    });
  }, this.isFieldValidating = function(n) {
    return r.warningUnhooked(), r.isFieldsValidating([n]);
  }, this.resetWithFieldInitialValue = function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = new Hr(), i = r.getFieldEntities(!0);
    i.forEach(function(c) {
      var s = c.props.initialValue, d = c.getNamePath();
      if (s !== void 0) {
        var M = a.get(d) || /* @__PURE__ */ new Set();
        M.add({
          entity: c,
          value: s
        }), a.set(d, M);
      }
    });
    var o = function(s) {
      s.forEach(function(d) {
        var M = d.props.initialValue;
        if (M !== void 0) {
          var f = d.getNamePath(), v = r.getInitialValue(f);
          if (v !== void 0)
            vt(!1, "Form already set 'initialValues' with path '".concat(f.join("."), "'. Field can not overwrite it."));
          else {
            var g = a.get(f);
            if (g && g.size > 1)
              vt(!1, "Multiple Field with path '".concat(f.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (g) {
              var m = r.getFieldValue(f);
              (!n.skipExist || m === void 0) && r.updateStore(fr(r.store, f, Me(g)[0].value));
            }
          }
        }
      });
    }, l;
    n.entities ? l = n.entities : n.namePathList ? (l = [], n.namePathList.forEach(function(c) {
      var s = a.get(c);
      if (s) {
        var d;
        (d = l).push.apply(d, Me(Me(s).map(function(M) {
          return M.entity;
        })));
      }
    })) : l = i, o(l);
  }, this.resetFields = function(n) {
    r.warningUnhooked();
    var a = r.store;
    if (!n) {
      r.updateStore(l0({}, r.initialValues)), r.resetWithFieldInitialValue(), r.notifyObservers(a, null, {
        type: "reset"
      }), r.notifyWatch();
      return;
    }
    var i = n.map(Re);
    i.forEach(function(o) {
      var l = r.getInitialValue(o);
      r.updateStore(fr(r.store, o, l));
    }), r.resetWithFieldInitialValue({
      namePathList: i
    }), r.notifyObservers(a, i, {
      type: "reset"
    }), r.notifyWatch(i);
  }, this.setFields = function(n) {
    r.warningUnhooked();
    var a = r.store, i = [];
    n.forEach(function(o) {
      var l = o.name;
      o.errors;
      var c = Wt(o, iv), s = Re(l);
      i.push(s), "value" in c && r.updateStore(fr(r.store, s, c.value)), r.notifyObservers(a, [s], {
        type: "setField",
        data: o
      });
    }), r.notifyWatch(i);
  }, this.getFields = function() {
    var n = r.getFieldEntities(!0), a = n.map(function(i) {
      var o = i.getNamePath(), l = i.getMeta(), c = H(H({}, l), {}, {
        name: o,
        value: r.getFieldValue(o)
      });
      return Object.defineProperty(c, "originRCField", {
        value: !0
      }), c;
    });
    return a;
  }, this.initEntityValue = function(n) {
    var a = n.props.initialValue;
    if (a !== void 0) {
      var i = n.getNamePath(), o = Mr(r.store, i);
      o === void 0 && r.updateStore(fr(r.store, i, a));
    }
  }, this.isMergedPreserve = function(n) {
    var a = n !== void 0 ? n : r.preserve;
    return a != null ? a : !0;
  }, this.registerField = function(n) {
    r.fieldEntities.push(n);
    var a = n.getNamePath();
    if (r.notifyWatch([a]), n.props.initialValue !== void 0) {
      var i = r.store;
      r.resetWithFieldInitialValue({
        entities: [n],
        skipExist: !0
      }), r.notifyObservers(i, [n.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(o, l) {
      var c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (r.fieldEntities = r.fieldEntities.filter(function(M) {
        return M !== n;
      }), !r.isMergedPreserve(l) && (!o || c.length > 1)) {
        var s = o ? void 0 : r.getInitialValue(a);
        if (a.length && r.getFieldValue(a) !== s && r.fieldEntities.every(function(M) {
          return !Ls(M.getNamePath(), a);
        })) {
          var d = r.store;
          r.updateStore(fr(d, a, s, !0)), r.notifyObservers(d, [a], {
            type: "remove"
          }), r.triggerDependenciesUpdate(d, a);
        }
      }
      r.notifyWatch([a]);
    };
  }, this.dispatch = function(n) {
    switch (n.type) {
      case "updateValue": {
        var a = n.namePath, i = n.value;
        r.updateValue(a, i);
        break;
      }
      case "validateField": {
        var o = n.namePath, l = n.triggerName;
        r.validateFields([o], {
          triggerName: l
        });
        break;
      }
    }
  }, this.notifyObservers = function(n, a, i) {
    if (r.subscribable) {
      var o = H(H({}, i), {}, {
        store: r.getFieldsValue(!0)
      });
      r.getFieldEntities().forEach(function(l) {
        var c = l.onStoreChange;
        c(n, a, o);
      });
    } else
      r.forceRootUpdate();
  }, this.triggerDependenciesUpdate = function(n, a) {
    var i = r.getDependencyChildrenFields(a);
    return i.length && r.validateFields(i), r.notifyObservers(n, i, {
      type: "dependenciesUpdate",
      relatedFields: [a].concat(Me(i))
    }), i;
  }, this.updateValue = function(n, a) {
    var i = Re(n), o = r.store;
    r.updateStore(fr(r.store, i, a)), r.notifyObservers(o, [i], {
      type: "valueUpdate",
      source: "internal"
    }), r.notifyWatch([i]);
    var l = r.triggerDependenciesUpdate(o, i), c = r.callbacks.onValuesChange;
    if (c) {
      var s = bc(r.store, [i]);
      c(s, r.getFieldsValue());
    }
    r.triggerOnFieldsChange([i].concat(Me(l)));
  }, this.setFieldsValue = function(n) {
    r.warningUnhooked();
    var a = r.store;
    if (n) {
      var i = l0(r.store, n);
      r.updateStore(i);
    }
    r.notifyObservers(a, null, {
      type: "valueUpdate",
      source: "external"
    }), r.notifyWatch();
  }, this.setFieldValue = function(n, a) {
    r.setFields([{
      name: n,
      value: a
    }]);
  }, this.getDependencyChildrenFields = function(n) {
    var a = /* @__PURE__ */ new Set(), i = [], o = new Hr();
    r.getFieldEntities().forEach(function(c) {
      var s = c.props.dependencies;
      (s || []).forEach(function(d) {
        var M = Re(d);
        o.update(M, function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return f.add(c), f;
        });
      });
    });
    var l = function c(s) {
      var d = o.get(s) || /* @__PURE__ */ new Set();
      d.forEach(function(M) {
        if (!a.has(M)) {
          a.add(M);
          var f = M.getNamePath();
          M.isFieldDirty() && f.length && (i.push(f), c(f));
        }
      });
    };
    return l(n), i;
  }, this.triggerOnFieldsChange = function(n, a) {
    var i = r.callbacks.onFieldsChange;
    if (i) {
      var o = r.getFields();
      if (a) {
        var l = new Hr();
        a.forEach(function(s) {
          var d = s.name, M = s.errors;
          l.set(d, M);
        }), o.forEach(function(s) {
          s.errors = l.get(s.name) || s.errors;
        });
      }
      var c = o.filter(function(s) {
        var d = s.name;
        return Zn(n, d);
      });
      i(c, o);
    }
  }, this.validateFields = function(n, a) {
    r.warningUnhooked();
    var i = !!n, o = i ? n.map(Re) : [], l = [];
    r.getFieldEntities(!0).forEach(function(d) {
      if (i || o.push(d.getNamePath()), (a == null ? void 0 : a.recursive) && i) {
        var M = d.getNamePath();
        M.every(function(g, m) {
          return n[m] === g || n[m] === void 0;
        }) && o.push(M);
      }
      if (!(!d.props.rules || !d.props.rules.length)) {
        var f = d.getNamePath();
        if (!i || Zn(o, f)) {
          var v = d.validateRules(H({
            validateMessages: H(H({}, ws), r.validateMessages)
          }, a));
          l.push(v.then(function() {
            return {
              name: f,
              errors: [],
              warnings: []
            };
          }).catch(function(g) {
            var m, p = [], h = [];
            return (m = g.forEach) === null || m === void 0 || m.call(g, function(y) {
              var N = y.rule.warningOnly, I = y.errors;
              N ? h.push.apply(h, Me(I)) : p.push.apply(p, Me(I));
            }), p.length ? Promise.reject({
              name: f,
              errors: p,
              warnings: h
            }) : {
              name: f,
              errors: p,
              warnings: h
            };
          }));
        }
      }
    });
    var c = av(l);
    r.lastValidatePromise = c, c.catch(function(d) {
      return d;
    }).then(function(d) {
      var M = d.map(function(f) {
        var v = f.name;
        return v;
      });
      r.notifyObservers(r.store, M, {
        type: "validateFinish"
      }), r.triggerOnFieldsChange(M, d);
    });
    var s = c.then(function() {
      return r.lastValidatePromise === c ? Promise.resolve(r.getFieldsValue(o)) : Promise.reject([]);
    }).catch(function(d) {
      var M = d.filter(function(f) {
        return f && f.errors.length;
      });
      return Promise.reject({
        values: r.getFieldsValue(o),
        errorFields: M,
        outOfDate: r.lastValidatePromise !== c
      });
    });
    return s.catch(function(d) {
      return d;
    }), s;
  }, this.submit = function() {
    r.warningUnhooked(), r.validateFields().then(function(n) {
      var a = r.callbacks.onFinish;
      if (a)
        try {
          a(n);
        } catch (i) {
          console.error(i);
        }
    }).catch(function(n) {
      var a = r.callbacks.onFinishFailed;
      a && a(n);
    });
  }, this.forceRootUpdate = t;
});
function Ro(e) {
  var t = z.useRef(), r = z.useState({}), n = pe(r, 2), a = n[1];
  if (!t.current)
    if (e)
      t.current = e;
    else {
      var i = function() {
        a({});
      }, o = new ov(i);
      t.current = o.getForm();
    }
  return [t.current];
}
var C1 = /* @__PURE__ */ z.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), Qs = function(t) {
  var r = t.validateMessages, n = t.onFormChange, a = t.onFormFinish, i = t.children, o = z.useContext(C1), l = z.useRef({});
  return /* @__PURE__ */ z.createElement(C1.Provider, {
    value: H(H({}, o), {}, {
      validateMessages: H(H({}, o.validateMessages), r),
      triggerFormChange: function(s, d) {
        n && n(s, {
          changedFields: d,
          forms: l.current
        }), o.triggerFormChange(s, d);
      },
      triggerFormFinish: function(s, d) {
        a && a(s, {
          values: d,
          forms: l.current
        }), o.triggerFormFinish(s, d);
      },
      registerForm: function(s, d) {
        s && (l.current = H(H({}, l.current), {}, je({}, s, d))), o.registerForm(s, d);
      },
      unregisterForm: function(s) {
        var d = H({}, l.current);
        delete d[s], l.current = d, o.unregisterForm(s);
      }
    })
  }, i);
}, lv = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"], cv = function(t, r) {
  var n = t.name, a = t.initialValues, i = t.fields, o = t.form, l = t.preserve, c = t.children, s = t.component, d = s === void 0 ? "form" : s, M = t.validateMessages, f = t.validateTrigger, v = f === void 0 ? "onChange" : f, g = t.onValuesChange, m = t.onFieldsChange, p = t.onFinish, h = t.onFinishFailed, y = Wt(t, lv), N = z.useContext(C1), I = Ro(o), D = pe(I, 1), A = D[0], k = A.getInternalHooks(wr), L = k.useSubscribe, T = k.setInitialValues, C = k.setCallbacks, j = k.setValidateMessages, w = k.setPreserve, E = k.destroyForm;
  z.useImperativeHandle(r, function() {
    return A;
  }), z.useEffect(function() {
    return N.registerForm(n, A), function() {
      N.unregisterForm(n);
    };
  }, [N, A, n]), j(H(H({}, N.validateMessages), M)), C({
    onValuesChange: g,
    onFieldsChange: function(P) {
      if (N.triggerFormChange(n, P), m) {
        for (var U = arguments.length, F = new Array(U > 1 ? U - 1 : 0), $ = 1; $ < U; $++)
          F[$ - 1] = arguments[$];
        m.apply(void 0, [P].concat(F));
      }
    },
    onFinish: function(P) {
      N.triggerFormFinish(n, P), p && p(P);
    },
    onFinishFailed: h
  }), w(l);
  var _ = z.useRef(null);
  T(a, !_.current), _.current || (_.current = !0), z.useEffect(
    function() {
      return E;
    },
    []
  );
  var b, O = typeof c == "function";
  if (O) {
    var S = A.getFieldsValue(!0);
    b = c(S, A);
  } else
    b = c;
  L(!O);
  var R = z.useRef();
  z.useEffect(function() {
    G6(R.current || [], i || []) || A.setFields(i || []), R.current = i;
  }, [i, A]);
  var V = z.useMemo(function() {
    return H(H({}, A), {}, {
      validateTrigger: v
    });
  }, [A, v]), Q = /* @__PURE__ */ z.createElement(Pr.Provider, {
    value: V
  }, b);
  return d === !1 ? Q : /* @__PURE__ */ z.createElement(d, Pe({}, y, {
    onSubmit: function(P) {
      P.preventDefault(), P.stopPropagation(), A.submit();
    },
    onReset: function(P) {
      var U;
      P.preventDefault(), A.resetFields(), (U = y.onReset) === null || U === void 0 || U.call(y, P);
    }
  }), Q);
};
function Oc(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return Math.random();
  }
}
function Vs() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = t[0], a = n === void 0 ? [] : n, i = t[1], o = de(), l = pe(o, 2), c = l[0], s = l[1], d = Qe(function() {
    return Oc(c);
  }, [c]), M = Le(d);
  M.current = d;
  var f = xe(Pr), v = i || f, g = v && v._init;
  process.env.NODE_ENV !== "production" && vt(t.length === 2 ? i ? g : !0 : g, "useWatch requires a form instance since it can not auto detect from context.");
  var m = Re(a), p = Le(m);
  return p.current = m, lt(
    function() {
      if (!!g) {
        var h = v.getFieldsValue, y = v.getInternalHooks, N = y(wr), I = N.registerWatch, D = I(function(k) {
          var L = Mr(k, p.current), T = Oc(L);
          M.current !== T && (M.current = T, s(L));
        }), A = Mr(h(), p.current);
        return s(A), D;
      }
    },
    [g]
  ), c;
}
var uv = /* @__PURE__ */ z.forwardRef(cv), dn = uv;
dn.FormProvider = Qs;
dn.Field = Po;
dn.List = Ps;
dn.useForm = Ro;
dn.useWatch = Vs;
const sv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Field: Po,
  List: Ps,
  useForm: Ro,
  FormProvider: Qs,
  FieldContext: Pr,
  ListContext: ks,
  useWatch: Vs,
  default: dn
}, Symbol.toStringTag, { value: "Module" }));
var fa = H({}, qd), dv = fa.version, fv = fa.render, vv = fa.unmountComponentAtNode, L0;
try {
  var Mv = Number((dv || "").split(".")[0]);
  Mv >= 18 && (L0 = fa.createRoot);
} catch {
}
function Tc(e) {
  var t = fa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  t && Ve(t) === "object" && (t.usingClientEntryPoint = e);
}
var N0 = "__rc_react_root__";
function gv(e, t) {
  Tc(!0);
  var r = t[N0] || L0(t);
  Tc(!1), r.render(e), t[N0] = r;
}
function pv(e, t) {
  fv(e, t);
}
function hv(e, t) {
  if (L0) {
    gv(e, t);
    return;
  }
  pv(e, t);
}
function mv(e) {
  return E1.apply(this, arguments);
}
function E1() {
  return E1 = Ur(/* @__PURE__ */ tt().mark(function e(t) {
    return tt().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            return n.abrupt("return", Promise.resolve().then(function() {
              var a;
              (a = t[N0]) === null || a === void 0 || a.unmount(), delete t[N0];
            }));
          case 1:
          case "end":
            return n.stop();
        }
    }, e);
  })), E1.apply(this, arguments);
}
function yv(e) {
  vv(e);
}
function Nv(e) {
  return b1.apply(this, arguments);
}
function b1() {
  return b1 = Ur(/* @__PURE__ */ tt().mark(function e(t) {
    return tt().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            if (L0 === void 0) {
              n.next = 2;
              break;
            }
            return n.abrupt("return", mv(t));
          case 2:
            yv(t);
          case 3:
          case "end":
            return n.stop();
        }
    }, e);
  })), b1.apply(this, arguments);
}
function z0(e) {
  return e instanceof HTMLElement ? e : Sr.findDOMNode(e);
}
function Sc(e, t) {
  var r = {};
  return r[e.toLowerCase()] = t.toLowerCase(), r["Webkit".concat(e)] = "webkit".concat(t), r["Moz".concat(e)] = "moz".concat(t), r["ms".concat(e)] = "MS".concat(t), r["O".concat(e)] = "o".concat(t.toLowerCase()), r;
}
function zv(e, t) {
  var r = {
    animationend: Sc("Animation", "AnimationEnd"),
    transitionend: Sc("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in t || delete r.animationend.animation, "TransitionEvent" in t || delete r.transitionend.transition), r;
}
var _v = zv(ua(), typeof window < "u" ? window : {}), Us = {};
if (ua()) {
  var Iv = document.createElement("div");
  Us = Iv.style;
}
var Ea = {};
function Fs(e) {
  if (Ea[e])
    return Ea[e];
  var t = _v[e];
  if (t)
    for (var r = Object.keys(t), n = r.length, a = 0; a < n; a += 1) {
      var i = r[a];
      if (Object.prototype.hasOwnProperty.call(t, i) && i in Us)
        return Ea[e] = t[i], Ea[e];
    }
  return "";
}
var $s = Fs("animationend"), Zs = Fs("transitionend"), Ys = !!($s && Zs), Lc = $s || "animationend", kc = Zs || "transitionend";
function Pc(e, t) {
  if (!e)
    return null;
  if (Ve(e) === "object") {
    var r = t.replace(/-\w/g, function(n) {
      return n[1].toUpperCase();
    });
    return e[r];
  }
  return "".concat(e, "-").concat(t);
}
var Kr = "none", ba = "appear", Aa = "enter", ja = "leave", Rc = "none", rr = "prepare", Xr = "start", Jr = "active", Qo = "end", Hs = function(t) {
  return +setTimeout(t, 16);
}, Ws = function(t) {
  return clearTimeout(t);
};
typeof window < "u" && "requestAnimationFrame" in window && (Hs = function(t) {
  return window.requestAnimationFrame(t);
}, Ws = function(t) {
  return window.cancelAnimationFrame(t);
});
var Qc = 0, Vo = /* @__PURE__ */ new Map();
function Bs(e) {
  Vo.delete(e);
}
function kt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Qc += 1;
  var r = Qc;
  function n(a) {
    if (a === 0)
      Bs(r), e();
    else {
      var i = Hs(function() {
        n(a - 1);
      });
      Vo.set(r, i);
    }
  }
  return n(t), r;
}
kt.cancel = function(e) {
  var t = Vo.get(e);
  return Bs(t), Ws(t);
};
const Dv = function() {
  var e = z.useRef(null);
  function t() {
    kt.cancel(e.current);
  }
  function r(n) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    t();
    var i = kt(function() {
      a <= 1 ? n({
        isCanceled: function() {
          return i !== e.current;
        }
      }) : r(n, a - 1);
    });
    e.current = i;
  }
  return z.useEffect(function() {
    return function() {
      t();
    };
  }, []), [r, t];
};
var qs = ua() ? md : lt, Vc = [rr, Xr, Jr, Qo], Gs = !1, Cv = !0;
function Ks(e) {
  return e === Jr || e === Qo;
}
const Ev = function(e, t) {
  var r = tn(Rc), n = pe(r, 2), a = n[0], i = n[1], o = Dv(), l = pe(o, 2), c = l[0], s = l[1];
  function d() {
    i(rr, !0);
  }
  return qs(function() {
    if (a !== Rc && a !== Qo) {
      var M = Vc.indexOf(a), f = Vc[M + 1], v = t(a);
      v === Gs ? i(f, !0) : c(function(g) {
        function m() {
          g.isCanceled() || i(f, !0);
        }
        v === !0 ? m() : Promise.resolve(v).then(m);
      });
    }
  }, [e, a]), z.useEffect(function() {
    return function() {
      s();
    };
  }, []), [d, a];
}, bv = function(e) {
  var t = Le(), r = Le(e);
  r.current = e;
  var n = z.useCallback(function(o) {
    r.current(o);
  }, []);
  function a(o) {
    o && (o.removeEventListener(kc, n), o.removeEventListener(Lc, n));
  }
  function i(o) {
    t.current && t.current !== o && a(t.current), o && o !== t.current && (o.addEventListener(kc, n), o.addEventListener(Lc, n), t.current = o);
  }
  return z.useEffect(function() {
    return function() {
      a(t.current);
    };
  }, []), [i, a];
};
function Av(e, t, r, n) {
  var a = n.motionEnter, i = a === void 0 ? !0 : a, o = n.motionAppear, l = o === void 0 ? !0 : o, c = n.motionLeave, s = c === void 0 ? !0 : c, d = n.motionDeadline, M = n.motionLeaveImmediately, f = n.onAppearPrepare, v = n.onEnterPrepare, g = n.onLeavePrepare, m = n.onAppearStart, p = n.onEnterStart, h = n.onLeaveStart, y = n.onAppearActive, N = n.onEnterActive, I = n.onLeaveActive, D = n.onAppearEnd, A = n.onEnterEnd, k = n.onLeaveEnd, L = n.onVisibleChanged, T = tn(), C = pe(T, 2), j = C[0], w = C[1], E = tn(Kr), _ = pe(E, 2), b = _[0], O = _[1], S = tn(null), R = pe(S, 2), V = R[0], Q = R[1], x = Le(!1), P = Le(null);
  function U() {
    return r();
  }
  var F = Le(!1);
  function $(ae) {
    var ne = U();
    if (!(ae && !ae.deadline && ae.target !== ne)) {
      var se = F.current, Ce;
      b === ba && se ? Ce = D == null ? void 0 : D(ne, ae) : b === Aa && se ? Ce = A == null ? void 0 : A(ne, ae) : b === ja && se && (Ce = k == null ? void 0 : k(ne, ae)), b !== Kr && se && Ce !== !1 && (O(Kr, !0), Q(null, !0));
    }
  }
  var W = bv($), te = pe(W, 1), J = te[0], q = z.useMemo(function() {
    var ae, ne, se;
    switch (b) {
      case ba:
        return ae = {}, je(ae, rr, f), je(ae, Xr, m), je(ae, Jr, y), ae;
      case Aa:
        return ne = {}, je(ne, rr, v), je(ne, Xr, p), je(ne, Jr, N), ne;
      case ja:
        return se = {}, je(se, rr, g), je(se, Xr, h), je(se, Jr, I), se;
      default:
        return {};
    }
  }, [b]), B = Ev(b, function(ae) {
    if (ae === rr) {
      var ne = q[rr];
      return ne ? ne(U()) : Gs;
    }
    if (K in q) {
      var se;
      Q(((se = q[K]) === null || se === void 0 ? void 0 : se.call(q, U(), null)) || null);
    }
    return K === Jr && (J(U()), d > 0 && (clearTimeout(P.current), P.current = setTimeout(function() {
      $({
        deadline: !0
      });
    }, d))), Cv;
  }), G = pe(B, 2), Z = G[0], K = G[1], ee = Ks(K);
  F.current = ee, qs(function() {
    w(t);
    var ae = x.current;
    if (x.current = !0, !!e) {
      var ne;
      !ae && t && l && (ne = ba), ae && t && i && (ne = Aa), (ae && !t && s || !ae && M && !t && s) && (ne = ja), ne && (O(ne), Z());
    }
  }, [t]), lt(function() {
    (b === ba && !l || b === Aa && !i || b === ja && !s) && O(Kr);
  }, [l, i, s]), lt(function() {
    return function() {
      x.current = !1, clearTimeout(P.current);
    };
  }, []);
  var ce = z.useRef(!1);
  lt(function() {
    j && (ce.current = !0), j !== void 0 && b === Kr && ((ce.current || j) && (L == null || L(j)), ce.current = !0);
  }, [j, b]);
  var ie = V;
  return q[rr] && K === Xr && (ie = H({
    transition: "none"
  }, ie)), [b, K, ie, j != null ? j : t];
}
var jv = /* @__PURE__ */ function(e) {
  Nr(r, e);
  var t = zr(r);
  function r() {
    return Bt(this, r), t.apply(this, arguments);
  }
  return qt(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(z.Component);
function xv(e) {
  var t = e;
  Ve(e) === "object" && (t = e.transitionSupport);
  function r(a) {
    return !!(a.motionName && t);
  }
  var n = /* @__PURE__ */ z.forwardRef(function(a, i) {
    var o = a.visible, l = o === void 0 ? !0 : o, c = a.removeOnLeave, s = c === void 0 ? !0 : c, d = a.forceRender, M = a.children, f = a.motionName, v = a.leavedClassName, g = a.eventProps, m = r(a), p = Le(), h = Le();
    function y() {
      try {
        return p.current instanceof HTMLElement ? p.current : z0(h.current);
      } catch {
        return null;
      }
    }
    var N = Av(m, l, y, a), I = pe(N, 4), D = I[0], A = I[1], k = I[2], L = I[3], T = z.useRef(L);
    L && (T.current = !0);
    var C = z.useCallback(function(S) {
      p.current = S, As(i, S);
    }, [i]), j, w = H(H({}, g), {}, {
      visible: l
    });
    if (!M)
      j = null;
    else if (D === Kr || !r(a))
      L ? j = M(H({}, w), C) : !s && T.current ? j = M(H(H({}, w), {}, {
        className: v
      }), C) : d ? j = M(H(H({}, w), {}, {
        style: {
          display: "none"
        }
      }), C) : j = null;
    else {
      var E, _;
      A === rr ? _ = "prepare" : Ks(A) ? _ = "active" : A === Xr && (_ = "start"), j = M(H(H({}, w), {}, {
        className: Y(Pc(f, D), (E = {}, je(E, Pc(f, "".concat(D, "-").concat(_)), _), je(E, f, typeof f == "string"), E)),
        style: k
      }), C);
    }
    if (/* @__PURE__ */ z.isValidElement(j) && So(j)) {
      var b = j, O = b.ref;
      O || (j = /* @__PURE__ */ z.cloneElement(j, {
        ref: C
      }));
    }
    return /* @__PURE__ */ z.createElement(jv, {
      ref: h
    }, j);
  });
  return n.displayName = "CSSMotion", n;
}
const k0 = xv(Ys);
var A1 = "add", j1 = "keep", x1 = "remove", wi = "removed";
function wv(e) {
  var t;
  return e && Ve(e) === "object" && "key" in e ? t = e : t = {
    key: e
  }, H(H({}, t), {}, {
    key: String(t.key)
  });
}
function w1() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(wv);
}
function Ov() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = [], n = 0, a = t.length, i = w1(e), o = w1(t);
  i.forEach(function(s) {
    for (var d = !1, M = n; M < a; M += 1) {
      var f = o[M];
      if (f.key === s.key) {
        n < M && (r = r.concat(o.slice(n, M).map(function(v) {
          return H(H({}, v), {}, {
            status: A1
          });
        })), n = M), r.push(H(H({}, f), {}, {
          status: j1
        })), n += 1, d = !0;
        break;
      }
    }
    d || r.push(H(H({}, s), {}, {
      status: x1
    }));
  }), n < a && (r = r.concat(o.slice(n).map(function(s) {
    return H(H({}, s), {}, {
      status: A1
    });
  })));
  var l = {};
  r.forEach(function(s) {
    var d = s.key;
    l[d] = (l[d] || 0) + 1;
  });
  var c = Object.keys(l).filter(function(s) {
    return l[s] > 1;
  });
  return c.forEach(function(s) {
    r = r.filter(function(d) {
      var M = d.key, f = d.status;
      return M !== s || f !== x1;
    }), r.forEach(function(d) {
      d.key === s && (d.status = j1);
    });
  }), r;
}
var Tv = ["component", "children", "onVisibleChanged", "onAllRemoved"], Sv = ["status"], Lv = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function kv(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : k0, r = /* @__PURE__ */ function(n) {
    Nr(i, n);
    var a = zr(i);
    function i() {
      var o;
      Bt(this, i);
      for (var l = arguments.length, c = new Array(l), s = 0; s < l; s++)
        c[s] = arguments[s];
      return o = a.call.apply(a, [this].concat(c)), o.state = {
        keyEntities: []
      }, o.removeKey = function(d) {
        var M = o.state.keyEntities, f = M.map(function(v) {
          return v.key !== d ? v : H(H({}, v), {}, {
            status: wi
          });
        });
        return o.setState({
          keyEntities: f
        }), f.filter(function(v) {
          var g = v.status;
          return g !== wi;
        }).length;
      }, o;
    }
    return qt(i, [{
      key: "render",
      value: function() {
        var l = this, c = this.state.keyEntities, s = this.props, d = s.component, M = s.children, f = s.onVisibleChanged, v = s.onAllRemoved, g = Wt(s, Tv), m = d || z.Fragment, p = {};
        return Lv.forEach(function(h) {
          p[h] = g[h], delete g[h];
        }), delete g.keys, /* @__PURE__ */ z.createElement(m, g, c.map(function(h) {
          var y = h.status, N = Wt(h, Sv), I = y === A1 || y === j1;
          return /* @__PURE__ */ z.createElement(t, Pe({}, p, {
            key: N.key,
            visible: I,
            eventProps: N,
            onVisibleChanged: function(A) {
              if (f == null || f(A, {
                key: N.key
              }), !A) {
                var k = l.removeKey(N.key);
                k === 0 && v && v();
              }
            }
          }), M);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(l, c) {
        var s = l.keys, d = c.keyEntities, M = w1(s), f = Ov(d, M);
        return {
          keyEntities: f.filter(function(v) {
            var g = d.find(function(m) {
              var p = m.key;
              return v.key === p;
            });
            return !(g && g.status === wi && v.status === x1);
          })
        };
      }
    }]), i;
  }(z.Component);
  return r.defaultProps = {
    component: "div"
  }, r;
}
const Pv = kv(Ys);
var Uo = /* @__PURE__ */ function(e) {
  Nr(r, e);
  var t = zr(r);
  function r() {
    var n;
    Bt(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), n.closeTimer = null, n.close = function(l) {
      l && l.stopPropagation(), n.clearCloseTimer();
      var c = n.props, s = c.onClose, d = c.noticeKey;
      s && s(d);
    }, n.startCloseTimer = function() {
      n.props.duration && (n.closeTimer = window.setTimeout(function() {
        n.close();
      }, n.props.duration * 1e3));
    }, n.clearCloseTimer = function() {
      n.closeTimer && (clearTimeout(n.closeTimer), n.closeTimer = null);
    }, n;
  }
  return qt(r, [{
    key: "componentDidMount",
    value: function() {
      this.startCloseTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      (this.props.duration !== a.duration || this.props.updateMark !== a.updateMark || this.props.visible !== a.visible && this.props.visible) && this.restartCloseTimer();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearCloseTimer();
    }
  }, {
    key: "restartCloseTimer",
    value: function() {
      this.clearCloseTimer(), this.startCloseTimer();
    }
  }, {
    key: "render",
    value: function() {
      var a = this, i = this.props, o = i.prefixCls, l = i.className, c = i.closable, s = i.closeIcon, d = i.style, M = i.onClick, f = i.children, v = i.holder, g = "".concat(o, "-notice"), m = Object.keys(this.props).reduce(function(h, y) {
        return (y.substr(0, 5) === "data-" || y.substr(0, 5) === "aria-" || y === "role") && (h[y] = a.props[y]), h;
      }, {}), p = /* @__PURE__ */ z.createElement("div", Pe({
        className: Y(g, l, je({}, "".concat(g, "-closable"), c)),
        style: d,
        onMouseEnter: this.clearCloseTimer,
        onMouseLeave: this.startCloseTimer,
        onClick: M
      }, m), /* @__PURE__ */ z.createElement("div", {
        className: "".concat(g, "-content")
      }, f), c ? /* @__PURE__ */ z.createElement("a", {
        tabIndex: 0,
        onClick: this.close,
        className: "".concat(g, "-close")
      }, s || /* @__PURE__ */ z.createElement("span", {
        className: "".concat(g, "-close-x")
      })) : null);
      return v ? /* @__PURE__ */ Sr.createPortal(p, v) : p;
    }
  }]), r;
}($u);
Uo.defaultProps = {
  onClose: function() {
  },
  duration: 1.5
};
function Rv(e) {
  var t = z.useRef({}), r = z.useState([]), n = pe(r, 2), a = n[0], i = n[1];
  function o(l) {
    var c = !0;
    e.add(l, function(s, d) {
      var M = d.key;
      if (s && (!t.current[M] || c)) {
        var f = /* @__PURE__ */ z.createElement(Uo, Pe({}, d, {
          holder: s
        }));
        t.current[M] = f, i(function(v) {
          var g = v.findIndex(function(p) {
            return p.key === d.key;
          });
          if (g === -1)
            return [].concat(Me(v), [f]);
          var m = Me(v);
          return m[g] = f, m;
        });
      }
      c = !1;
    });
  }
  return [o, /* @__PURE__ */ z.createElement(z.Fragment, null, a)];
}
var Qv = ["getContainer"], Uc = 0, Vv = Date.now();
function Fc() {
  var e = Uc;
  return Uc += 1, "rcNotification_".concat(Vv, "_").concat(e);
}
var rn = /* @__PURE__ */ function(e) {
  Nr(r, e);
  var t = zr(r);
  function r() {
    var n;
    Bt(this, r);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return n = t.call.apply(t, [this].concat(i)), n.state = {
      notices: []
    }, n.hookRefs = /* @__PURE__ */ new Map(), n.add = function(l, c) {
      var s, d = (s = l.key) !== null && s !== void 0 ? s : Fc(), M = H(H({}, l), {}, {
        key: d
      }), f = n.props.maxCount;
      n.setState(function(v) {
        var g = v.notices, m = g.map(function(h) {
          return h.notice.key;
        }).indexOf(d), p = g.concat();
        return m !== -1 ? p.splice(m, 1, {
          notice: M,
          holderCallback: c
        }) : (f && g.length >= f && (M.key = p[0].notice.key, M.updateMark = Fc(), M.userPassKey = d, p.shift()), p.push({
          notice: M,
          holderCallback: c
        })), {
          notices: p
        };
      });
    }, n.remove = function(l) {
      n.setState(function(c) {
        var s = c.notices;
        return {
          notices: s.filter(function(d) {
            var M = d.notice, f = M.key, v = M.userPassKey, g = v != null ? v : f;
            return g !== l;
          })
        };
      });
    }, n.noticePropsMap = {}, n;
  }
  return qt(r, [{
    key: "getTransitionName",
    value: function() {
      var a = this.props, i = a.prefixCls, o = a.animation, l = this.props.transitionName;
      return !l && o && (l = "".concat(i, "-").concat(o)), l;
    }
  }, {
    key: "render",
    value: function() {
      var a = this, i = this.state.notices, o = this.props, l = o.prefixCls, c = o.className, s = o.closeIcon, d = o.style, M = [];
      return i.forEach(function(f, v) {
        var g = f.notice, m = f.holderCallback, p = v === i.length - 1 ? g.updateMark : void 0, h = g.key, y = g.userPassKey, N = H(H(H({
          prefixCls: l,
          closeIcon: s
        }, g), g.props), {}, {
          key: h,
          noticeKey: y || h,
          updateMark: p,
          onClose: function(D) {
            var A;
            a.remove(D), (A = g.onClose) === null || A === void 0 || A.call(g);
          },
          onClick: g.onClick,
          children: g.content
        });
        M.push(h), a.noticePropsMap[h] = {
          props: N,
          holderCallback: m
        };
      }), /* @__PURE__ */ z.createElement("div", {
        className: Y(l, c),
        style: d
      }, /* @__PURE__ */ z.createElement(Pv, {
        keys: M,
        motionName: this.getTransitionName(),
        onVisibleChanged: function(v, g) {
          var m = g.key;
          v || delete a.noticePropsMap[m];
        }
      }, function(f) {
        var v = f.key, g = f.className, m = f.style, p = f.visible, h = a.noticePropsMap[v], y = h.props, N = h.holderCallback;
        return N ? /* @__PURE__ */ z.createElement("div", {
          key: v,
          className: Y(g, "".concat(l, "-hook-holder")),
          style: H({}, m),
          ref: function(D) {
            typeof v > "u" || (D ? (a.hookRefs.set(v, D), N(D, y)) : a.hookRefs.delete(v));
          }
        }) : /* @__PURE__ */ z.createElement(Uo, Pe({}, y, {
          className: Y(g, y == null ? void 0 : y.className),
          style: H(H({}, m), y == null ? void 0 : y.style),
          visible: p
        }));
      }));
    }
  }]), r;
}($u);
rn.newInstance = void 0;
rn.defaultProps = {
  prefixCls: "rc-notification",
  animation: "fade",
  style: {
    top: 65,
    left: "50%"
  }
};
rn.newInstance = function(t, r) {
  var n = t || {}, a = n.getContainer, i = Wt(n, Qv), o = document.createElement("div");
  if (a) {
    var l = a();
    l.appendChild(o);
  } else
    document.body.appendChild(o);
  var c = !1;
  function s(d) {
    c || (c = !0, r({
      notice: function(f) {
        d.add(f);
      },
      removeNotice: function(f) {
        d.remove(f);
      },
      component: d,
      destroy: function() {
        Nv(o), o.parentNode && o.parentNode.removeChild(o);
      },
      useNotification: function() {
        return Rv(d);
      }
    }));
  }
  if (process.env.NODE_ENV === "test" && t.TEST_RENDER) {
    t.TEST_RENDER(/* @__PURE__ */ z.createElement(rn, Pe({}, i, {
      ref: s
    })));
    return;
  }
  hv(/* @__PURE__ */ z.createElement(rn, Pe({}, i, {
    ref: s
  })), o);
};
const Uv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rn
}, Symbol.toStringTag, { value: "Module" }));
globalThis && globalThis.__rest;
function Fv(e, t, r, n) {
  if (!!r) {
    var a = t;
    if (t.type === "click") {
      var i = e.cloneNode(!0);
      a = Object.create(t, {
        target: {
          value: i
        },
        currentTarget: {
          value: i
        }
      }), i.value = "", r(a);
      return;
    }
    if (n !== void 0) {
      a = Object.create(t, {
        target: {
          value: e
        },
        currentTarget: {
          value: e
        }
      }), e.value = n, r(a);
      return;
    }
    r(a);
  }
}
const $c = (e) => e ? e.replace(/(^\s*)|(\s*$)/gi, "").replace(/' '{2,}/gi, " ").replace(/\n /, `
`).split(" ").filter((t) => t !== "").length : 0, Xs = ({
  className: e,
  roundCorners: t,
  autoSize: r = !0,
  characterLimit: n,
  wordLimit: a,
  showCount: i,
  onChange: o,
  ...l
}) => {
  const [c, s] = Ao(l.defaultValue, {
    value: l.value
  }), d = (f) => {
    let v = f.target.value;
    const g = $c(v);
    a && g > a && (v = c), s(v), Fv(f.currentTarget, f, o, v);
  }, M = Qe(() => a && i ? {
    formatter: () => `${$c(c)} / ${a}`
  } : i, [i, a, c]);
  return /* @__PURE__ */ u.createElement(vo.TextArea, {
    ...l,
    value: c,
    showCount: M,
    onChange: d,
    autoSize: r,
    maxLength: n,
    className: Y(
      nc.textarea,
      { [nc["textarea-roundCorners"]]: t },
      e
    )
  });
};
Xs.displayName = "TextArea";
const $v = "_input_1m46p_5", Zc = {
  input: $v,
  "input--roundCorners": "_input--roundCorners_1m46p_33"
}, zA = ({ className: e, roundCorners: t, ...r }) => /* @__PURE__ */ u.createElement(zd, {
  ...r,
  className: Y(
    Zc.input,
    { [Zc["input--roundCorners"]]: t },
    e
  )
}), Zv = "_add_1esym_5", Yv = "_items_1esym_8", Hv = "_item_1esym_8", Wv = "_point_1esym_21", Bv = "_point__action_1esym_26", qv = "_point__input_1esym_31", nn = {
  add: Zv,
  items: Yv,
  item: Hv,
  point: Wv,
  point__action: Bv,
  point__input: qv
}, on = (e, t) => ({ currentTarget: r }) => e(r[t]), Gv = (e) => (t) => {
  (t.key === "Enter" || t.key === "Space") && e();
}, Kv = ({ defaultValue: e, onRemove: t, id: r, onEdit: n, disabled: a }) => {
  const [i, o] = de(e);
  return /* @__PURE__ */ u.createElement("div", {
    className: nn.point
  }, /* @__PURE__ */ u.createElement("input", {
    disabled: a,
    onKeyDown: (l) => {
      l.key === "Enter" && (n(r, l.currentTarget.value), l.currentTarget.blur(), l.preventDefault());
    },
    type: "text",
    value: i,
    className: nn.point__input,
    onBlur: on((l) => n(r, l), "value"),
    onChange: on((l) => {
      o(l);
    }, "value")
  }), /* @__PURE__ */ u.createElement(ta, {
    disabled: a,
    icon: /* @__PURE__ */ u.createElement(Qr, null),
    onClick: () => t(r),
    className: nn.point__action
  }));
}, _A = ({
  defaultValue: e,
  onChange: t,
  placeholder: r,
  limit: n = 10,
  disabled: a
}) => {
  const [i, o] = de(e || []), [l, c] = de(""), s = (f) => {
    const v = i.filter((g) => g.id !== f);
    o(v), t == null || t(v);
  }, d = (f) => {
    if (!f)
      return;
    const v = Wd(), g = [...i, { text: f, id: v }];
    o(g), t == null || t(g), c("");
  }, M = (f, v) => {
    const g = i.map((m) => m.id === f ? {
      id: f,
      text: v
    } : m);
    o(g), t == null || t(g);
  };
  return /* @__PURE__ */ u.createElement("div", null, /* @__PURE__ */ u.createElement("ul", {
    className: nn.items
  }, i.map((f) => /* @__PURE__ */ u.createElement("li", {
    className: nn.item,
    key: f.id
  }, /* @__PURE__ */ u.createElement(Kv, {
    disabled: a,
    id: f.id,
    defaultValue: f.text,
    onRemove: s,
    onEdit: M
  })))), i.length < n && /* @__PURE__ */ u.createElement(Lr, {
    disabled: a,
    onPressEnter: (f) => {
      d(l), f.preventDefault();
    },
    placeholder: r,
    roundCorners: "large",
    value: l,
    size: "large",
    onChange: on(c, "value"),
    suffix: /* @__PURE__ */ u.createElement(ta, {
      className: nn.add,
      onClick: () => d(l),
      type: "text"
    }, /* @__PURE__ */ u.createElement(w0, null), " Add")
  }));
}, Oi = {
  "text-size-small": "_text-size-small_kjm79_5",
  "text-size-large": "_text-size-large_kjm79_8",
  "text-size-medium": "_text-size-medium_kjm79_12",
  "text-size-extra-large": "_text-size-extra-large_kjm79_16",
  "text-size-title": "_text-size-title_kjm79_20",
  "text-weight-bold": "_text-weight-bold_kjm79_24"
}, ve = ({ className: e, size: t = "medium", weight: r = "normal", ...n }) => /* @__PURE__ */ u.createElement(ra.Text, {
  ...n,
  className: Y(
    Oi.text,
    {
      [Oi[`text-size-${t}`]]: t,
      [Oi[`text-weight-${r}`]]: r
    },
    e
  )
}), Xv = "_text_1v0p1_5", Jv = "_list_1v0p1_8", e8 = "_card_1v0p1_22", t8 = "_card__content_1v0p1_56", r8 = "_card__icon_1v0p1_62", n8 = "_specify_1v0p1_66", Tr = {
  text: Xv,
  list: Jv,
  "list--vertical": "_list--vertical_1v0p1_15",
  "list--horizontal": "_list--horizontal_1v0p1_18",
  card: e8,
  card__content: t8,
  card__icon: r8,
  specify: n8
}, a8 = ({ icon: e, description: t, children: r, ...n }) => /* @__PURE__ */ u.createElement("div", {
  className: Tr.card
}, /* @__PURE__ */ u.createElement(j0, {
  ...n
}, /* @__PURE__ */ u.createElement("div", {
  className: Tr.card__content
}, e && /* @__PURE__ */ u.createElement("span", {
  className: Tr.card__icon
}, e), r, t && /* @__PURE__ */ u.createElement(ve, {
  size: "small",
  type: "secondary"
}, t)))), _0 = ({ optionType: e, ...t }) => {
  switch (e) {
    case "card":
      return /* @__PURE__ */ u.createElement(a8, {
        ...t
      });
    default:
      return /* @__PURE__ */ u.createElement(j0, {
        ...t
      });
  }
}, Yc = (e) => e.replace(/(^|\s)\S/g, (t) => t.toUpperCase()), Js = ({
  children: e,
  capitalize: t,
  defaultSpecific: r,
  value: n,
  onChangeSpecific: a,
  className: i,
  inputProps: o,
  ...l
}) => {
  const c = (o == null ? void 0 : o.triggerChange) || "onBlur";
  return /* @__PURE__ */ u.createElement(_0, {
    className: Y(Tr.specify, i),
    value: n,
    ...l
  }, /* @__PURE__ */ u.createElement("div", null, e, l.checked && /* @__PURE__ */ u.createElement(Lr, {
    placeholder: o == null ? void 0 : o.placeholder,
    className: Tr.specify__input,
    size: "large",
    disabled: l.disabled,
    roundCorners: "large",
    defaultValue: r,
    onChange: c === "onChange" ? on(
      (s) => a(
        n,
        t ? Yc(s) : s
      ),
      "value"
    ) : void 0,
    onBlur: c === "onBlur" ? on(
      (s) => a(
        n,
        t ? Yc(s) : s
      ),
      "value"
    ) : void 0
  })));
};
Js.displayName = "CheckboxSpecifiable";
const e3 = ({
  options: e,
  onChange: t,
  defaultValue: r,
  direction: n = "vertical",
  className: a,
  optionType: i,
  children: o,
  ...l
}) => {
  const [c, s] = de(r || l.value || []), d = (v, g) => {
    const m = c.map((p) => p.id === v ? {
      id: v,
      specific: g
    } : p);
    s(m), t == null || t(m);
  }, M = Qe(
    () => e == null ? void 0 : e.map((v) => {
      var g, m;
      return typeof v == "string" ? /* @__PURE__ */ u.createElement(_0, {
        optionType: i,
        value: v,
        key: v
      }, v) : "specifiable" in v && v.specifiable ? /* @__PURE__ */ u.createElement(Js, {
        optionType: i,
        disabled: l.disabled,
        checked: (g = c == null ? void 0 : c.map((p) => p.id)) == null ? void 0 : g.includes(v.value),
        key: v.value.toString(),
        onChangeSpecific: d,
        defaultSpecific: (m = c == null ? void 0 : c.find((p) => p.id === v.value)) == null ? void 0 : m.specific,
        ...v
      }, v.label) : /* @__PURE__ */ u.createElement(_0, {
        optionType: i,
        ...v,
        key: v.value.toString()
      }, v.label);
    }),
    [e, c]
  ), f = (v) => {
    const g = v.map((m) => {
      var p;
      return {
        id: m,
        specific: (p = c.find((h) => h.id === m)) == null ? void 0 : p.specific
      };
    });
    s(g), t == null || t(g);
  };
  return /* @__PURE__ */ u.createElement(j0.Group, {
    ...l,
    onChange: f,
    className: Y(Tr.list, Tr[`list--${n}`], a),
    value: c.map((v) => v.id)
  }, M || o);
};
e3.displayName = "CheckboxGroup";
const i8 = _0;
i8.Group = e3;
const o8 = ({ ...e }) => /* @__PURE__ */ u.createElement(gr.Button, {
  ...e
}), l8 = "_radio_1szw8_5", c8 = "_specifiableContainer_1szw8_16", O1 = {
  radio: l8,
  "radio-vertical": "_radio-vertical_1szw8_9",
  "radio-horizontal": "_radio-horizontal_1szw8_13",
  specifiableContainer: c8
}, u8 = ({
  onChangeSpecific: e,
  defaultSpecific: t,
  checked: r,
  ...n
}) => /* @__PURE__ */ u.createElement("div", {
  className: O1.specifiableContainer
}, /* @__PURE__ */ u.createElement(gr, {
  checked: r,
  ...n
}), r && /* @__PURE__ */ u.createElement(Lr, {
  disabled: n.disabled,
  size: "large",
  roundCorners: "large",
  onBlur: on((a) => e(a), "value"),
  defaultValue: t
})), s8 = ({
  direction: e = "vertical",
  onChange: t,
  defaultValue: r,
  options: n,
  className: a,
  children: i,
  ...o
}) => {
  const [l, c] = Ao(null, {
    defaultValue: r,
    value: o.value
  }), s = (f) => {
    const v = {
      id: l.id,
      specific: f
    };
    c(v), t == null || t(v);
  }, d = ({ target: f }) => {
    const v = { id: f.value };
    c(v), t == null || t(v);
  }, M = Qe(
    () => n == null ? void 0 : n.map((f) => typeof f == "string" || typeof f == "number" ? /* @__PURE__ */ u.createElement(gr, {
      key: f,
      value: f
    }, f) : "specifiable" in f && f.specifiable ? /* @__PURE__ */ u.createElement(u8, {
      disabled: o.disabled,
      onChangeSpecific: s,
      defaultSpecific: l == null ? void 0 : l.specific,
      checked: (l == null ? void 0 : l.id) === f.value,
      key: f.value.toString(),
      value: f.value
    }, f.label) : /* @__PURE__ */ u.createElement(gr, {
      value: f.value,
      key: f.value.toString()
    }, f.label)),
    [n, l]
  );
  return /* @__PURE__ */ u.createElement(gr.Group, {
    ...o,
    onChange: d,
    value: l == null ? void 0 : l.id,
    className: Y(
      O1.radio,
      O1[`radio-${o.optionType === "button" ? "horizontal" : e}`],
      a
    )
  }, M || i);
}, d8 = ({ ...e }) => /* @__PURE__ */ u.createElement(gr, {
  ...e
}), f8 = "_radio_1jv9k_5", v8 = "_title_1jv9k_21", M8 = "_icon_1jv9k_22", Ti = {
  radio: f8,
  title: v8,
  icon: M8
}, g8 = ({ children: e, title: t, icon: r, className: n, ...a }) => /* @__PURE__ */ u.createElement(gr, {
  ...a,
  className: Y(Ti.radio, n)
}, /* @__PURE__ */ u.createElement("span", {
  className: Ti.icon
}, r), /* @__PURE__ */ u.createElement("span", {
  className: Ti.title
}, t), /* @__PURE__ */ u.createElement("span", null, e)), p8 = "_radio_14ta5_5", h8 = {
  radio: p8
}, m8 = ({ className: e, ...t }) => /* @__PURE__ */ u.createElement(gr, {
  ...t,
  className: Y(h8.radio, e)
}), P0 = d8;
P0.Button = o8;
P0.Group = s8;
P0.Card = g8;
P0.Space = m8;
const y8 = "_select_1qeei_5", N8 = "_dropdown_1qeei_26", z8 = "_description_1qeei_29", _8 = "_icon_1qeei_45", Zt = {
  select: y8,
  "select--roundCorners": "_select--roundCorners_1qeei_20",
  "select--capitalize": "_select--capitalize_1qeei_23",
  "dropdown--capitalize": "_dropdown--capitalize_1qeei_26",
  dropdown: N8,
  description: z8,
  icon: _8,
  "add-option": "_add-option_1qeei_48",
  "add-option__icon": "_add-option__icon_1qeei_51",
  "add-option__input-container": "_add-option__input-container_1qeei_54"
}, I8 = ({
  className: e,
  capitalize: t,
  popupClassName: r,
  roundCorners: n,
  options: a,
  childrenMode: i = !1,
  ...o
}) => /* @__PURE__ */ u.createElement(e0, {
  ...o,
  className: Y(
    Zt.select,
    { [Zt["select--roundCorners"]]: n },
    { [Zt["select--capitalize"]]: t },
    e
  ),
  popupClassName: Y(
    Zt.dropdown,
    {
      [Zt["dropdown--capitalize"]]: t
    },
    r
  ),
  showArrow: !0,
  suffixIcon: /* @__PURE__ */ u.createElement(Ku, null)
}, i ? o.children : a == null ? void 0 : a.map((l) => typeof l == "string" || typeof l == "number" ? /* @__PURE__ */ u.createElement(e0.Option, {
  value: l,
  key: l
}, l) : /* @__PURE__ */ u.createElement(e0.Option, {
  key: l.value,
  value: l.value,
  disabled: l.disabled
}, (l == null ? void 0 : l.icon) && /* @__PURE__ */ u.createElement("i", {
  className: Zt.icon
}, l.icon), /* @__PURE__ */ u.createElement(u.Fragment, null, l.label), l.description && /* @__PURE__ */ u.createElement(ve, {
  type: "secondary",
  size: "small",
  className: Zt.description
}, l.description)))), bt = I8;
bt.Option = e0.Option;
const IA = ({
  limit: e,
  onChange: t,
  ...r
}) => {
  const [n, a] = de([]), i = (l, c) => {
    a(l), t == null || t(l, c);
  }, o = Qe(
    () => Array.isArray(n) && e && (n == null ? void 0 : n.length) >= e ? !1 : void 0,
    [n, e]
  );
  return /* @__PURE__ */ u.createElement(bt, {
    defaultValue: n,
    onChange: i,
    ...r,
    mode: "multiple",
    open: o
  });
}, DA = ({ options: e = [], onChange: t, ...r }) => {
  const [n, a] = de(!1), [i, o] = de([]), l = u.useRef(null), c = () => a(!0), s = () => a(!1), [d, M] = de(r.value), f = (p) => {
    var h;
    o([...i, p]), M(p.value), s(), document.activeElement && ((h = document.activeElement) == null || h.blur());
  }, v = ({ key: p, currentTarget: h }) => {
    if (p !== "Enter")
      return;
    const { value: y } = h;
    if (!y.trim())
      return;
    f({
      value: y,
      label: y
    });
  }, g = (p) => /* @__PURE__ */ u.createElement(u.Fragment, null, p, /* @__PURE__ */ u.createElement("div", {
    onKeyDown: (h) => h.stopPropagation()
  }, n ? /* @__PURE__ */ u.createElement("div", {
    className: Zt["add-option__input-container"]
  }, /* @__PURE__ */ u.createElement(_o, {
    placeholder: "Enter",
    onKeyDown: v,
    allowClear: !0
  })) : /* @__PURE__ */ u.createElement("div", {
    onClick: c,
    className: Y(
      "evercity-ui-select-item evercity-ui-select-item-option",
      Zt["add-option"]
    )
  }, /* @__PURE__ */ u.createElement("i", {
    className: Zt["add-option__icon"]
  }, /* @__PURE__ */ u.createElement(w0, null)), /* @__PURE__ */ u.createElement("span", null, "Add variant")))), m = (p, h) => {
    M(p), t == null || t(p, h);
  };
  return /* @__PURE__ */ u.createElement("div", {
    ref: l
  }, /* @__PURE__ */ u.createElement(bt, {
    ...r,
    onChange: m,
    value: d,
    options: [...e, ...i],
    dropdownRender: g
  }));
}, Hc = {
  "date-roundCorners": "_date-roundCorners_a85kk_1"
}, D8 = ({
  value: e,
  roundCorners: t,
  className: r,
  ...n
}) => /* @__PURE__ */ u.createElement(Zu, {
  placeholder: "",
  value: e && Bd(e),
  ...n,
  className: Y(
    Hc.date,
    { [Hc["date-roundCorners"]]: t },
    r
  )
}), C8 = D8;
C8.RangePicker = Zu.RangePicker;
const Wc = {
  "title-small": "_title-small_swigm_5",
  "title-medium": "_title-medium_swigm_9",
  "title-large": "_title-large_swigm_13"
}, fn = ({ size: e = "medium", className: t, ...r }) => /* @__PURE__ */ u.createElement(ra.Title, {
  ...r,
  className: Y(Wc.title, { [Wc[`title-${e}`]]: e }, t)
}), Si = {
  "paragraph-small": "_paragraph-small_1wrfn_5",
  "paragraph-large": "_paragraph-large_1wrfn_8",
  "paragraph-extra-large": "_paragraph-extra-large_1wrfn_11",
  "paragraph-medium": "_paragraph-medium_1wrfn_15",
  "paragraph-weight-bold": "_paragraph-weight-bold_1wrfn_19"
}, Fo = ({ size: e = "medium", className: t, weight: r, ...n }) => /* @__PURE__ */ u.createElement(ra.Paragraph, {
  ...n,
  className: Y(
    Si.paragraph,
    {
      [Si[`paragraph-${e}`]]: e,
      [Si[`paragraph-weight-${r}`]]: r
    },
    t
  )
}), E8 = "_container_12iyl_1", b8 = "_container__content_12iyl_1", Li = {
  container: E8,
  container__content: b8,
  "container--without_title__content": "_container--without_title__content_12iyl_4",
  "container__content--one": "_container__content--one_12iyl_11"
}, CA = ({ title: e, number: t, children: r, className: n }) => /* @__PURE__ */ u.createElement("div", {
  className: Y(Li.container, n)
}, e && /* @__PURE__ */ u.createElement(fn, {
  level: 3,
  size: "small"
}, t, " ", e), /* @__PURE__ */ u.createElement("div", {
  className: Y(Li.container__content, {
    [Li["container--without_title__content"]]: !e
  })
}, r)), A8 = "_container_q6ibz_5", j8 = "_container__description_q6ibz_14", x8 = "_container__content_q6ibz_23", w8 = "_container__title_q6ibz_33", sr = {
  container: A8,
  container__description: j8,
  container__content: x8,
  "container__content--describe": "_container__content--describe_q6ibz_26",
  "container__border--bottom": "_container__border--bottom_q6ibz_29",
  container__title: w8,
  "container__title--optional": "_container__title--optional_q6ibz_38",
  "thread-wrapper": "_thread-wrapper_q6ibz_41"
}, O8 = "_wrapper_9kvzz_5", T8 = "_container_9kvzz_11", S8 = "_thread_9kvzz_17", Yn = {
  wrapper: O8,
  container: T8,
  thread: S8,
  "thread--open": "_thread--open_9kvzz_35",
  "thread--submitted": "_thread--submitted_9kvzz_39",
  "thread--default": "_thread--default_9kvzz_43",
  "thread--active": "_thread--active_9kvzz_43"
}, L8 = "_button_orange_1jtti_5", k8 = "_button_green_1jtti_22", P8 = {
  button_orange: L8,
  "button_orange-alpha": "_button_orange-alpha_1jtti_14",
  button_green: k8,
  "button_gray-alpha": "_button_gray-alpha_1jtti_31"
}, _e = ({ className: e, appearance: t, ...r }) => /* @__PURE__ */ u.createElement(ta, {
  className: Y(e, {
    [P8[`button_${t}`]]: Boolean(t)
  }),
  ...r
}), ki = ({ count: e, onClick: t, status: r, active: n }) => /* @__PURE__ */ u.createElement(_e, {
  size: "middle",
  onClick: (a) => t(a, r),
  className: Y(Yn.thread, Yn[`thread--${r}`], {
    [Yn["thread--active"]]: n
  }),
  icon: n ? /* @__PURE__ */ u.createElement(wd, null) : /* @__PURE__ */ u.createElement(Od, null)
}, e);
var c0 = /* @__PURE__ */ ((e) => (e.Open = "open", e.Submitted = "submitted", e.Default = "default", e))(c0 || {});
const t3 = (e) => Qe(() => {
  var r, n, a, i, o, l, c, s, d;
  if (!e)
    return null;
  const t = [];
  return ((r = e.open) == null ? void 0 : r.count) && e.open.count > 0 && t.push(
    /* @__PURE__ */ u.createElement(ki, {
      status: c0.Open,
      active: (n = e.open) == null ? void 0 : n.active,
      count: (a = e.open) == null ? void 0 : a.count,
      onClick: e.onClickThread
    })
  ), ((i = e.submitted) == null ? void 0 : i.count) && e.submitted.count > 0 && t.push(
    /* @__PURE__ */ u.createElement(ki, {
      active: (o = e.submitted) == null ? void 0 : o.active,
      status: c0.Submitted,
      count: (l = e.submitted) == null ? void 0 : l.count,
      onClick: e.onClickThread
    })
  ), ((c = e.submitted) == null ? void 0 : c.count) || ((s = e.open) == null ? void 0 : s.count) || t.push(
    /* @__PURE__ */ u.createElement(ki, {
      status: c0.Default,
      active: (d = e.open) == null ? void 0 : d.active,
      onClick: e.onClickThread
    })
  ), /* @__PURE__ */ u.createElement("div", {
    className: Yn.wrapper
  }, /* @__PURE__ */ u.createElement("div", {
    className: Yn.container
  }, t));
}, [e]), r3 = u.createContext({
  openCount: 0,
  submittedCount: 0
}), n3 = ({ children: e, openCount: t, submittedCount: r }) => /* @__PURE__ */ u.createElement(r3.Provider, {
  value: {
    openCount: t,
    submittedCount: r
  }
}, e), EA = ({
  number: e,
  title: t,
  children: r,
  description: n,
  border: a = null,
  optional: i,
  discussions: o,
  extra: l,
  ...c
}) => {
  var d, M;
  const s = t3(o);
  return /* @__PURE__ */ u.createElement(n3, {
    openCount: ((d = o == null ? void 0 : o.open) == null ? void 0 : d.count) || 0,
    submittedCount: ((M = o == null ? void 0 : o.submitted) == null ? void 0 : M.count) || 0
  }, /* @__PURE__ */ u.createElement("div", {
    className: Y(sr.container, {
      [sr[`container__border--${a}`]]: a
    }),
    ...c
  }, t && /* @__PURE__ */ u.createElement("div", {
    className: sr["thread-wrapper"]
  }, /* @__PURE__ */ u.createElement(ve, {
    size: "large",
    strong: !0,
    className: Y(sr.container__title, {
      [sr["container__title--optional"]]: i
    })
  }, e, " ", t), s, l && /* @__PURE__ */ u.createElement("div", null, l)), n && /* @__PURE__ */ u.createElement("div", {
    className: sr.container__description
  }, n, !t && s), /* @__PURE__ */ u.createElement("div", {
    className: Y(
      sr.container__content,
      n && sr["container__content--describe"]
    )
  }, r)));
}, R8 = "_step_928as_5", Q8 = "_current_928as_33", V8 = "_currentText_928as_43", U8 = "_next_928as_50", F8 = "_nextText_928as_60", $8 = "_done_928as_67", Z8 = "_doneText_928as_77", Y8 = "_stepsBlock_928as_85", H8 = "_progress_928as_93", W8 = "_progress__title_928as_97", B8 = "_percent_928as_100", q8 = "_progress__inner_928as_103", G8 = "_progressTitle_928as_106", ft = {
  step: R8,
  current: Q8,
  currentText: V8,
  next: U8,
  nextText: F8,
  done: $8,
  doneText: Z8,
  stepsBlock: Y8,
  progress: H8,
  progress__title: W8,
  percent: B8,
  progress__inner: q8,
  progressTitle: G8
}, { Step: K8 } = Yu, X8 = ({ steps: e, stepIndex: t = 0, setStepIndex: r, progress: n }) => /* @__PURE__ */ u.createElement(Yu, {
  className: ft.stepsBlock,
  current: t,
  direction: "vertical",
  onChange: r
}, e.map((a) => /* @__PURE__ */ u.createElement(K8, {
  disabled: n && e.some((i) => {
    if (i.id < a.id && !i.optional)
      return !n[i.id] || n[i.id] < 100;
  }),
  className: ft.step,
  key: a.id,
  title: a.title,
  description: /* @__PURE__ */ u.createElement("div", {
    className: ft.progress
  }, /* @__PURE__ */ u.createElement(ve, {
    type: "secondary",
    className: ft.progress__title
  }, "Progress:"), /* @__PURE__ */ u.createElement("div", {
    className: ft.progress__inner
  }, /* @__PURE__ */ u.createElement(Hu, {
    showInfo: !1,
    type: "line",
    size: "small",
    strokeWidth: 8,
    strokeColor: "#91DCA6",
    percent: n && n[a.id]
  }), /* @__PURE__ */ u.createElement(ve, {
    className: Y(ft.progress__title, ft.percent),
    type: "secondary"
  }, n && n[a.id] || 0, "%"))),
  icon: /* @__PURE__ */ u.createElement("div", {
    className: Y(
      t === a.id && ft.current,
      t < a.id && ft.next,
      t > a.id && ft.done
    )
  }, t === a.id && /* @__PURE__ */ u.createElement(ve, {
    className: ft.currentText
  }, a.id + 1), t < a.id && /* @__PURE__ */ u.createElement(ve, {
    className: ft.nextText
  }, a.id + 1), t > a.id && /* @__PURE__ */ u.createElement(yo, {
    className: ft.doneText
  }))
}))), bA = yd(X8), $o = ({ ...e }) => /* @__PURE__ */ u.createElement(_d, {
  ...e
}), Gn = ({ ...e }) => /* @__PURE__ */ u.createElement(Id, {
  ...e
});
var a3 = {}, we = { exports: {} };
(function(e) {
  function t() {
    return e.exports = t = Object.assign ? Object.assign.bind() : function(r) {
      for (var n = 1; n < arguments.length; n++) {
        var a = arguments[n];
        for (var i in a)
          Object.prototype.hasOwnProperty.call(a, i) && (r[i] = a[i]);
      }
      return r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t.apply(this, arguments);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(we);
var vn = {}, Ze = { exports: {} }, rt = { exports: {} };
(function(e) {
  function t(r, n, a) {
    return n in r ? Object.defineProperty(r, n, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : r[n] = a, r;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(rt);
(function(e) {
  var t = rt.exports;
  function r(a, i) {
    var o = Object.keys(a);
    if (Object.getOwnPropertySymbols) {
      var l = Object.getOwnPropertySymbols(a);
      i && (l = l.filter(function(c) {
        return Object.getOwnPropertyDescriptor(a, c).enumerable;
      })), o.push.apply(o, l);
    }
    return o;
  }
  function n(a) {
    for (var i = 1; i < arguments.length; i++) {
      var o = arguments[i] != null ? arguments[i] : {};
      i % 2 ? r(Object(o), !0).forEach(function(l) {
        t(a, l, o[l]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(o)) : r(Object(o)).forEach(function(l) {
        Object.defineProperty(a, l, Object.getOwnPropertyDescriptor(o, l));
      });
    }
    return a;
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(Ze);
var J8 = X.exports.default;
Object.defineProperty(vn, "__esModule", {
  value: !0
});
vn.default = t9;
var e9 = J8(Ze.exports);
function t9(e, t) {
  var r = (0, e9.default)({}, e);
  return Array.isArray(t) && t.forEach(function(n) {
    delete r[n];
  }), r;
}
var Fr = {}, Rt = {};
Object.defineProperty(Rt, "__esModule", {
  value: !0
});
Rt.call = Zo;
Rt.default = void 0;
Rt.note = o3;
Rt.noteOnce = n9;
Rt.resetWarned = r9;
Rt.warning = i3;
Rt.warningOnce = l3;
var T1 = {};
function i3(e, t) {
  process.env.NODE_ENV !== "production" && !e && console !== void 0 && console.error("Warning: ".concat(t));
}
function o3(e, t) {
  process.env.NODE_ENV !== "production" && !e && console !== void 0 && console.warn("Note: ".concat(t));
}
function r9() {
  T1 = {};
}
function Zo(e, t, r) {
  !t && !T1[r] && (e(!1, r), T1[r] = !0);
}
function l3(e, t) {
  Zo(i3, e, t);
}
function n9(e, t) {
  Zo(o3, e, t);
}
var a9 = l3;
Rt.default = a9;
(function(e) {
  var t = le.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0, e.noop = n, Object.defineProperty(e, "resetWarned", {
    enumerable: !0,
    get: function() {
      return r.resetWarned;
    }
  });
  var r = t(Rt);
  function n() {
  }
  var a = n;
  process.env.NODE_ENV !== "production" && (a = function(l, c, s) {
    (0, r.default)(l, "[antd: ".concat(c, "] ").concat(s)), process.env.NODE_ENV === "test" && (0, r.resetWarned)();
  });
  var i = a;
  e.default = i;
})(Fr);
var c3 = {}, S1 = { exports: {} }, R0 = {}, xa = {}, Bc;
function i9() {
  if (Bc)
    return xa;
  Bc = 1, Object.defineProperty(xa, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, name: "check", theme: "outlined" };
  return xa.default = e, xa;
}
var An = {}, Pi = { exports: {} }, Ri = { exports: {} }, qc;
function o9() {
  return qc || (qc = 1, function(e) {
    function t(r, n) {
      if (r == null)
        return {};
      var a = {}, i = Object.keys(r), o, l;
      for (l = 0; l < i.length; l++)
        o = i[l], !(n.indexOf(o) >= 0) && (a[o] = r[o]);
      return a;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ri)), Ri.exports;
}
var Gc;
function u3() {
  return Gc || (Gc = 1, function(e) {
    var t = o9();
    function r(n, a) {
      if (n == null)
        return {};
      var i = t(n, a), o, l;
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(n);
        for (l = 0; l < c.length; l++)
          o = c[l], !(a.indexOf(o) >= 0) && (!Object.prototype.propertyIsEnumerable.call(n, o) || (i[o] = n[o]));
      }
      return i;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Pi)), Pi.exports;
}
var Mn = {};
Object.defineProperty(Mn, "__esModule", {
  value: !0
});
Mn.default = void 0;
var l9 = u, c9 = /* @__PURE__ */ (0, l9.createContext)({}), u9 = c9;
Mn.default = u9;
var jn = {}, et = {};
const s3 = /* @__PURE__ */ yr(t6);
var gn = {}, Yo = {};
Object.defineProperty(Yo, "__esModule", {
  value: !0
});
Yo.default = s9;
function s9(e, t) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(t);
  for (var r = t; r; ) {
    if (r === e)
      return !0;
    r = r.parentNode;
  }
  return !1;
}
var d3 = X.exports.default;
Object.defineProperty(gn, "__esModule", {
  value: !0
});
gn.injectCSS = Wo;
gn.removeCSS = g9;
gn.updateCSS = h9;
var d9 = d3(Vr), f9 = d3(Yo), Kc = "data-rc-order", v9 = "rc-util-key", L1 = /* @__PURE__ */ new Map();
function f3() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.mark;
  return t ? t.startsWith("data-") ? t : "data-".concat(t) : v9;
}
function Ho(e) {
  if (e.attachTo)
    return e.attachTo;
  var t = document.querySelector("head");
  return t || document.body;
}
function M9(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function v3(e) {
  return Array.from((L1.get(e) || e).children).filter(function(t) {
    return t.tagName === "STYLE";
  });
}
function Wo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!(0, d9.default)())
    return null;
  var r = t.csp, n = t.prepend, a = document.createElement("style");
  a.setAttribute(Kc, M9(n)), r != null && r.nonce && (a.nonce = r == null ? void 0 : r.nonce), a.innerHTML = e;
  var i = Ho(t), o = i.firstChild;
  if (n) {
    if (n === "queue") {
      var l = v3(i).filter(function(c) {
        return ["prepend", "prependQueue"].includes(c.getAttribute(Kc));
      });
      if (l.length)
        return i.insertBefore(a, l[l.length - 1].nextSibling), a;
    }
    i.insertBefore(a, o);
  } else
    i.appendChild(a);
  return a;
}
function M3(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = Ho(t);
  return v3(r).find(function(n) {
    return n.getAttribute(f3(t)) === e;
  });
}
function g9(e) {
  var t, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = M3(e, r);
  n == null || (t = n.parentNode) === null || t === void 0 || t.removeChild(n);
}
function p9(e, t) {
  var r = L1.get(e);
  if (!r || !(0, f9.default)(document, r)) {
    var n = Wo("", t), a = n.parentNode;
    L1.set(e, a), a.removeChild(n);
  }
}
function h9(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = Ho(r);
  p9(n, r);
  var a = M3(t, r);
  if (a) {
    var i, o;
    if (((i = r.csp) === null || i === void 0 ? void 0 : i.nonce) && a.nonce !== ((o = r.csp) === null || o === void 0 ? void 0 : o.nonce)) {
      var l;
      a.nonce = (l = r.csp) === null || l === void 0 ? void 0 : l.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var c = Wo(e, r);
  return c.setAttribute(f3(r), t), c;
}
var Xc;
function Bo() {
  if (Xc)
    return et;
  Xc = 1;
  var e = le.exports, t = X.exports;
  Object.defineProperty(et, "__esModule", {
    value: !0
  }), et.warning = s, et.isIconDefinition = d, et.normalizeAttrs = M, et.generate = f, et.getSecondaryColor = v, et.normalizeTwoToneColors = g, et.useInsertStyles = et.iconStyles = et.svgBaseProps = void 0;
  var r = t(Ze.exports), n = t(ct.exports), a = s3, i = e(u), o = t(Rt), l = gn, c = t(Mn);
  function s(y, N) {
    (0, o.default)(y, "[@ant-design/icons] ".concat(N));
  }
  function d(y) {
    return (0, n.default)(y) === "object" && typeof y.name == "string" && typeof y.theme == "string" && ((0, n.default)(y.icon) === "object" || typeof y.icon == "function");
  }
  function M() {
    var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.keys(y).reduce(function(N, I) {
      var D = y[I];
      switch (I) {
        case "class":
          N.className = D, delete N.class;
          break;
        default:
          N[I] = D;
      }
      return N;
    }, {});
  }
  function f(y, N, I) {
    return I ? /* @__PURE__ */ i.default.createElement(y.tag, (0, r.default)((0, r.default)({
      key: N
    }, M(y.attrs)), I), (y.children || []).map(function(D, A) {
      return f(D, "".concat(N, "-").concat(y.tag, "-").concat(A));
    })) : /* @__PURE__ */ i.default.createElement(y.tag, (0, r.default)({
      key: N
    }, M(y.attrs)), (y.children || []).map(function(D, A) {
      return f(D, "".concat(N, "-").concat(y.tag, "-").concat(A));
    }));
  }
  function v(y) {
    return (0, a.generate)(y)[0];
  }
  function g(y) {
    return y ? Array.isArray(y) ? y : [y] : [];
  }
  var m = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
  };
  et.svgBaseProps = m;
  var p = `
.anticon {
  display: inline-block;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
  et.iconStyles = p;
  var h = function() {
    var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : p, I = (0, i.useContext)(c.default), D = I.csp;
    (0, i.useEffect)(function() {
      (0, l.updateCSS)(N, "@ant-design-icons", {
        prepend: !0,
        csp: D
      });
    }, []);
  };
  return et.useInsertStyles = h, et;
}
var Jc;
function g3() {
  if (Jc)
    return jn;
  Jc = 1;
  var e = X.exports;
  Object.defineProperty(jn, "__esModule", {
    value: !0
  }), jn.default = void 0;
  var t = e(u3()), r = e(Ze.exports), n = Bo(), a = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], i = {
    primaryColor: "#333",
    secondaryColor: "#E6E6E6",
    calculated: !1
  };
  function o(d) {
    var M = d.primaryColor, f = d.secondaryColor;
    i.primaryColor = M, i.secondaryColor = f || (0, n.getSecondaryColor)(M), i.calculated = !!f;
  }
  function l() {
    return (0, r.default)({}, i);
  }
  var c = function(M) {
    var f = M.icon, v = M.className, g = M.onClick, m = M.style, p = M.primaryColor, h = M.secondaryColor, y = (0, t.default)(M, a), N = i;
    if (p && (N = {
      primaryColor: p,
      secondaryColor: h || (0, n.getSecondaryColor)(p)
    }), (0, n.useInsertStyles)(), (0, n.warning)((0, n.isIconDefinition)(f), "icon should be icon definiton, but got ".concat(f)), !(0, n.isIconDefinition)(f))
      return null;
    var I = f;
    return I && typeof I.icon == "function" && (I = (0, r.default)((0, r.default)({}, I), {}, {
      icon: I.icon(N.primaryColor, N.secondaryColor)
    })), (0, n.generate)(I.icon, "svg-".concat(I.name), (0, r.default)({
      className: v,
      onClick: g,
      style: m,
      "data-icon": I.name,
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true"
    }, y));
  };
  c.displayName = "IconReact", c.getTwoToneColors = l, c.setTwoToneColors = o;
  var s = c;
  return jn.default = s, jn;
}
var xn = {}, e2;
function m9() {
  if (e2)
    return xn;
  e2 = 1;
  var e = X.exports;
  Object.defineProperty(xn, "__esModule", {
    value: !0
  }), xn.setTwoToneColor = a, xn.getTwoToneColor = i;
  var t = e(gt.exports), r = e(g3()), n = Bo();
  function a(o) {
    var l = (0, n.normalizeTwoToneColors)(o), c = (0, t.default)(l, 2), s = c[0], d = c[1];
    return r.default.setTwoToneColors({
      primaryColor: s,
      secondaryColor: d
    });
  }
  function i() {
    var o = r.default.getTwoToneColors();
    return o.calculated ? [o.primaryColor, o.secondaryColor] : o.primaryColor;
  }
  return xn;
}
var t2;
function ut() {
  if (t2)
    return An;
  t2 = 1;
  var e = X.exports, t = le.exports;
  Object.defineProperty(An, "__esModule", {
    value: !0
  }), An.default = void 0;
  var r = e(Ze.exports), n = e(gt.exports), a = e(rt.exports), i = e(u3()), o = t(u), l = e(Y), c = e(Mn), s = e(g3()), d = m9(), M = Bo(), f = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
  (0, d.setTwoToneColor)("#1890ff");
  var v = /* @__PURE__ */ o.forwardRef(function(m, p) {
    var h, y = m.className, N = m.icon, I = m.spin, D = m.rotate, A = m.tabIndex, k = m.onClick, L = m.twoToneColor, T = (0, i.default)(m, f), C = o.useContext(c.default), j = C.prefixCls, w = j === void 0 ? "anticon" : j, E = (0, l.default)(w, (h = {}, (0, a.default)(h, "".concat(w, "-").concat(N.name), !!N.name), (0, a.default)(h, "".concat(w, "-spin"), !!I || N.name === "loading"), h), y), _ = A;
    _ === void 0 && k && (_ = -1);
    var b = D ? {
      msTransform: "rotate(".concat(D, "deg)"),
      transform: "rotate(".concat(D, "deg)")
    } : void 0, O = (0, M.normalizeTwoToneColors)(L), S = (0, n.default)(O, 2), R = S[0], V = S[1];
    return /* @__PURE__ */ o.createElement("span", (0, r.default)((0, r.default)({
      role: "img",
      "aria-label": N.name
    }, T), {}, {
      ref: p,
      tabIndex: _,
      onClick: k,
      className: E
    }), /* @__PURE__ */ o.createElement(s.default, {
      icon: N,
      primaryColor: R,
      secondaryColor: V,
      style: b
    }));
  });
  v.displayName = "AntdIcon", v.getTwoToneColor = d.getTwoToneColor, v.setTwoToneColor = d.setTwoToneColor;
  var g = v;
  return An.default = g, An;
}
var y9 = le.exports, qo = X.exports;
Object.defineProperty(R0, "__esModule", {
  value: !0
});
R0.default = void 0;
var r2 = qo(Ze.exports), p3 = y9(u), N9 = qo(i9()), z9 = qo(ut()), h3 = function(t, r) {
  return /* @__PURE__ */ p3.createElement(z9.default, (0, r2.default)((0, r2.default)({}, t), {}, {
    ref: r,
    icon: N9.default
  }));
};
h3.displayName = "CheckOutlined";
var _9 = /* @__PURE__ */ p3.forwardRef(h3);
R0.default = _9;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(R0);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(S1, S1.exports);
var k1 = { exports: {} }, Q0 = {}, wa = {}, n2;
function I9() {
  if (n2)
    return wa;
  n2 = 1, Object.defineProperty(wa, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, name: "copy", theme: "outlined" };
  return wa.default = e, wa;
}
var D9 = le.exports, Go = X.exports;
Object.defineProperty(Q0, "__esModule", {
  value: !0
});
Q0.default = void 0;
var a2 = Go(Ze.exports), m3 = D9(u), C9 = Go(I9()), E9 = Go(ut()), y3 = function(t, r) {
  return /* @__PURE__ */ m3.createElement(E9.default, (0, a2.default)((0, a2.default)({}, t), {}, {
    ref: r,
    icon: C9.default
  }));
};
y3.displayName = "CopyOutlined";
var b9 = /* @__PURE__ */ m3.forwardRef(y3);
Q0.default = b9;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(Q0);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(k1, k1.exports);
var P1 = { exports: {} }, V0 = {}, Oa = {}, i2;
function A9() {
  if (i2)
    return Oa;
  i2 = 1, Object.defineProperty(Oa, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" };
  return Oa.default = e, Oa;
}
var j9 = le.exports, Ko = X.exports;
Object.defineProperty(V0, "__esModule", {
  value: !0
});
V0.default = void 0;
var o2 = Ko(Ze.exports), N3 = j9(u), x9 = Ko(A9()), w9 = Ko(ut()), z3 = function(t, r) {
  return /* @__PURE__ */ N3.createElement(w9.default, (0, o2.default)((0, o2.default)({}, t), {}, {
    ref: r,
    icon: x9.default
  }));
};
z3.displayName = "EditOutlined";
var O9 = /* @__PURE__ */ N3.forwardRef(z3);
V0.default = O9;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(V0);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(P1, P1.exports);
var T9 = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, r = [], n = 0; n < e.rangeCount; n++)
    r.push(e.getRangeAt(n));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
      e.addRange(a);
    }), t && t.focus();
  };
}, S9 = T9, l2 = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, L9 = "Copy to clipboard: #{key}, Enter";
function k9(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function P9(e, t) {
  var r, n, a, i, o, l, c = !1;
  t || (t = {}), r = t.debug || !1;
  try {
    a = S9(), i = document.createRange(), o = document.getSelection(), l = document.createElement("span"), l.textContent = e, l.ariaHidden = "true", l.style.all = "unset", l.style.position = "fixed", l.style.top = 0, l.style.clip = "rect(0, 0, 0, 0)", l.style.whiteSpace = "pre", l.style.webkitUserSelect = "text", l.style.MozUserSelect = "text", l.style.msUserSelect = "text", l.style.userSelect = "text", l.addEventListener("copy", function(d) {
      if (d.stopPropagation(), t.format)
        if (d.preventDefault(), typeof d.clipboardData > "u") {
          r && console.warn("unable to use e.clipboardData"), r && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var M = l2[t.format] || l2.default;
          window.clipboardData.setData(M, e);
        } else
          d.clipboardData.clearData(), d.clipboardData.setData(t.format, e);
      t.onCopy && (d.preventDefault(), t.onCopy(d.clipboardData));
    }), document.body.appendChild(l), i.selectNodeContents(l), o.addRange(i);
    var s = document.execCommand("copy");
    if (!s)
      throw new Error("copy command was unsuccessful");
    c = !0;
  } catch (d) {
    r && console.error("unable to copy using execCommand: ", d), r && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), c = !0;
    } catch (M) {
      r && console.error("unable to copy using clipboardData: ", M), r && console.error("falling back to prompt"), n = k9("message" in t ? t.message : L9), window.prompt(n, e);
    }
  } finally {
    o && (typeof o.removeRange == "function" ? o.removeRange(i) : o.removeAllRanges()), l && document.body.removeChild(l), a();
  }
  return c;
}
var R9 = P9, _3 = function() {
  if (typeof Map < "u")
    return Map;
  function e(t, r) {
    var n = -1;
    return t.some(function(a, i) {
      return a[0] === r ? (n = i, !0) : !1;
    }), n;
  }
  return function() {
    function t() {
      this.__entries__ = [];
    }
    return Object.defineProperty(t.prototype, "size", {
      get: function() {
        return this.__entries__.length;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.get = function(r) {
      var n = e(this.__entries__, r), a = this.__entries__[n];
      return a && a[1];
    }, t.prototype.set = function(r, n) {
      var a = e(this.__entries__, r);
      ~a ? this.__entries__[a][1] = n : this.__entries__.push([r, n]);
    }, t.prototype.delete = function(r) {
      var n = this.__entries__, a = e(n, r);
      ~a && n.splice(a, 1);
    }, t.prototype.has = function(r) {
      return !!~e(this.__entries__, r);
    }, t.prototype.clear = function() {
      this.__entries__.splice(0);
    }, t.prototype.forEach = function(r, n) {
      n === void 0 && (n = null);
      for (var a = 0, i = this.__entries__; a < i.length; a++) {
        var o = i[a];
        r.call(n, o[1], o[0]);
      }
    }, t;
  }();
}(), R1 = typeof window < "u" && typeof document < "u" && window.document === document, I0 = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Q9 = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(I0) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), V9 = 2;
function U9(e, t) {
  var r = !1, n = !1, a = 0;
  function i() {
    r && (r = !1, e()), n && l();
  }
  function o() {
    Q9(i);
  }
  function l() {
    var c = Date.now();
    if (r) {
      if (c - a < V9)
        return;
      n = !0;
    } else
      r = !0, n = !1, setTimeout(o, t);
    a = c;
  }
  return l;
}
var F9 = 20, $9 = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Z9 = typeof MutationObserver < "u", Y9 = function() {
  function e() {
    this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = U9(this.refresh.bind(this), F9);
  }
  return e.prototype.addObserver = function(t) {
    ~this.observers_.indexOf(t) || this.observers_.push(t), this.connected_ || this.connect_();
  }, e.prototype.removeObserver = function(t) {
    var r = this.observers_, n = r.indexOf(t);
    ~n && r.splice(n, 1), !r.length && this.connected_ && this.disconnect_();
  }, e.prototype.refresh = function() {
    var t = this.updateObservers_();
    t && this.refresh();
  }, e.prototype.updateObservers_ = function() {
    var t = this.observers_.filter(function(r) {
      return r.gatherActive(), r.hasActive();
    });
    return t.forEach(function(r) {
      return r.broadcastActive();
    }), t.length > 0;
  }, e.prototype.connect_ = function() {
    !R1 || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Z9 ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
      attributes: !0,
      childList: !0,
      characterData: !0,
      subtree: !0
    })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
  }, e.prototype.disconnect_ = function() {
    !R1 || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
  }, e.prototype.onTransitionEnd_ = function(t) {
    var r = t.propertyName, n = r === void 0 ? "" : r, a = $9.some(function(i) {
      return !!~n.indexOf(i);
    });
    a && this.refresh();
  }, e.getInstance = function() {
    return this.instance_ || (this.instance_ = new e()), this.instance_;
  }, e.instance_ = null, e;
}(), I3 = function(e, t) {
  for (var r = 0, n = Object.keys(t); r < n.length; r++) {
    var a = n[r];
    Object.defineProperty(e, a, {
      value: t[a],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, ln = function(e) {
  var t = e && e.ownerDocument && e.ownerDocument.defaultView;
  return t || I0;
}, D3 = U0(0, 0, 0, 0);
function D0(e) {
  return parseFloat(e) || 0;
}
function c2(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  return t.reduce(function(n, a) {
    var i = e["border-" + a + "-width"];
    return n + D0(i);
  }, 0);
}
function H9(e) {
  for (var t = ["top", "right", "bottom", "left"], r = {}, n = 0, a = t; n < a.length; n++) {
    var i = a[n], o = e["padding-" + i];
    r[i] = D0(o);
  }
  return r;
}
function W9(e) {
  var t = e.getBBox();
  return U0(0, 0, t.width, t.height);
}
function B9(e) {
  var t = e.clientWidth, r = e.clientHeight;
  if (!t && !r)
    return D3;
  var n = ln(e).getComputedStyle(e), a = H9(n), i = a.left + a.right, o = a.top + a.bottom, l = D0(n.width), c = D0(n.height);
  if (n.boxSizing === "border-box" && (Math.round(l + i) !== t && (l -= c2(n, "left", "right") + i), Math.round(c + o) !== r && (c -= c2(n, "top", "bottom") + o)), !G9(e)) {
    var s = Math.round(l + i) - t, d = Math.round(c + o) - r;
    Math.abs(s) !== 1 && (l -= s), Math.abs(d) !== 1 && (c -= d);
  }
  return U0(a.left, a.top, l, c);
}
var q9 = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof ln(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof ln(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function G9(e) {
  return e === ln(e).document.documentElement;
}
function K9(e) {
  return R1 ? q9(e) ? W9(e) : B9(e) : D3;
}
function X9(e) {
  var t = e.x, r = e.y, n = e.width, a = e.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, o = Object.create(i.prototype);
  return I3(o, {
    x: t,
    y: r,
    width: n,
    height: a,
    top: r,
    right: t + n,
    bottom: a + r,
    left: t
  }), o;
}
function U0(e, t, r, n) {
  return { x: e, y: t, width: r, height: n };
}
var J9 = function() {
  function e(t) {
    this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = U0(0, 0, 0, 0), this.target = t;
  }
  return e.prototype.isActive = function() {
    var t = K9(this.target);
    return this.contentRect_ = t, t.width !== this.broadcastWidth || t.height !== this.broadcastHeight;
  }, e.prototype.broadcastRect = function() {
    var t = this.contentRect_;
    return this.broadcastWidth = t.width, this.broadcastHeight = t.height, t;
  }, e;
}(), e7 = function() {
  function e(t, r) {
    var n = X9(r);
    I3(this, { target: t, contentRect: n });
  }
  return e;
}(), t7 = function() {
  function e(t, r, n) {
    if (this.activeObservations_ = [], this.observations_ = new _3(), typeof t != "function")
      throw new TypeError("The callback provided as parameter 1 is not a function.");
    this.callback_ = t, this.controller_ = r, this.callbackCtx_ = n;
  }
  return e.prototype.observe = function(t) {
    if (!arguments.length)
      throw new TypeError("1 argument required, but only 0 present.");
    if (!(typeof Element > "u" || !(Element instanceof Object))) {
      if (!(t instanceof ln(t).Element))
        throw new TypeError('parameter 1 is not of type "Element".');
      var r = this.observations_;
      r.has(t) || (r.set(t, new J9(t)), this.controller_.addObserver(this), this.controller_.refresh());
    }
  }, e.prototype.unobserve = function(t) {
    if (!arguments.length)
      throw new TypeError("1 argument required, but only 0 present.");
    if (!(typeof Element > "u" || !(Element instanceof Object))) {
      if (!(t instanceof ln(t).Element))
        throw new TypeError('parameter 1 is not of type "Element".');
      var r = this.observations_;
      !r.has(t) || (r.delete(t), r.size || this.controller_.removeObserver(this));
    }
  }, e.prototype.disconnect = function() {
    this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
  }, e.prototype.gatherActive = function() {
    var t = this;
    this.clearActive(), this.observations_.forEach(function(r) {
      r.isActive() && t.activeObservations_.push(r);
    });
  }, e.prototype.broadcastActive = function() {
    if (!!this.hasActive()) {
      var t = this.callbackCtx_, r = this.activeObservations_.map(function(n) {
        return new e7(n.target, n.broadcastRect());
      });
      this.callback_.call(t, r, t), this.clearActive();
    }
  }, e.prototype.clearActive = function() {
    this.activeObservations_.splice(0);
  }, e.prototype.hasActive = function() {
    return this.activeObservations_.length > 0;
  }, e;
}(), C3 = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new _3(), E3 = function() {
  function e(t) {
    if (!(this instanceof e))
      throw new TypeError("Cannot call a class as a function.");
    if (!arguments.length)
      throw new TypeError("1 argument required, but only 0 present.");
    var r = Y9.getInstance(), n = new t7(t, r, this);
    C3.set(this, n);
  }
  return e;
}();
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  E3.prototype[e] = function() {
    var t;
    return (t = C3.get(this))[e].apply(t, arguments);
  };
});
var b3 = function() {
  return typeof I0.ResizeObserver < "u" ? I0.ResizeObserver : E3;
}(), nr = /* @__PURE__ */ new Map();
function A3(e) {
  e.forEach(function(t) {
    var r, n = t.target;
    (r = nr.get(n)) === null || r === void 0 || r.forEach(function(a) {
      return a(n);
    });
  });
}
var j3 = new b3(A3);
process.env.NODE_ENV;
process.env.NODE_ENV;
function r7(e, t) {
  nr.has(e) || (nr.set(e, /* @__PURE__ */ new Set()), j3.observe(e)), nr.get(e).add(t);
}
function n7(e, t) {
  nr.has(e) && (nr.get(e).delete(t), nr.get(e).size || (j3.unobserve(e), nr.delete(e)));
}
var a7 = /* @__PURE__ */ function(e) {
  Nr(r, e);
  var t = zr(r);
  function r() {
    return Bt(this, r), t.apply(this, arguments);
  }
  return qt(r, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), r;
}(z.Component), Q1 = /* @__PURE__ */ z.createContext(null);
function i7(e) {
  var t = e.children, r = e.onBatchResize, n = z.useRef(0), a = z.useRef([]), i = z.useContext(Q1), o = z.useCallback(function(l, c, s) {
    n.current += 1;
    var d = n.current;
    a.current.push({
      size: l,
      element: c,
      data: s
    }), Promise.resolve().then(function() {
      d === n.current && (r == null || r(a.current), a.current = []);
    }), i == null || i(l, c, s);
  }, [r, i]);
  return /* @__PURE__ */ z.createElement(Q1.Provider, {
    value: o
  }, t);
}
function o7(e) {
  var t = e.children, r = e.disabled, n = z.useRef(null), a = z.useRef(null), i = z.useContext(Q1), o = typeof t == "function", l = o ? t(n) : t, c = z.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  }), s = !o && /* @__PURE__ */ z.isValidElement(l) && So(l), d = s ? l.ref : null, M = z.useMemo(function() {
    return To(d, n);
  }, [d, n]), f = z.useRef(e);
  f.current = e;
  var v = z.useCallback(function(g) {
    var m = f.current, p = m.onResize, h = m.data, y = g.getBoundingClientRect(), N = y.width, I = y.height, D = g.offsetWidth, A = g.offsetHeight, k = Math.floor(N), L = Math.floor(I);
    if (c.current.width !== k || c.current.height !== L || c.current.offsetWidth !== D || c.current.offsetHeight !== A) {
      var T = {
        width: k,
        height: L,
        offsetWidth: D,
        offsetHeight: A
      };
      c.current = T;
      var C = D === Math.round(N) ? N : D, j = A === Math.round(I) ? I : A, w = H(H({}, T), {}, {
        offsetWidth: C,
        offsetHeight: j
      });
      i == null || i(w, g, h), p && Promise.resolve().then(function() {
        p(w, g);
      });
    }
  }, []);
  return z.useEffect(function() {
    var g = z0(n.current) || z0(a.current);
    return g && !r && r7(g, v), function() {
      return n7(g, v);
    };
  }, [n.current, r]), /* @__PURE__ */ z.createElement(a7, {
    ref: a
  }, s ? /* @__PURE__ */ z.cloneElement(l, {
    ref: M
  }) : l);
}
var l7 = "rc-observer-key";
function Xo(e) {
  var t = e.children, r = typeof t == "function" ? [t] : y0(t);
  return process.env.NODE_ENV !== "production" && (r.length > 1 ? v1(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && v1(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(n, a) {
    var i = (n == null ? void 0 : n.key) || "".concat(l7, "-").concat(a);
    return /* @__PURE__ */ z.createElement(o7, Pe({}, e, {
      key: i
    }), n);
  });
}
Xo.Collection = i7;
const c7 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xo
}, Symbol.toStringTag, { value: "Module" })), u7 = /* @__PURE__ */ yr(c7);
var va = {}, s7 = X.exports.default;
Object.defineProperty(va, "__esModule", {
  value: !0
});
va.default = V1;
var d7 = s7(u), f7 = sa.exports;
function V1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [];
  return d7.default.Children.forEach(e, function(n) {
    n == null && !t.keepEmpty || (Array.isArray(n) ? r = r.concat(V1(n)) : (0, f7.isFragment)(n) && n.props ? r = r.concat(V1(n.props.children, t)) : r.push(n));
  }), r;
}
var _r = {}, F0 = {}, v7 = le.exports.default;
Object.defineProperty(F0, "__esModule", {
  value: !0
});
F0.default = g7;
var M7 = v7(u);
function g7(e, t, r) {
  var n = M7.useRef({});
  return (!("value" in n.current) || r(n.current.condition, t)) && (n.current.value = e(), n.current.condition = t), n.current.value;
}
var x3 = X.exports.default;
Object.defineProperty(_r, "__esModule", {
  value: !0
});
_r.composeRef = O3;
_r.fillRef = w3;
_r.supportRef = N7;
_r.useComposeRef = y7;
var p7 = x3(ct.exports), h7 = sa.exports, m7 = x3(F0);
function w3(e, t) {
  typeof e == "function" ? e(t) : (0, p7.default)(e) === "object" && e && "current" in e && (e.current = t);
}
function O3() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = t.filter(function(a) {
    return a;
  });
  return n.length <= 1 ? n[0] : function(a) {
    t.forEach(function(i) {
      w3(i, a);
    });
  };
}
function y7() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return (0, m7.default)(function() {
    return O3.apply(void 0, t);
  }, t, function(n, a) {
    return n.length === a.length && n.every(function(i, o) {
      return i === a[o];
    });
  });
}
function N7(e) {
  var t, r, n = (0, h7.isMemo)(e) ? e.type.type : e.type;
  return !(typeof n == "function" && !(!((t = n.prototype) === null || t === void 0) && t.render) || typeof e == "function" && !(!((r = e.prototype) === null || r === void 0) && r.render));
}
var Qi = {};
const T3 = /* @__PURE__ */ yr(sv);
var S3 = {}, $0 = {}, Z0 = {}, Y0 = {};
Object.defineProperty(Y0, "__esModule", {
  value: !0
});
Y0.default = void 0;
var z7 = {
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
};
Y0.default = z7;
var L3 = {}, Jo = {}, H0 = {};
Object.defineProperty(H0, "__esModule", {
  value: !0
});
H0.default = void 0;
var _7 = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
}, I7 = _7;
H0.default = I7;
var el = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = {
    placeholder: "Select time",
    rangePlaceholder: ["Start time", "End time"]
  }, r = t;
  e.default = r;
})(el);
(function(e) {
  var t = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = t(we.exports), n = t(H0), a = t(el), i = {
    lang: (0, r.default)({
      placeholder: "Select date",
      yearPlaceholder: "Select year",
      quarterPlaceholder: "Select quarter",
      monthPlaceholder: "Select month",
      weekPlaceholder: "Select week",
      rangePlaceholder: ["Start date", "End date"],
      rangeYearPlaceholder: ["Start year", "End year"],
      rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
      rangeMonthPlaceholder: ["Start month", "End month"],
      rangeWeekPlaceholder: ["Start week", "End week"]
    }, n.default),
    timePickerLocale: (0, r.default)({}, a.default)
  }, o = i;
  e.default = o;
})(Jo);
(function(e) {
  var t = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = t(Jo), n = r.default;
  e.default = n;
})(L3);
(function(e) {
  var t = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = t(Y0), n = t(L3), a = t(Jo), i = t(el), o = "${label} is not a valid ${type}", l = {
    locale: "en",
    Pagination: r.default,
    DatePicker: a.default,
    TimePicker: i.default,
    Calendar: n.default,
    global: {
      placeholder: "Please select"
    },
    Table: {
      filterTitle: "Filter menu",
      filterConfirm: "OK",
      filterReset: "Reset",
      filterEmptyText: "No filters",
      filterCheckall: "Select all items",
      filterSearchPlaceholder: "Search in filters",
      emptyText: "No data",
      selectAll: "Select current page",
      selectInvert: "Invert current page",
      selectNone: "Clear all data",
      selectionAll: "Select all data",
      sortTitle: "Sort",
      expand: "Expand row",
      collapse: "Collapse row",
      triggerDesc: "Click to sort descending",
      triggerAsc: "Click to sort ascending",
      cancelSort: "Click to cancel sorting"
    },
    Modal: {
      okText: "OK",
      cancelText: "Cancel",
      justOkText: "OK"
    },
    Popconfirm: {
      okText: "OK",
      cancelText: "Cancel"
    },
    Transfer: {
      titles: ["", ""],
      searchPlaceholder: "Search here",
      itemUnit: "item",
      itemsUnit: "items",
      remove: "Remove",
      selectCurrent: "Select current page",
      removeCurrent: "Remove current page",
      selectAll: "Select all data",
      removeAll: "Remove all data",
      selectInvert: "Invert current page"
    },
    Upload: {
      uploading: "Uploading...",
      removeFile: "Remove file",
      uploadError: "Upload error",
      previewFile: "Preview file",
      downloadFile: "Download file"
    },
    Empty: {
      description: "No data"
    },
    Icon: {
      icon: "icon"
    },
    Text: {
      edit: "Edit",
      copy: "Copy",
      copied: "Copied",
      expand: "Expand"
    },
    PageHeader: {
      back: "Back"
    },
    Form: {
      optional: "(optional)",
      defaultValidateMessages: {
        default: "Field validation error for ${label}",
        required: "Please enter ${label}",
        enum: "${label} must be one of [${enum}]",
        whitespace: "${label} cannot be a blank character",
        date: {
          format: "${label} date format is invalid",
          parse: "${label} cannot be converted to a date",
          invalid: "${label} is an invalid date"
        },
        types: {
          string: o,
          method: o,
          array: o,
          object: o,
          number: o,
          date: o,
          boolean: o,
          integer: o,
          float: o,
          regexp: o,
          email: o,
          url: o,
          hex: o
        },
        string: {
          len: "${label} must be ${len} characters",
          min: "${label} must be at least ${min} characters",
          max: "${label} must be up to ${max} characters",
          range: "${label} must be between ${min}-${max} characters"
        },
        number: {
          len: "${label} must be equal to ${len}",
          min: "${label} must be minimum ${min}",
          max: "${label} must be maximum ${max}",
          range: "${label} must be between ${min}-${max}"
        },
        array: {
          len: "Must be ${len} ${label}",
          min: "At least ${min} ${label}",
          max: "At most ${max} ${label}",
          range: "The amount of ${label} must be between ${min}-${max}"
        },
        pattern: {
          mismatch: "${label} does not match the pattern ${pattern}"
        }
      }
    },
    Image: {
      preview: "Preview"
    }
  }, c = l;
  e.default = c;
})(Z0);
var k3 = X.exports.default;
Object.defineProperty($0, "__esModule", {
  value: !0
});
$0.changeConfirmLocale = D7;
$0.getConfirmLocale = C7;
var u0 = k3(we.exports), P3 = k3(Z0), s0 = (0, u0.default)({}, P3.default.Modal);
function D7(e) {
  e ? s0 = (0, u0.default)((0, u0.default)({}, s0), e) : s0 = (0, u0.default)({}, P3.default.Modal);
}
function C7() {
  return s0;
}
var tl = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = u, r = /* @__PURE__ */ (0, t.createContext)(void 0), n = r;
  e.default = n;
})(tl);
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.ANT_MARK = void 0;
  var n = r(we.exports), a = t(u), i = r(Fr), o = $0, l = r(tl), c = "internalMark";
  e.ANT_MARK = c;
  var s = function(f) {
    var v = f.locale, g = v === void 0 ? {} : v, m = f.children, p = f._ANT_MARK__;
    process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (0, i.default)(p === c, "LocaleProvider", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale"), a.useEffect(function() {
      return (0, o.changeConfirmLocale)(g && g.Modal), function() {
        (0, o.changeConfirmLocale)();
      };
    }, [g]);
    var h = a.useMemo(function() {
      return (0, n.default)((0, n.default)({}, g), {
        exist: !0
      });
    }, [g]);
    return /* @__PURE__ */ a.createElement(l.default.Provider, {
      value: h
    }, m);
  }, d = s;
  e.default = d;
})(S3);
var rl = {}, R3 = {};
(function(e) {
  var t = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = t(Z0), n = r.default;
  e.default = n;
})(R3);
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.useLocaleReceiver = e.default = void 0;
  var n = r(we.exports), a = t(u), i = r(tl), o = r(R3), l = function(M) {
    var f = M.componentName, v = f === void 0 ? "global" : f, g = M.defaultLocale, m = M.children, p = a.useContext(i.default), h = a.useMemo(function() {
      var N, I = g || o.default[v], D = (N = p == null ? void 0 : p[v]) !== null && N !== void 0 ? N : {};
      return (0, n.default)((0, n.default)({}, I instanceof Function ? I() : I), D || {});
    }, [v, g, p]), y = a.useMemo(function() {
      var N = p && p.locale;
      return p && p.exist && !N ? o.default.locale : N;
    }, [p]);
    return m(h, y, p);
  }, c = l;
  e.default = c;
  var s = function(M, f) {
    var v = a.useContext(i.default), g = a.useMemo(function() {
      var m, p = f || o.default[M], h = (m = v == null ? void 0 : v[M]) !== null && m !== void 0 ? m : {};
      return (0, n.default)((0, n.default)({}, typeof p == "function" ? p() : p), h || {});
    }, [M, f, v]);
    return [g];
  };
  e.useLocaleReceiver = s;
})(rl);
var Vi = {}, U1 = { exports: {} }, W0 = {}, Ta = {}, u2;
function E7() {
  if (u2)
    return Ta;
  u2 = 1, Object.defineProperty(Ta, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
  return Ta.default = e, Ta;
}
var b7 = le.exports, nl = X.exports;
Object.defineProperty(W0, "__esModule", {
  value: !0
});
W0.default = void 0;
var s2 = nl(Ze.exports), Q3 = b7(u), A7 = nl(E7()), j7 = nl(ut()), V3 = function(t, r) {
  return /* @__PURE__ */ Q3.createElement(j7.default, (0, s2.default)((0, s2.default)({}, t), {}, {
    ref: r,
    icon: A7.default
  }));
};
V3.displayName = "CheckCircleFilled";
var x7 = /* @__PURE__ */ Q3.forwardRef(V3);
W0.default = x7;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(W0);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(U1, U1.exports);
var Kn = { exports: {} }, B0 = {}, Sa = {}, d2;
function w7() {
  if (d2)
    return Sa;
  d2 = 1, Object.defineProperty(Sa, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] }, name: "close-circle", theme: "filled" };
  return Sa.default = e, Sa;
}
var O7 = le.exports, al = X.exports;
Object.defineProperty(B0, "__esModule", {
  value: !0
});
B0.default = void 0;
var f2 = al(Ze.exports), U3 = O7(u), T7 = al(w7()), S7 = al(ut()), F3 = function(t, r) {
  return /* @__PURE__ */ U3.createElement(S7.default, (0, f2.default)((0, f2.default)({}, t), {}, {
    ref: r,
    icon: T7.default
  }));
};
F3.displayName = "CloseCircleFilled";
var L7 = /* @__PURE__ */ U3.forwardRef(F3);
B0.default = L7;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(B0);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(Kn, Kn.exports);
var F1 = { exports: {} }, q0 = {}, La = {}, v2;
function k7() {
  if (v2)
    return La;
  v2 = 1, Object.defineProperty(La, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
  return La.default = e, La;
}
var P7 = le.exports, il = X.exports;
Object.defineProperty(q0, "__esModule", {
  value: !0
});
q0.default = void 0;
var M2 = il(Ze.exports), $3 = P7(u), R7 = il(k7()), Q7 = il(ut()), Z3 = function(t, r) {
  return /* @__PURE__ */ $3.createElement(Q7.default, (0, M2.default)((0, M2.default)({}, t), {}, {
    ref: r,
    icon: R7.default
  }));
};
Z3.displayName = "ExclamationCircleFilled";
var V7 = /* @__PURE__ */ $3.forwardRef(Z3);
q0.default = V7;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(q0);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(F1, F1.exports);
var $1 = { exports: {} }, G0 = {}, ka = {}, g2;
function U7() {
  if (g2)
    return ka;
  g2 = 1, Object.defineProperty(ka, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
  return ka.default = e, ka;
}
var F7 = le.exports, ol = X.exports;
Object.defineProperty(G0, "__esModule", {
  value: !0
});
G0.default = void 0;
var p2 = ol(Ze.exports), Y3 = F7(u), $7 = ol(U7()), Z7 = ol(ut()), H3 = function(t, r) {
  return /* @__PURE__ */ Y3.createElement(Z7.default, (0, p2.default)((0, p2.default)({}, t), {}, {
    ref: r,
    icon: $7.default
  }));
};
H3.displayName = "InfoCircleFilled";
var Y7 = /* @__PURE__ */ Y3.forwardRef(H3);
G0.default = Y7;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(G0);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})($1, $1.exports);
var Z1 = { exports: {} }, K0 = {}, Pa = {}, h2;
function H7() {
  if (h2)
    return Pa;
  h2 = 1, Object.defineProperty(Pa, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
  return Pa.default = e, Pa;
}
var W7 = le.exports, ll = X.exports;
Object.defineProperty(K0, "__esModule", {
  value: !0
});
K0.default = void 0;
var m2 = ll(Ze.exports), W3 = W7(u), B7 = ll(H7()), q7 = ll(ut()), B3 = function(t, r) {
  return /* @__PURE__ */ W3.createElement(q7.default, (0, m2.default)((0, m2.default)({}, t), {}, {
    ref: r,
    icon: B7.default
  }));
};
B3.displayName = "LoadingOutlined";
var G7 = /* @__PURE__ */ W3.forwardRef(B3);
K0.default = G7;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(K0);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(Z1, Z1.exports);
const q3 = /* @__PURE__ */ yr(Uv);
var Ui = {}, X0 = {}, cl = { exports: {} }, G3 = { exports: {} };
(function(e) {
  var t = Do.exports;
  function r(n) {
    if (Array.isArray(n))
      return t(n);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(G3);
var K3 = { exports: {} };
(function(e) {
  function t(r) {
    if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null)
      return Array.from(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(K3);
var X3 = { exports: {} };
(function(e) {
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(X3);
(function(e) {
  var t = G3.exports, r = K3.exports, n = Io.exports, a = X3.exports;
  function i(o) {
    return t(o) || r(o) || n(o) || a();
  }
  e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
})(cl);
var wn = {}, ul = { exports: {} };
(function(e) {
  function t(r, n) {
    if (!(r instanceof n))
      throw new TypeError("Cannot call a class as a function");
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ul);
var sl = { exports: {} };
(function(e) {
  function t(n, a) {
    for (var i = 0; i < a.length; i++) {
      var o = a[i];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(n, o.key, o);
    }
  }
  function r(n, a, i) {
    return a && t(n.prototype, a), i && t(n, i), Object.defineProperty(n, "prototype", {
      writable: !1
    }), n;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(sl);
var dl = { exports: {} }, J3 = { exports: {} };
(function(e) {
  function t(r, n) {
    return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, o) {
      return i.__proto__ = o, i;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r, n);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(J3);
(function(e) {
  var t = J3.exports;
  function r(n, a) {
    if (typeof a != "function" && a !== null)
      throw new TypeError("Super expression must either be null or a function");
    n.prototype = Object.create(a && a.prototype, {
      constructor: {
        value: n,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(n, "prototype", {
      writable: !1
    }), a && t(n, a);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(dl);
var fl = { exports: {} }, e4 = { exports: {} };
(function(e) {
  function t(r) {
    return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
      return a.__proto__ || Object.getPrototypeOf(a);
    }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(e4);
var t4 = { exports: {} };
(function(e) {
  function t() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(t4);
var r4 = { exports: {} }, n4 = { exports: {} };
(function(e) {
  function t(r) {
    if (r === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return r;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(n4);
(function(e) {
  var t = ct.exports.default, r = n4.exports;
  function n(a, i) {
    if (i && (t(i) === "object" || typeof i == "function"))
      return i;
    if (i !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return r(a);
  }
  e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
})(r4);
(function(e) {
  var t = e4.exports, r = t4.exports, n = r4.exports;
  function a(i) {
    var o = r();
    return function() {
      var c = t(i), s;
      if (o) {
        var d = t(this).constructor;
        s = Reflect.construct(c, arguments, d);
      } else
        s = c.apply(this, arguments);
      return n(this, s);
    };
  }
  e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
})(fl);
var y2;
function K7() {
  if (y2)
    return wn;
  y2 = 1;
  var e = X.exports, t = ct.exports;
  Object.defineProperty(wn, "__esModule", {
    value: !0
  }), wn.default = void 0;
  var r = e(we.exports), n = e(rt.exports), a = e(ul.exports), i = e(sl.exports), o = e(dl.exports), l = e(fl.exports), c = f(u), s = e(Sr), d = e(Y);
  function M(g) {
    if (typeof WeakMap != "function")
      return null;
    var m = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap();
    return (M = function(y) {
      return y ? p : m;
    })(g);
  }
  function f(g, m) {
    if (!m && g && g.__esModule)
      return g;
    if (g === null || t(g) !== "object" && typeof g != "function")
      return { default: g };
    var p = M(m);
    if (p && p.has(g))
      return p.get(g);
    var h = {}, y = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var N in g)
      if (N !== "default" && Object.prototype.hasOwnProperty.call(g, N)) {
        var I = y ? Object.getOwnPropertyDescriptor(g, N) : null;
        I && (I.get || I.set) ? Object.defineProperty(h, N, I) : h[N] = g[N];
      }
    return h.default = g, p && p.set(g, h), h;
  }
  var v = /* @__PURE__ */ function(g) {
    (0, o.default)(p, g);
    var m = (0, l.default)(p);
    function p() {
      var h;
      (0, a.default)(this, p);
      for (var y = arguments.length, N = new Array(y), I = 0; I < y; I++)
        N[I] = arguments[I];
      return h = m.call.apply(m, [this].concat(N)), h.closeTimer = null, h.close = function(D) {
        D && D.stopPropagation(), h.clearCloseTimer();
        var A = h.props, k = A.onClose, L = A.noticeKey;
        k && k(L);
      }, h.startCloseTimer = function() {
        h.props.duration && (h.closeTimer = window.setTimeout(function() {
          h.close();
        }, h.props.duration * 1e3));
      }, h.clearCloseTimer = function() {
        h.closeTimer && (clearTimeout(h.closeTimer), h.closeTimer = null);
      }, h;
    }
    return (0, i.default)(p, [{
      key: "componentDidMount",
      value: function() {
        this.startCloseTimer();
      }
    }, {
      key: "componentDidUpdate",
      value: function(y) {
        (this.props.duration !== y.duration || this.props.updateMark !== y.updateMark || this.props.visible !== y.visible && this.props.visible) && this.restartCloseTimer();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.clearCloseTimer();
      }
    }, {
      key: "restartCloseTimer",
      value: function() {
        this.clearCloseTimer(), this.startCloseTimer();
      }
    }, {
      key: "render",
      value: function() {
        var y = this, N = this.props, I = N.prefixCls, D = N.className, A = N.closable, k = N.closeIcon, L = N.style, T = N.onClick, C = N.children, j = N.holder, w = "".concat(I, "-notice"), E = Object.keys(this.props).reduce(function(b, O) {
          return (O.substr(0, 5) === "data-" || O.substr(0, 5) === "aria-" || O === "role") && (b[O] = y.props[O]), b;
        }, {}), _ = /* @__PURE__ */ c.createElement("div", (0, r.default)({
          className: (0, d.default)(w, D, (0, n.default)({}, "".concat(w, "-closable"), A)),
          style: L,
          onMouseEnter: this.clearCloseTimer,
          onMouseLeave: this.startCloseTimer,
          onClick: T
        }, E), /* @__PURE__ */ c.createElement("div", {
          className: "".concat(w, "-content")
        }, C), A ? /* @__PURE__ */ c.createElement("a", {
          tabIndex: 0,
          onClick: this.close,
          className: "".concat(w, "-close")
        }, k || /* @__PURE__ */ c.createElement("span", {
          className: "".concat(w, "-close-x")
        })) : null);
        return j ? /* @__PURE__ */ s.default.createPortal(_, j) : _;
      }
    }]), p;
  }(c.Component);
  return wn.default = v, v.defaultProps = {
    onClose: function() {
    },
    duration: 1.5
  }, wn;
}
var J0 = X.exports, X7 = ct.exports;
Object.defineProperty(X0, "__esModule", {
  value: !0
});
X0.default = nM;
var N2 = J0(cl.exports), J7 = J0(we.exports), eM = J0(gt.exports), On = rM(u), tM = J0(K7());
function a4(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (a4 = function(a) {
    return a ? r : t;
  })(e);
}
function rM(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || X7(e) !== "object" && typeof e != "function")
    return { default: e };
  var r = a4(t);
  if (r && r.has(e))
    return r.get(e);
  var n = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(n, i, o) : n[i] = e[i];
    }
  return n.default = e, r && r.set(e, n), n;
}
function nM(e) {
  var t = On.useRef({}), r = On.useState([]), n = (0, eM.default)(r, 2), a = n[0], i = n[1];
  function o(l) {
    var c = !0;
    e.add(l, function(s, d) {
      var M = d.key;
      if (s && (!t.current[M] || c)) {
        var f = /* @__PURE__ */ On.createElement(tM.default, (0, J7.default)({}, d, {
          holder: s
        }));
        t.current[M] = f, i(function(v) {
          var g = v.findIndex(function(p) {
            return p.key === d.key;
          });
          if (g === -1)
            return [].concat((0, N2.default)(v), [f]);
          var m = (0, N2.default)(v);
          return m[g] = f, m;
        });
      }
      c = !1;
    });
  }
  return [o, /* @__PURE__ */ On.createElement(On.Fragment, null, a)];
}
var z2;
function aM() {
  return z2 || (z2 = 1, function(e) {
    var t = le.exports.default, r = X.exports.default;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = s;
    var n = r(we.exports), a = r(gt.exports), i = r(X0), o = t(u), l = i4(), c = Gt();
    function s(d, M) {
      var f = function() {
        var g, m, p = null, h = {
          add: function(T, C) {
            p == null || p.component.add(T, C);
          }
        }, y = (0, i.default)(h), N = (0, a.default)(y, 2), I = N[0], D = N[1];
        function A(L) {
          var T = L.prefixCls, C = g("message", T), j = g(), w = L.key || (0, l.getKeyThenIncreaseKey)(), E = new Promise(function(b) {
            var O = function() {
              return typeof L.onClose == "function" && L.onClose(), b(!0);
            };
            d((0, n.default)((0, n.default)({}, L), {
              prefixCls: C,
              rootPrefixCls: j,
              getPopupContainer: m
            }), function(S) {
              var R = S.prefixCls, V = S.instance;
              p = V, I(M((0, n.default)((0, n.default)({}, L), {
                key: w,
                onClose: O
              }), R));
            });
          }), _ = function() {
            p && p.removeNotice(w);
          };
          return _.then = function(b, O) {
            return E.then(b, O);
          }, _.promise = E, _;
        }
        var k = o.useRef({});
        return k.current.open = A, l.typeList.forEach(function(L) {
          return (0, l.attachTypeApi)(k.current, L);
        }), [k.current, /* @__PURE__ */ o.createElement(c.ConfigConsumer, {
          key: "holder"
        }, function(L) {
          return g = L.getPrefixCls, m = L.getPopupContainer, D;
        })];
      };
      return f;
    }
  }(Ui)), Ui;
}
var _2;
function i4() {
  return _2 || (_2 = 1, function(e) {
    var t = le.exports.default, r = X.exports.default;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.attachTypeApi = R, e.getInstance = e.default = void 0, e.getKeyThenIncreaseKey = T, e.typeList = void 0;
    var n = r(we.exports), a = r(rt.exports), i = r(U1.exports), o = r(Kn.exports), l = r(F1.exports), c = r($1.exports), s = r(Z1.exports), d = r(Y), M = r(q3), f = t(u), v = t(Gt()), g = r(aM()), m, p = 3, h, y = 1, N = "", I = "move-up", D = !1, A, k, L = !1;
    function T() {
      return y++;
    }
    function C(x) {
      x.top !== void 0 && (h = x.top, m = null), x.duration !== void 0 && (p = x.duration), x.prefixCls !== void 0 && (N = x.prefixCls), x.getContainer !== void 0 && (A = x.getContainer, m = null), x.transitionName !== void 0 && (I = x.transitionName, m = null, D = !0), x.maxCount !== void 0 && (k = x.maxCount, m = null), x.rtl !== void 0 && (L = x.rtl);
    }
    function j(x, P) {
      var U = x.prefixCls, F = x.getPopupContainer, $ = (0, v.globalConfig)(), W = $.getPrefixCls, te = $.getRootPrefixCls, J = $.getIconPrefixCls, q = W("message", U || N), B = te(x.rootPrefixCls, q), G = J();
      if (m) {
        P({
          prefixCls: q,
          rootPrefixCls: B,
          iconPrefixCls: G,
          instance: m
        });
        return;
      }
      var Z = {
        prefixCls: q,
        transitionName: D ? I : "".concat(B, "-").concat(I),
        style: {
          top: h
        },
        getContainer: A || F,
        maxCount: k
      };
      M.default.newInstance(Z, function(K) {
        if (m) {
          P({
            prefixCls: q,
            rootPrefixCls: B,
            iconPrefixCls: G,
            instance: m
          });
          return;
        }
        m = K, process.env.NODE_ENV === "test" && (m.config = Z), P({
          prefixCls: q,
          rootPrefixCls: B,
          iconPrefixCls: G,
          instance: K
        });
      });
    }
    var w = {
      info: c.default,
      success: i.default,
      error: o.default,
      warning: l.default,
      loading: s.default
    }, E = Object.keys(w);
    e.typeList = E;
    function _(x, P, U) {
      var F, $ = x.duration !== void 0 ? x.duration : p, W = w[x.type], te = (0, d.default)("".concat(P, "-custom-content"), (F = {}, (0, a.default)(F, "".concat(P, "-").concat(x.type), x.type), (0, a.default)(F, "".concat(P, "-rtl"), L === !0), F));
      return {
        key: x.key,
        duration: $,
        style: x.style || {},
        className: x.className,
        content: /* @__PURE__ */ f.createElement(v.default, {
          iconPrefixCls: U
        }, /* @__PURE__ */ f.createElement("div", {
          className: te
        }, x.icon || W && /* @__PURE__ */ f.createElement(W, null), /* @__PURE__ */ f.createElement("span", null, x.content))),
        onClose: x.onClose,
        onClick: x.onClick
      };
    }
    function b(x) {
      var P = x.key || T(), U = new Promise(function($) {
        var W = function() {
          return typeof x.onClose == "function" && x.onClose(), $(!0);
        };
        j(x, function(te) {
          var J = te.prefixCls, q = te.iconPrefixCls, B = te.instance;
          B.notice(_((0, n.default)((0, n.default)({}, x), {
            key: P,
            onClose: W
          }), J, q));
        });
      }), F = function() {
        var W;
        m && (m.removeNotice(P), (W = x.onClose) === null || W === void 0 || W.call(x));
      };
      return F.then = function($, W) {
        return U.then($, W);
      }, F.promise = U, F;
    }
    function O(x) {
      return Object.prototype.toString.call(x) === "[object Object]" && !!x.content;
    }
    var S = {
      open: b,
      config: C,
      destroy: function(P) {
        if (m)
          if (P) {
            var U = m, F = U.removeNotice;
            F(P);
          } else {
            var $ = m, W = $.destroy;
            W(), m = null;
          }
      }
    };
    function R(x, P) {
      x[P] = function(U, F, $) {
        return O(U) ? x.open((0, n.default)((0, n.default)({}, U), {
          type: P
        })) : (typeof F == "function" && ($ = F, F = void 0), x.open({
          content: U,
          duration: F,
          type: P,
          onClose: $
        }));
      };
    }
    E.forEach(function(x) {
      return R(S, x);
    }), S.warn = S.warning, S.useMessage = (0, g.default)(j, _);
    var V = function() {
      return process.env.NODE_ENV === "test" ? m : null;
    };
    e.getInstance = V;
    var Q = S;
    e.default = Q;
  }(Vi)), Vi;
}
var Fi = {}, o4 = { exports: {} };
(function(e) {
  var t = ct.exports.default;
  function r() {
    e.exports = r = function() {
      return n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
    var n = {}, a = Object.prototype, i = a.hasOwnProperty, o = typeof Symbol == "function" ? Symbol : {}, l = o.iterator || "@@iterator", c = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
    function d(E, _, b) {
      return Object.defineProperty(E, _, {
        value: b,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), E[_];
    }
    try {
      d({}, "");
    } catch {
      d = function(b, O, S) {
        return b[O] = S;
      };
    }
    function M(E, _, b, O) {
      var S = _ && _.prototype instanceof g ? _ : g, R = Object.create(S.prototype), V = new C(O || []);
      return R._invoke = function(Q, x, P) {
        var U = "suspendedStart";
        return function(F, $) {
          if (U === "executing")
            throw new Error("Generator is already running");
          if (U === "completed") {
            if (F === "throw")
              throw $;
            return w();
          }
          for (P.method = F, P.arg = $; ; ) {
            var W = P.delegate;
            if (W) {
              var te = k(W, P);
              if (te) {
                if (te === v)
                  continue;
                return te;
              }
            }
            if (P.method === "next")
              P.sent = P._sent = P.arg;
            else if (P.method === "throw") {
              if (U === "suspendedStart")
                throw U = "completed", P.arg;
              P.dispatchException(P.arg);
            } else
              P.method === "return" && P.abrupt("return", P.arg);
            U = "executing";
            var J = f(Q, x, P);
            if (J.type === "normal") {
              if (U = P.done ? "completed" : "suspendedYield", J.arg === v)
                continue;
              return {
                value: J.arg,
                done: P.done
              };
            }
            J.type === "throw" && (U = "completed", P.method = "throw", P.arg = J.arg);
          }
        };
      }(E, b, V), R;
    }
    function f(E, _, b) {
      try {
        return {
          type: "normal",
          arg: E.call(_, b)
        };
      } catch (O) {
        return {
          type: "throw",
          arg: O
        };
      }
    }
    n.wrap = M;
    var v = {};
    function g() {
    }
    function m() {
    }
    function p() {
    }
    var h = {};
    d(h, l, function() {
      return this;
    });
    var y = Object.getPrototypeOf, N = y && y(y(j([])));
    N && N !== a && i.call(N, l) && (h = N);
    var I = p.prototype = g.prototype = Object.create(h);
    function D(E) {
      ["next", "throw", "return"].forEach(function(_) {
        d(E, _, function(b) {
          return this._invoke(_, b);
        });
      });
    }
    function A(E, _) {
      function b(S, R, V, Q) {
        var x = f(E[S], E, R);
        if (x.type !== "throw") {
          var P = x.arg, U = P.value;
          return U && t(U) == "object" && i.call(U, "__await") ? _.resolve(U.__await).then(function(F) {
            b("next", F, V, Q);
          }, function(F) {
            b("throw", F, V, Q);
          }) : _.resolve(U).then(function(F) {
            P.value = F, V(P);
          }, function(F) {
            return b("throw", F, V, Q);
          });
        }
        Q(x.arg);
      }
      var O;
      this._invoke = function(S, R) {
        function V() {
          return new _(function(Q, x) {
            b(S, R, Q, x);
          });
        }
        return O = O ? O.then(V, V) : V();
      };
    }
    function k(E, _) {
      var b = E.iterator[_.method];
      if (b === void 0) {
        if (_.delegate = null, _.method === "throw") {
          if (E.iterator.return && (_.method = "return", _.arg = void 0, k(E, _), _.method === "throw"))
            return v;
          _.method = "throw", _.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return v;
      }
      var O = f(b, E.iterator, _.arg);
      if (O.type === "throw")
        return _.method = "throw", _.arg = O.arg, _.delegate = null, v;
      var S = O.arg;
      return S ? S.done ? (_[E.resultName] = S.value, _.next = E.nextLoc, _.method !== "return" && (_.method = "next", _.arg = void 0), _.delegate = null, v) : S : (_.method = "throw", _.arg = new TypeError("iterator result is not an object"), _.delegate = null, v);
    }
    function L(E) {
      var _ = {
        tryLoc: E[0]
      };
      1 in E && (_.catchLoc = E[1]), 2 in E && (_.finallyLoc = E[2], _.afterLoc = E[3]), this.tryEntries.push(_);
    }
    function T(E) {
      var _ = E.completion || {};
      _.type = "normal", delete _.arg, E.completion = _;
    }
    function C(E) {
      this.tryEntries = [{
        tryLoc: "root"
      }], E.forEach(L, this), this.reset(!0);
    }
    function j(E) {
      if (E) {
        var _ = E[l];
        if (_)
          return _.call(E);
        if (typeof E.next == "function")
          return E;
        if (!isNaN(E.length)) {
          var b = -1, O = function S() {
            for (; ++b < E.length; )
              if (i.call(E, b))
                return S.value = E[b], S.done = !1, S;
            return S.value = void 0, S.done = !0, S;
          };
          return O.next = O;
        }
      }
      return {
        next: w
      };
    }
    function w() {
      return {
        value: void 0,
        done: !0
      };
    }
    return m.prototype = p, d(I, "constructor", p), d(p, "constructor", m), m.displayName = d(p, s, "GeneratorFunction"), n.isGeneratorFunction = function(E) {
      var _ = typeof E == "function" && E.constructor;
      return !!_ && (_ === m || (_.displayName || _.name) === "GeneratorFunction");
    }, n.mark = function(E) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(E, p) : (E.__proto__ = p, d(E, s, "GeneratorFunction")), E.prototype = Object.create(I), E;
    }, n.awrap = function(E) {
      return {
        __await: E
      };
    }, D(A.prototype), d(A.prototype, c, function() {
      return this;
    }), n.AsyncIterator = A, n.async = function(E, _, b, O, S) {
      S === void 0 && (S = Promise);
      var R = new A(M(E, _, b, O), S);
      return n.isGeneratorFunction(_) ? R : R.next().then(function(V) {
        return V.done ? V.value : R.next();
      });
    }, D(I), d(I, s, "Generator"), d(I, l, function() {
      return this;
    }), d(I, "toString", function() {
      return "[object Generator]";
    }), n.keys = function(E) {
      var _ = [];
      for (var b in E)
        _.push(b);
      return _.reverse(), function O() {
        for (; _.length; ) {
          var S = _.pop();
          if (S in E)
            return O.value = S, O.done = !1, O;
        }
        return O.done = !0, O;
      };
    }, n.values = j, C.prototype = {
      constructor: C,
      reset: function(_) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(T), !_)
          for (var b in this)
            b.charAt(0) === "t" && i.call(this, b) && !isNaN(+b.slice(1)) && (this[b] = void 0);
      },
      stop: function() {
        this.done = !0;
        var _ = this.tryEntries[0].completion;
        if (_.type === "throw")
          throw _.arg;
        return this.rval;
      },
      dispatchException: function(_) {
        if (this.done)
          throw _;
        var b = this;
        function O(P, U) {
          return V.type = "throw", V.arg = _, b.next = P, U && (b.method = "next", b.arg = void 0), !!U;
        }
        for (var S = this.tryEntries.length - 1; S >= 0; --S) {
          var R = this.tryEntries[S], V = R.completion;
          if (R.tryLoc === "root")
            return O("end");
          if (R.tryLoc <= this.prev) {
            var Q = i.call(R, "catchLoc"), x = i.call(R, "finallyLoc");
            if (Q && x) {
              if (this.prev < R.catchLoc)
                return O(R.catchLoc, !0);
              if (this.prev < R.finallyLoc)
                return O(R.finallyLoc);
            } else if (Q) {
              if (this.prev < R.catchLoc)
                return O(R.catchLoc, !0);
            } else {
              if (!x)
                throw new Error("try statement without catch or finally");
              if (this.prev < R.finallyLoc)
                return O(R.finallyLoc);
            }
          }
        }
      },
      abrupt: function(_, b) {
        for (var O = this.tryEntries.length - 1; O >= 0; --O) {
          var S = this.tryEntries[O];
          if (S.tryLoc <= this.prev && i.call(S, "finallyLoc") && this.prev < S.finallyLoc) {
            var R = S;
            break;
          }
        }
        R && (_ === "break" || _ === "continue") && R.tryLoc <= b && b <= R.finallyLoc && (R = null);
        var V = R ? R.completion : {};
        return V.type = _, V.arg = b, R ? (this.method = "next", this.next = R.finallyLoc, v) : this.complete(V);
      },
      complete: function(_, b) {
        if (_.type === "throw")
          throw _.arg;
        return _.type === "break" || _.type === "continue" ? this.next = _.arg : _.type === "return" ? (this.rval = this.arg = _.arg, this.method = "return", this.next = "end") : _.type === "normal" && b && (this.next = b), v;
      },
      finish: function(_) {
        for (var b = this.tryEntries.length - 1; b >= 0; --b) {
          var O = this.tryEntries[b];
          if (O.finallyLoc === _)
            return this.complete(O.completion, O.afterLoc), T(O), v;
        }
      },
      catch: function(_) {
        for (var b = this.tryEntries.length - 1; b >= 0; --b) {
          var O = this.tryEntries[b];
          if (O.tryLoc === _) {
            var S = O.completion;
            if (S.type === "throw") {
              var R = S.arg;
              T(O);
            }
            return R;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(_, b, O) {
        return this.delegate = {
          iterator: j(_),
          resultName: b,
          nextLoc: O
        }, this.method === "next" && (this.arg = void 0), v;
      }
    }, n;
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(o4);
var Y1 = { exports: {} }, ei = {}, Ra = {}, I2;
function iM() {
  if (I2)
    return Ra;
  I2 = 1, Object.defineProperty(Ra, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, name: "check-circle", theme: "outlined" };
  return Ra.default = e, Ra;
}
var oM = le.exports, vl = X.exports;
Object.defineProperty(ei, "__esModule", {
  value: !0
});
ei.default = void 0;
var D2 = vl(Ze.exports), l4 = oM(u), lM = vl(iM()), cM = vl(ut()), c4 = function(t, r) {
  return /* @__PURE__ */ l4.createElement(cM.default, (0, D2.default)((0, D2.default)({}, t), {}, {
    ref: r,
    icon: lM.default
  }));
};
c4.displayName = "CheckCircleOutlined";
var uM = /* @__PURE__ */ l4.forwardRef(c4);
ei.default = uM;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(ei);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(Y1, Y1.exports);
var H1 = { exports: {} }, ti = {}, Qa = {}, C2;
function sM() {
  if (C2)
    return Qa;
  C2 = 1, Object.defineProperty(Qa, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" } }, { tag: "path", attrs: { d: "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, name: "close-circle", theme: "outlined" };
  return Qa.default = e, Qa;
}
var dM = le.exports, Ml = X.exports;
Object.defineProperty(ti, "__esModule", {
  value: !0
});
ti.default = void 0;
var E2 = Ml(Ze.exports), u4 = dM(u), fM = Ml(sM()), vM = Ml(ut()), s4 = function(t, r) {
  return /* @__PURE__ */ u4.createElement(vM.default, (0, E2.default)((0, E2.default)({}, t), {}, {
    ref: r,
    icon: fM.default
  }));
};
s4.displayName = "CloseCircleOutlined";
var MM = /* @__PURE__ */ u4.forwardRef(s4);
ti.default = MM;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(ti);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(H1, H1.exports);
var W1 = { exports: {} }, ri = {}, Va = {}, b2;
function gM() {
  if (b2)
    return Va;
  b2 = 1, Object.defineProperty(Va, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] }, name: "close", theme: "outlined" };
  return Va.default = e, Va;
}
var pM = le.exports, gl = X.exports;
Object.defineProperty(ri, "__esModule", {
  value: !0
});
ri.default = void 0;
var A2 = gl(Ze.exports), d4 = pM(u), hM = gl(gM()), mM = gl(ut()), f4 = function(t, r) {
  return /* @__PURE__ */ d4.createElement(mM.default, (0, A2.default)((0, A2.default)({}, t), {}, {
    ref: r,
    icon: hM.default
  }));
};
f4.displayName = "CloseOutlined";
var yM = /* @__PURE__ */ d4.forwardRef(f4);
ri.default = yM;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(ri);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(W1, W1.exports);
var B1 = { exports: {} }, ni = {}, Ua = {}, j2;
function NM() {
  if (j2)
    return Ua;
  j2 = 1, Object.defineProperty(Ua, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, name: "exclamation-circle", theme: "outlined" };
  return Ua.default = e, Ua;
}
var zM = le.exports, pl = X.exports;
Object.defineProperty(ni, "__esModule", {
  value: !0
});
ni.default = void 0;
var x2 = pl(Ze.exports), v4 = zM(u), _M = pl(NM()), IM = pl(ut()), M4 = function(t, r) {
  return /* @__PURE__ */ v4.createElement(IM.default, (0, x2.default)((0, x2.default)({}, t), {}, {
    ref: r,
    icon: _M.default
  }));
};
M4.displayName = "ExclamationCircleOutlined";
var DM = /* @__PURE__ */ v4.forwardRef(M4);
ni.default = DM;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(ni);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(B1, B1.exports);
var q1 = { exports: {} }, ai = {}, Fa = {}, w2;
function CM() {
  if (w2)
    return Fa;
  w2 = 1, Object.defineProperty(Fa, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { tag: "path", attrs: { d: "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, name: "info-circle", theme: "outlined" };
  return Fa.default = e, Fa;
}
var EM = le.exports, hl = X.exports;
Object.defineProperty(ai, "__esModule", {
  value: !0
});
ai.default = void 0;
var O2 = hl(Ze.exports), g4 = EM(u), bM = hl(CM()), AM = hl(ut()), p4 = function(t, r) {
  return /* @__PURE__ */ g4.createElement(AM.default, (0, O2.default)((0, O2.default)({}, t), {}, {
    ref: r,
    icon: bM.default
  }));
};
p4.displayName = "InfoCircleOutlined";
var jM = /* @__PURE__ */ g4.forwardRef(p4);
ai.default = jM;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(ai);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(q1, q1.exports);
var $i = {}, T2;
function xM() {
  return T2 || (T2 = 1, function(e) {
    var t = le.exports.default, r = X.exports.default;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = c;
    var n = r(we.exports), a = r(gt.exports), i = r(X0), o = t(u), l = Gt();
    function c(s, d) {
      var M = function() {
        var v, g = null, m = {
          add: function(k, L) {
            g == null || g.component.add(k, L);
          }
        }, p = (0, i.default)(m), h = (0, a.default)(p, 2), y = h[0], N = h[1];
        function I(A) {
          var k = A.prefixCls, L = v("notification", k);
          s((0, n.default)((0, n.default)({}, A), {
            prefixCls: L
          }), function(T) {
            var C = T.prefixCls, j = T.instance;
            g = j, y(d(A, C));
          });
        }
        var D = o.useRef({});
        return D.current.open = I, ["success", "info", "warning", "error"].forEach(function(A) {
          D.current[A] = function(k) {
            return D.current.open((0, n.default)((0, n.default)({}, k), {
              type: A
            }));
          };
        }), [D.current, /* @__PURE__ */ o.createElement(l.ConfigConsumer, {
          key: "holder"
        }, function(A) {
          return v = A.getPrefixCls, N;
        })];
      };
      return M;
    }
  }($i)), $i;
}
var S2;
function wM() {
  return S2 || (S2 = 1, function(e) {
    var t = le.exports.default, r = X.exports.default;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.getInstance = e.default = void 0;
    var n = r(o4.exports), a = r(we.exports), i = r(rt.exports), o = r(Y1.exports), l = r(H1.exports), c = r(W1.exports), s = r(B1.exports), d = r(q1.exports), M = r(Y), f = r(q3), v = t(u), g = t(Gt()), m = r(xM()), p = function(Q, x, P, U) {
      function F($) {
        return $ instanceof P ? $ : new P(function(W) {
          W($);
        });
      }
      return new (P || (P = Promise))(function($, W) {
        function te(B) {
          try {
            q(U.next(B));
          } catch (G) {
            W(G);
          }
        }
        function J(B) {
          try {
            q(U.throw(B));
          } catch (G) {
            W(G);
          }
        }
        function q(B) {
          B.done ? $(B.value) : F(B.value).then(te, J);
        }
        q((U = U.apply(Q, x || [])).next());
      });
    }, h = {}, y = 4.5, N = 24, I = 24, D = "", A = "topRight", k, L, T = !1, C;
    function j(Q) {
      var x = Q.duration, P = Q.placement, U = Q.bottom, F = Q.top, $ = Q.getContainer, W = Q.closeIcon, te = Q.prefixCls;
      te !== void 0 && (D = te), x !== void 0 && (y = x), P !== void 0 ? A = P : Q.rtl && (A = "topLeft"), U !== void 0 && (I = U), F !== void 0 && (N = F), $ !== void 0 && (k = $), W !== void 0 && (L = W), Q.rtl !== void 0 && (T = Q.rtl), Q.maxCount !== void 0 && (C = Q.maxCount);
    }
    function w(Q) {
      var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : N, P = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : I, U;
      switch (Q) {
        case "top":
          U = {
            left: "50%",
            transform: "translateX(-50%)",
            right: "auto",
            top: x,
            bottom: "auto"
          };
          break;
        case "topLeft":
          U = {
            left: 0,
            top: x,
            bottom: "auto"
          };
          break;
        case "topRight":
          U = {
            right: 0,
            top: x,
            bottom: "auto"
          };
          break;
        case "bottom":
          U = {
            left: "50%",
            transform: "translateX(-50%)",
            right: "auto",
            top: "auto",
            bottom: P
          };
          break;
        case "bottomLeft":
          U = {
            left: 0,
            top: "auto",
            bottom: P
          };
          break;
        default:
          U = {
            right: 0,
            top: "auto",
            bottom: P
          };
          break;
      }
      return U;
    }
    function E(Q, x) {
      var P = Q.placement, U = P === void 0 ? A : P, F = Q.top, $ = Q.bottom, W = Q.getContainer, te = W === void 0 ? k : W, J = Q.prefixCls, q = (0, g.globalConfig)(), B = q.getPrefixCls, G = q.getIconPrefixCls, Z = B("notification", J || D), K = G(), ee = "".concat(Z, "-").concat(U), ce = h[ee];
      if (ce) {
        Promise.resolve(ce).then(function(ae) {
          x({
            prefixCls: "".concat(Z, "-notice"),
            iconPrefixCls: K,
            instance: ae
          });
        });
        return;
      }
      var ie = (0, M.default)("".concat(Z, "-").concat(U), (0, i.default)({}, "".concat(Z, "-rtl"), T === !0));
      h[ee] = new Promise(function(ae) {
        f.default.newInstance({
          prefixCls: Z,
          className: ie,
          style: w(U, F, $),
          getContainer: te,
          maxCount: C
        }, function(ne) {
          ae(ne), x({
            prefixCls: "".concat(Z, "-notice"),
            iconPrefixCls: K,
            instance: ne
          });
        });
      });
    }
    var _ = {
      success: o.default,
      info: d.default,
      error: l.default,
      warning: s.default
    };
    function b(Q, x, P) {
      var U = Q.duration, F = Q.icon, $ = Q.type, W = Q.description, te = Q.message, J = Q.btn, q = Q.onClose, B = Q.onClick, G = Q.key, Z = Q.style, K = Q.className, ee = Q.closeIcon, ce = ee === void 0 ? L : ee, ie = Q.props, ae = U === void 0 ? y : U, ne = null;
      F ? ne = /* @__PURE__ */ v.createElement("span", {
        className: "".concat(x, "-icon")
      }, Q.icon) : $ && (ne = /* @__PURE__ */ v.createElement(_[$] || null, {
        className: "".concat(x, "-icon ").concat(x, "-icon-").concat($)
      }));
      var se = /* @__PURE__ */ v.createElement("span", {
        className: "".concat(x, "-close-x")
      }, ce || /* @__PURE__ */ v.createElement(c.default, {
        className: "".concat(x, "-close-icon")
      })), Ce = !W && ne ? /* @__PURE__ */ v.createElement("span", {
        className: "".concat(x, "-message-single-line-auto-margin")
      }) : null;
      return {
        content: /* @__PURE__ */ v.createElement(g.default, {
          iconPrefixCls: P
        }, /* @__PURE__ */ v.createElement("div", {
          className: ne ? "".concat(x, "-with-icon") : "",
          role: "alert"
        }, ne, /* @__PURE__ */ v.createElement("div", {
          className: "".concat(x, "-message")
        }, Ce, te), /* @__PURE__ */ v.createElement("div", {
          className: "".concat(x, "-description")
        }, W), J ? /* @__PURE__ */ v.createElement("span", {
          className: "".concat(x, "-btn")
        }, J) : null)),
        duration: ae,
        closable: !0,
        closeIcon: se,
        onClose: q,
        onClick: B,
        key: G,
        style: Z || {},
        className: (0, M.default)(K, (0, i.default)({}, "".concat(x, "-").concat($), !!$)),
        props: ie
      };
    }
    function O(Q) {
      E(Q, function(x) {
        var P = x.prefixCls, U = x.iconPrefixCls, F = x.instance;
        F.notice(b(Q, P, U));
      });
    }
    var S = {
      open: O,
      close: function(x) {
        Object.keys(h).forEach(function(P) {
          return Promise.resolve(h[P]).then(function(U) {
            U.removeNotice(x);
          });
        });
      },
      config: j,
      destroy: function() {
        Object.keys(h).forEach(function(x) {
          Promise.resolve(h[x]).then(function(P) {
            P.destroy();
          }), delete h[x];
        });
      }
    };
    ["success", "info", "warning", "error"].forEach(function(Q) {
      S[Q] = function(x) {
        return S.open((0, a.default)((0, a.default)({}, x), {
          type: Q
        }));
      };
    }), S.warn = S.warning, S.useNotification = (0, m.default)(E, b);
    var R = function(x) {
      return p(void 0, void 0, void 0, /* @__PURE__ */ (0, n.default)().mark(function P() {
        return (0, n.default)().wrap(function(F) {
          for (; ; )
            switch (F.prev = F.next) {
              case 0:
                return F.abrupt("return", process.env.NODE_ENV === "test" ? h[x] : null);
              case 1:
              case "end":
                return F.stop();
            }
        }, P);
      }));
    };
    e.getInstance = R;
    var V = S;
    e.default = V;
  }(Fi)), Fi;
}
var Rr = {}, OM = le.exports.default, TM = X.exports.default;
Object.defineProperty(Rr, "__esModule", {
  value: !0
});
Rr.ConfigContext = Rr.ConfigConsumer = void 0;
Rr.withConfigConsumer = kM;
var SM = TM(we.exports), G1 = OM(u), LM = function(t, r) {
  return r || (t ? "ant-".concat(t) : "ant");
}, h4 = /* @__PURE__ */ G1.createContext({
  getPrefixCls: LM
});
Rr.ConfigContext = h4;
var m4 = h4.Consumer;
Rr.ConfigConsumer = m4;
function kM(e) {
  return function(r) {
    var n = function(l) {
      return /* @__PURE__ */ G1.createElement(m4, null, function(c) {
        var s = e.prefixCls, d = c.getPrefixCls, M = l.prefixCls, f = d(s, M);
        return /* @__PURE__ */ G1.createElement(r, (0, SM.default)({}, c, l, {
          prefixCls: f
        }));
      });
    }, a = r.constructor, i = a && a.displayName || r.name || "Component";
    return process.env.NODE_ENV !== "production" && (n.displayName = "withConfigConsumer(".concat(i, ")")), n;
  };
}
var ii = {};
const PM = /* @__PURE__ */ yr(kf);
var y4 = X.exports.default;
Object.defineProperty(ii, "__esModule", {
  value: !0
});
ii.getStyle = N4;
ii.registerTheme = FM;
var L2 = s3, Zi = PM, RM = y4(Vr), QM = gn, VM = y4(Fr), UM = "-ant-".concat(Date.now(), "-").concat(Math.random());
function N4(e, t) {
  var r = {}, n = function(d, M) {
    var f = d.clone();
    return f = (M == null ? void 0 : M(f)) || f, f.toRgbString();
  }, a = function(d, M) {
    var f = new Zi.TinyColor(d), v = (0, L2.generate)(f.toRgbString());
    r["".concat(M, "-color")] = n(f), r["".concat(M, "-color-disabled")] = v[1], r["".concat(M, "-color-hover")] = v[4], r["".concat(M, "-color-active")] = v[6], r["".concat(M, "-color-outline")] = f.clone().setAlpha(0.2).toRgbString(), r["".concat(M, "-color-deprecated-bg")] = v[0], r["".concat(M, "-color-deprecated-border")] = v[2];
  };
  if (t.primaryColor) {
    a(t.primaryColor, "primary");
    var i = new Zi.TinyColor(t.primaryColor), o = (0, L2.generate)(i.toRgbString());
    o.forEach(function(s, d) {
      r["primary-".concat(d + 1)] = s;
    }), r["primary-color-deprecated-l-35"] = n(i, function(s) {
      return s.lighten(35);
    }), r["primary-color-deprecated-l-20"] = n(i, function(s) {
      return s.lighten(20);
    }), r["primary-color-deprecated-t-20"] = n(i, function(s) {
      return s.tint(20);
    }), r["primary-color-deprecated-t-50"] = n(i, function(s) {
      return s.tint(50);
    }), r["primary-color-deprecated-f-12"] = n(i, function(s) {
      return s.setAlpha(s.getAlpha() * 0.12);
    });
    var l = new Zi.TinyColor(o[0]);
    r["primary-color-active-deprecated-f-30"] = n(l, function(s) {
      return s.setAlpha(s.getAlpha() * 0.3);
    }), r["primary-color-active-deprecated-d-02"] = n(l, function(s) {
      return s.darken(2);
    });
  }
  t.successColor && a(t.successColor, "success"), t.warningColor && a(t.warningColor, "warning"), t.errorColor && a(t.errorColor, "error"), t.infoColor && a(t.infoColor, "info");
  var c = Object.keys(r).map(function(s) {
    return "--".concat(e, "-").concat(s, ": ").concat(r[s], ";");
  });
  return `
  :root {
    `.concat(c.join(`
`), `
  }
  `).trim();
}
function FM(e, t) {
  var r = N4(e, t);
  (0, RM.default)() ? (0, QM.updateCSS)(r, "".concat(UM, "-dynamic-theme")) : process.env.NODE_ENV !== "production" && (0, VM.default)(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
var oi = {};
(function(e) {
  var t = le.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.DisabledContextProvider = void 0;
  var r = t(u), n = /* @__PURE__ */ r.createContext(!1), a = function(l) {
    var c = l.children, s = l.disabled, d = r.useContext(n);
    return /* @__PURE__ */ r.createElement(n.Provider, {
      value: s != null ? s : d
    }, c);
  };
  e.DisabledContextProvider = a;
  var i = n;
  e.default = i;
})(oi);
var li = {};
(function(e) {
  var t = le.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.SizeContextProvider = void 0;
  var r = t(u), n = /* @__PURE__ */ r.createContext(void 0), a = function(l) {
    var c = l.children, s = l.size;
    return /* @__PURE__ */ r.createElement(n.Consumer, null, function(d) {
      return /* @__PURE__ */ r.createElement(n.Provider, {
        value: s || d
      }, c);
    });
  };
  e.SizeContextProvider = a;
  var i = n;
  e.default = i;
})(li);
var k2;
function Gt() {
  return k2 || (k2 = 1, function(e) {
    var t = le.exports.default, r = X.exports.default;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "ConfigConsumer", {
      enumerable: !0,
      get: function() {
        return v.ConfigConsumer;
      }
    }), Object.defineProperty(e, "ConfigContext", {
      enumerable: !0,
      get: function() {
        return v.ConfigContext;
      }
    }), e.globalConfig = e.defaultPrefixCls = e.defaultIconPrefixCls = e.default = e.configConsumerProps = void 0;
    var n = r(we.exports), a = r(Mn), i = T3, o = r(F0), l = t(u), c = t(S3), s = r(rl), d = r(Z0), M = r(i4()), f = r(wM()), v = Rr, g = ii, m = oi, p = t(li), h = ["getTargetContainer", "getPopupContainer", "rootPrefixCls", "getPrefixCls", "renderEmpty", "csp", "autoInsertSpaceInButton", "locale", "pageHeader"];
    e.configConsumerProps = h;
    var y = ["getTargetContainer", "getPopupContainer", "renderEmpty", "pageHeader", "input", "pagination", "form"], N = "ant";
    e.defaultPrefixCls = N;
    var I = "anticon";
    e.defaultIconPrefixCls = I;
    var D, A;
    function k() {
      return D || N;
    }
    function L() {
      return A || I;
    }
    var T = function(b) {
      var O = b.prefixCls, S = b.iconPrefixCls, R = b.theme;
      O !== void 0 && (D = O), S !== void 0 && (A = S), R && (0, g.registerTheme)(k(), R);
    }, C = function() {
      return {
        getPrefixCls: function(O, S) {
          return S || (O ? "".concat(k(), "-").concat(O) : k());
        },
        getIconPrefixCls: L,
        getRootPrefixCls: function(O, S) {
          return O || D || (S && S.includes("-") ? S.replace(/^(.*)-[^-]*$/, "$1") : k());
        }
      };
    };
    e.globalConfig = C;
    var j = function(b) {
      var O, S, R = b.children, V = b.csp, Q = b.autoInsertSpaceInButton, x = b.form, P = b.locale, U = b.componentSize, F = b.direction, $ = b.space, W = b.virtual, te = b.dropdownMatchSelectWidth, J = b.legacyLocale, q = b.parentContext, B = b.iconPrefixCls, G = b.componentDisabled, Z = l.useCallback(function(ne, se) {
        var Ce = b.prefixCls;
        if (se)
          return se;
        var Oe = Ce || q.getPrefixCls("");
        return ne ? "".concat(Oe, "-").concat(ne) : Oe;
      }, [q.getPrefixCls, b.prefixCls]), K = (0, n.default)((0, n.default)({}, q), {
        csp: V,
        autoInsertSpaceInButton: Q,
        locale: P || J,
        direction: F,
        space: $,
        virtual: W,
        dropdownMatchSelectWidth: te,
        getPrefixCls: Z
      });
      y.forEach(function(ne) {
        var se = b[ne];
        se && (K[ne] = se);
      });
      var ee = (0, o.default)(function() {
        return K;
      }, K, function(ne, se) {
        var Ce = Object.keys(ne), Oe = Object.keys(se);
        return Ce.length !== Oe.length || Ce.some(function(Ye) {
          return ne[Ye] !== se[Ye];
        });
      }), ce = l.useMemo(function() {
        return {
          prefixCls: B,
          csp: V
        };
      }, [B, V]), ie = R, ae = {};
      return P && (ae = ((O = P.Form) === null || O === void 0 ? void 0 : O.defaultValidateMessages) || ((S = d.default.Form) === null || S === void 0 ? void 0 : S.defaultValidateMessages) || {}), x && x.validateMessages && (ae = (0, n.default)((0, n.default)({}, ae), x.validateMessages)), Object.keys(ae).length > 0 && (ie = /* @__PURE__ */ l.createElement(i.FormProvider, {
        validateMessages: ae
      }, R)), P && (ie = /* @__PURE__ */ l.createElement(c.default, {
        locale: P,
        _ANT_MARK__: c.ANT_MARK
      }, ie)), (B || V) && (ie = /* @__PURE__ */ l.createElement(a.default.Provider, {
        value: ce
      }, ie)), U && (ie = /* @__PURE__ */ l.createElement(p.SizeContextProvider, {
        size: U
      }, ie)), G !== void 0 && (ie = /* @__PURE__ */ l.createElement(m.DisabledContextProvider, {
        disabled: G
      }, ie)), /* @__PURE__ */ l.createElement(v.ConfigContext.Provider, {
        value: ee
      }, ie);
    }, w = function(b) {
      return l.useEffect(function() {
        b.direction && (M.default.config({
          rtl: b.direction === "rtl"
        }), f.default.config({
          rtl: b.direction === "rtl"
        }));
      }, [b.direction]), /* @__PURE__ */ l.createElement(s.default, null, function(O, S, R) {
        return /* @__PURE__ */ l.createElement(v.ConfigConsumer, null, function(V) {
          return /* @__PURE__ */ l.createElement(j, (0, n.default)({
            parentContext: V,
            legacyLocale: R
          }, b));
        });
      });
    };
    w.ConfigContext = v.ConfigContext, w.SizeContext = p.default, w.config = T;
    var E = w;
    e.default = E;
  }(Qi)), Qi;
}
var z4 = {}, Ma = {};
Object.defineProperty(Ma, "__esModule", {
  value: !0
});
Ma.default = void 0;
var oe = {
  MAC_ENTER: 3,
  BACKSPACE: 8,
  TAB: 9,
  NUM_CENTER: 12,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPS_LOCK: 20,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  PRINT_SCREEN: 44,
  INSERT: 45,
  DELETE: 46,
  ZERO: 48,
  ONE: 49,
  TWO: 50,
  THREE: 51,
  FOUR: 52,
  FIVE: 53,
  SIX: 54,
  SEVEN: 55,
  EIGHT: 56,
  NINE: 57,
  QUESTION_MARK: 63,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  META: 91,
  WIN_KEY_RIGHT: 92,
  CONTEXT_MENU: 93,
  NUM_ZERO: 96,
  NUM_ONE: 97,
  NUM_TWO: 98,
  NUM_THREE: 99,
  NUM_FOUR: 100,
  NUM_FIVE: 101,
  NUM_SIX: 102,
  NUM_SEVEN: 103,
  NUM_EIGHT: 104,
  NUM_NINE: 105,
  NUM_MULTIPLY: 106,
  NUM_PLUS: 107,
  NUM_MINUS: 109,
  NUM_PERIOD: 110,
  NUM_DIVISION: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  NUMLOCK: 144,
  SEMICOLON: 186,
  DASH: 189,
  EQUALS: 187,
  COMMA: 188,
  PERIOD: 190,
  SLASH: 191,
  APOSTROPHE: 192,
  SINGLE_QUOTE: 222,
  OPEN_SQUARE_BRACKET: 219,
  BACKSLASH: 220,
  CLOSE_SQUARE_BRACKET: 221,
  WIN_KEY: 224,
  MAC_FF_META: 224,
  WIN_IME: 229,
  isTextModifyingKeyEvent: function(t) {
    var r = t.keyCode;
    if (t.altKey && !t.ctrlKey || t.metaKey || r >= oe.F1 && r <= oe.F12)
      return !1;
    switch (r) {
      case oe.ALT:
      case oe.CAPS_LOCK:
      case oe.CONTEXT_MENU:
      case oe.CTRL:
      case oe.DOWN:
      case oe.END:
      case oe.ESC:
      case oe.HOME:
      case oe.INSERT:
      case oe.LEFT:
      case oe.MAC_FF_META:
      case oe.META:
      case oe.NUMLOCK:
      case oe.NUM_CENTER:
      case oe.PAGE_DOWN:
      case oe.PAGE_UP:
      case oe.PAUSE:
      case oe.PRINT_SCREEN:
      case oe.RIGHT:
      case oe.SHIFT:
      case oe.UP:
      case oe.WIN_KEY:
      case oe.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  isCharacterKey: function(t) {
    if (t >= oe.ZERO && t <= oe.NINE || t >= oe.NUM_ZERO && t <= oe.NUM_MULTIPLY || t >= oe.A && t <= oe.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && t === 0)
      return !0;
    switch (t) {
      case oe.SPACE:
      case oe.QUESTION_MARK:
      case oe.NUM_PLUS:
      case oe.NUM_MINUS:
      case oe.NUM_PERIOD:
      case oe.NUM_DIVISION:
      case oe.SEMICOLON:
      case oe.DASH:
      case oe.EQUALS:
      case oe.COMMA:
      case oe.PERIOD:
      case oe.SLASH:
      case oe.APOSTROPHE:
      case oe.SINGLE_QUOTE:
      case oe.OPEN_SQUARE_BRACKET:
      case oe.BACKSLASH:
      case oe.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, $M = oe;
Ma.default = $M;
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(we.exports), a = r(Ma), i = t(u), o = function(d, M) {
    var f = {};
    for (var v in d)
      Object.prototype.hasOwnProperty.call(d, v) && M.indexOf(v) < 0 && (f[v] = d[v]);
    if (d != null && typeof Object.getOwnPropertySymbols == "function")
      for (var g = 0, v = Object.getOwnPropertySymbols(d); g < v.length; g++)
        M.indexOf(v[g]) < 0 && Object.prototype.propertyIsEnumerable.call(d, v[g]) && (f[v[g]] = d[v[g]]);
    return f;
  }, l = {
    border: 0,
    background: "transparent",
    padding: 0,
    lineHeight: "inherit",
    display: "inline-block"
  }, c = /* @__PURE__ */ i.forwardRef(function(d, M) {
    var f = function(I) {
      var D = I.keyCode;
      D === a.default.ENTER && I.preventDefault();
    }, v = function(I) {
      var D = I.keyCode, A = d.onClick;
      D === a.default.ENTER && A && A();
    }, g = d.style, m = d.noStyle, p = d.disabled, h = o(d, ["style", "noStyle", "disabled"]), y = {};
    return m || (y = (0, n.default)({}, l)), p && (y.pointerEvents = "none"), y = (0, n.default)((0, n.default)({}, y), g), /* @__PURE__ */ i.createElement("div", (0, n.default)({
      role: "button",
      tabIndex: 0,
      ref: M
    }, h, {
      onKeyDown: f,
      onKeyUp: v,
      style: y
    }));
  }), s = c;
  e.default = s;
})(z4);
var _4 = {}, ml = {}, ZM = X.exports.default;
Object.defineProperty(ml, "__esModule", {
  value: !0
});
ml.isStyleSupport = WM;
var YM = ZM(Vr), I4 = function(t) {
  if ((0, YM.default)() && window.document.documentElement) {
    var r = Array.isArray(t) ? t : [t], n = window.document.documentElement;
    return r.some(function(a) {
      return a in n.style;
    });
  }
  return !1;
}, HM = function(t, r) {
  if (!I4(t))
    return !1;
  var n = document.createElement("div"), a = n.style[t];
  return n.style[t] = r, n.style[t] !== a;
};
function WM(e, t) {
  return !Array.isArray(e) && t !== void 0 ? HM(e, t) : I4(e);
}
(function(e) {
  var t = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.detectFlexGapSupported = e.canUseDocElement = void 0, Object.defineProperty(e, "isStyleSupport", {
    enumerable: !0,
    get: function() {
      return n.isStyleSupport;
    }
  });
  var r = t(Vr), n = ml, a = function() {
    return (0, r.default)() && window.document.documentElement;
  };
  e.canUseDocElement = a;
  var i, o = function() {
    if (!a())
      return !1;
    if (i !== void 0)
      return i;
    var c = document.createElement("div");
    return c.style.display = "flex", c.style.flexDirection = "column", c.style.rowGap = "1px", c.appendChild(document.createElement("div")), c.appendChild(document.createElement("div")), document.body.appendChild(c), i = c.scrollHeight === 1, document.body.removeChild(c), i;
  };
  e.detectFlexGapSupported = o;
})(_4);
var yl = {};
function Qn(e, t, r, n) {
  var a = Sr.unstable_batchedUpdates ? function(o) {
    Sr.unstable_batchedUpdates(r, o);
  } : r;
  return e.addEventListener && e.addEventListener(t, a, n), {
    remove: function() {
      e.removeEventListener && e.removeEventListener(t, a, n);
    }
  };
}
var BM = /* @__PURE__ */ fo(function(e, t) {
  var r = e.didUpdate, n = e.getContainer, a = e.children, i = Le(), o = Le();
  A0(t, function() {
    return {};
  });
  var l = Le(!1);
  return !l.current && ua() && (o.current = n(), i.current = o.current.parentNode, l.current = !0), lt(function() {
    r == null || r(e);
  }), lt(function() {
    return o.current.parentNode === null && i.current !== null && i.current.appendChild(o.current), function() {
      var c, s;
      (c = o.current) === null || c === void 0 || (s = c.parentNode) === null || s === void 0 || s.removeChild(o.current);
    };
  }, []), o.current ? /* @__PURE__ */ Sr.createPortal(a, o.current) : null;
});
function qM(e, t, r) {
  return r ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function GM(e, t, r) {
  var n = e[t] || {};
  return H(H({}, n), r);
}
function KM(e, t, r, n) {
  for (var a = r.points, i = Object.keys(e), o = 0; o < i.length; o += 1) {
    var l = i[o];
    if (qM(e[l].points, a, n))
      return "".concat(t, "-placement-").concat(l);
  }
  return "";
}
const XM = function() {
  if (typeof navigator > "u" || typeof window > "u")
    return !1;
  var e = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(e == null ? void 0 : e.substr(0, 4));
};
function D4(e) {
  var t = e.prefixCls, r = e.motion, n = e.animation, a = e.transitionName;
  return r || (n ? {
    motionName: "".concat(t, "-").concat(n)
  } : a ? {
    motionName: a
  } : null);
}
function JM(e) {
  var t = e.prefixCls, r = e.visible, n = e.zIndex, a = e.mask, i = e.maskMotion, o = e.maskAnimation, l = e.maskTransitionName;
  if (!a)
    return null;
  var c = {};
  return (i || l || o) && (c = H({
    motionAppear: !0
  }, D4({
    motion: i,
    prefixCls: t,
    transitionName: l,
    animation: o
  }))), /* @__PURE__ */ z.createElement(k0, Pe({}, c, {
    visible: r,
    removeOnLeave: !0
  }), function(s) {
    var d = s.className;
    return /* @__PURE__ */ z.createElement("div", {
      style: {
        zIndex: n
      },
      className: Y("".concat(t, "-mask"), d)
    });
  });
}
const eg = function(e) {
  if (!e)
    return !1;
  if (e instanceof HTMLElement && e.offsetParent)
    return !0;
  if (e instanceof SVGGraphicsElement && e.getBBox) {
    var t = e.getBBox(), r = t.width, n = t.height;
    if (r || n)
      return !0;
  }
  if (e instanceof HTMLElement && e.getBoundingClientRect) {
    var a = e.getBoundingClientRect(), i = a.width, o = a.height;
    if (i || o)
      return !0;
  }
  return !1;
};
function P2(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function R2(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? P2(Object(r), !0).forEach(function(n) {
      tg(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : P2(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function d0(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? d0 = function(t) {
    return typeof t;
  } : d0 = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, d0(e);
}
function tg(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var Tn, rg = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-",
  O: "-o-"
};
function C0() {
  if (Tn !== void 0)
    return Tn;
  Tn = "";
  var e = document.createElement("p").style, t = "Transform";
  for (var r in rg)
    r + t in e && (Tn = r);
  return Tn;
}
function C4() {
  return C0() ? "".concat(C0(), "TransitionProperty") : "transitionProperty";
}
function ci() {
  return C0() ? "".concat(C0(), "Transform") : "transform";
}
function Q2(e, t) {
  var r = C4();
  r && (e.style[r] = t, r !== "transitionProperty" && (e.style.transitionProperty = t));
}
function Yi(e, t) {
  var r = ci();
  r && (e.style[r] = t, r !== "transform" && (e.style.transform = t));
}
function ng(e) {
  return e.style.transitionProperty || e.style[C4()];
}
function ag(e) {
  var t = window.getComputedStyle(e, null), r = t.getPropertyValue("transform") || t.getPropertyValue(ci());
  if (r && r !== "none") {
    var n = r.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(n[12] || n[4], 0),
      y: parseFloat(n[13] || n[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var ig = /matrix\((.*)\)/, og = /matrix3d\((.*)\)/;
function lg(e, t) {
  var r = window.getComputedStyle(e, null), n = r.getPropertyValue("transform") || r.getPropertyValue(ci());
  if (n && n !== "none") {
    var a, i = n.match(ig);
    if (i)
      i = i[1], a = i.split(",").map(function(l) {
        return parseFloat(l, 10);
      }), a[4] = t.x, a[5] = t.y, Yi(e, "matrix(".concat(a.join(","), ")"));
    else {
      var o = n.match(og)[1];
      a = o.split(",").map(function(l) {
        return parseFloat(l, 10);
      }), a[12] = t.x, a[13] = t.y, Yi(e, "matrix3d(".concat(a.join(","), ")"));
    }
  } else
    Yi(e, "translateX(".concat(t.x, "px) translateY(").concat(t.y, "px) translateZ(0)"));
}
var cg = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, ga;
function V2(e) {
  var t = e.style.display;
  e.style.display = "none", e.offsetHeight, e.style.display = t;
}
function an(e, t, r) {
  var n = r;
  if (d0(t) === "object") {
    for (var a in t)
      t.hasOwnProperty(a) && an(e, a, t[a]);
    return;
  }
  if (typeof n < "u") {
    typeof n == "number" && (n = "".concat(n, "px")), e.style[t] = n;
    return;
  }
  return ga(e, t);
}
function ug(e) {
  var t, r, n, a = e.ownerDocument, i = a.body, o = a && a.documentElement;
  return t = e.getBoundingClientRect(), r = Math.floor(t.left), n = Math.floor(t.top), r -= o.clientLeft || i.clientLeft || 0, n -= o.clientTop || i.clientTop || 0, {
    left: r,
    top: n
  };
}
function E4(e, t) {
  var r = e["page".concat(t ? "Y" : "X", "Offset")], n = "scroll".concat(t ? "Top" : "Left");
  if (typeof r != "number") {
    var a = e.document;
    r = a.documentElement[n], typeof r != "number" && (r = a.body[n]);
  }
  return r;
}
function b4(e) {
  return E4(e);
}
function A4(e) {
  return E4(e, !0);
}
function Xn(e) {
  var t = ug(e), r = e.ownerDocument, n = r.defaultView || r.parentWindow;
  return t.left += b4(n), t.top += A4(n), t;
}
function Nl(e) {
  return e != null && e == e.window;
}
function j4(e) {
  return Nl(e) ? e.document : e.nodeType === 9 ? e : e.ownerDocument;
}
function sg(e, t, r) {
  var n = r, a = "", i = j4(e);
  return n = n || i.defaultView.getComputedStyle(e, null), n && (a = n.getPropertyValue(t) || n[t]), a;
}
var dg = new RegExp("^(".concat(cg, ")(?!px)[a-z%]+$"), "i"), fg = /^(top|right|bottom|left)$/, Hi = "currentStyle", Wi = "runtimeStyle", Dr = "left", vg = "px";
function Mg(e, t) {
  var r = e[Hi] && e[Hi][t];
  if (dg.test(r) && !fg.test(t)) {
    var n = e.style, a = n[Dr], i = e[Wi][Dr];
    e[Wi][Dr] = e[Hi][Dr], n[Dr] = t === "fontSize" ? "1em" : r || 0, r = n.pixelLeft + vg, n[Dr] = a, e[Wi][Dr] = i;
  }
  return r === "" ? "auto" : r;
}
typeof window < "u" && (ga = window.getComputedStyle ? sg : Mg);
function $a(e, t) {
  return e === "left" ? t.useCssRight ? "right" : e : t.useCssBottom ? "bottom" : e;
}
function U2(e) {
  if (e === "left")
    return "right";
  if (e === "right")
    return "left";
  if (e === "top")
    return "bottom";
  if (e === "bottom")
    return "top";
}
function F2(e, t, r) {
  an(e, "position") === "static" && (e.style.position = "relative");
  var n = -999, a = -999, i = $a("left", r), o = $a("top", r), l = U2(i), c = U2(o);
  i !== "left" && (n = 999), o !== "top" && (a = 999);
  var s = "", d = Xn(e);
  ("left" in t || "top" in t) && (s = ng(e) || "", Q2(e, "none")), "left" in t && (e.style[l] = "", e.style[i] = "".concat(n, "px")), "top" in t && (e.style[c] = "", e.style[o] = "".concat(a, "px")), V2(e);
  var M = Xn(e), f = {};
  for (var v in t)
    if (t.hasOwnProperty(v)) {
      var g = $a(v, r), m = v === "left" ? n : a, p = d[v] - M[v];
      g === v ? f[g] = m + p : f[g] = m - p;
    }
  an(e, f), V2(e), ("left" in t || "top" in t) && Q2(e, s);
  var h = {};
  for (var y in t)
    if (t.hasOwnProperty(y)) {
      var N = $a(y, r), I = t[y] - d[y];
      y === N ? h[N] = f[N] + I : h[N] = f[N] - I;
    }
  an(e, h);
}
function gg(e, t) {
  var r = Xn(e), n = ag(e), a = {
    x: n.x,
    y: n.y
  };
  "left" in t && (a.x = n.x + t.left - r.left), "top" in t && (a.y = n.y + t.top - r.top), lg(e, a);
}
function pg(e, t, r) {
  if (r.ignoreShake) {
    var n = Xn(e), a = n.left.toFixed(0), i = n.top.toFixed(0), o = t.left.toFixed(0), l = t.top.toFixed(0);
    if (a === o && i === l)
      return;
  }
  r.useCssRight || r.useCssBottom ? F2(e, t, r) : r.useCssTransform && ci() in document.body.style ? gg(e, t) : F2(e, t, r);
}
function zl(e, t) {
  for (var r = 0; r < e.length; r++)
    t(e[r]);
}
function x4(e) {
  return ga(e, "boxSizing") === "border-box";
}
var hg = ["margin", "border", "padding"], K1 = -1, mg = 2, X1 = 1, yg = 0;
function Ng(e, t, r) {
  var n = {}, a = e.style, i;
  for (i in t)
    t.hasOwnProperty(i) && (n[i] = a[i], a[i] = t[i]);
  r.call(e);
  for (i in t)
    t.hasOwnProperty(i) && (a[i] = n[i]);
}
function Vn(e, t, r) {
  var n = 0, a, i, o;
  for (i = 0; i < t.length; i++)
    if (a = t[i], a)
      for (o = 0; o < r.length; o++) {
        var l = void 0;
        a === "border" ? l = "".concat(a).concat(r[o], "Width") : l = a + r[o], n += parseFloat(ga(e, l)) || 0;
      }
  return n;
}
var Ht = {
  getParent: function(t) {
    var r = t;
    do
      r.nodeType === 11 && r.host ? r = r.host : r = r.parentNode;
    while (r && r.nodeType !== 1 && r.nodeType !== 9);
    return r;
  }
};
zl(["Width", "Height"], function(e) {
  Ht["doc".concat(e)] = function(t) {
    var r = t.document;
    return Math.max(
      r.documentElement["scroll".concat(e)],
      r.body["scroll".concat(e)],
      Ht["viewport".concat(e)](r)
    );
  }, Ht["viewport".concat(e)] = function(t) {
    var r = "client".concat(e), n = t.document, a = n.body, i = n.documentElement, o = i[r];
    return n.compatMode === "CSS1Compat" && o || a && a[r] || o;
  };
});
function $2(e, t, r) {
  var n = r;
  if (Nl(e))
    return t === "width" ? Ht.viewportWidth(e) : Ht.viewportHeight(e);
  if (e.nodeType === 9)
    return t === "width" ? Ht.docWidth(e) : Ht.docHeight(e);
  var a = t === "width" ? ["Left", "Right"] : ["Top", "Bottom"], i = Math.floor(t === "width" ? e.getBoundingClientRect().width : e.getBoundingClientRect().height), o = x4(e), l = 0;
  (i == null || i <= 0) && (i = void 0, l = ga(e, t), (l == null || Number(l) < 0) && (l = e.style[t] || 0), l = parseFloat(l) || 0), n === void 0 && (n = o ? X1 : K1);
  var c = i !== void 0 || o, s = i || l;
  return n === K1 ? c ? s - Vn(e, ["border", "padding"], a) : l : c ? n === X1 ? s : s + (n === mg ? -Vn(e, ["border"], a) : Vn(e, ["margin"], a)) : l + Vn(e, hg.slice(n), a);
}
var zg = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function Z2() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n, a = t[0];
  return a.offsetWidth !== 0 ? n = $2.apply(void 0, t) : Ng(a, zg, function() {
    n = $2.apply(void 0, t);
  }), n;
}
zl(["width", "height"], function(e) {
  var t = e.charAt(0).toUpperCase() + e.slice(1);
  Ht["outer".concat(t)] = function(n, a) {
    return n && Z2(n, e, a ? yg : X1);
  };
  var r = e === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  Ht[e] = function(n, a) {
    var i = a;
    if (i !== void 0) {
      if (n) {
        var o = x4(n);
        return o && (i += Vn(n, ["padding", "border"], r)), an(n, e, i);
      }
      return;
    }
    return n && Z2(n, e, K1);
  };
});
function w4(e, t) {
  for (var r in t)
    t.hasOwnProperty(r) && (e[r] = t[r]);
  return e;
}
var ue = {
  getWindow: function(t) {
    if (t && t.document && t.setTimeout)
      return t;
    var r = t.ownerDocument || t;
    return r.defaultView || r.parentWindow;
  },
  getDocument: j4,
  offset: function(t, r, n) {
    if (typeof r < "u")
      pg(t, r, n || {});
    else
      return Xn(t);
  },
  isWindow: Nl,
  each: zl,
  css: an,
  clone: function(t) {
    var r, n = {};
    for (r in t)
      t.hasOwnProperty(r) && (n[r] = t[r]);
    var a = t.overflow;
    if (a)
      for (r in t)
        t.hasOwnProperty(r) && (n.overflow[r] = t.overflow[r]);
    return n;
  },
  mix: w4,
  getWindowScrollLeft: function(t) {
    return b4(t);
  },
  getWindowScrollTop: function(t) {
    return A4(t);
  },
  merge: function() {
    for (var t = {}, r = 0; r < arguments.length; r++)
      ue.mix(t, r < 0 || arguments.length <= r ? void 0 : arguments[r]);
    return t;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
w4(ue, Ht);
var Bi = ue.getParent;
function J1(e) {
  if (ue.isWindow(e) || e.nodeType === 9)
    return null;
  var t = ue.getDocument(e), r = t.body, n, a = ue.css(e, "position"), i = a === "fixed" || a === "absolute";
  if (!i)
    return e.nodeName.toLowerCase() === "html" ? null : Bi(e);
  for (n = Bi(e); n && n !== r && n.nodeType !== 9; n = Bi(n))
    if (a = ue.css(n, "position"), a !== "static")
      return n;
  return null;
}
var Y2 = ue.getParent;
function _g(e) {
  if (ue.isWindow(e) || e.nodeType === 9)
    return !1;
  var t = ue.getDocument(e), r = t.body, n = null;
  for (n = Y2(e); n && n !== r && n !== t; n = Y2(n)) {
    var a = ue.css(n, "position");
    if (a === "fixed")
      return !0;
  }
  return !1;
}
function _l(e, t) {
  for (var r = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, n = J1(e), a = ue.getDocument(e), i = a.defaultView || a.parentWindow, o = a.body, l = a.documentElement; n; ) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || n.clientWidth !== 0) && n !== o && n !== l && ue.css(n, "overflow") !== "visible") {
      var c = ue.offset(n);
      c.left += n.clientLeft, c.top += n.clientTop, r.top = Math.max(r.top, c.top), r.right = Math.min(
        r.right,
        c.left + n.clientWidth
      ), r.bottom = Math.min(r.bottom, c.top + n.clientHeight), r.left = Math.max(r.left, c.left);
    } else if (n === o || n === l)
      break;
    n = J1(n);
  }
  var s = null;
  if (!ue.isWindow(e) && e.nodeType !== 9) {
    s = e.style.position;
    var d = ue.css(e, "position");
    d === "absolute" && (e.style.position = "fixed");
  }
  var M = ue.getWindowScrollLeft(i), f = ue.getWindowScrollTop(i), v = ue.viewportWidth(i), g = ue.viewportHeight(i), m = l.scrollWidth, p = l.scrollHeight, h = window.getComputedStyle(o);
  if (h.overflowX === "hidden" && (m = i.innerWidth), h.overflowY === "hidden" && (p = i.innerHeight), e.style && (e.style.position = s), t || _g(e))
    r.left = Math.max(r.left, M), r.top = Math.max(r.top, f), r.right = Math.min(r.right, M + v), r.bottom = Math.min(r.bottom, f + g);
  else {
    var y = Math.max(m, M + v);
    r.right = Math.min(r.right, y);
    var N = Math.max(p, f + g);
    r.bottom = Math.min(r.bottom, N);
  }
  return r.top >= 0 && r.left >= 0 && r.bottom > r.top && r.right > r.left ? r : null;
}
function Ig(e, t, r, n) {
  var a = ue.clone(e), i = {
    width: t.width,
    height: t.height
  };
  return n.adjustX && a.left < r.left && (a.left = r.left), n.resizeWidth && a.left >= r.left && a.left + i.width > r.right && (i.width -= a.left + i.width - r.right), n.adjustX && a.left + i.width > r.right && (a.left = Math.max(r.right - i.width, r.left)), n.adjustY && a.top < r.top && (a.top = r.top), n.resizeHeight && a.top >= r.top && a.top + i.height > r.bottom && (i.height -= a.top + i.height - r.bottom), n.adjustY && a.top + i.height > r.bottom && (a.top = Math.max(r.bottom - i.height, r.top)), ue.mix(a, i);
}
function Il(e) {
  var t, r, n;
  if (!ue.isWindow(e) && e.nodeType !== 9)
    t = ue.offset(e), r = ue.outerWidth(e), n = ue.outerHeight(e);
  else {
    var a = ue.getWindow(e);
    t = {
      left: ue.getWindowScrollLeft(a),
      top: ue.getWindowScrollTop(a)
    }, r = ue.viewportWidth(a), n = ue.viewportHeight(a);
  }
  return t.width = r, t.height = n, t;
}
function H2(e, t) {
  var r = t.charAt(0), n = t.charAt(1), a = e.width, i = e.height, o = e.left, l = e.top;
  return r === "c" ? l += i / 2 : r === "b" && (l += i), n === "c" ? o += a / 2 : n === "r" && (o += a), {
    left: o,
    top: l
  };
}
function Za(e, t, r, n, a) {
  var i = H2(t, r[1]), o = H2(e, r[0]), l = [o.left - i.left, o.top - i.top];
  return {
    left: Math.round(e.left - l[0] + n[0] - a[0]),
    top: Math.round(e.top - l[1] + n[1] - a[1])
  };
}
function W2(e, t, r) {
  return e.left < r.left || e.left + t.width > r.right;
}
function B2(e, t, r) {
  return e.top < r.top || e.top + t.height > r.bottom;
}
function Dg(e, t, r) {
  return e.left > r.right || e.left + t.width < r.left;
}
function Cg(e, t, r) {
  return e.top > r.bottom || e.top + t.height < r.top;
}
function Ya(e, t, r) {
  var n = [];
  return ue.each(e, function(a) {
    n.push(a.replace(t, function(i) {
      return r[i];
    }));
  }), n;
}
function Ha(e, t) {
  return e[t] = -e[t], e;
}
function q2(e, t) {
  var r;
  return /%$/.test(e) ? r = parseInt(e.substring(0, e.length - 1), 10) / 100 * t : r = parseInt(e, 10), r || 0;
}
function G2(e, t) {
  e[0] = q2(e[0], t.width), e[1] = q2(e[1], t.height);
}
function O4(e, t, r, n) {
  var a = r.points, i = r.offset || [0, 0], o = r.targetOffset || [0, 0], l = r.overflow, c = r.source || e;
  i = [].concat(i), o = [].concat(o), l = l || {};
  var s = {}, d = 0, M = !!(l && l.alwaysByViewport), f = _l(c, M), v = Il(c);
  G2(i, v), G2(o, t);
  var g = Za(v, t, a, i, o), m = ue.merge(v, g);
  if (f && (l.adjustX || l.adjustY) && n) {
    if (l.adjustX && W2(g, v, f)) {
      var p = Ya(a, /[lr]/gi, {
        l: "r",
        r: "l"
      }), h = Ha(i, 0), y = Ha(o, 0), N = Za(v, t, p, h, y);
      Dg(N, v, f) || (d = 1, a = p, i = h, o = y);
    }
    if (l.adjustY && B2(g, v, f)) {
      var I = Ya(a, /[tb]/gi, {
        t: "b",
        b: "t"
      }), D = Ha(i, 1), A = Ha(o, 1), k = Za(v, t, I, D, A);
      Cg(k, v, f) || (d = 1, a = I, i = D, o = A);
    }
    d && (g = Za(v, t, a, i, o), ue.mix(m, g));
    var L = W2(g, v, f), T = B2(g, v, f);
    if (L || T) {
      var C = a;
      L && (C = Ya(a, /[lr]/gi, {
        l: "r",
        r: "l"
      })), T && (C = Ya(a, /[tb]/gi, {
        t: "b",
        b: "t"
      })), a = C, i = r.offset || [0, 0], o = r.targetOffset || [0, 0];
    }
    s.adjustX = l.adjustX && L, s.adjustY = l.adjustY && T, (s.adjustX || s.adjustY) && (m = Ig(g, v, f, s));
  }
  return m.width !== v.width && ue.css(c, "width", ue.width(c) + m.width - v.width), m.height !== v.height && ue.css(c, "height", ue.height(c) + m.height - v.height), ue.offset(c, {
    left: m.left,
    top: m.top
  }, {
    useCssRight: r.useCssRight,
    useCssBottom: r.useCssBottom,
    useCssTransform: r.useCssTransform,
    ignoreShake: r.ignoreShake
  }), {
    points: a,
    offset: i,
    targetOffset: o,
    overflow: s
  };
}
function Eg(e, t) {
  var r = _l(e, t), n = Il(e);
  return !r || n.left + n.width <= r.left || n.top + n.height <= r.top || n.left >= r.right || n.top >= r.bottom;
}
function Dl(e, t, r) {
  var n = r.target || t, a = Il(n), i = !Eg(n, r.overflow && r.overflow.alwaysByViewport);
  return O4(e, a, r, i);
}
Dl.__getOffsetParent = J1;
Dl.__getVisibleRectForElement = _l;
function bg(e, t, r) {
  var n, a, i = ue.getDocument(e), o = i.defaultView || i.parentWindow, l = ue.getWindowScrollLeft(o), c = ue.getWindowScrollTop(o), s = ue.viewportWidth(o), d = ue.viewportHeight(o);
  "pageX" in t ? n = t.pageX : n = l + t.clientX, "pageY" in t ? a = t.pageY : a = c + t.clientY;
  var M = {
    left: n,
    top: a,
    width: 0,
    height: 0
  }, f = n >= 0 && n <= l + s && a >= 0 && a <= c + d, v = [r.points[0], "cc"];
  return O4(e, M, R2(R2({}, r), {}, {
    points: v
  }), f);
}
function Ag() {
  this.__data__ = [], this.size = 0;
}
var jg = Ag;
function xg(e, t) {
  return e === t || e !== e && t !== t;
}
var T4 = xg, wg = T4;
function Og(e, t) {
  for (var r = e.length; r--; )
    if (wg(e[r][0], t))
      return r;
  return -1;
}
var ui = Og, Tg = ui, Sg = Array.prototype, Lg = Sg.splice;
function kg(e) {
  var t = this.__data__, r = Tg(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Lg.call(t, r, 1), --this.size, !0;
}
var Pg = kg, Rg = ui;
function Qg(e) {
  var t = this.__data__, r = Rg(t, e);
  return r < 0 ? void 0 : t[r][1];
}
var Vg = Qg, Ug = ui;
function Fg(e) {
  return Ug(this.__data__, e) > -1;
}
var $g = Fg, Zg = ui;
function Yg(e, t) {
  var r = this.__data__, n = Zg(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
var Hg = Yg, Wg = jg, Bg = Pg, qg = Vg, Gg = $g, Kg = Hg;
function pn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
pn.prototype.clear = Wg;
pn.prototype.delete = Bg;
pn.prototype.get = qg;
pn.prototype.has = Gg;
pn.prototype.set = Kg;
var si = pn, Xg = si;
function Jg() {
  this.__data__ = new Xg(), this.size = 0;
}
var ep = Jg;
function tp(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}
var rp = tp;
function np(e) {
  return this.__data__.get(e);
}
var ap = np;
function ip(e) {
  return this.__data__.has(e);
}
var op = ip, lp = typeof jr == "object" && jr && jr.Object === Object && jr, S4 = lp, cp = S4, up = typeof self == "object" && self && self.Object === Object && self, sp = cp || up || Function("return this")(), ir = sp, dp = ir, fp = dp.Symbol, Cl = fp, K2 = Cl, L4 = Object.prototype, vp = L4.hasOwnProperty, Mp = L4.toString, Sn = K2 ? K2.toStringTag : void 0;
function gp(e) {
  var t = vp.call(e, Sn), r = e[Sn];
  try {
    e[Sn] = void 0;
    var n = !0;
  } catch {
  }
  var a = Mp.call(e);
  return n && (t ? e[Sn] = r : delete e[Sn]), a;
}
var pp = gp, hp = Object.prototype, mp = hp.toString;
function yp(e) {
  return mp.call(e);
}
var Np = yp, X2 = Cl, zp = pp, _p = Np, Ip = "[object Null]", Dp = "[object Undefined]", J2 = X2 ? X2.toStringTag : void 0;
function Cp(e) {
  return e == null ? e === void 0 ? Dp : Ip : J2 && J2 in Object(e) ? zp(e) : _p(e);
}
var di = Cp;
function Ep(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var k4 = Ep, bp = di, Ap = k4, jp = "[object AsyncFunction]", xp = "[object Function]", wp = "[object GeneratorFunction]", Op = "[object Proxy]";
function Tp(e) {
  if (!Ap(e))
    return !1;
  var t = bp(e);
  return t == xp || t == wp || t == jp || t == Op;
}
var P4 = Tp, Sp = ir, Lp = Sp["__core-js_shared__"], kp = Lp, qi = kp, eu = function() {
  var e = /[^.]+$/.exec(qi && qi.keys && qi.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Pp(e) {
  return !!eu && eu in e;
}
var Rp = Pp, Qp = Function.prototype, Vp = Qp.toString;
function Up(e) {
  if (e != null) {
    try {
      return Vp.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var R4 = Up, Fp = P4, $p = Rp, Zp = k4, Yp = R4, Hp = /[\\^$.*+?()[\]{}|]/g, Wp = /^\[object .+?Constructor\]$/, Bp = Function.prototype, qp = Object.prototype, Gp = Bp.toString, Kp = qp.hasOwnProperty, Xp = RegExp(
  "^" + Gp.call(Kp).replace(Hp, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Jp(e) {
  if (!Zp(e) || $p(e))
    return !1;
  var t = Fp(e) ? Xp : Wp;
  return t.test(Yp(e));
}
var eh = Jp;
function th(e, t) {
  return e == null ? void 0 : e[t];
}
var rh = th, nh = eh, ah = rh;
function ih(e, t) {
  var r = ah(e, t);
  return nh(r) ? r : void 0;
}
var hn = ih, oh = hn, lh = ir, ch = oh(lh, "Map"), El = ch, uh = hn, sh = uh(Object, "create"), fi = sh, tu = fi;
function dh() {
  this.__data__ = tu ? tu(null) : {}, this.size = 0;
}
var fh = dh;
function vh(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Mh = vh, gh = fi, ph = "__lodash_hash_undefined__", hh = Object.prototype, mh = hh.hasOwnProperty;
function yh(e) {
  var t = this.__data__;
  if (gh) {
    var r = t[e];
    return r === ph ? void 0 : r;
  }
  return mh.call(t, e) ? t[e] : void 0;
}
var Nh = yh, zh = fi, _h = Object.prototype, Ih = _h.hasOwnProperty;
function Dh(e) {
  var t = this.__data__;
  return zh ? t[e] !== void 0 : Ih.call(t, e);
}
var Ch = Dh, Eh = fi, bh = "__lodash_hash_undefined__";
function Ah(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Eh && t === void 0 ? bh : t, this;
}
var jh = Ah, xh = fh, wh = Mh, Oh = Nh, Th = Ch, Sh = jh;
function mn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
mn.prototype.clear = xh;
mn.prototype.delete = wh;
mn.prototype.get = Oh;
mn.prototype.has = Th;
mn.prototype.set = Sh;
var Lh = mn, ru = Lh, kh = si, Ph = El;
function Rh() {
  this.size = 0, this.__data__ = {
    hash: new ru(),
    map: new (Ph || kh)(),
    string: new ru()
  };
}
var Qh = Rh;
function Vh(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var Uh = Vh, Fh = Uh;
function $h(e, t) {
  var r = e.__data__;
  return Fh(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
var vi = $h, Zh = vi;
function Yh(e) {
  var t = Zh(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Hh = Yh, Wh = vi;
function Bh(e) {
  return Wh(this, e).get(e);
}
var qh = Bh, Gh = vi;
function Kh(e) {
  return Gh(this, e).has(e);
}
var Xh = Kh, Jh = vi;
function em(e, t) {
  var r = Jh(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
var tm = em, rm = Qh, nm = Hh, am = qh, im = Xh, om = tm;
function yn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
yn.prototype.clear = rm;
yn.prototype.delete = nm;
yn.prototype.get = am;
yn.prototype.has = im;
yn.prototype.set = om;
var Q4 = yn, lm = si, cm = El, um = Q4, sm = 200;
function dm(e, t) {
  var r = this.__data__;
  if (r instanceof lm) {
    var n = r.__data__;
    if (!cm || n.length < sm - 1)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new um(n);
  }
  return r.set(e, t), this.size = r.size, this;
}
var fm = dm, vm = si, Mm = ep, gm = rp, pm = ap, hm = op, mm = fm;
function Nn(e) {
  var t = this.__data__ = new vm(e);
  this.size = t.size;
}
Nn.prototype.clear = Mm;
Nn.prototype.delete = gm;
Nn.prototype.get = pm;
Nn.prototype.has = hm;
Nn.prototype.set = mm;
var ym = Nn, Nm = "__lodash_hash_undefined__";
function zm(e) {
  return this.__data__.set(e, Nm), this;
}
var _m = zm;
function Im(e) {
  return this.__data__.has(e);
}
var Dm = Im, Cm = Q4, Em = _m, bm = Dm;
function E0(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new Cm(); ++t < r; )
    this.add(e[t]);
}
E0.prototype.add = E0.prototype.push = Em;
E0.prototype.has = bm;
var Am = E0;
function jm(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
var xm = jm;
function wm(e, t) {
  return e.has(t);
}
var Om = wm, Tm = Am, Sm = xm, Lm = Om, km = 1, Pm = 2;
function Rm(e, t, r, n, a, i) {
  var o = r & km, l = e.length, c = t.length;
  if (l != c && !(o && c > l))
    return !1;
  var s = i.get(e), d = i.get(t);
  if (s && d)
    return s == t && d == e;
  var M = -1, f = !0, v = r & Pm ? new Tm() : void 0;
  for (i.set(e, t), i.set(t, e); ++M < l; ) {
    var g = e[M], m = t[M];
    if (n)
      var p = o ? n(m, g, M, t, e, i) : n(g, m, M, e, t, i);
    if (p !== void 0) {
      if (p)
        continue;
      f = !1;
      break;
    }
    if (v) {
      if (!Sm(t, function(h, y) {
        if (!Lm(v, y) && (g === h || a(g, h, r, n, i)))
          return v.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(g === m || a(g, m, r, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var V4 = Rm, Qm = ir, Vm = Qm.Uint8Array, Um = Vm;
function Fm(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, a) {
    r[++t] = [a, n];
  }), r;
}
var $m = Fm;
function Zm(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var Ym = Zm, nu = Cl, au = Um, Hm = T4, Wm = V4, Bm = $m, qm = Ym, Gm = 1, Km = 2, Xm = "[object Boolean]", Jm = "[object Date]", ey = "[object Error]", ty = "[object Map]", ry = "[object Number]", ny = "[object RegExp]", ay = "[object Set]", iy = "[object String]", oy = "[object Symbol]", ly = "[object ArrayBuffer]", cy = "[object DataView]", iu = nu ? nu.prototype : void 0, Gi = iu ? iu.valueOf : void 0;
function uy(e, t, r, n, a, i, o) {
  switch (r) {
    case cy:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case ly:
      return !(e.byteLength != t.byteLength || !i(new au(e), new au(t)));
    case Xm:
    case Jm:
    case ry:
      return Hm(+e, +t);
    case ey:
      return e.name == t.name && e.message == t.message;
    case ny:
    case iy:
      return e == t + "";
    case ty:
      var l = Bm;
    case ay:
      var c = n & Gm;
      if (l || (l = qm), e.size != t.size && !c)
        return !1;
      var s = o.get(e);
      if (s)
        return s == t;
      n |= Km, o.set(e, t);
      var d = Wm(l(e), l(t), n, a, i, o);
      return o.delete(e), d;
    case oy:
      if (Gi)
        return Gi.call(e) == Gi.call(t);
  }
  return !1;
}
var sy = uy;
function dy(e, t) {
  for (var r = -1, n = t.length, a = e.length; ++r < n; )
    e[a + r] = t[r];
  return e;
}
var fy = dy, vy = Array.isArray, bl = vy, My = fy, gy = bl;
function py(e, t, r) {
  var n = t(e);
  return gy(e) ? n : My(n, r(e));
}
var hy = py;
function my(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++r < n; ) {
    var o = e[r];
    t(o, r, e) && (i[a++] = o);
  }
  return i;
}
var yy = my;
function Ny() {
  return [];
}
var zy = Ny, _y = yy, Iy = zy, Dy = Object.prototype, Cy = Dy.propertyIsEnumerable, ou = Object.getOwnPropertySymbols, Ey = ou ? function(e) {
  return e == null ? [] : (e = Object(e), _y(ou(e), function(t) {
    return Cy.call(e, t);
  }));
} : Iy, by = Ey;
function Ay(e, t) {
  for (var r = -1, n = Array(e); ++r < e; )
    n[r] = t(r);
  return n;
}
var jy = Ay;
function xy(e) {
  return e != null && typeof e == "object";
}
var Mi = xy, wy = di, Oy = Mi, Ty = "[object Arguments]";
function Sy(e) {
  return Oy(e) && wy(e) == Ty;
}
var Ly = Sy, lu = Ly, ky = Mi, U4 = Object.prototype, Py = U4.hasOwnProperty, Ry = U4.propertyIsEnumerable, Qy = lu(function() {
  return arguments;
}()) ? lu : function(e) {
  return ky(e) && Py.call(e, "callee") && !Ry.call(e, "callee");
}, Vy = Qy, b0 = { exports: {} };
function Uy() {
  return !1;
}
var Fy = Uy;
(function(e, t) {
  var r = ir, n = Fy, a = t && !t.nodeType && t, i = a && !0 && e && !e.nodeType && e, o = i && i.exports === a, l = o ? r.Buffer : void 0, c = l ? l.isBuffer : void 0, s = c || n;
  e.exports = s;
})(b0, b0.exports);
var $y = 9007199254740991, Zy = /^(?:0|[1-9]\d*)$/;
function Yy(e, t) {
  var r = typeof e;
  return t = t == null ? $y : t, !!t && (r == "number" || r != "symbol" && Zy.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Hy = Yy, Wy = 9007199254740991;
function By(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Wy;
}
var F4 = By, qy = di, Gy = F4, Ky = Mi, Xy = "[object Arguments]", Jy = "[object Array]", eN = "[object Boolean]", tN = "[object Date]", rN = "[object Error]", nN = "[object Function]", aN = "[object Map]", iN = "[object Number]", oN = "[object Object]", lN = "[object RegExp]", cN = "[object Set]", uN = "[object String]", sN = "[object WeakMap]", dN = "[object ArrayBuffer]", fN = "[object DataView]", vN = "[object Float32Array]", MN = "[object Float64Array]", gN = "[object Int8Array]", pN = "[object Int16Array]", hN = "[object Int32Array]", mN = "[object Uint8Array]", yN = "[object Uint8ClampedArray]", NN = "[object Uint16Array]", zN = "[object Uint32Array]", Se = {};
Se[vN] = Se[MN] = Se[gN] = Se[pN] = Se[hN] = Se[mN] = Se[yN] = Se[NN] = Se[zN] = !0;
Se[Xy] = Se[Jy] = Se[dN] = Se[eN] = Se[fN] = Se[tN] = Se[rN] = Se[nN] = Se[aN] = Se[iN] = Se[oN] = Se[lN] = Se[cN] = Se[uN] = Se[sN] = !1;
function _N(e) {
  return Ky(e) && Gy(e.length) && !!Se[qy(e)];
}
var IN = _N;
function DN(e) {
  return function(t) {
    return e(t);
  };
}
var CN = DN, eo = { exports: {} };
(function(e, t) {
  var r = S4, n = t && !t.nodeType && t, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, l = function() {
    try {
      var c = a && a.require && a.require("util").types;
      return c || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = l;
})(eo, eo.exports);
var EN = IN, bN = CN, cu = eo.exports, uu = cu && cu.isTypedArray, AN = uu ? bN(uu) : EN, $4 = AN, jN = jy, xN = Vy, wN = bl, ON = b0.exports, TN = Hy, SN = $4, LN = Object.prototype, kN = LN.hasOwnProperty;
function PN(e, t) {
  var r = wN(e), n = !r && xN(e), a = !r && !n && ON(e), i = !r && !n && !a && SN(e), o = r || n || a || i, l = o ? jN(e.length, String) : [], c = l.length;
  for (var s in e)
    (t || kN.call(e, s)) && !(o && (s == "length" || a && (s == "offset" || s == "parent") || i && (s == "buffer" || s == "byteLength" || s == "byteOffset") || TN(s, c))) && l.push(s);
  return l;
}
var RN = PN, QN = Object.prototype;
function VN(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || QN;
  return e === r;
}
var UN = VN;
function FN(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var $N = FN, ZN = $N, YN = ZN(Object.keys, Object), HN = YN, WN = UN, BN = HN, qN = Object.prototype, GN = qN.hasOwnProperty;
function KN(e) {
  if (!WN(e))
    return BN(e);
  var t = [];
  for (var r in Object(e))
    GN.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var XN = KN, JN = P4, ez = F4;
function tz(e) {
  return e != null && ez(e.length) && !JN(e);
}
var rz = tz, nz = RN, az = XN, iz = rz;
function oz(e) {
  return iz(e) ? nz(e) : az(e);
}
var lz = oz, cz = hy, uz = by, sz = lz;
function dz(e) {
  return cz(e, sz, uz);
}
var fz = dz, su = fz, vz = 1, Mz = Object.prototype, gz = Mz.hasOwnProperty;
function pz(e, t, r, n, a, i) {
  var o = r & vz, l = su(e), c = l.length, s = su(t), d = s.length;
  if (c != d && !o)
    return !1;
  for (var M = c; M--; ) {
    var f = l[M];
    if (!(o ? f in t : gz.call(t, f)))
      return !1;
  }
  var v = i.get(e), g = i.get(t);
  if (v && g)
    return v == t && g == e;
  var m = !0;
  i.set(e, t), i.set(t, e);
  for (var p = o; ++M < c; ) {
    f = l[M];
    var h = e[f], y = t[f];
    if (n)
      var N = o ? n(y, h, f, t, e, i) : n(h, y, f, e, t, i);
    if (!(N === void 0 ? h === y || a(h, y, r, n, i) : N)) {
      m = !1;
      break;
    }
    p || (p = f == "constructor");
  }
  if (m && !p) {
    var I = e.constructor, D = t.constructor;
    I != D && "constructor" in e && "constructor" in t && !(typeof I == "function" && I instanceof I && typeof D == "function" && D instanceof D) && (m = !1);
  }
  return i.delete(e), i.delete(t), m;
}
var hz = pz, mz = hn, yz = ir, Nz = mz(yz, "DataView"), zz = Nz, _z = hn, Iz = ir, Dz = _z(Iz, "Promise"), Cz = Dz, Ez = hn, bz = ir, Az = Ez(bz, "Set"), jz = Az, xz = hn, wz = ir, Oz = xz(wz, "WeakMap"), Tz = Oz, to = zz, ro = El, no = Cz, ao = jz, io = Tz, Z4 = di, zn = R4, du = "[object Map]", Sz = "[object Object]", fu = "[object Promise]", vu = "[object Set]", Mu = "[object WeakMap]", gu = "[object DataView]", Lz = zn(to), kz = zn(ro), Pz = zn(no), Rz = zn(ao), Qz = zn(io), br = Z4;
(to && br(new to(new ArrayBuffer(1))) != gu || ro && br(new ro()) != du || no && br(no.resolve()) != fu || ao && br(new ao()) != vu || io && br(new io()) != Mu) && (br = function(e) {
  var t = Z4(e), r = t == Sz ? e.constructor : void 0, n = r ? zn(r) : "";
  if (n)
    switch (n) {
      case Lz:
        return gu;
      case kz:
        return du;
      case Pz:
        return fu;
      case Rz:
        return vu;
      case Qz:
        return Mu;
    }
  return t;
});
var Vz = br, Ki = ym, Uz = V4, Fz = sy, $z = hz, pu = Vz, hu = bl, mu = b0.exports, Zz = $4, Yz = 1, yu = "[object Arguments]", Nu = "[object Array]", Wa = "[object Object]", Hz = Object.prototype, zu = Hz.hasOwnProperty;
function Wz(e, t, r, n, a, i) {
  var o = hu(e), l = hu(t), c = o ? Nu : pu(e), s = l ? Nu : pu(t);
  c = c == yu ? Wa : c, s = s == yu ? Wa : s;
  var d = c == Wa, M = s == Wa, f = c == s;
  if (f && mu(e)) {
    if (!mu(t))
      return !1;
    o = !0, d = !1;
  }
  if (f && !d)
    return i || (i = new Ki()), o || Zz(e) ? Uz(e, t, r, n, a, i) : Fz(e, t, c, r, n, a, i);
  if (!(r & Yz)) {
    var v = d && zu.call(e, "__wrapped__"), g = M && zu.call(t, "__wrapped__");
    if (v || g) {
      var m = v ? e.value() : e, p = g ? t.value() : t;
      return i || (i = new Ki()), a(m, p, r, n, i);
    }
  }
  return f ? (i || (i = new Ki()), $z(e, t, r, n, a, i)) : !1;
}
var Bz = Wz, qz = Bz, _u = Mi;
function Y4(e, t, r, n, a) {
  return e === t ? !0 : e == null || t == null || !_u(e) && !_u(t) ? e !== e && t !== t : qz(e, t, r, n, Y4, a);
}
var Gz = Y4, Kz = Gz;
function Xz(e, t) {
  return Kz(e, t);
}
var Jz = Xz;
function e_(e, t) {
  return e === t ? !0 : !e || !t ? !1 : "pageX" in t && "pageY" in t ? e.pageX === t.pageX && e.pageY === t.pageY : "clientX" in t && "clientY" in t ? e.clientX === t.clientX && e.clientY === t.clientY : !1;
}
function t_(e, t) {
  e !== document.activeElement && a0(t, e) && typeof e.focus == "function" && e.focus();
}
function Iu(e, t) {
  var r = null, n = null;
  function a(o) {
    var l = pe(o, 1), c = l[0].target;
    if (!!document.documentElement.contains(c)) {
      var s = c.getBoundingClientRect(), d = s.width, M = s.height, f = Math.floor(d), v = Math.floor(M);
      (r !== f || n !== v) && Promise.resolve().then(function() {
        t({
          width: f,
          height: v
        });
      }), r = f, n = v;
    }
  }
  var i = new b3(a);
  return e && i.observe(e), function() {
    i.disconnect();
  };
}
const r_ = function(e, t) {
  var r = u.useRef(!1), n = u.useRef(null);
  function a() {
    window.clearTimeout(n.current);
  }
  function i(o) {
    if (a(), !r.current || o === !0) {
      if (e() === !1)
        return;
      r.current = !0, n.current = window.setTimeout(function() {
        r.current = !1;
      }, t);
    } else
      n.current = window.setTimeout(function() {
        r.current = !1, i();
      }, t);
  }
  return [i, function() {
    r.current = !1, a();
  }];
};
function Du(e) {
  return typeof e != "function" ? null : e();
}
function Cu(e) {
  return Ve(e) !== "object" || !e ? null : e;
}
var n_ = function(t, r) {
  var n = t.children, a = t.disabled, i = t.target, o = t.align, l = t.onAlign, c = t.monitorWindowResize, s = t.monitorBufferTime, d = s === void 0 ? 0 : s, M = u.useRef({}), f = u.useRef(), v = u.Children.only(n), g = u.useRef({});
  g.current.disabled = a, g.current.target = i, g.current.align = o, g.current.onAlign = l;
  var m = r_(function() {
    var A = g.current, k = A.disabled, L = A.target, T = A.align, C = A.onAlign;
    if (!k && L) {
      var j = f.current, w, E = Du(L), _ = Cu(L);
      M.current.element = E, M.current.point = _, M.current.align = T;
      var b = document, O = b.activeElement;
      return E && eg(E) ? w = Dl(j, E, T) : _ && (w = bg(j, _, T)), t_(O, j), C && w && C(j, w), !0;
    }
    return !1;
  }, d), p = pe(m, 2), h = p[0], y = p[1], N = u.useRef({
    cancel: function() {
    }
  }), I = u.useRef({
    cancel: function() {
    }
  });
  u.useEffect(function() {
    var A = Du(i), k = Cu(i);
    f.current !== I.current.element && (I.current.cancel(), I.current.element = f.current, I.current.cancel = Iu(f.current, h)), (M.current.element !== A || !e_(M.current.point, k) || !Jz(M.current.align, o)) && (h(), N.current.element !== A && (N.current.cancel(), N.current.element = A, N.current.cancel = Iu(A, h)));
  }), u.useEffect(function() {
    a ? y() : h();
  }, [a]);
  var D = u.useRef(null);
  return u.useEffect(function() {
    c ? D.current || (D.current = Qn(window, "resize", h)) : D.current && (D.current.remove(), D.current = null);
  }, [c]), u.useEffect(function() {
    return function() {
      N.current.cancel(), I.current.cancel(), D.current && D.current.remove(), y();
    };
  }, []), u.useImperativeHandle(r, function() {
    return {
      forceAlign: function() {
        return h(!0);
      }
    };
  }), /* @__PURE__ */ u.isValidElement(v) && (v = /* @__PURE__ */ u.cloneElement(v, {
    ref: To(v.ref, f)
  })), v;
}, H4 = /* @__PURE__ */ u.forwardRef(n_);
H4.displayName = "Align";
var Eu = ["measure", "alignPre", "align", null, "motion"];
const a_ = function(e, t) {
  var r = tn(null), n = pe(r, 2), a = n[0], i = n[1], o = Le();
  function l(d) {
    i(d, !0);
  }
  function c() {
    kt.cancel(o.current);
  }
  function s(d) {
    c(), o.current = kt(function() {
      l(function(M) {
        switch (a) {
          case "align":
            return "motion";
          case "motion":
            return "stable";
        }
        return M;
      }), d == null || d();
    });
  }
  return lt(function() {
    l("measure");
  }, [e]), lt(function() {
    switch (a) {
      case "measure":
        t();
        break;
    }
    a && (o.current = kt(/* @__PURE__ */ Ur(/* @__PURE__ */ tt().mark(function d() {
      var M, f;
      return tt().wrap(function(g) {
        for (; ; )
          switch (g.prev = g.next) {
            case 0:
              M = Eu.indexOf(a), f = Eu[M + 1], f && M !== -1 && l(f);
            case 3:
            case "end":
              return g.stop();
          }
      }, d);
    }))));
  }, [a]), lt(function() {
    return function() {
      c();
    };
  }, []), [a, s];
}, i_ = function(e) {
  var t = z.useState({
    width: 0,
    height: 0
  }), r = pe(t, 2), n = r[0], a = r[1];
  function i(l) {
    a({
      width: l.offsetWidth,
      height: l.offsetHeight
    });
  }
  var o = z.useMemo(function() {
    var l = {};
    if (e) {
      var c = n.width, s = n.height;
      e.indexOf("height") !== -1 && s ? l.height = s : e.indexOf("minHeight") !== -1 && s && (l.minHeight = s), e.indexOf("width") !== -1 && c ? l.width = c : e.indexOf("minWidth") !== -1 && c && (l.minWidth = c);
    }
    return l;
  }, [e, n]);
  return [o, i];
};
var W4 = /* @__PURE__ */ z.forwardRef(function(e, t) {
  var r = e.visible, n = e.prefixCls, a = e.className, i = e.style, o = e.children, l = e.zIndex, c = e.stretch, s = e.destroyPopupOnHide, d = e.forceRender, M = e.align, f = e.point, v = e.getRootDomNode, g = e.getClassNameFromAlign, m = e.onAlign, p = e.onMouseEnter, h = e.onMouseLeave, y = e.onMouseDown, N = e.onTouchStart, I = e.onClick, D = Le(), A = Le(), k = de(), L = pe(k, 2), T = L[0], C = L[1], j = i_(c), w = pe(j, 2), E = w[0], _ = w[1];
  function b() {
    c && _(v());
  }
  var O = a_(r, b), S = pe(O, 2), R = S[0], V = S[1], Q = de(0), x = pe(Q, 2), P = x[0], U = x[1], F = Le();
  kr(function() {
    R === "alignPre" && U(0);
  }, [R]);
  function $() {
    return f || v;
  }
  function W() {
    var K;
    (K = D.current) === null || K === void 0 || K.forceAlign();
  }
  function te(K, ee) {
    var ce = g(ee);
    T !== ce && C(ce), U(function(ie) {
      return ie + 1;
    }), R === "align" && (m == null || m(K, ee));
  }
  kr(function() {
    R === "align" && (P < 2 ? W() : V(function() {
      var K;
      (K = F.current) === null || K === void 0 || K.call(F);
    }));
  }, [P]);
  var J = H({}, D4(e));
  ["onAppearEnd", "onEnterEnd", "onLeaveEnd"].forEach(function(K) {
    var ee = J[K];
    J[K] = function(ce, ie) {
      return V(), ee == null ? void 0 : ee(ce, ie);
    };
  });
  function q() {
    return new Promise(function(K) {
      F.current = K;
    });
  }
  z.useEffect(function() {
    !J.motionName && R === "motion" && V();
  }, [J.motionName, R]), z.useImperativeHandle(t, function() {
    return {
      forceAlign: W,
      getElement: function() {
        return A.current;
      }
    };
  });
  var B = H(H({}, E), {}, {
    zIndex: l,
    opacity: R === "motion" || R === "stable" || !r ? void 0 : 0,
    pointerEvents: !r && R !== "stable" ? "none" : void 0
  }, i), G = !0;
  (M == null ? void 0 : M.points) && (R === "align" || R === "stable") && (G = !1);
  var Z = o;
  return z.Children.count(o) > 1 && (Z = /* @__PURE__ */ z.createElement("div", {
    className: "".concat(n, "-content")
  }, o)), /* @__PURE__ */ z.createElement(k0, Pe({
    visible: r,
    ref: A,
    leavedClassName: "".concat(n, "-hidden")
  }, J, {
    onAppearPrepare: q,
    onEnterPrepare: q,
    removeOnLeave: s,
    forceRender: d
  }), function(K, ee) {
    var ce = K.className, ie = K.style, ae = Y(n, a, T, ce);
    return /* @__PURE__ */ z.createElement(H4, {
      target: $(),
      key: "popup",
      ref: D,
      monitorWindowResize: !0,
      disabled: G,
      align: M,
      onAlign: te
    }, /* @__PURE__ */ z.createElement("div", {
      ref: ee,
      className: ae,
      onMouseEnter: p,
      onMouseLeave: h,
      onMouseDownCapture: y,
      onTouchStartCapture: N,
      onClick: I,
      style: H(H({}, ie), B)
    }, Z));
  });
});
W4.displayName = "PopupInner";
var B4 = /* @__PURE__ */ z.forwardRef(function(e, t) {
  var r = e.prefixCls, n = e.visible, a = e.zIndex, i = e.children, o = e.mobile;
  o = o === void 0 ? {} : o;
  var l = o.popupClassName, c = o.popupStyle, s = o.popupMotion, d = s === void 0 ? {} : s, M = o.popupRender, f = e.onClick, v = z.useRef();
  z.useImperativeHandle(t, function() {
    return {
      forceAlign: function() {
      },
      getElement: function() {
        return v.current;
      }
    };
  });
  var g = H({
    zIndex: a
  }, c), m = i;
  return z.Children.count(i) > 1 && (m = /* @__PURE__ */ z.createElement("div", {
    className: "".concat(r, "-content")
  }, i)), M && (m = M(m)), /* @__PURE__ */ z.createElement(k0, Pe({
    visible: n,
    ref: v,
    removeOnLeave: !0
  }, d), function(p, h) {
    var y = p.className, N = p.style, I = Y(r, l, y);
    return /* @__PURE__ */ z.createElement("div", {
      ref: h,
      className: I,
      onClick: f,
      style: H(H({}, N), g)
    }, m);
  });
});
B4.displayName = "MobilePopupInner";
var o_ = ["visible", "mobile"], q4 = /* @__PURE__ */ z.forwardRef(function(e, t) {
  var r = e.visible, n = e.mobile, a = Wt(e, o_), i = de(r), o = pe(i, 2), l = o[0], c = o[1], s = de(!1), d = pe(s, 2), M = d[0], f = d[1], v = H(H({}, a), {}, {
    visible: l
  });
  lt(function() {
    c(r), r && n && f(XM());
  }, [r, n]);
  var g = M ? /* @__PURE__ */ z.createElement(B4, Pe({}, v, {
    mobile: n,
    ref: t
  })) : /* @__PURE__ */ z.createElement(W4, Pe({}, v, {
    ref: t
  }));
  return /* @__PURE__ */ z.createElement("div", null, /* @__PURE__ */ z.createElement(JM, v), g);
});
q4.displayName = "Popup";
var bu = /* @__PURE__ */ z.createContext(null);
function Xi() {
}
function l_() {
  return "";
}
function c_(e) {
  return e ? e.ownerDocument : window.document;
}
var u_ = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"];
function s_(e) {
  var t = /* @__PURE__ */ function(r) {
    Nr(a, r);
    var n = zr(a);
    function a(i) {
      var o;
      Bt(this, a), o = n.call(this, i), o.popupRef = /* @__PURE__ */ z.createRef(), o.triggerRef = /* @__PURE__ */ z.createRef(), o.portalContainer = void 0, o.attachId = void 0, o.clickOutsideHandler = void 0, o.touchOutsideHandler = void 0, o.contextMenuOutsideHandler1 = void 0, o.contextMenuOutsideHandler2 = void 0, o.mouseDownTimeout = void 0, o.focusTime = void 0, o.preClickTime = void 0, o.preTouchTime = void 0, o.delayTimer = void 0, o.hasPopupMouseDown = void 0, o.onMouseEnter = function(c) {
        var s = o.props.mouseEnterDelay;
        o.fireEvents("onMouseEnter", c), o.delaySetPopupVisible(!0, s, s ? null : c);
      }, o.onMouseMove = function(c) {
        o.fireEvents("onMouseMove", c), o.setPoint(c);
      }, o.onMouseLeave = function(c) {
        o.fireEvents("onMouseLeave", c), o.delaySetPopupVisible(!1, o.props.mouseLeaveDelay);
      }, o.onPopupMouseEnter = function() {
        o.clearDelayTimer();
      }, o.onPopupMouseLeave = function(c) {
        var s;
        c.relatedTarget && !c.relatedTarget.setTimeout && a0((s = o.popupRef.current) === null || s === void 0 ? void 0 : s.getElement(), c.relatedTarget) || o.delaySetPopupVisible(!1, o.props.mouseLeaveDelay);
      }, o.onFocus = function(c) {
        o.fireEvents("onFocus", c), o.clearDelayTimer(), o.isFocusToShow() && (o.focusTime = Date.now(), o.delaySetPopupVisible(!0, o.props.focusDelay));
      }, o.onMouseDown = function(c) {
        o.fireEvents("onMouseDown", c), o.preClickTime = Date.now();
      }, o.onTouchStart = function(c) {
        o.fireEvents("onTouchStart", c), o.preTouchTime = Date.now();
      }, o.onBlur = function(c) {
        o.fireEvents("onBlur", c), o.clearDelayTimer(), o.isBlurToHide() && o.delaySetPopupVisible(!1, o.props.blurDelay);
      }, o.onContextMenu = function(c) {
        c.preventDefault(), o.fireEvents("onContextMenu", c), o.setPopupVisible(!0, c);
      }, o.onContextMenuClose = function() {
        o.isContextMenuToShow() && o.close();
      }, o.onClick = function(c) {
        if (o.fireEvents("onClick", c), o.focusTime) {
          var s;
          if (o.preClickTime && o.preTouchTime ? s = Math.min(o.preClickTime, o.preTouchTime) : o.preClickTime ? s = o.preClickTime : o.preTouchTime && (s = o.preTouchTime), Math.abs(s - o.focusTime) < 20)
            return;
          o.focusTime = 0;
        }
        o.preClickTime = 0, o.preTouchTime = 0, o.isClickToShow() && (o.isClickToHide() || o.isBlurToHide()) && c && c.preventDefault && c.preventDefault();
        var d = !o.state.popupVisible;
        (o.isClickToHide() && !d || d && o.isClickToShow()) && o.setPopupVisible(!o.state.popupVisible, c);
      }, o.onPopupMouseDown = function() {
        if (o.hasPopupMouseDown = !0, clearTimeout(o.mouseDownTimeout), o.mouseDownTimeout = window.setTimeout(function() {
          o.hasPopupMouseDown = !1;
        }, 0), o.context) {
          var c;
          (c = o.context).onPopupMouseDown.apply(c, arguments);
        }
      }, o.onDocumentClick = function(c) {
        if (!(o.props.mask && !o.props.maskClosable)) {
          var s = c.target, d = o.getRootDomNode(), M = o.getPopupDomNode();
          (!a0(d, s) || o.isContextMenuOnly()) && !a0(M, s) && !o.hasPopupMouseDown && o.close();
        }
      }, o.getRootDomNode = function() {
        var c = o.props.getTriggerDOMNode;
        if (c)
          return c(o.triggerRef.current);
        try {
          var s = z0(o.triggerRef.current);
          if (s)
            return s;
        } catch {
        }
        return Sr.findDOMNode(Lo(o));
      }, o.getPopupClassNameFromAlign = function(c) {
        var s = [], d = o.props, M = d.popupPlacement, f = d.builtinPlacements, v = d.prefixCls, g = d.alignPoint, m = d.getPopupClassNameFromAlign;
        return M && f && s.push(KM(f, v, c, g)), m && s.push(m(c)), s.join(" ");
      }, o.getComponent = function() {
        var c = o.props, s = c.prefixCls, d = c.destroyPopupOnHide, M = c.popupClassName, f = c.onPopupAlign, v = c.popupMotion, g = c.popupAnimation, m = c.popupTransitionName, p = c.popupStyle, h = c.mask, y = c.maskAnimation, N = c.maskTransitionName, I = c.maskMotion, D = c.zIndex, A = c.popup, k = c.stretch, L = c.alignPoint, T = c.mobile, C = c.forceRender, j = c.onPopupClick, w = o.state, E = w.popupVisible, _ = w.point, b = o.getPopupAlign(), O = {};
        return o.isMouseEnterToShow() && (O.onMouseEnter = o.onPopupMouseEnter), o.isMouseLeaveToHide() && (O.onMouseLeave = o.onPopupMouseLeave), O.onMouseDown = o.onPopupMouseDown, O.onTouchStart = o.onPopupMouseDown, /* @__PURE__ */ z.createElement(q4, Pe({
          prefixCls: s,
          destroyPopupOnHide: d,
          visible: E,
          point: L && _,
          className: M,
          align: b,
          onAlign: f,
          animation: g,
          getClassNameFromAlign: o.getPopupClassNameFromAlign
        }, O, {
          stretch: k,
          getRootDomNode: o.getRootDomNode,
          style: p,
          mask: h,
          zIndex: D,
          transitionName: m,
          maskAnimation: y,
          maskTransitionName: N,
          maskMotion: I,
          ref: o.popupRef,
          motion: v,
          mobile: T,
          forceRender: C,
          onClick: j
        }), typeof A == "function" ? A() : A);
      }, o.attachParent = function(c) {
        kt.cancel(o.attachId);
        var s = o.props, d = s.getPopupContainer, M = s.getDocument, f = o.getRootDomNode(), v;
        d ? (f || d.length === 0) && (v = d(f)) : v = M(o.getRootDomNode()).body, v ? v.appendChild(c) : o.attachId = kt(function() {
          o.attachParent(c);
        });
      }, o.getContainer = function() {
        if (!o.portalContainer) {
          var c = o.props.getDocument, s = c(o.getRootDomNode()).createElement("div");
          s.style.position = "absolute", s.style.top = "0", s.style.left = "0", s.style.width = "100%", o.portalContainer = s;
        }
        return o.attachParent(o.portalContainer), o.portalContainer;
      }, o.setPoint = function(c) {
        var s = o.props.alignPoint;
        !s || !c || o.setState({
          point: {
            pageX: c.pageX,
            pageY: c.pageY
          }
        });
      }, o.handlePortalUpdate = function() {
        o.state.prevPopupVisible !== o.state.popupVisible && o.props.afterPopupVisibleChange(o.state.popupVisible);
      }, o.triggerContextValue = {
        onPopupMouseDown: o.onPopupMouseDown
      };
      var l;
      return "popupVisible" in i ? l = !!i.popupVisible : l = !!i.defaultPopupVisible, o.state = {
        prevPopupVisible: l,
        popupVisible: l
      }, u_.forEach(function(c) {
        o["fire".concat(c)] = function(s) {
          o.fireEvents(c, s);
        };
      }), o;
    }
    return qt(a, [{
      key: "componentDidMount",
      value: function() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        var o = this.props, l = this.state;
        if (l.popupVisible) {
          var c;
          !this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow()) && (c = o.getDocument(this.getRootDomNode()), this.clickOutsideHandler = Qn(c, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (c = c || o.getDocument(this.getRootDomNode()), this.touchOutsideHandler = Qn(c, "touchstart", this.onDocumentClick)), !this.contextMenuOutsideHandler1 && this.isContextMenuToShow() && (c = c || o.getDocument(this.getRootDomNode()), this.contextMenuOutsideHandler1 = Qn(c, "scroll", this.onContextMenuClose)), !this.contextMenuOutsideHandler2 && this.isContextMenuToShow() && (this.contextMenuOutsideHandler2 = Qn(window, "blur", this.onContextMenuClose));
          return;
        }
        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.clearDelayTimer(), this.clearOutsideHandler(), clearTimeout(this.mouseDownTimeout), kt.cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function() {
        var o;
        return ((o = this.popupRef.current) === null || o === void 0 ? void 0 : o.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function() {
        var o = this.props, l = o.popupPlacement, c = o.popupAlign, s = o.builtinPlacements;
        return l && s ? GM(s, l, c) : c;
      }
    }, {
      key: "setPopupVisible",
      value: function(o, l) {
        var c = this.props.alignPoint, s = this.state.popupVisible;
        this.clearDelayTimer(), s !== o && ("popupVisible" in this.props || this.setState({
          popupVisible: o,
          prevPopupVisible: s
        }), this.props.onPopupVisibleChange(o)), c && l && o && this.setPoint(l);
      }
    }, {
      key: "delaySetPopupVisible",
      value: function(o, l, c) {
        var s = this, d = l * 1e3;
        if (this.clearDelayTimer(), d) {
          var M = c ? {
            pageX: c.pageX,
            pageY: c.pageY
          } : null;
          this.delayTimer = window.setTimeout(function() {
            s.setPopupVisible(o, M), s.clearDelayTimer();
          }, d);
        } else
          this.setPopupVisible(o, c);
      }
    }, {
      key: "clearDelayTimer",
      value: function() {
        this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
      }
    }, {
      key: "clearOutsideHandler",
      value: function() {
        this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextMenuOutsideHandler1 && (this.contextMenuOutsideHandler1.remove(), this.contextMenuOutsideHandler1 = null), this.contextMenuOutsideHandler2 && (this.contextMenuOutsideHandler2.remove(), this.contextMenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
      }
    }, {
      key: "createTwoChains",
      value: function(o) {
        var l = this.props.children.props, c = this.props;
        return l[o] && c[o] ? this["fire".concat(o)] : l[o] || c[o];
      }
    }, {
      key: "isClickToShow",
      value: function() {
        var o = this.props, l = o.action, c = o.showAction;
        return l.indexOf("click") !== -1 || c.indexOf("click") !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function() {
        var o = this.props.action;
        return o === "contextMenu" || o.length === 1 && o[0] === "contextMenu";
      }
    }, {
      key: "isContextMenuToShow",
      value: function() {
        var o = this.props, l = o.action, c = o.showAction;
        return l.indexOf("contextMenu") !== -1 || c.indexOf("contextMenu") !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function() {
        var o = this.props, l = o.action, c = o.hideAction;
        return l.indexOf("click") !== -1 || c.indexOf("click") !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function() {
        var o = this.props, l = o.action, c = o.showAction;
        return l.indexOf("hover") !== -1 || c.indexOf("mouseEnter") !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function() {
        var o = this.props, l = o.action, c = o.hideAction;
        return l.indexOf("hover") !== -1 || c.indexOf("mouseLeave") !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function() {
        var o = this.props, l = o.action, c = o.showAction;
        return l.indexOf("focus") !== -1 || c.indexOf("focus") !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function() {
        var o = this.props, l = o.action, c = o.hideAction;
        return l.indexOf("focus") !== -1 || c.indexOf("blur") !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function() {
        if (this.state.popupVisible) {
          var o;
          (o = this.popupRef.current) === null || o === void 0 || o.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function(o, l) {
        var c = this.props.children.props[o];
        c && c(l);
        var s = this.props[o];
        s && s(l);
      }
    }, {
      key: "close",
      value: function() {
        this.setPopupVisible(!1);
      }
    }, {
      key: "render",
      value: function() {
        var o = this.state.popupVisible, l = this.props, c = l.children, s = l.forceRender, d = l.alignPoint, M = l.className, f = l.autoDestroy, v = z.Children.only(c), g = {
          key: "trigger"
        };
        this.isContextMenuToShow() ? g.onContextMenu = this.onContextMenu : g.onContextMenu = this.createTwoChains("onContextMenu"), this.isClickToHide() || this.isClickToShow() ? (g.onClick = this.onClick, g.onMouseDown = this.onMouseDown, g.onTouchStart = this.onTouchStart) : (g.onClick = this.createTwoChains("onClick"), g.onMouseDown = this.createTwoChains("onMouseDown"), g.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? (g.onMouseEnter = this.onMouseEnter, d && (g.onMouseMove = this.onMouseMove)) : g.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? g.onMouseLeave = this.onMouseLeave : g.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (g.onFocus = this.onFocus, g.onBlur = this.onBlur) : (g.onFocus = this.createTwoChains("onFocus"), g.onBlur = this.createTwoChains("onBlur"));
        var m = Y(v && v.props && v.props.className, M);
        m && (g.className = m);
        var p = H({}, g);
        So(v) && (p.ref = To(this.triggerRef, v.ref));
        var h = /* @__PURE__ */ z.cloneElement(v, p), y;
        return (o || this.popupRef.current || s) && (y = /* @__PURE__ */ z.createElement(e, {
          key: "portal",
          getContainer: this.getContainer,
          didUpdate: this.handlePortalUpdate
        }, this.getComponent())), !o && f && (y = null), /* @__PURE__ */ z.createElement(bu.Provider, {
          value: this.triggerContextValue
        }, h, y);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(o, l) {
        var c = o.popupVisible, s = {};
        return c !== void 0 && l.popupVisible !== c && (s.popupVisible = c, s.prevPopupVisible = l.popupVisible), s;
      }
    }]), a;
  }(z.Component);
  return t.contextType = bu, t.defaultProps = {
    prefixCls: "rc-trigger-popup",
    getPopupClassNameFromAlign: l_,
    getDocument: c_,
    onPopupVisibleChange: Xi,
    afterPopupVisibleChange: Xi,
    onPopupAlign: Xi,
    popupClassName: "",
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: !1,
    popupAlign: {},
    defaultPopupVisible: !1,
    mask: !1,
    maskClosable: !0,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: !1
  }, t;
}
const d_ = s_(BM);
var zt = {
  adjustX: 1,
  adjustY: 1
}, _t = [0, 0], f_ = {
  left: {
    points: ["cr", "cl"],
    overflow: zt,
    offset: [-4, 0],
    targetOffset: _t
  },
  right: {
    points: ["cl", "cr"],
    overflow: zt,
    offset: [4, 0],
    targetOffset: _t
  },
  top: {
    points: ["bc", "tc"],
    overflow: zt,
    offset: [0, -4],
    targetOffset: _t
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: zt,
    offset: [0, 4],
    targetOffset: _t
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: zt,
    offset: [0, -4],
    targetOffset: _t
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: zt,
    offset: [-4, 0],
    targetOffset: _t
  },
  topRight: {
    points: ["br", "tr"],
    overflow: zt,
    offset: [0, -4],
    targetOffset: _t
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: zt,
    offset: [4, 0],
    targetOffset: _t
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: zt,
    offset: [0, 4],
    targetOffset: _t
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: zt,
    offset: [4, 0],
    targetOffset: _t
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: zt,
    offset: [0, 4],
    targetOffset: _t
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: zt,
    offset: [-4, 0],
    targetOffset: _t
  }
};
function G4(e) {
  var t = e.showArrow, r = e.arrowContent, n = e.children, a = e.prefixCls, i = e.id, o = e.overlayInnerStyle, l = e.className, c = e.style;
  return /* @__PURE__ */ z.createElement("div", {
    className: Y("".concat(a, "-content"), l),
    style: c
  }, t !== !1 && /* @__PURE__ */ z.createElement("div", {
    className: "".concat(a, "-arrow"),
    key: "arrow"
  }, r), /* @__PURE__ */ z.createElement("div", {
    className: "".concat(a, "-inner"),
    id: i,
    role: "tooltip",
    style: o
  }, typeof n == "function" ? n() : n));
}
var v_ = function(t, r) {
  var n = t.overlayClassName, a = t.trigger, i = a === void 0 ? ["hover"] : a, o = t.mouseEnterDelay, l = o === void 0 ? 0 : o, c = t.mouseLeaveDelay, s = c === void 0 ? 0.1 : c, d = t.overlayStyle, M = t.prefixCls, f = M === void 0 ? "rc-tooltip" : M, v = t.children, g = t.onVisibleChange, m = t.afterVisibleChange, p = t.transitionName, h = t.animation, y = t.motion, N = t.placement, I = N === void 0 ? "right" : N, D = t.align, A = D === void 0 ? {} : D, k = t.destroyTooltipOnHide, L = k === void 0 ? !1 : k, T = t.defaultVisible, C = t.getTooltipContainer, j = t.overlayInnerStyle, w = t.arrowContent, E = t.overlay, _ = t.id, b = t.showArrow, O = Wt(t, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"]), S = Le(null);
  A0(r, function() {
    return S.current;
  });
  var R = H({}, O);
  "visible" in t && (R.popupVisible = t.visible);
  var V = function() {
    return /* @__PURE__ */ z.createElement(G4, {
      showArrow: b,
      arrowContent: w,
      key: "content",
      prefixCls: f,
      id: _,
      overlayInnerStyle: j
    }, E);
  }, Q = !1, x = !1;
  if (typeof L == "boolean")
    Q = L;
  else if (L && Ve(L) === "object") {
    var P = L.keepParent;
    Q = P === !0, x = P === !1;
  }
  return /* @__PURE__ */ z.createElement(d_, Pe({
    popupClassName: n,
    prefixCls: f,
    popup: V,
    action: i,
    builtinPlacements: f_,
    popupPlacement: I,
    ref: S,
    popupAlign: A,
    getPopupContainer: C,
    onPopupVisibleChange: g,
    afterPopupVisibleChange: m,
    popupTransitionName: p,
    popupAnimation: h,
    popupMotion: y,
    defaultPopupVisible: T,
    destroyPopupOnHide: Q,
    autoDestroy: x,
    mouseLeaveDelay: s,
    popupStyle: d,
    mouseEnterDelay: l
  }, R), v);
};
const M_ = /* @__PURE__ */ fo(v_), g_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Popup: G4,
  default: M_
}, Symbol.toStringTag, { value: "Module" })), p_ = /* @__PURE__ */ yr(g_);
var cn = {}, ar = {};
Object.defineProperty(ar, "__esModule", {
  value: !0
});
ar.tupleNum = ar.tuple = void 0;
var h_ = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return r;
};
ar.tuple = h_;
var m_ = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  return r;
};
ar.tupleNum = m_;
Object.defineProperty(cn, "__esModule", {
  value: !0
});
cn.PresetStatusColorTypes = cn.PresetColorTypes = void 0;
var K4 = ar, y_ = (0, K4.tuple)("success", "processing", "error", "default", "warning");
cn.PresetStatusColorTypes = y_;
var N_ = (0, K4.tuple)("pink", "red", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "gold", "lime");
cn.PresetColorTypes = N_;
var X4 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.getTransitionName = e.getTransitionDirection = e.default = void 0;
  var t = ar, r = function() {
    return {
      height: 0,
      opacity: 0
    };
  }, n = function(M) {
    var f = M.scrollHeight;
    return {
      height: f,
      opacity: 1
    };
  }, a = function(M) {
    return {
      height: M ? M.offsetHeight : 0
    };
  }, i = function(M, f) {
    return (f == null ? void 0 : f.deadline) === !0 || f.propertyName === "height";
  }, o = {
    motionName: "ant-motion-collapse",
    onAppearStart: r,
    onEnterStart: r,
    onAppearActive: n,
    onEnterActive: n,
    onLeaveStart: a,
    onLeaveActive: r,
    onAppearEnd: i,
    onEnterEnd: i,
    onLeaveEnd: i,
    motionDeadline: 500
  };
  (0, t.tuple)("bottomLeft", "bottomRight", "topLeft", "topRight");
  var l = function(M) {
    return M !== void 0 && (M === "topLeft" || M === "topRight") ? "slide-down" : "slide-up";
  };
  e.getTransitionDirection = l;
  var c = function(M, f, v) {
    return v !== void 0 ? v : "".concat(M, "-").concat(f);
  };
  e.getTransitionName = c;
  var s = o;
  e.default = s;
})(X4);
var J4 = {}, un = {};
Object.defineProperty(un, "__esModule", {
  value: !0
});
un.default = un.placements = void 0;
var It = {
  adjustX: 1,
  adjustY: 1
}, Dt = [0, 0], e5 = {
  left: {
    points: ["cr", "cl"],
    overflow: It,
    offset: [-4, 0],
    targetOffset: Dt
  },
  right: {
    points: ["cl", "cr"],
    overflow: It,
    offset: [4, 0],
    targetOffset: Dt
  },
  top: {
    points: ["bc", "tc"],
    overflow: It,
    offset: [0, -4],
    targetOffset: Dt
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: It,
    offset: [0, 4],
    targetOffset: Dt
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: It,
    offset: [0, -4],
    targetOffset: Dt
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: It,
    offset: [-4, 0],
    targetOffset: Dt
  },
  topRight: {
    points: ["br", "tr"],
    overflow: It,
    offset: [0, -4],
    targetOffset: Dt
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: It,
    offset: [4, 0],
    targetOffset: Dt
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: It,
    offset: [0, 4],
    targetOffset: Dt
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: It,
    offset: [4, 0],
    targetOffset: Dt
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: It,
    offset: [0, 4],
    targetOffset: Dt
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: It,
    offset: [-4, 0],
    targetOffset: Dt
  }
};
un.placements = e5;
var z_ = e5;
un.default = z_;
(function(e) {
  var t = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = c, e.getOverflowOptions = l;
  var r = t(we.exports), n = un, a = {
    adjustX: 1,
    adjustY: 1
  }, i = {
    adjustX: 0,
    adjustY: 0
  }, o = [0, 0];
  function l(s) {
    return typeof s == "boolean" ? s ? a : i : (0, r.default)((0, r.default)({}, i), s);
  }
  function c(s) {
    var d = s.arrowWidth, M = d === void 0 ? 4 : d, f = s.horizontalArrowShift, v = f === void 0 ? 16 : f, g = s.verticalArrowShift, m = g === void 0 ? 8 : g, p = s.autoAdjustOverflow, h = s.arrowPointAtCenter, y = {
      left: {
        points: ["cr", "cl"],
        offset: [-4, 0]
      },
      right: {
        points: ["cl", "cr"],
        offset: [4, 0]
      },
      top: {
        points: ["bc", "tc"],
        offset: [0, -4]
      },
      bottom: {
        points: ["tc", "bc"],
        offset: [0, 4]
      },
      topLeft: {
        points: ["bl", "tc"],
        offset: [-(v + M), -4]
      },
      leftTop: {
        points: ["tr", "cl"],
        offset: [-4, -(m + M)]
      },
      topRight: {
        points: ["br", "tc"],
        offset: [v + M, -4]
      },
      rightTop: {
        points: ["tl", "cr"],
        offset: [4, -(m + M)]
      },
      bottomRight: {
        points: ["tr", "bc"],
        offset: [v + M, 4]
      },
      rightBottom: {
        points: ["bl", "cr"],
        offset: [4, m + M]
      },
      bottomLeft: {
        points: ["tl", "bc"],
        offset: [-(v + M), 4]
      },
      leftBottom: {
        points: ["br", "cl"],
        offset: [-4, m + M]
      }
    };
    return Object.keys(y).forEach(function(N) {
      y[N] = h ? (0, r.default)((0, r.default)({}, y[N]), {
        overflow: l(p),
        targetOffset: o
      }) : (0, r.default)((0, r.default)({}, n.placements[N]), {
        overflow: l(p)
      }), y[N].ignoreShake = !0;
    }), y;
  }
})(J4);
var or = {}, __ = le.exports.default;
Object.defineProperty(or, "__esModule", {
  value: !0
});
or.cloneElement = D_;
or.isFragment = I_;
or.isValidElement = void 0;
or.replaceElement = t5;
var Al = __(u), jl = Al.isValidElement;
or.isValidElement = jl;
function I_(e) {
  return e && jl(e) && e.type === Al.Fragment;
}
function t5(e, t, r) {
  return jl(e) ? /* @__PURE__ */ Al.cloneElement(e, typeof r == "function" ? r(e.props || {}) : r) : t;
}
function D_(e, t) {
  return t5(e, e, t);
}
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(rt.exports), a = r(gt.exports), i = r(we.exports), o = r(Y), l = r(p_), c = r(ca), s = t(u), d = Gt(), M = cn, f = X4, v = r(J4), g = or, m = r(Fr), p = function(A, k) {
    var L = {};
    for (var T in A)
      Object.prototype.hasOwnProperty.call(A, T) && k.indexOf(T) < 0 && (L[T] = A[T]);
    if (A != null && typeof Object.getOwnPropertySymbols == "function")
      for (var C = 0, T = Object.getOwnPropertySymbols(A); C < T.length; C++)
        k.indexOf(T[C]) < 0 && Object.prototype.propertyIsEnumerable.call(A, T[C]) && (L[T[C]] = A[T[C]]);
    return L;
  }, h = function(k, L) {
    var T = {}, C = (0, i.default)({}, k);
    return L.forEach(function(j) {
      k && j in k && (T[j] = k[j], delete C[j]);
    }), {
      picked: T,
      omitted: C
    };
  }, y = new RegExp("^(".concat(M.PresetColorTypes.join("|"), ")(-inverse)?$"));
  function N(A, k) {
    var L = A.type;
    if ((L.__ANT_BUTTON === !0 || A.type === "button") && A.props.disabled || L.__ANT_SWITCH === !0 && (A.props.disabled || A.props.loading) || L.__ANT_RADIO === !0 && A.props.disabled) {
      var T = h(A.props.style, ["position", "left", "right", "top", "bottom", "float", "display", "zIndex"]), C = T.picked, j = T.omitted, w = (0, i.default)((0, i.default)({
        display: "inline-block"
      }, C), {
        cursor: "not-allowed",
        width: A.props.block ? "100%" : void 0
      }), E = (0, i.default)((0, i.default)({}, j), {
        pointerEvents: "none"
      }), _ = (0, g.cloneElement)(A, {
        style: E,
        className: null
      });
      return /* @__PURE__ */ s.createElement("span", {
        style: w,
        className: (0, o.default)(A.props.className, "".concat(k, "-disabled-compatible-wrapper"))
      }, _);
    }
    return A;
  }
  var I = /* @__PURE__ */ s.forwardRef(function(A, k) {
    var L, T = s.useContext(d.ConfigContext), C = T.getPopupContainer, j = T.getPrefixCls, w = T.direction;
    process.env.NODE_ENV !== "production" && [["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"]].forEach(function(at) {
      var be = (0, a.default)(at, 2), ye = be[0], fe = be[1];
      process.env.NODE_ENV !== "production" && (0, m.default)(!(ye in A), "Tooltip", "`".concat(ye, "` is deprecated which will be removed in next major version, please use `").concat(fe, "` instead."));
    });
    var E = (0, c.default)(!1, {
      value: A.open !== void 0 ? A.open : A.visible,
      defaultValue: A.defaultOpen !== void 0 ? A.defaultOpen : A.defaultVisible
    }), _ = (0, a.default)(E, 2), b = _[0], O = _[1], S = function() {
      var be = A.title, ye = A.overlay;
      return !be && !ye && be !== 0;
    }, R = function(be) {
      var ye, fe;
      O(S() ? !1 : be), S() || ((ye = A.onOpenChange) === null || ye === void 0 || ye.call(A, be), (fe = A.onVisibleChange) === null || fe === void 0 || fe.call(A, be));
    }, V = function() {
      var be = A.builtinPlacements, ye = A.arrowPointAtCenter, fe = ye === void 0 ? !1 : ye, Ge = A.autoAdjustOverflow, At = Ge === void 0 ? !0 : Ge;
      return be || (0, v.default)({
        arrowPointAtCenter: fe,
        autoAdjustOverflow: At
      });
    }, Q = function(be, ye) {
      var fe = V(), Ge = Object.keys(fe).find(function(jt) {
        var Qt, pt;
        return fe[jt].points[0] === ((Qt = ye.points) === null || Qt === void 0 ? void 0 : Qt[0]) && fe[jt].points[1] === ((pt = ye.points) === null || pt === void 0 ? void 0 : pt[1]);
      });
      if (!!Ge) {
        var At = be.getBoundingClientRect(), Ke = {
          top: "50%",
          left: "50%"
        };
        /top|Bottom/.test(Ge) ? Ke.top = "".concat(At.height - ye.offset[1], "px") : /Top|bottom/.test(Ge) && (Ke.top = "".concat(-ye.offset[1], "px")), /left|Right/.test(Ge) ? Ke.left = "".concat(At.width - ye.offset[0], "px") : /right|Left/.test(Ge) && (Ke.left = "".concat(-ye.offset[0], "px")), be.style.transformOrigin = "".concat(Ke.left, " ").concat(Ke.top);
      }
    }, x = function() {
      var be = A.title, ye = A.overlay;
      return be === 0 ? be : ye || be || "";
    }, P = A.getPopupContainer, U = A.placement, F = U === void 0 ? "top" : U, $ = A.mouseEnterDelay, W = $ === void 0 ? 0.1 : $, te = A.mouseLeaveDelay, J = te === void 0 ? 0.1 : te, q = p(A, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay"]), B = A.prefixCls, G = A.openClassName, Z = A.getTooltipContainer, K = A.overlayClassName, ee = A.color, ce = A.overlayInnerStyle, ie = A.children, ae = j("tooltip", B), ne = j(), se = b;
    !("open" in A) && !("visible" in A) && S() && (se = !1);
    var Ce = N((0, g.isValidElement)(ie) && !(0, g.isFragment)(ie) ? ie : /* @__PURE__ */ s.createElement("span", null, ie), ae), Oe = Ce.props, Ye = !Oe.className || typeof Oe.className == "string" ? (0, o.default)(Oe.className, (0, n.default)({}, G || "".concat(ae, "-open"), !0)) : Oe.className, st = (0, o.default)(K, (L = {}, (0, n.default)(L, "".concat(ae, "-rtl"), w === "rtl"), (0, n.default)(L, "".concat(ae, "-").concat(ee), ee && y.test(ee)), L)), Ue = ce, nt = {};
    return ee && !y.test(ee) && (Ue = (0, i.default)((0, i.default)({}, ce), {
      background: ee
    }), nt = {
      "--antd-arrow-background-color": ee
    }), /* @__PURE__ */ s.createElement(l.default, (0, i.default)({}, q, {
      placement: F,
      mouseEnterDelay: W,
      mouseLeaveDelay: J,
      prefixCls: ae,
      overlayClassName: st,
      getTooltipContainer: P || Z || C,
      ref: k,
      builtinPlacements: V(),
      overlay: x(),
      visible: se,
      onVisibleChange: R,
      onPopupAlign: Q,
      overlayInnerStyle: Ue,
      arrowContent: /* @__PURE__ */ s.createElement("span", {
        className: "".concat(ae, "-arrow-content"),
        style: nt
      }),
      motion: {
        motionName: (0, f.getTransitionName)(ne, "zoom-big-fast", A.transitionName),
        motionDeadline: 1e3
      }
    }), se ? (0, g.cloneElement)(Ce, {
      className: Ye
    }) : Ce);
  });
  process.env.NODE_ENV !== "production" && (I.displayName = "Tooltip");
  var D = I;
  e.default = D;
})(yl);
var r5 = {}, oo = { exports: {} }, gi = {}, Ba = {}, Au;
function C_() {
  if (Au)
    return Ba;
  Au = 1, Object.defineProperty(Ba, "__esModule", { value: !0 });
  var e = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, name: "enter", theme: "outlined" };
  return Ba.default = e, Ba;
}
var E_ = le.exports, xl = X.exports;
Object.defineProperty(gi, "__esModule", {
  value: !0
});
gi.default = void 0;
var ju = xl(Ze.exports), n5 = E_(u), b_ = xl(C_()), A_ = xl(ut()), a5 = function(t, r) {
  return /* @__PURE__ */ n5.createElement(A_.default, (0, ju.default)((0, ju.default)({}, t), {}, {
    ref: r,
    icon: b_.default
  }));
};
a5.displayName = "EnterOutlined";
var j_ = /* @__PURE__ */ n5.forwardRef(a5);
gi.default = j_;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var r = n(gi);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var a = r;
  t.default = a, e.exports = a;
})(oo, oo.exports);
var i5 = {}, x_ = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`, w_ = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break"], Ji = {}, Ct;
function O_(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = e.getAttribute("id") || e.getAttribute("data-reactid") || e.getAttribute("name");
  if (t && Ji[r])
    return Ji[r];
  var n = window.getComputedStyle(e), a = n.getPropertyValue("box-sizing") || n.getPropertyValue("-moz-box-sizing") || n.getPropertyValue("-webkit-box-sizing"), i = parseFloat(n.getPropertyValue("padding-bottom")) + parseFloat(n.getPropertyValue("padding-top")), o = parseFloat(n.getPropertyValue("border-bottom-width")) + parseFloat(n.getPropertyValue("border-top-width")), l = w_.map(function(s) {
    return "".concat(s, ":").concat(n.getPropertyValue(s));
  }).join(";"), c = {
    sizingStyle: l,
    paddingSize: i,
    borderSize: o,
    boxSizing: a
  };
  return t && r && (Ji[r] = c), c;
}
function T_(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  Ct || (Ct = document.createElement("textarea"), Ct.setAttribute("tab-index", "-1"), Ct.setAttribute("aria-hidden", "true"), document.body.appendChild(Ct)), e.getAttribute("wrap") ? Ct.setAttribute("wrap", e.getAttribute("wrap")) : Ct.removeAttribute("wrap");
  var a = O_(e, t), i = a.paddingSize, o = a.borderSize, l = a.boxSizing, c = a.sizingStyle;
  Ct.setAttribute("style", "".concat(c, ";").concat(x_)), Ct.value = e.value || e.placeholder || "";
  var s = void 0, d = void 0, M, f = Ct.scrollHeight;
  if (l === "border-box" ? f += o : l === "content-box" && (f -= i), r !== null || n !== null) {
    Ct.value = " ";
    var v = Ct.scrollHeight - i;
    r !== null && (s = v * r, l === "border-box" && (s = s + i + o), f = Math.max(s, f)), n !== null && (d = v * n, l === "border-box" && (d = d + i + o), M = f > d ? "" : "hidden", f = Math.min(d, f));
  }
  var g = {
    height: f,
    overflowY: M,
    resize: "none"
  };
  return s && (g.minHeight = s), d && (g.maxHeight = d), g;
}
var S_ = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"], e1 = 0, t1 = 1, r1 = 2, o5 = /* @__PURE__ */ z.forwardRef(function(e, t) {
  var r = e.prefixCls, n = r === void 0 ? "rc-textarea" : r;
  e.onPressEnter;
  var a = e.defaultValue, i = e.value, o = e.autoSize, l = e.onResize, c = e.className, s = e.style, d = e.disabled, M = e.onChange, f = e.onInternalAutoSize, v = Wt(e, S_), g = bs(a, {
    value: i,
    postState: function($) {
      return $ != null ? $ : "";
    }
  }), m = pe(g, 2), p = m[0], h = m[1], y = function($) {
    h($.target.value), M == null || M($);
  }, N = z.useRef();
  z.useImperativeHandle(t, function() {
    return {
      textArea: N.current
    };
  });
  var I = z.useMemo(function() {
    return o && Ve(o) === "object" ? [o.minRows, o.maxRows] : [];
  }, [o]), D = pe(I, 2), A = D[0], k = D[1], L = !!o, T = function() {
    try {
      if (document.activeElement === N.current) {
        var $ = N.current, W = $.selectionStart, te = $.selectionEnd, J = $.scrollTop;
        N.current.setSelectionRange(W, te), N.current.scrollTop = J;
      }
    } catch {
    }
  }, C = z.useState(r1), j = pe(C, 2), w = j[0], E = j[1], _ = z.useState(), b = pe(_, 2), O = b[0], S = b[1], R = function() {
    E(e1), process.env.NODE_ENV === "test" && (f == null || f());
  };
  kr(function() {
    L && R();
  }, [i, A, k, L]), kr(function() {
    if (w === e1)
      E(t1);
    else if (w === t1) {
      var F = T_(N.current, !1, A, k);
      E(r1), S(F);
    } else
      T();
  }, [w]);
  var V = z.useRef(), Q = function() {
    kt.cancel(V.current);
  }, x = function($) {
    w === r1 && (l == null || l($), o && (Q(), V.current = kt(function() {
      R();
    })));
  };
  z.useEffect(function() {
    return Q;
  }, []);
  var P = L ? O : null, U = H(H({}, s), P);
  return (w === e1 || w === t1) && (U.overflowY = "hidden", U.overflowX = "hidden"), /* @__PURE__ */ z.createElement(Xo, {
    onResize: x,
    disabled: !(o || l)
  }, /* @__PURE__ */ z.createElement("textarea", Pe({}, v, {
    ref: N,
    style: U,
    className: Y(n, c, je({}, "".concat(n, "-disabled"), d)),
    disabled: d,
    value: p,
    onChange: y
  })));
}), L_ = /* @__PURE__ */ function(e) {
  Nr(r, e);
  var t = zr(r);
  function r(n) {
    var a;
    Bt(this, r), a = t.call(this, n), a.resizableTextArea = void 0, a.focus = function() {
      a.resizableTextArea.textArea.focus();
    }, a.saveTextArea = function(o) {
      a.resizableTextArea = o;
    }, a.handleChange = function(o) {
      var l = a.props.onChange;
      a.setValue(o.target.value), l && l(o);
    }, a.handleKeyDown = function(o) {
      var l = a.props, c = l.onPressEnter, s = l.onKeyDown;
      o.keyCode === 13 && c && c(o), s && s(o);
    };
    var i = typeof n.value > "u" || n.value === null ? n.defaultValue : n.value;
    return a.state = {
      value: i
    }, a;
  }
  return qt(r, [{
    key: "setValue",
    value: function(a, i) {
      "value" in this.props || this.setState({
        value: a
      }, i);
    }
  }, {
    key: "blur",
    value: function() {
      this.resizableTextArea.textArea.blur();
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ z.createElement(o5, Pe({}, this.props, {
        value: this.state.value,
        onKeyDown: this.handleKeyDown,
        onChange: this.handleChange,
        ref: this.saveTextArea
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(a) {
      return "value" in a ? {
        value: a.value
      } : null;
    }
  }]), r;
}(z.Component);
const k_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ResizableTextArea: o5,
  default: L_
}, Symbol.toStringTag, { value: "Module" })), P_ = /* @__PURE__ */ yr(k_);
var Xe = {}, R_ = le.exports.default, l5 = X.exports.default;
Object.defineProperty(Xe, "__esModule", {
  value: !0
});
Xe.NoStyleItemContext = Xe.NoFormStyle = Xe.FormProvider = Xe.FormItemPrefixContext = Xe.FormItemInputContext = Xe.FormContext = void 0;
var c5 = l5(we.exports), Q_ = T3, V_ = l5(vn), pr = R_(u), U_ = /* @__PURE__ */ pr.createContext({
  labelAlign: "right",
  vertical: !1,
  itemRef: function() {
  }
});
Xe.FormContext = U_;
var F_ = /* @__PURE__ */ pr.createContext(null);
Xe.NoStyleItemContext = F_;
var $_ = function(t) {
  var r = (0, V_.default)(t, ["prefixCls"]);
  return /* @__PURE__ */ pr.createElement(Q_.FormProvider, (0, c5.default)({}, r));
};
Xe.FormProvider = $_;
var Z_ = /* @__PURE__ */ pr.createContext({
  prefixCls: ""
});
Xe.FormItemPrefixContext = Z_;
var lo = /* @__PURE__ */ pr.createContext({});
Xe.FormItemInputContext = lo;
var Y_ = function(t) {
  var r = t.children, n = t.status, a = t.override, i = (0, pr.useContext)(lo), o = (0, pr.useMemo)(function() {
    var l = (0, c5.default)({}, i);
    return a && delete l.isFormItemInput, n && (delete l.status, delete l.hasFeedback, delete l.feedbackIcon), l;
  }, [n, a, i]);
  return /* @__PURE__ */ pr.createElement(lo.Provider, {
    value: o
  }, r);
};
Xe.NoFormStyle = Y_;
var $r = {}, u5 = X.exports.default;
Object.defineProperty($r, "__esModule", {
  value: !0
});
$r.getMergedStatus = void 0;
$r.getStatusClassNames = B_;
var Ln = u5(rt.exports), H_ = u5(Y), W_ = ar;
(0, W_.tuple)("warning", "error", "");
function B_(e, t, r) {
  var n;
  return (0, H_.default)((n = {}, (0, Ln.default)(n, "".concat(e, "-status-success"), t === "success"), (0, Ln.default)(n, "".concat(e, "-status-warning"), t === "warning"), (0, Ln.default)(n, "".concat(e, "-status-error"), t === "error"), (0, Ln.default)(n, "".concat(e, "-status-validating"), t === "validating"), (0, Ln.default)(n, "".concat(e, "-has-feedback"), r), n));
}
var q_ = function(t, r) {
  return r || t;
};
$r.getMergedStatus = q_;
var s5 = {};
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(rt.exports), a = r(ul.exports), i = r(sl.exports), o = r(dl.exports), l = r(fl.exports), c = r(Kn.exports), s = r(Y), d = t(u), M = Xe, f = or, v = $r, g = ar, m = (0, g.tuple)("text", "input");
  function p(N) {
    return !!(N.addonBefore || N.addonAfter);
  }
  var h = /* @__PURE__ */ function(N) {
    (0, o.default)(D, N);
    var I = (0, l.default)(D);
    function D() {
      return (0, a.default)(this, D), I.apply(this, arguments);
    }
    return (0, i.default)(D, [{
      key: "renderClearIcon",
      value: function(k) {
        var L, T = this.props, C = T.value, j = T.disabled, w = T.readOnly, E = T.handleReset, _ = T.suffix, b = !j && !w && C, O = "".concat(k, "-clear-icon");
        return /* @__PURE__ */ d.createElement(c.default, {
          onClick: E,
          onMouseDown: function(R) {
            return R.preventDefault();
          },
          className: (0, s.default)((L = {}, (0, n.default)(L, "".concat(O, "-hidden"), !b), (0, n.default)(L, "".concat(O, "-has-suffix"), !!_), L), O),
          role: "button"
        });
      }
    }, {
      key: "renderTextAreaWithClearIcon",
      value: function(k, L, T) {
        var C, j = this.props, w = j.value, E = j.allowClear, _ = j.className, b = j.style, O = j.direction, S = j.bordered, R = j.hidden, V = j.status, Q = T.status, x = T.hasFeedback;
        if (!E)
          return (0, f.cloneElement)(L, {
            value: w
          });
        var P = (0, s.default)("".concat(k, "-affix-wrapper"), "".concat(k, "-affix-wrapper-textarea-with-clear-btn"), (0, v.getStatusClassNames)("".concat(k, "-affix-wrapper"), (0, v.getMergedStatus)(Q, V), x), (C = {}, (0, n.default)(C, "".concat(k, "-affix-wrapper-rtl"), O === "rtl"), (0, n.default)(C, "".concat(k, "-affix-wrapper-borderless"), !S), (0, n.default)(C, "".concat(_), !p(this.props) && _), C));
        return /* @__PURE__ */ d.createElement("span", {
          className: P,
          style: b,
          hidden: R
        }, (0, f.cloneElement)(L, {
          style: null,
          value: w
        }), this.renderClearIcon(k));
      }
    }, {
      key: "render",
      value: function() {
        var k = this;
        return /* @__PURE__ */ d.createElement(M.FormItemInputContext.Consumer, null, function(L) {
          var T = k.props, C = T.prefixCls, j = T.inputType, w = T.element;
          if (j === m[0])
            return k.renderTextAreaWithClearIcon(C, w, L);
        });
      }
    }]), D;
  }(d.Component), y = h;
  e.default = y;
})(s5);
var d5 = {};
const G_ = /* @__PURE__ */ yr(s6);
var f5 = {};
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.useCompactItemContext = e.default = e.SpaceCompactItemContext = e.NoCompactStyle = void 0;
  var n = r(we.exports), a = r(rt.exports), i = r(Y), o = r(va), l = t(u), c = Gt(), s = function(p, h) {
    var y = {};
    for (var N in p)
      Object.prototype.hasOwnProperty.call(p, N) && h.indexOf(N) < 0 && (y[N] = p[N]);
    if (p != null && typeof Object.getOwnPropertySymbols == "function")
      for (var I = 0, N = Object.getOwnPropertySymbols(p); I < N.length; I++)
        h.indexOf(N[I]) < 0 && Object.prototype.propertyIsEnumerable.call(p, N[I]) && (y[N[I]] = p[N[I]]);
    return y;
  }, d = /* @__PURE__ */ l.createContext(null);
  e.SpaceCompactItemContext = d;
  var M = function(h, y) {
    var N = l.useContext(d), I = l.useMemo(function() {
      var D;
      if (!N)
        return "";
      var A = N.compactDirection, k = N.isFirstItem, L = N.isLastItem, T = A === "vertical" ? "-vertical-" : "-";
      return (0, i.default)((D = {}, (0, a.default)(D, "".concat(h, "-compact").concat(T, "item"), !0), (0, a.default)(D, "".concat(h, "-compact").concat(T, "first-item"), k), (0, a.default)(D, "".concat(h, "-compact").concat(T, "last-item"), L), (0, a.default)(D, "".concat(h, "-compact").concat(T, "item-rtl"), y === "rtl"), D));
    }, [h, y, N]);
    return {
      compactSize: N == null ? void 0 : N.compactSize,
      compactDirection: N == null ? void 0 : N.compactDirection,
      compactItemClassnames: I
    };
  };
  e.useCompactItemContext = M;
  var f = function(h) {
    var y = h.children;
    return /* @__PURE__ */ l.createElement(d.Provider, {
      value: null
    }, y);
  };
  e.NoCompactStyle = f;
  var v = function(h) {
    var y = h.children, N = s(h, ["children"]);
    return /* @__PURE__ */ l.createElement(d.Provider, {
      value: N
    }, y);
  }, g = function(h) {
    var y, N = l.useContext(c.ConfigContext), I = N.getPrefixCls, D = N.direction, A = h.size, k = A === void 0 ? "middle" : A, L = h.direction, T = h.block, C = h.prefixCls, j = h.className, w = h.children, E = s(h, ["size", "direction", "block", "prefixCls", "className", "children"]), _ = I("space-compact", C), b = (0, i.default)(_, (y = {}, (0, a.default)(y, "".concat(_, "-rtl"), D === "rtl"), (0, a.default)(y, "".concat(_, "-block"), T), (0, a.default)(y, "".concat(_, "-vertical"), L === "vertical"), y), j), O = l.useContext(d), S = (0, o.default)(w), R = l.useMemo(function() {
      return S.map(function(V, Q) {
        var x = V && V.key || "".concat(_, "-item-").concat(Q);
        return /* @__PURE__ */ l.createElement(v, {
          key: x,
          compactSize: k,
          compactDirection: L,
          isFirstItem: Q === 0 && (!O || (O == null ? void 0 : O.isFirstItem)),
          isLastItem: Q === S.length - 1 && (!O || (O == null ? void 0 : O.isLastItem))
        }, V);
      });
    }, [k, S, O]);
    return S.length === 0 ? null : /* @__PURE__ */ l.createElement("div", (0, n.default)({
      className: b
    }, E), R);
  }, m = g;
  e.default = m;
})(f5);
var v5 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = r;
  var t = u;
  function r(n, a) {
    var i = (0, t.useRef)([]), o = function() {
      i.current.push(setTimeout(function() {
        var c, s, d, M;
        ((c = n.current) === null || c === void 0 ? void 0 : c.input) && ((s = n.current) === null || s === void 0 ? void 0 : s.input.getAttribute("type")) === "password" && ((d = n.current) === null || d === void 0 ? void 0 : d.input.hasAttribute("value")) && ((M = n.current) === null || M === void 0 || M.input.removeAttribute("value"));
      }));
    };
    return (0, t.useEffect)(function() {
      return a && o(), function() {
        return i.current.forEach(function(l) {
          l && clearTimeout(l);
        });
      };
    }, []), o;
  }
})(v5);
var wl = {};
Object.defineProperty(wl, "__esModule", {
  value: !0
});
wl.hasPrefixSuffix = K_;
function K_(e) {
  return !!(e.prefix || e.suffix || e.allowClear);
}
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0, e.fixControlledValue = D, e.resolveOnChange = A, e.triggerFocus = k;
  var n = r(rt.exports), a = r(we.exports), i = r(ct.exports), o = r(Kn.exports), l = r(Y), c = r(G_), s = _r, d = t(u), M = Gt(), f = r(oi), v = r(li), g = Xe, m = f5, p = $r, h = r(Fr), y = r(v5), N = wl, I = function(C, j) {
    var w = {};
    for (var E in C)
      Object.prototype.hasOwnProperty.call(C, E) && j.indexOf(E) < 0 && (w[E] = C[E]);
    if (C != null && typeof Object.getOwnPropertySymbols == "function")
      for (var _ = 0, E = Object.getOwnPropertySymbols(C); _ < E.length; _++)
        j.indexOf(E[_]) < 0 && Object.prototype.propertyIsEnumerable.call(C, E[_]) && (w[E[_]] = C[E[_]]);
    return w;
  };
  function D(C) {
    return typeof C > "u" || C === null ? "" : String(C);
  }
  function A(C, j, w, E) {
    if (!!w) {
      var _ = j;
      if (j.type === "click") {
        var b = C.cloneNode(!0);
        _ = Object.create(j, {
          target: {
            value: b
          },
          currentTarget: {
            value: b
          }
        }), b.value = "", w(_);
        return;
      }
      if (E !== void 0) {
        _ = Object.create(j, {
          target: {
            value: C
          },
          currentTarget: {
            value: C
          }
        }), C.value = E, w(_);
        return;
      }
      w(_);
    }
  }
  function k(C, j) {
    if (!!C) {
      C.focus(j);
      var w = j || {}, E = w.cursor;
      if (E) {
        var _ = C.value.length;
        switch (E) {
          case "start":
            C.setSelectionRange(0, 0);
            break;
          case "end":
            C.setSelectionRange(_, _);
            break;
          default:
            C.setSelectionRange(0, _);
            break;
        }
      }
    }
  }
  var L = /* @__PURE__ */ (0, d.forwardRef)(function(C, j) {
    var w, E, _, b = C.prefixCls, O = C.bordered, S = O === void 0 ? !0 : O, R = C.status, V = C.size, Q = C.disabled, x = C.onBlur, P = C.onFocus, U = C.suffix, F = C.allowClear, $ = C.addonAfter, W = C.addonBefore, te = C.className, J = C.onChange, q = I(C, ["prefixCls", "bordered", "status", "size", "disabled", "onBlur", "onFocus", "suffix", "allowClear", "addonAfter", "addonBefore", "className", "onChange"]), B = d.default.useContext(M.ConfigContext), G = B.getPrefixCls, Z = B.direction, K = B.input, ee = G("input", b), ce = (0, d.useRef)(null), ie = (0, m.useCompactItemContext)(ee, Z), ae = ie.compactSize, ne = ie.compactItemClassnames, se = d.default.useContext(v.default), Ce = ae || V || se, Oe = d.default.useContext(f.default), Ye = Q != null ? Q : Oe, st = (0, d.useContext)(g.FormItemInputContext), Ue = st.status, nt = st.hasFeedback, at = st.feedbackIcon, be = (0, p.getMergedStatus)(Ue, R), ye = (0, N.hasPrefixSuffix)(C) || !!nt, fe = (0, d.useRef)(ye);
    (0, d.useEffect)(function() {
      var ht;
      ye && !fe.current && process.env.NODE_ENV !== "production" && (0, h.default)(document.activeElement === ((ht = ce.current) === null || ht === void 0 ? void 0 : ht.input), "Input", "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ"), fe.current = ye;
    }, [ye]);
    var Ge = (0, y.default)(ce, !0), At = function(Vt) {
      Ge(), x == null || x(Vt);
    }, Ke = function(Vt) {
      Ge(), P == null || P(Vt);
    }, jt = function(Vt) {
      Ge(), J == null || J(Vt);
    }, Qt = (nt || U) && /* @__PURE__ */ d.default.createElement(d.default.Fragment, null, U, nt && at), pt;
    return (0, i.default)(F) === "object" && (F == null ? void 0 : F.clearIcon) ? pt = F : F && (pt = {
      clearIcon: /* @__PURE__ */ d.default.createElement(o.default, null)
    }), /* @__PURE__ */ d.default.createElement(c.default, (0, a.default)({
      ref: (0, s.composeRef)(j, ce),
      prefixCls: ee,
      autoComplete: K == null ? void 0 : K.autoComplete
    }, q, {
      disabled: Ye || void 0,
      onBlur: At,
      onFocus: Ke,
      suffix: Qt,
      allowClear: pt,
      className: (0, l.default)(te, ne),
      onChange: jt,
      addonAfter: $ && /* @__PURE__ */ d.default.createElement(m.NoCompactStyle, null, /* @__PURE__ */ d.default.createElement(g.NoFormStyle, {
        override: !0,
        status: !0
      }, $)),
      addonBefore: W && /* @__PURE__ */ d.default.createElement(m.NoCompactStyle, null, /* @__PURE__ */ d.default.createElement(g.NoFormStyle, {
        override: !0,
        status: !0
      }, W)),
      inputClassName: (0, l.default)((w = {}, (0, n.default)(w, "".concat(ee, "-sm"), Ce === "small"), (0, n.default)(w, "".concat(ee, "-lg"), Ce === "large"), (0, n.default)(w, "".concat(ee, "-rtl"), Z === "rtl"), (0, n.default)(w, "".concat(ee, "-borderless"), !S), w), !ye && (0, p.getStatusClassNames)(ee, be)),
      affixWrapperClassName: (0, l.default)((E = {}, (0, n.default)(E, "".concat(ee, "-affix-wrapper-sm"), Ce === "small"), (0, n.default)(E, "".concat(ee, "-affix-wrapper-lg"), Ce === "large"), (0, n.default)(E, "".concat(ee, "-affix-wrapper-rtl"), Z === "rtl"), (0, n.default)(E, "".concat(ee, "-affix-wrapper-borderless"), !S), E), (0, p.getStatusClassNames)("".concat(ee, "-affix-wrapper"), be, nt)),
      wrapperClassName: (0, l.default)((0, n.default)({}, "".concat(ee, "-group-rtl"), Z === "rtl")),
      groupClassName: (0, l.default)((_ = {}, (0, n.default)(_, "".concat(ee, "-group-wrapper-sm"), Ce === "small"), (0, n.default)(_, "".concat(ee, "-group-wrapper-lg"), Ce === "large"), (0, n.default)(_, "".concat(ee, "-group-wrapper-rtl"), Z === "rtl"), _), (0, p.getStatusClassNames)("".concat(ee, "-group-wrapper"), be, nt))
    }));
  }), T = L;
  e.default = T;
})(d5);
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(ct.exports), a = r(rt.exports), i = r(we.exports), o = r(gt.exports), l = r(cl.exports), c = r(Y), s = r(P_), d = r(ca), M = r(vn), f = t(u), v = Gt(), g = r(oi), m = r(li), p = Xe, h = $r, y = r(s5), N = d5, I = function(T, C) {
    var j = {};
    for (var w in T)
      Object.prototype.hasOwnProperty.call(T, w) && C.indexOf(w) < 0 && (j[w] = T[w]);
    if (T != null && typeof Object.getOwnPropertySymbols == "function")
      for (var E = 0, w = Object.getOwnPropertySymbols(T); E < w.length; E++)
        C.indexOf(w[E]) < 0 && Object.prototype.propertyIsEnumerable.call(T, w[E]) && (j[w[E]] = T[w[E]]);
    return j;
  };
  function D(T, C) {
    return (0, l.default)(T || "").slice(0, C).join("");
  }
  function A(T, C, j, w) {
    var E = j;
    return T ? E = D(j, w) : (0, l.default)(C || "").length < j.length && (0, l.default)(j || "").length > w && (E = C), E;
  }
  var k = /* @__PURE__ */ f.forwardRef(function(T, C) {
    var j, w = T.prefixCls, E = T.bordered, _ = E === void 0 ? !0 : E, b = T.showCount, O = b === void 0 ? !1 : b, S = T.maxLength, R = T.className, V = T.style, Q = T.size, x = T.disabled, P = T.onCompositionStart, U = T.onCompositionEnd, F = T.onChange, $ = T.status, W = I(T, ["prefixCls", "bordered", "showCount", "maxLength", "className", "style", "size", "disabled", "onCompositionStart", "onCompositionEnd", "onChange", "status"]), te = f.useContext(v.ConfigContext), J = te.getPrefixCls, q = te.direction, B = f.useContext(m.default), G = f.useContext(g.default), Z = x != null ? x : G, K = f.useContext(p.FormItemInputContext), ee = K.status, ce = K.hasFeedback, ie = K.isFormItemInput, ae = K.feedbackIcon, ne = (0, h.getMergedStatus)(ee, $), se = f.useRef(null), Ce = f.useRef(null), Oe = f.useState(!1), Ye = (0, o.default)(Oe, 2), st = Ye[0], Ue = Ye[1], nt = f.useRef(), at = f.useRef(0), be = (0, d.default)(W.defaultValue, {
      value: W.value
    }), ye = (0, o.default)(be, 2), fe = ye[0], Ge = ye[1], At = W.hidden, Ke = function(Te, Ae) {
      W.value === void 0 && (Ge(Te), Ae == null || Ae());
    }, jt = Number(S) > 0, Qt = function(Te) {
      Ue(!0), nt.current = fe, at.current = Te.currentTarget.selectionStart, P == null || P(Te);
    }, pt = function(Te) {
      var Ae;
      Ue(!1);
      var He = Te.currentTarget.value;
      if (jt) {
        var mt = at.current >= S + 1 || at.current === ((Ae = nt.current) === null || Ae === void 0 ? void 0 : Ae.length);
        He = A(mt, nt.current, He, S);
      }
      He !== fe && (Ke(He), (0, N.resolveOnChange)(Te.currentTarget, Te, F, He)), U == null || U(Te);
    }, ht = function(Te) {
      var Ae = Te.target.value;
      if (!st && jt) {
        var He = Te.target.selectionStart >= S + 1 || Te.target.selectionStart === Ae.length || !Te.target.selectionStart;
        Ae = A(He, fe, Ae, S);
      }
      Ke(Ae), (0, N.resolveOnChange)(Te.currentTarget, Te, F, Ae);
    }, Vt = function(Te) {
      var Ae, He, mt;
      Ke(""), (Ae = se.current) === null || Ae === void 0 || Ae.focus(), (0, N.resolveOnChange)((mt = (He = se.current) === null || He === void 0 ? void 0 : He.resizableTextArea) === null || mt === void 0 ? void 0 : mt.textArea, Te, F);
    }, it = J("input", w);
    f.useImperativeHandle(C, function() {
      var xt;
      return {
        resizableTextArea: (xt = se.current) === null || xt === void 0 ? void 0 : xt.resizableTextArea,
        focus: function(Ae) {
          var He, mt;
          (0, N.triggerFocus)((mt = (He = se.current) === null || He === void 0 ? void 0 : He.resizableTextArea) === null || mt === void 0 ? void 0 : mt.textArea, Ae);
        },
        blur: function() {
          var Ae;
          return (Ae = se.current) === null || Ae === void 0 ? void 0 : Ae.blur();
        }
      };
    });
    var zi = /* @__PURE__ */ f.createElement(s.default, (0, i.default)({}, (0, M.default)(W, ["allowClear"]), {
      disabled: Z,
      className: (0, c.default)((j = {}, (0, a.default)(j, "".concat(it, "-borderless"), !_), (0, a.default)(j, R, R && !O), (0, a.default)(j, "".concat(it, "-sm"), B === "small" || Q === "small"), (0, a.default)(j, "".concat(it, "-lg"), B === "large" || Q === "large"), j), (0, h.getStatusClassNames)(it, ne)),
      style: O ? {
        resize: V == null ? void 0 : V.resize
      } : V,
      prefixCls: it,
      onCompositionStart: Qt,
      onChange: ht,
      onCompositionEnd: pt,
      ref: se
    })), Ir = (0, N.fixControlledValue)(fe);
    !st && jt && (W.value === null || W.value === void 0) && (Ir = D(Ir, S));
    var Cn = /* @__PURE__ */ f.createElement(y.default, (0, i.default)({
      disabled: Z
    }, W, {
      prefixCls: it,
      direction: q,
      inputType: "text",
      value: Ir,
      element: zi,
      handleReset: Vt,
      ref: Ce,
      bordered: _,
      status: $,
      style: O ? void 0 : V
    }));
    if (O || ce) {
      var Kt, Ut = (0, l.default)(Ir).length, En = "";
      return (0, n.default)(O) === "object" ? En = O.formatter({
        value: Ir,
        count: Ut,
        maxLength: S
      }) : En = "".concat(Ut).concat(jt ? " / ".concat(S) : ""), /* @__PURE__ */ f.createElement("div", {
        hidden: At,
        className: (0, c.default)("".concat(it, "-textarea"), (Kt = {}, (0, a.default)(Kt, "".concat(it, "-textarea-rtl"), q === "rtl"), (0, a.default)(Kt, "".concat(it, "-textarea-show-count"), O), (0, a.default)(Kt, "".concat(it, "-textarea-in-form-item"), ie), Kt), (0, h.getStatusClassNames)("".concat(it, "-textarea"), ne, ce), R),
        style: V,
        "data-count": En
      }, Cn, ce && /* @__PURE__ */ f.createElement("span", {
        className: "".concat(it, "-textarea-suffix")
      }, ae));
    }
    return Cn;
  }), L = k;
  e.default = L;
})(i5);
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(rt.exports), a = r(gt.exports), i = r(oo.exports), o = r(Y), l = r(Ma), c = t(u), s = r(i5), d = or, M = function(g) {
    var m = g.prefixCls, p = g["aria-label"], h = g.className, y = g.style, N = g.direction, I = g.maxLength, D = g.autoSize, A = D === void 0 ? !0 : D, k = g.value, L = g.onSave, T = g.onCancel, C = g.onEnd, j = g.component, w = g.enterIcon, E = w === void 0 ? /* @__PURE__ */ c.createElement(i.default, null) : w, _ = c.useRef(null), b = c.useRef(!1), O = c.useRef(), S = c.useState(k), R = (0, a.default)(S, 2), V = R[0], Q = R[1];
    c.useEffect(function() {
      Q(k);
    }, [k]), c.useEffect(function() {
      if (_.current && _.current.resizableTextArea) {
        var B = _.current.resizableTextArea.textArea;
        B.focus();
        var G = B.value.length;
        B.setSelectionRange(G, G);
      }
    }, []);
    var x = function(G) {
      var Z = G.target;
      Q(Z.value.replace(/[\n\r]/g, ""));
    }, P = function() {
      b.current = !0;
    }, U = function() {
      b.current = !1;
    }, F = function(G) {
      var Z = G.keyCode;
      b.current || (O.current = Z);
    }, $ = function() {
      L(V.trim());
    }, W = function(G) {
      var Z = G.keyCode, K = G.ctrlKey, ee = G.altKey, ce = G.metaKey, ie = G.shiftKey;
      O.current === Z && !b.current && !K && !ee && !ce && !ie && (Z === l.default.ENTER ? ($(), C == null || C()) : Z === l.default.ESC && T());
    }, te = function() {
      $();
    }, J = j ? "".concat(m, "-").concat(j) : "", q = (0, o.default)(m, "".concat(m, "-edit-content"), (0, n.default)({}, "".concat(m, "-rtl"), N === "rtl"), h, J);
    return /* @__PURE__ */ c.createElement("div", {
      className: q,
      style: y
    }, /* @__PURE__ */ c.createElement(s.default, {
      ref: _,
      maxLength: I,
      value: V,
      onChange: x,
      onKeyDown: F,
      onKeyUp: W,
      onCompositionStart: P,
      onCompositionEnd: U,
      onBlur: te,
      "aria-label": p,
      rows: 1,
      autoSize: A
    }), E !== null ? (0, d.cloneElement)(E, {
      className: "".concat(m, "-edit-content-confirm")
    }) : null);
  }, f = M;
  e.default = f;
})(r5);
var M5 = {};
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var n = r(ct.exports), a = r(we.exports), i = t(u);
  function o(l, c) {
    return i.useMemo(function() {
      var s = !!l;
      return [s, (0, a.default)((0, a.default)({}, c), s && (0, n.default)(l) === "object" ? l : null)];
    }, [l]);
  }
})(M5);
var g5 = {};
(function(e) {
  var t = le.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = t(u), n = function(o, l) {
    var c = r.useRef(!1);
    r.useEffect(function() {
      c.current ? o() : c.current = !0;
    }, l);
  }, a = n;
  e.default = a;
})(g5);
var p5 = {};
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(we.exports), a = r(rt.exports), i = r(Y), o = _r, l = t(u), c = Gt(), s = r(Fr), d = function(v, g) {
    var m = {};
    for (var p in v)
      Object.prototype.hasOwnProperty.call(v, p) && g.indexOf(p) < 0 && (m[p] = v[p]);
    if (v != null && typeof Object.getOwnPropertySymbols == "function")
      for (var h = 0, p = Object.getOwnPropertySymbols(v); h < p.length; h++)
        g.indexOf(p[h]) < 0 && Object.prototype.propertyIsEnumerable.call(v, p[h]) && (m[p[h]] = v[p[h]]);
    return m;
  }, M = /* @__PURE__ */ l.forwardRef(function(v, g) {
    var m = v.prefixCls, p = v.component, h = p === void 0 ? "article" : p, y = v.className, N = v.setContentRef, I = v.children, D = v.direction, A = d(v, ["prefixCls", "component", "className", "setContentRef", "children", "direction"]), k = l.useContext(c.ConfigContext), L = k.getPrefixCls, T = k.direction, C = D != null ? D : T, j = g;
    N && (process.env.NODE_ENV !== "production" && (0, s.default)(!1, "Typography", "`setContentRef` is deprecated. Please use `ref` instead."), j = (0, o.composeRef)(g, N));
    var w = L("typography", m), E = (0, i.default)(w, (0, a.default)({}, "".concat(w, "-rtl"), C === "rtl"), y);
    return /* @__PURE__ */ l.createElement(h, (0, n.default)({
      className: E,
      ref: j
    }, A), I);
  });
  process.env.NODE_ENV !== "production" && (M.displayName = "Typography");
  var f = M;
  e.default = f;
})(p5);
var h5 = {};
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(we.exports), a = r(gt.exports), i = r(ct.exports), o = r(va), l = r(hr), c = t(u);
  function s(N) {
    var I = (0, i.default)(N);
    return I === "string" || I === "number";
  }
  function d(N) {
    var I = 0;
    return N.forEach(function(D) {
      s(D) ? I += String(D).length : I += 1;
    }), I;
  }
  function M(N, I) {
    for (var D = 0, A = [], k = 0; k < N.length; k += 1) {
      if (D === I)
        return A;
      var L = N[k], T = s(L), C = T ? String(L).length : 1, j = D + C;
      if (j > I) {
        var w = I - D;
        return A.push(String(L).slice(0, w)), A;
      }
      A.push(L), D = j;
    }
    return N;
  }
  var f = 0, v = 1, g = 2, m = 3, p = 4, h = function(I) {
    var D = I.enabledMeasure, A = I.children, k = I.text, L = I.width, T = I.fontSize, C = I.rows, j = I.onEllipsis, w = c.useState([0, 0, 0]), E = (0, a.default)(w, 2), _ = (0, a.default)(E[0], 3), b = _[0], O = _[1], S = _[2], R = E[1], V = c.useState(f), Q = (0, a.default)(V, 2), x = Q[0], P = Q[1], U = c.useState(0), F = (0, a.default)(U, 2), $ = F[0], W = F[1], te = c.useRef(null), J = c.useRef(null), q = c.useMemo(function() {
      return (0, o.default)(k);
    }, [k]), B = c.useMemo(function() {
      return d(q);
    }, [q]), G = c.useMemo(function() {
      return !D || x !== m ? A(q, !1) : A(M(q, O), O < B);
    }, [D, x, A, q, O, B]);
    (0, l.default)(function() {
      D && L && T && B && (P(v), R([0, Math.ceil(B / 2), B]));
    }, [D, L, T, k, B, C]), (0, l.default)(function() {
      var ce;
      x === v && W(((ce = te.current) === null || ce === void 0 ? void 0 : ce.offsetHeight) || 0);
    }, [x]), (0, l.default)(function() {
      var ce, ie;
      if ($) {
        if (x === v) {
          var ae = ((ce = J.current) === null || ce === void 0 ? void 0 : ce.offsetHeight) || 0, ne = C * $;
          ae <= ne ? (P(p), j(!1)) : P(g);
        } else if (x === g)
          if (b !== S) {
            var se = ((ie = J.current) === null || ie === void 0 ? void 0 : ie.offsetHeight) || 0, Ce = C * $, Oe = b, Ye = S;
            b === S - 1 ? Ye = b : se <= Ce ? Oe = O : Ye = O;
            var st = Math.ceil((Oe + Ye) / 2);
            R([Oe, st, Ye]);
          } else
            P(m), j(!0);
      }
    }, [x, b, S, C, $]);
    var Z = {
      width: L,
      whiteSpace: "normal",
      margin: 0,
      padding: 0
    }, K = function(ie, ae, ne) {
      return /* @__PURE__ */ c.createElement("span", {
        "aria-hidden": !0,
        ref: ae,
        style: (0, n.default)({
          position: "fixed",
          display: "block",
          left: 0,
          top: 0,
          zIndex: -9999,
          visibility: "hidden",
          pointerEvents: "none",
          fontSize: Math.floor(T / 2) * 2
        }, ne)
      }, ie);
    }, ee = function(ie, ae) {
      var ne = M(q, ie);
      return K(A(ne, !0), ae, Z);
    };
    return /* @__PURE__ */ c.createElement(c.Fragment, null, G, D && x !== m && x !== p && /* @__PURE__ */ c.createElement(c.Fragment, null, K("lg", te, {
      wordBreak: "keep-all",
      whiteSpace: "nowrap"
    }), x === v ? K(A(q, !1), J, Z) : ee(O, J)));
  };
  process.env.NODE_ENV !== "production" && (h.displayName = "Ellipsis");
  var y = h;
  e.default = y;
})(h5);
var m5 = {};
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(we.exports), a = t(u), i = r(yl), o = function(s) {
    var d = s.enabledEllipsis, M = s.isEllipsis, f = s.children, v = s.tooltipProps;
    return !(v != null && v.title) || !d ? f : /* @__PURE__ */ a.createElement(i.default, (0, n.default)({
      open: M ? void 0 : !1
    }, v), f);
  };
  process.env.NODE_ENV !== "production" && (o.displayName = "EllipsisTooltip");
  var l = o;
  e.default = l;
})(m5);
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(rt.exports), a = r(we.exports), i = r(ct.exports), o = r(gt.exports), l = r(S1.exports), c = r(k1.exports), s = r(P1.exports), d = r(Y), M = r(R9), f = r(u7), v = r(va), g = r(hr), m = r(ca), p = r(vn), h = _r, y = t(u), N = Gt(), I = rl, D = r(z4), A = _4, k = r(yl), L = r(r5), T = r(M5), C = r(g5), j = r(p5), w = r(h5), E = r(m5), _ = function(x, P) {
    var U = {};
    for (var F in x)
      Object.prototype.hasOwnProperty.call(x, F) && P.indexOf(F) < 0 && (U[F] = x[F]);
    if (x != null && typeof Object.getOwnPropertySymbols == "function")
      for (var $ = 0, F = Object.getOwnPropertySymbols(x); $ < F.length; $++)
        P.indexOf(F[$]) < 0 && Object.prototype.propertyIsEnumerable.call(x, F[$]) && (U[F[$]] = x[F[$]]);
    return U;
  };
  function b(x, P) {
    var U = x.mark, F = x.code, $ = x.underline, W = x.delete, te = x.strong, J = x.keyboard, q = x.italic, B = P;
    function G(Z, K) {
      !Z || (B = /* @__PURE__ */ y.createElement(K, {}, B));
    }
    return G(te, "strong"), G($, "u"), G(W, "del"), G(F, "code"), G(U, "mark"), G(J, "kbd"), G(q, "i"), B;
  }
  function O(x, P, U) {
    return x === !0 || x === void 0 ? P : x || U && P;
  }
  function S(x) {
    return x === !1 ? [!1, !1] : Array.isArray(x) ? x : [x];
  }
  var R = "...", V = /* @__PURE__ */ y.forwardRef(function(x, P) {
    var U, F, $, W = x.prefixCls, te = x.className, J = x.style, q = x.type, B = x.disabled, G = x.children, Z = x.ellipsis, K = x.editable, ee = x.copyable, ce = x.component, ie = x.title, ae = _(x, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]), ne = y.useContext(N.ConfigContext), se = ne.getPrefixCls, Ce = ne.direction, Oe = (0, I.useLocaleReceiver)("Text")[0], Ye = y.useRef(null), st = y.useRef(null), Ue = se("typography", W), nt = (0, p.default)(ae, ["mark", "code", "delete", "underline", "strong", "keyboard", "italic"]), at = (0, T.default)(K), be = (0, o.default)(at, 2), ye = be[0], fe = be[1], Ge = (0, m.default)(!1, {
      value: fe.editing
    }), At = (0, o.default)(Ge, 2), Ke = At[0], jt = At[1], Qt = fe.triggerType, pt = Qt === void 0 ? ["icon"] : Qt, ht = function(re) {
      var me;
      re && ((me = fe.onStart) === null || me === void 0 || me.call(fe)), jt(re);
    };
    (0, C.default)(function() {
      var he;
      Ke || (he = st.current) === null || he === void 0 || he.focus();
    }, [Ke]);
    var Vt = function(re) {
      re == null || re.preventDefault(), ht(!0);
    }, it = function(re) {
      var me;
      (me = fe.onChange) === null || me === void 0 || me.call(fe, re), ht(!1);
    }, zi = function() {
      var re;
      (re = fe.onCancel) === null || re === void 0 || re.call(fe), ht(!1);
    }, Ir = (0, T.default)(ee), Cn = (0, o.default)(Ir, 2), Kt = Cn[0], Ut = Cn[1], En = y.useState(!1), xt = (0, o.default)(En, 2), Te = xt[0], Ae = xt[1], He = y.useRef(), mt = {};
    Ut.format && (mt.format = Ut.format);
    var kl = function() {
      window.clearTimeout(He.current);
    }, Q5 = function(re) {
      var me;
      re == null || re.preventDefault(), re == null || re.stopPropagation(), (0, M.default)(Ut.text || String(G) || "", mt), Ae(!0), kl(), He.current = window.setTimeout(function() {
        Ae(!1);
      }, 3e3), (me = Ut.onCopy) === null || me === void 0 || me.call(Ut, re);
    };
    y.useEffect(function() {
      return kl;
    }, []);
    var V5 = y.useState(!1), Pl = (0, o.default)(V5, 2), Rl = Pl[0], U5 = Pl[1], F5 = y.useState(!1), Ql = (0, o.default)(F5, 2), Vl = Ql[0], $5 = Ql[1], Z5 = y.useState(!1), Ul = (0, o.default)(Z5, 2), Y5 = Ul[0], H5 = Ul[1], W5 = y.useState(!1), Fl = (0, o.default)(W5, 2), $l = Fl[0], B5 = Fl[1], q5 = y.useState(!1), Zl = (0, o.default)(q5, 2), Yl = Zl[0], G5 = Zl[1], K5 = y.useState(!0), Hl = (0, o.default)(K5, 2), X5 = Hl[0], J5 = Hl[1], ed = (0, T.default)(Z, {
      expandable: !1
    }), Wl = (0, o.default)(ed, 2), cr = Wl[0], We = Wl[1], wt = cr && !Y5, Bl = We.rows, Zr = Bl === void 0 ? 1 : Bl, ma = y.useMemo(function() {
      return !wt || We.suffix !== void 0 || We.onEllipsis || We.expandable || ye || Kt;
    }, [wt, We, ye, Kt]);
    (0, g.default)(function() {
      cr && !ma && (U5((0, A.isStyleSupport)("webkitLineClamp")), $5((0, A.isStyleSupport)("textOverflow")));
    }, [ma, cr]);
    var Ot = y.useMemo(function() {
      return ma ? !1 : Zr === 1 ? Vl : Rl;
    }, [ma, Vl, Rl]), ql = wt && (Ot ? Yl : $l), td = wt && Zr === 1 && Ot, ya = wt && Zr > 1 && Ot, rd = function(re) {
      var me;
      H5(!0), (me = We.onExpand) === null || me === void 0 || me.call(We, re);
    }, nd = y.useState(0), Gl = (0, o.default)(nd, 2), ad = Gl[0], id = Gl[1], od = y.useState(0), Kl = (0, o.default)(od, 2), ld = Kl[0], cd = Kl[1], ud = function(re, me) {
      var Je = re.offsetWidth, yt;
      id(Je), cd(parseInt((yt = window.getComputedStyle) === null || yt === void 0 ? void 0 : yt.call(window, me).fontSize, 10) || 0);
    }, sd = function(re) {
      var me;
      B5(re), $l !== re && ((me = We.onEllipsis) === null || me === void 0 || me.call(We, re));
    };
    y.useEffect(function() {
      var he = Ye.current;
      if (cr && Ot && he) {
        var re = ya ? he.offsetHeight < he.scrollHeight : he.offsetWidth < he.scrollWidth;
        Yl !== re && G5(re);
      }
    }, [cr, Ot, G, ya, X5]), y.useEffect(function() {
      var he = Ye.current;
      if (!(typeof IntersectionObserver > "u" || !he || !Ot || !wt)) {
        var re = new IntersectionObserver(function() {
          J5(!!he.offsetParent);
        });
        return re.observe(he), function() {
          re.disconnect();
        };
      }
    }, [Ot, wt]);
    var ur = {};
    We.tooltip === !0 ? ur = {
      title: (U = fe.text) !== null && U !== void 0 ? U : G
    } : /* @__PURE__ */ y.isValidElement(We.tooltip) ? ur = {
      title: We.tooltip
    } : (0, i.default)(We.tooltip) === "object" ? ur = (0, a.default)({
      title: (F = fe.text) !== null && F !== void 0 ? F : G
    }, We.tooltip) : ur = {
      title: We.tooltip
    };
    var Na = y.useMemo(function() {
      var he = function(me) {
        return ["string", "number"].includes((0, i.default)(me));
      };
      if (!(!cr || Ot)) {
        if (he(fe.text))
          return fe.text;
        if (he(G))
          return G;
        if (he(ie))
          return ie;
        if (he(ur.title))
          return ur.title;
      }
    }, [cr, Ot, ie, ur.title, ql]);
    if (Ke)
      return /* @__PURE__ */ y.createElement(L.default, {
        value: ($ = fe.text) !== null && $ !== void 0 ? $ : typeof G == "string" ? G : "",
        onSave: it,
        onCancel: zi,
        onEnd: fe.onEnd,
        prefixCls: Ue,
        className: te,
        style: J,
        direction: Ce,
        component: ce,
        maxLength: fe.maxLength,
        autoSize: fe.autoSize,
        enterIcon: fe.enterIcon
      });
    var dd = function() {
      var re = We.expandable, me = We.symbol;
      if (!re)
        return null;
      var Je;
      return me ? Je = me : Je = Oe.expand, /* @__PURE__ */ y.createElement("a", {
        key: "expand",
        className: "".concat(Ue, "-expand"),
        onClick: rd,
        "aria-label": Oe.expand
      }, Je);
    }, fd = function() {
      if (!!ye) {
        var re = fe.icon, me = fe.tooltip, Je = (0, v.default)(me)[0] || Oe.edit, yt = typeof Je == "string" ? Je : "";
        return pt.includes("icon") ? /* @__PURE__ */ y.createElement(k.default, {
          key: "edit",
          title: me === !1 ? "" : Je
        }, /* @__PURE__ */ y.createElement(D.default, {
          ref: st,
          className: "".concat(Ue, "-edit"),
          onClick: Vt,
          "aria-label": yt
        }, re || /* @__PURE__ */ y.createElement(s.default, {
          role: "button"
        }))) : null;
      }
    }, vd = function() {
      if (!!Kt) {
        var re = Ut.tooltips, me = Ut.icon, Je = S(re), yt = S(me), bn = Te ? O(Je[1], Oe.copied) : O(Je[0], Oe.copy), pd = Te ? Oe.copied : Oe.copy, hd = typeof bn == "string" ? bn : pd;
        return /* @__PURE__ */ y.createElement(k.default, {
          key: "copy",
          title: bn
        }, /* @__PURE__ */ y.createElement(D.default, {
          className: (0, d.default)("".concat(Ue, "-copy"), Te && "".concat(Ue, "-copy-success")),
          onClick: Q5,
          "aria-label": hd
        }, Te ? O(yt[1], /* @__PURE__ */ y.createElement(l.default, null), !0) : O(yt[0], /* @__PURE__ */ y.createElement(c.default, null), !0)));
      }
    }, Md = function(re) {
      return [re && dd(), fd(), vd()];
    }, gd = function(re) {
      return [re && /* @__PURE__ */ y.createElement("span", {
        "aria-hidden": !0,
        key: "ellipsis"
      }, R), We.suffix, Md(re)];
    };
    return /* @__PURE__ */ y.createElement(f.default, {
      onResize: ud,
      disabled: !wt || Ot
    }, function(he) {
      var re;
      return /* @__PURE__ */ y.createElement(E.default, {
        tooltipProps: ur,
        enabledEllipsis: wt,
        isEllipsis: ql
      }, /* @__PURE__ */ y.createElement(j.default, (0, a.default)({
        className: (0, d.default)((re = {}, (0, n.default)(re, "".concat(Ue, "-").concat(q), q), (0, n.default)(re, "".concat(Ue, "-disabled"), B), (0, n.default)(re, "".concat(Ue, "-ellipsis"), cr), (0, n.default)(re, "".concat(Ue, "-single-line"), wt && Zr === 1), (0, n.default)(re, "".concat(Ue, "-ellipsis-single-line"), td), (0, n.default)(re, "".concat(Ue, "-ellipsis-multiple-line"), ya), re), te),
        prefixCls: W,
        style: (0, a.default)((0, a.default)({}, J), {
          WebkitLineClamp: ya ? Zr : void 0
        }),
        component: ce,
        ref: (0, h.composeRef)(he, Ye, P),
        direction: Ce,
        onClick: pt.includes("text") ? Vt : void 0,
        "aria-label": Na == null ? void 0 : Na.toString(),
        title: ie
      }, nt), /* @__PURE__ */ y.createElement(w.default, {
        enabledMeasure: wt && !Ot,
        text: G,
        rows: Zr,
        width: ad,
        fontSize: ld,
        onEllipsis: sd
      }, function(me, Je) {
        var yt = me;
        me.length && Je && Na && (yt = /* @__PURE__ */ y.createElement("span", {
          key: "show-content",
          "aria-hidden": !0
        }, yt));
        var bn = b(x, /* @__PURE__ */ y.createElement(y.Fragment, null, yt, gd(Je)));
        return bn;
      })));
    });
  }), Q = V;
  e.default = Q;
})(c3);
(function(e) {
  var t = le.exports.default, r = X.exports.default;
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = r(we.exports), a = r(ct.exports), i = r(vn), o = t(u), l = r(Fr), c = r(c3), s = function(f, v) {
    var g = {};
    for (var m in f)
      Object.prototype.hasOwnProperty.call(f, m) && v.indexOf(m) < 0 && (g[m] = f[m]);
    if (f != null && typeof Object.getOwnPropertySymbols == "function")
      for (var p = 0, m = Object.getOwnPropertySymbols(f); p < m.length; p++)
        v.indexOf(m[p]) < 0 && Object.prototype.propertyIsEnumerable.call(f, m[p]) && (g[m[p]] = f[m[p]]);
    return g;
  }, d = function(v, g) {
    var m = v.ellipsis, p = s(v, ["ellipsis"]), h = o.useMemo(function() {
      return m && (0, a.default)(m) === "object" ? (0, i.default)(m, ["expandable", "rows"]) : m;
    }, [m]);
    return process.env.NODE_ENV !== "production" && (0, l.default)((0, a.default)(m) !== "object" || !m || !("expandable" in m) && !("rows" in m), "Typography.Text", "`ellipsis` do not support `expandable` or `rows` props."), /* @__PURE__ */ o.createElement(c.default, (0, n.default)({
      ref: g
    }, p, {
      ellipsis: h,
      component: "span"
    }));
  }, M = /* @__PURE__ */ o.forwardRef(d);
  e.default = M;
})(a3);
const X_ = /* @__PURE__ */ of(a3), J_ = "_collapse_t6a2v_5", eI = "_container_t6a2v_19", tI = "_icon_t6a2v_29", rI = "_content_t6a2v_37", nI = "_close_t6a2v_41", kn = {
  collapse: J_,
  container: eI,
  icon: tI,
  content: rI,
  close: nI
}, AA = ({
  children: e,
  bodyPaddingBottom: t,
  className: r,
  style: n
}) => {
  const [i, o] = de(1);
  return /* @__PURE__ */ u.createElement(Xl, {
    defaultActiveKey: 1,
    activeKey: i,
    ghost: !0,
    style: n,
    className: Y(kn.collapse, r)
  }, /* @__PURE__ */ u.createElement(Xl.Panel, {
    header: null,
    key: 1
  }, /* @__PURE__ */ u.createElement("div", {
    style: { paddingBottom: t }
  }, /* @__PURE__ */ u.createElement("div", {
    className: kn.container
  }, /* @__PURE__ */ u.createElement("div", {
    className: kn.icon
  }, /* @__PURE__ */ u.createElement(Td, null)), /* @__PURE__ */ u.createElement(X_, {
    className: kn.content
  }, e), /* @__PURE__ */ u.createElement("div", {
    className: kn.close,
    onClick: () => o(0),
    tabIndex: 0,
    role: "button",
    onKeyDown: Gv(() => o(0))
  }, /* @__PURE__ */ u.createElement(Sd, null))))));
}, { Link: aI } = ra, jA = u.forwardRef(({ noMargin: e, className: t, type: r, ...n }, a) => /* @__PURE__ */ u.createElement(aI, {
  ...n,
  target: "_blank",
  type: r,
  ref: a
})), iI = "_item_1a5zg_5", oI = {
  item: iI
}, y5 = ({ className: e, ...t }) => /* @__PURE__ */ u.createElement(mr.Item, {
  ...t,
  className: Y(oI.item, e)
}), N5 = ({ ...e }) => {
  const { openCount: t, submittedCount: r } = xe(r3);
  return /* @__PURE__ */ u.createElement(y5, {
    ...e,
    validateStatus: t > 0 ? "error" : r > 0 ? "warning" : void 0
  });
}, lI = "_formItem_14wnp_5", cI = {
  formItem: lI
}, uI = ({ label: e, discussions: t, className: r, ...n }) => {
  var o, l;
  const a = t3(t), i = t != null && t.hideDisscussion ? null : a;
  return /* @__PURE__ */ u.createElement(n3, {
    openCount: ((o = t == null ? void 0 : t.open) == null ? void 0 : o.count) || 0,
    submittedCount: ((l = t == null ? void 0 : t.submitted) == null ? void 0 : l.count) || 0
  }, /* @__PURE__ */ u.createElement(N5, {
    ...n,
    className: Y(cI.formItem, r),
    label: /* @__PURE__ */ u.createElement(u.Fragment, null, e, " ", i)
  }));
}, sI = u.forwardRef(
  ({ ...e }, t) => /* @__PURE__ */ u.createElement(mr, {
    ...e,
    ref: t
  })
), Ne = sI;
Ne.Item = y5;
Ne.DiscussedItem = N5;
Ne.ThreadItem = uI;
Ne.List = mr.List;
Ne.ErrorList = mr.ErrorList;
Ne.useForm = mr.useForm;
Ne.useFormInstance = mr.useFormInstance;
Ne.useWatch = mr.useWatch;
Ne.Provider = mr.Provider;
const dI = "_hint_rj9cy_5", fI = {
  hint: dI
}, xA = ({ text: e, children: t }) => /* @__PURE__ */ u.createElement(x0, {
  title: e
}, /* @__PURE__ */ u.createElement("span", {
  className: fI.hint
}, t)), vI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279V49.72a.278.278 0 0 1-.28.279H.28a.278.278 0 0 1-.28-.279V.28C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "m15.818 8.68-.939-2.561V8.68h-.605V4.465h.573l.933 2.554V4.465h.605V8.68zM17.037 4.861c.097-.134.219-.239.366-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .535.598 1.3 1.3 0 0 1 .05.371v2.146c0 .126-.012.237-.037.333a.947.947 0 0 1-.151.321.94.94 0 0 1-.334.302.928.928 0 0 1-.48.126 1.1 1.1 0 0 1-.29-.038 1.301 1.301 0 0 1-.472-.27.778.778 0 0 1-.138-.183 1.21 1.21 0 0 1-.114-.314 1.792 1.792 0 0 1-.019-.277V5.49c0-.126.013-.237.038-.333.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.327-.177.42.42 0 0 0-.215.063.373.373 0 0 0-.145.132.532.532 0 0 0-.05.151.79.79 0 0 0-.013.126V7.706c0 .02.002.043.007.068a.58.58 0 0 0 .1.208c.063.088.168.132.316.132a.4.4 0 0 0 .201-.05.349.349 0 0 0 .133-.126.459.459 0 0 0 .056-.139.861.861 0 0 0 .013-.163V5.49a.833.833 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM14.274 14.494v-4.216h1.002c.126 0 .246.027.36.082.113.05.214.117.302.201a.94.94 0 0 1 .208.29.762.762 0 0 1 .088.327v.673a.941.941 0 0 1-.082.39.959.959 0 0 1-.523.516.951.951 0 0 1-.378.076h-.372v1.66h-.605Zm1.28-2.353a.235.235 0 0 0 .069-.12.556.556 0 0 0 .019-.157v-.623a.404.404 0 0 0-.108-.29.37.37 0 0 0-.29-.12h-.365v1.43h.315a.864.864 0 0 0 .202-.02.386.386 0 0 0 .157-.1ZM16.944 10.675c.097-.135.219-.24.366-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .535.598 1.3 1.3 0 0 1 .05.37v2.146c0 .126-.012.237-.037.334a.948.948 0 0 1-.151.32.94.94 0 0 1-.334.303.928.928 0 0 1-.48.126 1.1 1.1 0 0 1-.29-.038 1.305 1.305 0 0 1-.257-.113 1.176 1.176 0 0 1-.215-.158.778.778 0 0 1-.138-.182 1.21 1.21 0 0 1-.114-.315 1.792 1.792 0 0 1-.019-.277v-2.145c0-.126.013-.237.038-.334.03-.1.078-.199.145-.295Zm1.172.333a.376.376 0 0 0-.327-.176.42.42 0 0 0-.215.063.373.373 0 0 0-.145.132.532.532 0 0 0-.05.151.79.79 0 0 0-.013.126v2.215c0 .02.002.044.007.069a.581.581 0 0 0 .1.207c.063.089.168.133.316.133a.4.4 0 0 0 .201-.05.349.349 0 0 0 .133-.127.459.459 0 0 0 .056-.138.86.86 0 0 0 .013-.164v-2.145a.832.832 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM19.976 14.494l-.864-4.216h.63l.492 2.926.498-2.926h.643l-.883 4.216zM23.55 13.89v.604h-1.809v-4.216h1.809v.554h-1.21v1.246h1.059v.572H22.34v1.24zM23.836 14.494v-4.216h1.058a.94.94 0 0 1 .7.29c.193.193.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.932h-.643l-.567-1.806h-.378v1.806h-.605Zm1.342-2.473a.366.366 0 0 0 .076-.157.707.707 0 0 0 .025-.195v-.39a.453.453 0 0 0-.107-.315.376.376 0 0 0-.303-.126h-.428v1.315h.422a.418.418 0 0 0 .315-.132ZM26.746 14.494v-3.656h-.712v-.56h2.036v.56h-.725v3.656zM28.955 14.494v-1.812l-.819-2.404h.63l.492 1.649.497-1.649h.637l-.838 2.404v1.812zM7.166 14.302V5.72L5.719 6.804V5.268l1.447-1.054h1.433v10.088z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M10.798 23.9a1.387 1.387 0 0 1-1.39 1.388 1.391 1.391 0 0 1-1.39-1.389 1.386 1.386 0 0 1 1.39-1.388 1.392 1.392 0 0 1 1.39 1.388ZM22.574 24.668a1.387 1.387 0 0 1-1.39 1.388 1.392 1.392 0 0 1-1.391-1.388 1.387 1.387 0 0 1 1.39-1.388 1.392 1.392 0 0 1 1.39 1.388ZM30.371 24.668a1.387 1.387 0 0 1-1.39 1.388 1.392 1.392 0 0 1-1.39-1.388 1.387 1.387 0 0 1 1.39-1.388 1.392 1.392 0 0 1 1.39 1.388ZM41.293 23.932a1.388 1.388 0 0 1-1.39 1.388 1.392 1.392 0 0 1-1.391-1.388 1.386 1.386 0 0 1 1.39-1.389 1.392 1.392 0 0 1 1.39 1.389ZM16.104 30.883a1.11 1.11 0 0 1-1.113 1.11 1.113 1.113 0 0 1-1.027-1.535 1.11 1.11 0 0 1 1.453-.6 1.112 1.112 0 0 1 .687 1.025ZM35.798 30.883a1.106 1.106 0 0 1-.687 1.026 1.114 1.114 0 0 1-1.538-1.026 1.11 1.11 0 0 1 1.113-1.11 1.114 1.114 0 0 1 1.112 1.11ZM39.624 32.41v5.681c0 .972-1.433.977-1.433 0V28.14c0-.36-.492-.39-.492 0v3.353c0 .793-1.048.826-1.048 0v-4.08c0-.834.633-1.558 1.561-1.558h3.38c.929 0 1.562.724 1.562 1.559v4.079c0 .826-1.048.793-1.048 0v-3.353c0-.39-.492-.36-.492 0v9.952c0 .977-1.434.972-1.434 0v-5.68c0-.315-.556-.326-.556 0ZM7.672 25.854c-.929 0-1.561.724-1.561 1.559v4.079c0 .28.12.46.28.546l-1.264 6.31c-.074.37.421.45.487.091l1.163-6.365c.206-.063.381-.258.381-.582v-3.353c0-.39.492-.36.492 0v9.952c0 .976 1.434.972 1.434 0v-5.68c0-.326.556-.315.556 0v5.68c0 .972 1.433.976 1.433 0V28.14c0-.36.492-.39.492 0v3.353c0 .793 1.048.826 1.048 0v-4.08c0-.834-.633-1.558-1.561-1.558h-3.38ZM20.937 34.108v4.022c0 .996-1.392.98-1.392 0v-4.022H18.21l1.512-5.358c.068-.243-.33-.422-.43-.104l-.92 2.93c-.217.694-1.149.448-.904-.355l1.157-3.789c.132-.432.574-.77 1.052-.77h2.951c.479 0 .921.338 1.053.77l1.156 3.79c.245.802-.687 1.048-.904.355l-.92-2.931c-.099-.318-.497-.139-.43.104l1.513 5.358h-1.334v4.022c0 .98-1.392.996-1.392 0v-4.022h-.434ZM28.778 34.108v4.022c0 .996-1.392.98-1.392 0v-4.022h-1.334l1.512-5.358c.068-.243-.33-.422-.43-.104l-.92 2.93c-.216.694-1.148.448-.903-.355l1.156-3.789c.132-.432.574-.77 1.052-.77h2.952c.478 0 .92.338 1.052.77l1.157 3.79c.245.802-.687 1.048-.905.355l-.919-2.931c-.1-.318-.498-.139-.43.104l1.512 5.358h-1.334v4.022c0 .98-1.392.996-1.392 0v-4.022h-.434ZM34.953 36.55v1.673c0 .71.979.799.979 0v-3.99c0-.21.227-.217.304-.014l.512 1.35c.175.46.712.264.52-.207l-1.017-2.49a.632.632 0 0 0-.594-.392h-1.902a.632.632 0 0 0-.593.392l-1.017 2.49c-.192.47.345.667.52.207l.512-1.35c.077-.203.304-.197.304.015v3.989c0 .799.978.71.978 0V36.55c0-.297.494-.318.494 0Z",
  fill: "currentColor"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M14.79 36.652v1.708c0 .614-.895.718-.895 0v-1.88h-.62l.54-1.957c.093-.337.022-.681-.144-.973l-.935-1.643c-.28-.493.402-.767.619-.42l.684 1.09c.102.161.227.145.382.145h1.277c.155 0 .28.016.381-.145l.685-1.09c.217-.347.899-.073.619.42l-.935 1.643c-.166.292-.238.636-.145.973l.54 1.958h-.619v1.88c0 .717-.895.613-.895 0v-1.71c0-.385-.54-.375-.54 0Z",
  fill: "currentColor"
}))), MI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0H49.72c.155 0 .279.124.279.279V49.72a.278.278 0 0 1-.279.279H.28A.278.278 0 0 1 0 49.721V.28C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M14.44 8.68v-.541l1.135-3.114h-1.053v-.56h1.727v.484l-1.128 3.127h1.128v.604zM18.566 8.076v.604h-1.809V4.465h1.809v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM18.875 8.68V4.465h1.06a.94.94 0 0 1 .699.29c.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.931h-.643l-.567-1.805h-.378V8.68h-.606Zm1.343-2.472a.366.366 0 0 0 .075-.158.708.708 0 0 0 .026-.195v-.39a.454.454 0 0 0-.107-.314.376.376 0 0 0-.303-.126h-.428V6.34h.422a.417.417 0 0 0 .315-.132ZM21.463 4.861c.097-.134.219-.239.366-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.598c.033.113.05.237.05.371v2.146c0 .126-.013.237-.038.333a.947.947 0 0 1-.151.321.94.94 0 0 1-.334.302.928.928 0 0 1-.479.126 1.1 1.1 0 0 1-.29-.038 1.303 1.303 0 0 1-.258-.113 1.177 1.177 0 0 1-.215-.157.778.778 0 0 1-.138-.183c-.063-.13-.101-.235-.114-.314a1.792 1.792 0 0 1-.019-.277V5.49c0-.126.013-.237.038-.333.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.327-.177.42.42 0 0 0-.215.063.374.374 0 0 0-.145.132.534.534 0 0 0-.05.151.793.793 0 0 0-.013.126V7.706c0 .02.003.043.007.068a.581.581 0 0 0 .1.208c.064.088.169.132.316.132a.4.4 0 0 0 .201-.05.35.35 0 0 0 .133-.126.457.457 0 0 0 .056-.139.86.86 0 0 0 .013-.163V5.49a.832.832 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM14.566 14.494v-4.216h.599v1.8h.769v-1.8h.598v4.216h-.598v-1.882h-.769v1.882zM19.016 14.053a1.09 1.09 0 0 1-.36.346.894.894 0 0 1-.479.133.962.962 0 0 1-.264-.038 1.497 1.497 0 0 1-.24-.095 1.22 1.22 0 0 1-.201-.138.604.604 0 0 1-.133-.17 1.324 1.324 0 0 1-.126-.308 1.51 1.51 0 0 1-.025-.283v-3.222h.605v3.303l.013.063a.516.516 0 0 0 .094.177c.055.075.15.113.284.113.122 0 .212-.044.27-.132a.525.525 0 0 0 .095-.302v-3.222h.605V13.5c0 .1-.01.197-.031.29a.896.896 0 0 1-.107.263ZM21.079 14.494l-.939-2.561v2.561h-.605v-4.216h.573l.933 2.555v-2.555h.605v4.216zM23.978 14.053a1.01 1.01 0 0 1-.87.478c-.16 0-.315-.037-.466-.113a1.01 1.01 0 0 1-.347-.276 1.051 1.051 0 0 1-.164-.34 1.773 1.773 0 0 1-.038-.384V11.31c0-.105.011-.21.032-.314.03-.105.107-.254.233-.447.13-.206.387-.309.769-.309.168 0 .326.04.473.12a.89.89 0 0 1 .334.296c.08.113.13.222.151.327.025.1.038.21.038.327v.176h-.599v-.176a.54.54 0 0 0-.006-.088.389.389 0 0 0-.007-.075.492.492 0 0 0-.094-.183c-.059-.084-.158-.126-.296-.126-.164 0-.273.044-.328.132a.763.763 0 0 0-.088.195.742.742 0 0 0-.013.145V13.525c0 .03.002.054.006.075a.67.67 0 0 0 .095.195c.055.089.162.133.321.133.164 0 .27-.044.316-.133.025-.046.044-.083.056-.113a.483.483 0 0 0 .026-.088.237.237 0 0 0 .012-.075v-.837h-.485v-.529h1.084v1.265c0 .088-.002.164-.006.226a.714.714 0 0 1-.076.29 1.112 1.112 0 0 1-.063.12ZM26.388 13.89v.604H24.58v-4.216h1.808v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM26.65 14.494v-4.216h1.059a.94.94 0 0 1 .7.29c.193.193.29.43.29.71v.39a.99.99 0 0 1-.498.894l.642 1.932h-.642l-.568-1.806h-.378v1.806h-.605Zm1.343-2.473a.366.366 0 0 0 .075-.157.707.707 0 0 0 .025-.195v-.39a.454.454 0 0 0-.107-.315.376.376 0 0 0-.302-.126h-.429v1.315h.422a.417.417 0 0 0 .316-.132ZM9.63 14.302H5.334v-1.325l2.684-5.21c.12-.24.181-.486.181-.737v-.753c0-.2-.07-.371-.211-.512a.676.676 0 0 0-.513-.226.744.744 0 0 0-.498.196.631.631 0 0 0-.21.482v.888H5.301v-.723c0-.391.146-.868.438-1.43.301-.552.905-.828 1.81-.828.573 0 1.06.216 1.462.647.413.442.619.944.619 1.506v.919c0 .411-.111.823-.332 1.234l-2.262 4.442H9.63v1.43Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M28.207 43.552c.397 0 .467-.43.448-.71-.024-.339.303-.392.474-.446a13.347 13.347 0 0 0 5.556-3.47c1.535-1.618 2.747-3.297 3.186-6.1.053-.339-.139-.604-.474-.604H11.285c-.335 0-.527.265-.473.605.438 2.802 1.65 4.48 3.186 6.098a13.348 13.348 0 0 0 5.555 3.47c.171.055.498.108.474.447-.02.28.051.71.448.71h7.732Zm-8.903-12.475h1.731s.794-2.214-1.098-4.108c-.606-.606-.99-1.514-.99-2.37 0-1.628.732-2.57.949-2.918.557-.896-.772-1.526-1.343-.841-.883 1.058-1.396 2.513-1.396 3.89 0 1.553.755 2.341 1.527 3.26 1.434 1.707.62 3.087.62 3.087Zm10.426 0h1.732s.794-2.214-1.099-4.108c-.605-.606-.989-1.514-.989-2.37 0-1.628.732-2.57.948-2.918.558-.896-.77-1.526-1.342-.841-.884 1.058-1.396 2.513-1.396 3.89 0 1.553.755 2.341 1.527 3.26 1.434 1.707.62 3.087.62 3.087Zm-5.187 0h1.732s.793-2.214-1.099-4.108c-.605-.606-.989-1.514-.989-2.37 0-1.628.732-2.57.948-2.918.558-.896-.77-1.526-1.343-.841-.883 1.058-1.395 2.513-1.395 3.89 0 1.553.755 2.341 1.527 3.26 1.434 1.707.62 3.087.62 3.087Z",
  fill: "currentColor"
}))), gI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279V49.72a.278.278 0 0 1-.28.279H.28a.278.278 0 0 1-.28-.279V.28C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M16.656 8.24a1.01 1.01 0 0 1-.87.478c-.16 0-.315-.038-.466-.113a1.01 1.01 0 0 1-.347-.277 1.051 1.051 0 0 1-.163-.34 1.775 1.775 0 0 1-.038-.384V5.497c0-.105.01-.21.031-.315.03-.105.107-.254.234-.447.13-.205.386-.308.768-.308.168 0 .326.04.473.12a.89.89 0 0 1 .334.295c.08.113.13.223.151.327.026.101.038.21.038.328v.176h-.599v-.176a.54.54 0 0 0-.006-.089.389.389 0 0 0-.006-.075.492.492 0 0 0-.095-.182c-.059-.084-.157-.126-.296-.126-.164 0-.273.044-.328.132a.764.764 0 0 0-.088.195.742.742 0 0 0-.012.145V7.71c0 .03.002.055.006.076a.67.67 0 0 0 .094.195c.055.088.162.132.322.132.164 0 .269-.044.315-.132.025-.046.044-.084.057-.113a.48.48 0 0 0 .025-.088.237.237 0 0 0 .012-.076v-.837h-.485V6.34h1.084v1.264c0 .088-.002.164-.006.227a.714.714 0 0 1-.076.29 1.114 1.114 0 0 1-.063.119ZM17.468 4.861c.096-.134.218-.239.365-.315a1.013 1.013 0 0 1 .901-.025.976.976 0 0 1 .536.598c.034.113.05.237.05.371v2.146c0 .126-.012.237-.037.333a.947.947 0 0 1-.152.321.94.94 0 0 1-.334.302.928.928 0 0 1-.479.126 1.1 1.1 0 0 1-.29-.038 1.302 1.302 0 0 1-.472-.27.776.776 0 0 1-.139-.183c-.063-.13-.1-.235-.113-.314a1.788 1.788 0 0 1-.02-.277V5.49c0-.126.013-.237.039-.333.03-.1.077-.2.145-.296Zm1.172.334a.376.376 0 0 0-.328-.177.42.42 0 0 0-.214.063.374.374 0 0 0-.145.132.534.534 0 0 0-.05.151.79.79 0 0 0-.013.126V7.706c0 .02.002.043.006.068a.581.581 0 0 0 .101.208c.063.088.168.132.315.132a.4.4 0 0 0 .202-.05.349.349 0 0 0 .132-.126.459.459 0 0 0 .057-.139.861.861 0 0 0 .013-.163V5.49a.833.833 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM20.017 4.861c.097-.134.218-.239.366-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .535.598 1.3 1.3 0 0 1 .05.371v2.146c0 .126-.012.237-.037.333a.947.947 0 0 1-.151.321.94.94 0 0 1-.334.302.928.928 0 0 1-.48.126 1.1 1.1 0 0 1-.29-.038 1.301 1.301 0 0 1-.472-.27.777.777 0 0 1-.138-.183c-.063-.13-.101-.235-.114-.314a1.788 1.788 0 0 1-.019-.277V5.49c0-.126.013-.237.038-.333.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.327-.177.42.42 0 0 0-.215.063.373.373 0 0 0-.145.132.534.534 0 0 0-.05.151.79.79 0 0 0-.013.126V7.706c0 .02.002.043.007.068a.581.581 0 0 0 .1.208c.063.088.168.132.316.132a.4.4 0 0 0 .201-.05.35.35 0 0 0 .133-.126.459.459 0 0 0 .056-.139.861.861 0 0 0 .013-.163V5.49a.833.833 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM23.386 4.465c.273 0 .506.096.7.29a.92.92 0 0 1 .295.691v2.19c0 .31-.094.562-.283.755a.979.979 0 0 1-.731.29h-.94V4.464h.959Zm.397 3.17V5.447a.383.383 0 0 0-.133-.295.432.432 0 0 0-.308-.12h-.316v3.09h.297c.306 0 .46-.162.46-.485ZM25.536 8.68V4.465h.598v1.799h.769V4.465h.599V8.68h-.599V6.799h-.769V8.68zM29.871 8.076v.604h-1.808V4.465h1.808v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM29.961 8.68l.945-4.215h.523l.946 4.215h-.65l-.17-.906h-.781l-.176.906h-.637Zm.92-1.466h.567l-.283-1.535-.284 1.535ZM34.491 8.68h-1.802V4.465h.605v3.611h1.197zM34.765 8.68V5.025h-.712v-.56h2.035v.56h-.724V8.68zM36.412 8.68V4.465h.599v1.799h.769V4.465h.599V8.68h-.599V6.799h-.769V8.68zM14.494 14.494l.946-4.216h.523l.945 4.216h-.65l-.17-.906h-.78l-.177.906h-.637Zm.92-1.466h.568l-.284-1.535-.284 1.535ZM18.76 14.494l-.939-2.561v2.561h-.605v-4.216h.573l.933 2.555v-2.555h.605v4.216zM20.943 10.278c.273 0 .506.097.7.29a.92.92 0 0 1 .296.692v2.19c0 .31-.095.561-.284.754a.979.979 0 0 1-.73.29h-.94v-4.216h.958Zm.397 3.171v-2.19a.383.383 0 0 0-.132-.295.432.432 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.162.46-.485ZM25.054 14.494l-.498-2.567-.485 2.567h-.561l-.611-4.216h.642l.303 2.548.485-2.548h.448l.498 2.548.302-2.548h.637l-.593 4.216zM28.335 13.89v.604h-1.809v-4.216h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM30.364 14.494h-1.802v-4.216h.605v3.612h1.197zM32.342 14.494H30.54v-4.216h.605v3.612h1.197zM34.32 10.278c.13 0 .252.027.365.082.127.059.255.153.385.283.139.134.208.344.208.63v.32c0 .323-.128.55-.385.68.257.15.385.386.385.704v.491a.996.996 0 0 1-.29.736.978.978 0 0 1-.731.29h-.933v-4.216h.996Zm.36 1.252v-.258a.398.398 0 0 0-.416-.428h-.341v1.164h.36c.138 0 .239-.041.302-.125a.595.595 0 0 0 .094-.353Zm0 1.938v-.49a.425.425 0 0 0-.114-.315.385.385 0 0 0-.303-.12h-.34v1.353h.346a.39.39 0 0 0 .297-.12.444.444 0 0 0 .113-.308ZM37.538 13.89v.604h-1.809v-4.216h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM37.806 14.494v-4.216h.598v4.216zM40.462 14.494l-.939-2.561v2.561h-.605v-4.216h.573l.933 2.555v-2.555h.605v4.216zM43.242 14.053a1.009 1.009 0 0 1-.87.478c-.16 0-.315-.037-.467-.113a1.012 1.012 0 0 1-.346-.276 1.054 1.054 0 0 1-.164-.34 1.787 1.787 0 0 1-.038-.384V11.31c0-.105.01-.21.032-.314.03-.105.107-.254.233-.447.13-.206.386-.309.769-.309.168 0 .325.04.473.12.146.08.258.178.334.296.08.113.13.222.15.327.026.1.039.21.039.327v.176h-.599v-.176a.558.558 0 0 0-.006-.088.375.375 0 0 0-.007-.075.485.485 0 0 0-.094-.183c-.06-.084-.158-.126-.296-.126-.164 0-.274.044-.328.132a.766.766 0 0 0-.088.195.74.74 0 0 0-.013.145V13.525c0 .03.002.054.006.075a.678.678 0 0 0 .095.195c.054.089.161.133.321.133.164 0 .27-.044.315-.133.025-.046.044-.083.057-.113a.477.477 0 0 0 .025-.088.236.236 0 0 0 .013-.075v-.837h-.486v-.529h1.085v1.265c0 .088-.002.164-.007.226a.713.713 0 0 1-.076.29 1.165 1.165 0 0 1-.062.12ZM9.895 11.983v.181c0 .07-.005.15-.015.24 0 .081-.015.202-.045.362-.141.482-.407.873-.8 1.175-.382.3-.829.451-1.342.451-.402 0-.784-.12-1.146-.361-.362-.251-.593-.497-.693-.738-.06-.13-.111-.246-.151-.346-.03-.1-.056-.196-.076-.286a2.431 2.431 0 0 1-.045-.286v-.979H7.03v.828c.02.13.075.276.166.437.1.18.281.27.543.27.261 0 .447-.09.558-.27.11-.18.165-.407.165-.678v-1.55c-.01-.191-.05-.337-.12-.437a.504.504 0 0 0-.226-.21.582.582 0 0 0-.287-.076c-.1-.01-.191-.015-.271-.015H7.3v-1.28h.257c.603 0 .904-.281.904-.843V6.367c0-.12-.01-.22-.03-.3a.346.346 0 0 0-.045-.136.707.707 0 0 0-.136-.18.6.6 0 0 0-.482-.212c-.252 0-.438.08-.558.241-.12.15-.181.347-.181.587v.738H5.582v-.738c0-.632.206-1.164.618-1.596.403-.431.925-.647 1.569-.647.352 0 .688.09 1.01.271.332.18.573.392.724.632.16.241.266.467.317.678.05.21.075.432.075.662v1.175c0 .652-.286 1.149-.86 1.49.322.231.543.462.664.693.13.22.196.522.196.903v1.355Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.092 32.787h8.266l2.905-6.357 1.452 9.703 3.463-6.209 2.085 11.785 6.703-22.082 3.09 6.357"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M38.115 36.389s2.275-2.311 3.422-3.457c.353-.352.632-.892.632-1.538 0-1.14-.492-2.655-2.185-2.655-.964 0-1.769.927-1.856 1.025-.132.148-.285.14-.396 0-.081-.103-.892-1.025-1.856-1.025-1.693 0-2.185 1.516-2.185 2.655 0 .646.279 1.186.632 1.538 1.147 1.146 3.423 3.457 3.423 3.457.125.132.224.135.369 0Z",
  fill: "currentColor"
}))), pI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279V49.72a.278.278 0 0 1-.28.279H.28a.278.278 0 0 1-.28-.279V.28C0 .124.125 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M14.91 8.353a.83.83 0 0 1-.195-.333 1.725 1.725 0 0 1-.044-.416V5.51c0-.306.097-.562.29-.768a.979.979 0 0 1 .743-.314 1 1 0 0 1 .713.296.952.952 0 0 1 .302.704v2.177c0 .122-.006.212-.019.27a.694.694 0 0 1-.05.177l.397.334-.334.402-.378-.302a1.022 1.022 0 0 1-1.084.126 1.106 1.106 0 0 1-.34-.258Zm1.002-.906.202.157V5.51a.518.518 0 0 0-.113-.34.378.378 0 0 0-.315-.144.394.394 0 0 0-.36.214.556.556 0 0 0-.044.138 1.01 1.01 0 0 0-.006.132V7.648c0 .122.033.231.1.328.072.092.181.14.328.144a.397.397 0 0 0 .152-.037l-.278-.233.334-.403ZM19.128 8.24a1.089 1.089 0 0 1-.36.346.894.894 0 0 1-.479.132.96.96 0 0 1-.264-.038 1.494 1.494 0 0 1-.24-.094 1.217 1.217 0 0 1-.201-.138.603.603 0 0 1-.133-.17 1.324 1.324 0 0 1-.126-.309 1.51 1.51 0 0 1-.025-.283V4.465h.605v3.303l.013.063a.515.515 0 0 0 .094.176c.055.076.15.113.284.113.122 0 .212-.044.27-.132a.525.525 0 0 0 .095-.302V4.465h.605v3.221c0 .1-.01.197-.031.29a.897.897 0 0 1-.107.264ZM19.588 8.68l.946-4.215h.523l.945 4.215h-.65l-.17-.906h-.78l-.177.906h-.637Zm.92-1.466h.568l-.284-1.535-.284 1.535ZM24.119 8.68h-1.803V4.465h.605v3.611h1.198zM24.289 8.68V4.465h.598V8.68zM25.934 8.68V5.025h-.712v-.56h2.035v.56h-.724V8.68zM28.143 8.68V6.868l-.82-2.403h.63l.492 1.648.498-1.648h.636l-.838 2.403V8.68zM16.524 13.89v.604h-1.809v-4.216h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM17.94 10.278c.274 0 .507.097.7.29a.92.92 0 0 1 .297.692v2.19c0 .31-.095.561-.284.754a.979.979 0 0 1-.731.29h-.94v-4.216h.959Zm.398 3.171v-2.19a.383.383 0 0 0-.133-.295.432.432 0 0 0-.308-.12h-.315v3.09h.296c.306 0 .46-.162.46-.485ZM21.275 14.053a1.09 1.09 0 0 1-.359.346.894.894 0 0 1-.479.133.962.962 0 0 1-.264-.038 1.497 1.497 0 0 1-.24-.095 1.218 1.218 0 0 1-.202-.138.603.603 0 0 1-.132-.17 1.324 1.324 0 0 1-.126-.308 1.51 1.51 0 0 1-.025-.283v-3.222h.605v3.303l.012.063a.516.516 0 0 0 .095.177c.055.075.15.113.283.113.122 0 .213-.044.272-.132a.524.524 0 0 0 .094-.302v-3.222h.605V13.5c0 .1-.01.197-.031.29a.897.897 0 0 1-.108.263ZM23.878 13.43c0 .135-.009.25-.026.347a.795.795 0 0 1-.126.314.89.89 0 0 1-.145.17 1.1 1.1 0 0 1-.189.139c-.067.037-.14.069-.22.094a.774.774 0 0 1-.233.038c-.19 0-.362-.04-.517-.12a.812.812 0 0 1-.334-.302 1.114 1.114 0 0 1-.139-.34 2.15 2.15 0 0 1-.025-.34v-2.17c0-.118.01-.223.031-.315a.992.992 0 0 1 .152-.308.912.912 0 0 1 .321-.277.86.86 0 0 1 .435-.12c.29 0 .531.097.725.29.193.189.29.432.29.73v.226h-.6v-.226a.443.443 0 0 0-.1-.296c-.063-.08-.158-.12-.284-.12-.117 0-.21.04-.277.12a.462.462 0 0 0-.094.296v2.334a.55.55 0 0 0 .088.214c.059.084.155.126.29.126.143 0 .237-.038.283-.113a.71.71 0 0 0 .082-.164.725.725 0 0 0 .013-.15v-.215h.599v.139ZM24.078 14.494l.945-4.216h.523l.945 4.216h-.649l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.284-1.535-.283 1.535ZM26.998 14.494v-3.656h-.712v-.56h2.036v.56h-.725v3.656zM28.645 14.494v-4.216h.599v4.216zM29.972 10.675c.097-.135.219-.24.366-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.598 1.3 1.3 0 0 1 .05.37v2.146c0 .126-.012.237-.038.334a.947.947 0 0 1-.15.32.94.94 0 0 1-.335.303.928.928 0 0 1-.479.126 1.1 1.1 0 0 1-.29-.038 1.307 1.307 0 0 1-.258-.113 1.177 1.177 0 0 1-.215-.158.777.777 0 0 1-.138-.182c-.063-.13-.101-.235-.114-.315a1.788 1.788 0 0 1-.018-.277v-2.145c0-.126.012-.237.037-.334.03-.1.078-.199.145-.295Zm1.172.333a.376.376 0 0 0-.327-.176.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.533.533 0 0 0-.05.151.79.79 0 0 0-.013.126v2.215c0 .02.002.044.006.069a.581.581 0 0 0 .1.207c.064.089.169.133.316.133a.4.4 0 0 0 .201-.05.349.349 0 0 0 .133-.127.458.458 0 0 0 .057-.138.861.861 0 0 0 .012-.164v-2.145a.833.833 0 0 0-.012-.176.255.255 0 0 0-.063-.12ZM33.812 14.494l-.939-2.561v2.561h-.605v-4.216h.574l.932 2.555v-2.555h.605v4.216zM8.076 14.302v-1.536h-2.88v-1.355l2.096-7.197h1.523l-2.157 7.197h1.418V8.536h1.448v2.875h.709v1.355h-.709v1.536z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M38.138 20.19c-.513.002-1.027.283-1.027.834v1.502h2.054v-1.502c0-.561-.514-.837-1.027-.835Zm-1.027 2.982V38.19l1.027 3.365 1.027-3.365V23.172H37.11Zm-23.829-1.451v16.605l8.814 2.714V26.839l-8.814-5.118Zm8.74 21.215-10.669-3.011v-17.51l.929-.708v17.534l9.954 2.9h.81L33 39.24V21.707l.928.708v17.51l-10.668 3.01h-1.24ZM32 21.72v16.605l-8.814 2.714V26.839L32 21.72Z",
  fill: "currentColor"
}))), hI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0H49.72c.155 0 .279.124.279.279V49.72a.278.278 0 0 1-.279.279H.28A.278.278 0 0 1 0 49.721V.28C0 .124.125 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M16.743 8.24a1.01 1.01 0 0 1-.87.478c-.16 0-.315-.038-.466-.113a1.01 1.01 0 0 1-.347-.277 1.052 1.052 0 0 1-.164-.34 1.775 1.775 0 0 1-.038-.384V5.497c0-.105.01-.21.032-.315.03-.105.107-.254.233-.447.13-.205.386-.308.769-.308.168 0 .325.04.472.12a.89.89 0 0 1 .335.295c.08.113.13.223.15.327.026.101.039.21.039.328v.176h-.6v-.176a.54.54 0 0 0-.005-.089.389.389 0 0 0-.007-.075.492.492 0 0 0-.094-.182c-.06-.084-.158-.126-.297-.126-.163 0-.273.044-.327.132a.764.764 0 0 0-.088.195.742.742 0 0 0-.013.145V7.71c0 .03.002.055.006.076a.67.67 0 0 0 .095.195c.054.088.162.132.321.132.164 0 .27-.044.315-.132.026-.046.044-.084.057-.113a.483.483 0 0 0 .025-.088.237.237 0 0 0 .013-.076v-.837h-.485V6.34h1.084v1.264c0 .088-.003.164-.007.227a.714.714 0 0 1-.076.29 1.114 1.114 0 0 1-.062.119ZM19.296 8.076v.604h-1.809V4.465h1.809v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM21.06 8.68l-.939-2.561V8.68h-.605V4.465h.574l.933 2.554V4.465h.605V8.68zM23.005 4.465c.273 0 .507.096.7.29a.92.92 0 0 1 .296.691v2.19c0 .31-.094.562-.284.755a.979.979 0 0 1-.73.29h-.94V4.464h.958Zm.397 3.17V5.447a.383.383 0 0 0-.132-.295.432.432 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.162.46-.485ZM26.226 8.076v.604h-1.809V4.465h1.809v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM26.535 8.68V4.465h1.06a.94.94 0 0 1 .699.29c.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.931h-.643l-.567-1.805h-.379V8.68h-.605Zm1.343-2.472a.366.366 0 0 0 .075-.158.708.708 0 0 0 .026-.195v-.39a.454.454 0 0 0-.108-.314.376.376 0 0 0-.302-.126h-.429V6.34h.423a.417.417 0 0 0 .315-.132ZM16.711 13.89v.604h-1.809v-4.216h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM17.175 14.167a.83.83 0 0 1-.195-.334 1.725 1.725 0 0 1-.045-.415v-2.095c0-.307.097-.562.29-.768a.979.979 0 0 1 .744-.315 1 1 0 0 1 .712.296.952.952 0 0 1 .303.705v2.177c0 .122-.007.212-.02.27a.695.695 0 0 1-.05.177l.397.333-.334.403-.378-.302a1.022 1.022 0 0 1-1.084.126 1.106 1.106 0 0 1-.34-.258Zm1.002-.906.202.157v-2.095a.519.519 0 0 0-.114-.34.378.378 0 0 0-.315-.145.394.394 0 0 0-.36.214.555.555 0 0 0-.043.139 1.01 1.01 0 0 0-.007.132V13.462c0 .122.034.23.101.327.072.092.18.14.328.145a.397.397 0 0 0 .151-.038l-.277-.233.334-.402ZM21.392 14.053a1.09 1.09 0 0 1-.359.346.894.894 0 0 1-.479.133.962.962 0 0 1-.265-.038 1.497 1.497 0 0 1-.24-.095 1.218 1.218 0 0 1-.2-.138.603.603 0 0 1-.133-.17 1.323 1.323 0 0 1-.126-.308 1.51 1.51 0 0 1-.025-.283v-3.222h.605v3.303l.012.063a.515.515 0 0 0 .095.177c.054.075.149.113.283.113.122 0 .212-.044.271-.132a.525.525 0 0 0 .095-.302v-3.222h.605V13.5c0 .1-.01.197-.032.29a.896.896 0 0 1-.107.263ZM21.662 14.494l.945-4.216h.523l.945 4.216h-.649l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.284-1.535-.283 1.535ZM26.192 14.494H24.39v-4.216h.605v3.612h1.197zM26.362 14.494v-4.216h.599v4.216zM28.007 14.494v-3.656h-.712v-.56h2.036v.56h-.725v3.656zM30.217 14.494v-1.812l-.82-2.404h.631l.491 1.649.498-1.649h.637l-.839 2.404v1.812zM8.157 7.813c.251 0 .503.07.754.21.262.141.453.307.573.497.13.191.216.392.257.603.05.2.075.416.075.647v2.258c0 .221-.01.412-.03.573-.01.15-.066.361-.166.632s-.347.532-.739.783a2.163 2.163 0 0 1-1.237.376c-.341 0-.668-.08-.98-.24a2.106 2.106 0 0 1-1.07-1.356c-.06-.25-.091-.507-.091-.768v-.255H6.98v.557c0 .05.015.11.045.18.03.07.07.14.12.211.051.06.121.115.212.166.09.04.196.06.317.06.271 0 .452-.075.542-.226.09-.15.141-.266.151-.346.01-.09.015-.186.015-.286V9.83c0-.05-.005-.1-.015-.15 0-.05-.015-.11-.045-.18a.453.453 0 0 0-.12-.197.503.503 0 0 0-.212-.165.56.56 0 0 0-.301-.076c-.352 0-.589.181-.71.542H5.685v-5.39h4.132v1.34H6.981v2.71a1.728 1.728 0 0 1 1.176-.451Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M21.192 27.858v1.983h7.557v-1.983h-7.557Zm0 3.076v2.077h7.557v-2.077h-7.557ZM30.13 19.05v2.156h2.569l-2.737 2.733a8.16 8.16 0 0 0-5.026-1.744 8.158 8.158 0 0 0-5.764 2.384 8.131 8.131 0 0 0-2.388 5.754 8.13 8.13 0 0 0 2.027 5.36 8.154 8.154 0 0 0 5.063 2.699v2.388h-2.57v2.398h2.57v2.342h2.383v-2.342h2.55V40.78h-2.55v-2.426a8.153 8.153 0 0 0 4.889-2.76 8.13 8.13 0 0 0 1.94-5.26 8.129 8.129 0 0 0-1.492-4.678l2.707-2.702v2.36h2.215V19.05H30.13Zm-5.194 5.366c1.571 0 3.079.623 4.19 1.733a5.912 5.912 0 0 1 0 8.368 5.931 5.931 0 0 1-9.667-1.92 5.91 5.91 0 0 1 1.285-6.448 5.933 5.933 0 0 1 4.192-1.733Z",
  fill: "currentColor"
}))), mI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279V49.72a.278.278 0 0 1-.28.279H.28a.278.278 0 0 1-.28-.279V.28C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M16.556 7.617c0 .134-.008.25-.025.346a.796.796 0 0 1-.126.315.892.892 0 0 1-.145.17 1.1 1.1 0 0 1-.19.138c-.066.038-.14.07-.22.094a.774.774 0 0 1-.233.038c-.19 0-.361-.04-.517-.12a.812.812 0 0 1-.334-.301 1.115 1.115 0 0 1-.138-.34 2.15 2.15 0 0 1-.026-.34v-2.17c0-.118.01-.223.032-.315a.991.991 0 0 1 .151-.309.912.912 0 0 1 .321-.277.86.86 0 0 1 .435-.12c.29 0 .532.097.725.29.193.19.29.432.29.73v.227h-.599v-.227a.443.443 0 0 0-.1-.295c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.277.12a.462.462 0 0 0-.095.295v2.335a.55.55 0 0 0 .088.214c.06.083.156.125.29.125.143 0 .238-.037.284-.113a.709.709 0 0 0 .082-.164.722.722 0 0 0 .012-.15v-.214h.6v.138ZM18.791 8.68h-1.803V4.465h.605v3.611h1.198zM20.793 8.076v.604h-1.809V4.465h1.809v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM20.907 8.68l.945-4.215h.524l.945 4.215h-.65l-.17-.906h-.78l-.177.906h-.637Zm.92-1.466h.567l-.283-1.535-.284 1.535ZM25.125 8.68l-.939-2.561V8.68h-.605V4.465h.574l.932 2.554V4.465h.605V8.68zM28.739 8.68l-.497-2.567-.486 2.567h-.561l-.611-4.215h.643l.302 2.548.486-2.548h.447l.498 2.548.303-2.548h.636l-.592 4.215zM29.747 8.68l.945-4.215h.523l.946 4.215h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567L30.95 5.68l-.283 1.535ZM32.62 8.68V5.025h-.712v-.56h2.035v.56h-.724V8.68zM36.1 8.076v.604h-1.809V4.465H36.1v.553h-1.21v1.246h1.058v.573H34.89v1.239zM36.41 8.68V4.465h1.058c.278 0 .51.096.7.29.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.931h-.643l-.567-1.805h-.378V8.68h-.605Zm1.342-2.472a.364.364 0 0 0 .076-.158.705.705 0 0 0 .025-.195v-.39a.453.453 0 0 0-.107-.314.375.375 0 0 0-.303-.126h-.428V6.34h.422c.126 0 .23-.044.315-.132ZM14.462 14.494l.945-4.216h.523l.946 4.216h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.283-1.535-.284 1.535ZM18.68 14.494l-.939-2.561v2.561h-.605v-4.216h.573l.933 2.555v-2.555h.605v4.216zM20.577 10.278c.273 0 .506.097.7.29a.92.92 0 0 1 .296.692v2.19c0 .31-.095.561-.284.754a.979.979 0 0 1-.73.29h-.94v-4.216h.958Zm.397 3.171v-2.19a.383.383 0 0 0-.132-.295.432.432 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.162.46-.485ZM23.342 13.443v.107c0 .03.002.055.006.076.008.042.04.102.095.182.058.084.163.126.315.126a.542.542 0 0 0 .233-.05.35.35 0 0 0 .202-.277.583.583 0 0 0 .012-.114v-.409a.384.384 0 0 0-.05-.213.644.644 0 0 0-.227-.183 4.06 4.06 0 0 0-.429-.176 1.212 1.212 0 0 1-.516-.359c-.14-.163-.208-.386-.208-.667v-.188c0-.29.096-.537.29-.743a.95.95 0 0 1 .718-.315.96.96 0 0 1 .731.309c.197.205.296.455.296.749v.188h-.605v-.188a.5.5 0 0 0-.006-.082.351.351 0 0 0-.006-.07.265.265 0 0 0-.032-.075 1.446 1.446 0 0 0-.07-.107c-.058-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.113.328v.245c0 .084.012.15.037.201a.58.58 0 0 0 .202.158c.034.016.084.04.151.069.072.025.158.056.259.094.201.067.382.187.542.359.16.172.24.398.24.68v.34c0 .146-.016.27-.045.37-.025.101-.111.248-.258.44-.147.185-.393.278-.738.278-.365 0-.63-.118-.794-.353a1.288 1.288 0 0 1-.246-.736v-.15h.612v.15ZM24.927 14.494l.945-4.216h.523l.946 4.216h-.65l-.17-.906h-.781l-.176.906h-.637Zm.92-1.466h.567l-.283-1.535-.284 1.535ZM29.192 14.494l-.939-2.561v2.561h-.605v-4.216h.574l.933 2.555v-2.555h.605v4.216zM30.156 14.494v-4.216h.598v4.216zM31.801 14.494v-3.656h-.712v-.56h2.035v.56H32.4v3.656zM32.912 14.494l.945-4.216h.523l.946 4.216h-.65l-.17-.906h-.78l-.178.906h-.636Zm.92-1.466h.567l-.283-1.535-.284 1.535ZM35.856 14.494v-3.656h-.712v-.56h2.036v.56h-.725v3.656zM37.503 14.494v-4.216h.599v4.216zM38.779 10.675c.097-.135.218-.24.366-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.598c.033.113.05.237.05.37v2.146c0 .126-.013.237-.038.334a.95.95 0 0 1-.151.32.941.941 0 0 1-.334.303.929.929 0 0 1-.48.126 1.1 1.1 0 0 1-.29-.038 1.3 1.3 0 0 1-.472-.27.773.773 0 0 1-.138-.183 1.2 1.2 0 0 1-.114-.315 1.763 1.763 0 0 1-.019-.277v-2.145c0-.126.013-.237.038-.334.03-.1.078-.199.145-.295Zm1.172.333a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.063.372.372 0 0 0-.145.132.54.54 0 0 0-.05.151.783.783 0 0 0-.013.126v2.215c0 .02.002.044.006.069a.583.583 0 0 0 .101.207c.064.089.169.133.315.133a.401.401 0 0 0 .202-.05.352.352 0 0 0 .133-.127.46.46 0 0 0 .056-.138.888.888 0 0 0 .013-.164v-2.145a.856.856 0 0 0-.013-.176.256.256 0 0 0-.063-.12ZM42.686 14.494l-.939-2.561v2.561h-.605v-4.216h.573l.933 2.555v-2.555h.605v4.216zM9.586 9.138c.08.14.13.286.15.436.03.15.046.337.046.557v1.928c0 .23-.026.461-.076.692-.05.221-.2.532-.452.934-.262.411-.754.647-1.478.707a2.67 2.67 0 0 1-1.237-.286c-.362-.2-.618-.436-.769-.707a3.08 3.08 0 0 1-.271-.708 4.061 4.061 0 0 1-.046-.632v-1.581c0-.221.005-.377.016-.467.01-.1.045-.23.105-.391L7.58 4.214h1.629l-1.63 4.231c.182-.07.398-.105.65-.105h.135c.553.08.96.346 1.222.798Zm-1.373.768a.717.717 0 0 0-.603-.302.604.604 0 0 0-.513.241c-.12.161-.18.372-.18.633v1.58c0 .211.05.412.15.603.11.18.297.27.558.27h.09c.262 0 .433-.09.513-.27.08-.18.12-.382.12-.602v-1.581c0-.13-.01-.236-.03-.316a.518.518 0 0 0-.105-.256ZM16.147 20.156c-.239 0-.473.21-.42.526l2.948 17.902c.038.231.185.447.421.447h3.581l.264 2.917h-1.527l3.62 3.615 3.62-3.615h-1.527l.264-2.917h3.58c.236 0 .384-.216.422-.447l2.949-17.902a.435.435 0 0 0-.422-.526H16.147Zm.545.892h16.684l-.493 2.991c-1.934-.223-4.833 2.25-8.09.616-4.01-2.011-4.097.157-7.511-.026l-.59-3.58Zm8.329 6.259c1.574 2.722 2.918 3.77 2.918 5.612 0 1.231-.779 2.826-2.918 2.826-2.14 0-2.918-1.595-2.918-2.826 0-1.842 1.344-2.89 2.918-5.612Z",
  fill: "currentColor",
  fillRule: "nonzero"
}))), yI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279v49.443a.278.278 0 0 1-.28.278H.28a.278.278 0 0 1-.28-.278V.279C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "m14.172 8.621.946-4.216h.523l.945 4.216h-.649l-.17-.906h-.782l-.176.906h-.637Zm.92-1.466h.568l-.284-1.535-.283 1.535ZM16.856 8.621V4.405h1.802v.567h-1.204v1.264h1.053v.567h-1.053v1.818zM18.949 8.621V4.405h1.802v.567h-1.204v1.264H20.6v.567h-1.053v1.818zM21.026 4.802c.097-.134.218-.24.365-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.598c.034.113.05.237.05.371v2.146c0 .125-.012.237-.037.333a.947.947 0 0 1-.151.32.94.94 0 0 1-.334.303.928.928 0 0 1-.48.126 1.1 1.1 0 0 1-.29-.038 1.307 1.307 0 0 1-.258-.113 1.177 1.177 0 0 1-.214-.158.777.777 0 0 1-.139-.182c-.063-.13-.1-.235-.113-.315a1.788 1.788 0 0 1-.019-.276V5.43c0-.126.013-.237.038-.334.03-.1.078-.199.145-.295Zm1.172.333a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.533.533 0 0 0-.05.151.793.793 0 0 0-.013.126v2.215c0 .02.002.044.006.069a.581.581 0 0 0 .101.208c.063.088.168.132.315.132a.4.4 0 0 0 .202-.05.35.35 0 0 0 .132-.126.457.457 0 0 0 .057-.139.861.861 0 0 0 .013-.163V5.43a.833.833 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM23.4 8.621V4.405h1.06a.94.94 0 0 1 .699.29c.193.193.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.932h-.643l-.567-1.806h-.379v1.806H23.4Zm1.343-2.473a.366.366 0 0 0 .075-.157.707.707 0 0 0 .026-.195v-.39a.454.454 0 0 0-.108-.315.376.376 0 0 0-.302-.126h-.429V6.28h.423a.417.417 0 0 0 .315-.132ZM26.78 4.405c.273 0 .507.097.7.29a.92.92 0 0 1 .296.692v2.19c0 .31-.094.562-.283.755a.979.979 0 0 1-.732.29h-.939V4.404h.958Zm.397 3.172v-2.19a.383.383 0 0 0-.132-.296.432.432 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.161.46-.484ZM28.061 8.621l.946-4.216h.523l.945 4.216h-.65l-.17-.906h-.78l-.177.906h-.637Zm.92-1.466h.568l-.284-1.535-.284 1.535ZM31.778 4.405c.13 0 .252.028.366.082.126.059.254.153.384.283.139.135.208.344.208.63v.32c0 .323-.128.55-.384.68.256.151.384.386.384.705v.49a.996.996 0 0 1-.29.737.979.979 0 0 1-.73.29h-.933V4.404h.995Zm.36 1.252V5.4a.398.398 0 0 0-.416-.428h-.34v1.164h.359c.138 0 .24-.042.302-.126a.594.594 0 0 0 .095-.353Zm0 1.938v-.49a.425.425 0 0 0-.114-.315.385.385 0 0 0-.302-.12h-.34v1.353h.346a.39.39 0 0 0 .296-.12.444.444 0 0 0 .114-.308ZM35.023 8.621h-1.802V4.405h.605v3.612h1.197zM37.016 8.017v.604h-1.809V4.405h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM37.67 8.621l.946-4.216h.523l.946 4.216h-.65l-.17-.906h-.781l-.176.906h-.637Zm.921-1.466h.567l-.283-1.535-.284 1.535ZM41.936 8.621l-.938-2.561v2.561h-.605V4.405h.573l.933 2.555V4.405h.605v4.216zM43.887 4.405c.273 0 .506.097.7.29a.92.92 0 0 1 .296.692v2.19c0 .31-.095.562-.284.755a.979.979 0 0 1-.73.29h-.94V4.404h.958Zm.397 3.172v-2.19a.383.383 0 0 0-.132-.296.432.432 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.161.46-.484ZM16.37 13.371c0 .135-.008.25-.024.346a.796.796 0 0 1-.127.315.892.892 0 0 1-.144.17c-.055.05-.118.096-.19.138-.067.038-.14.07-.22.095a.773.773 0 0 1-.233.037c-.19 0-.362-.04-.517-.12a.813.813 0 0 1-.334-.301 1.116 1.116 0 0 1-.139-.34 2.154 2.154 0 0 1-.025-.34v-2.17c0-.118.01-.223.032-.315a.992.992 0 0 1 .15-.308.912.912 0 0 1 .322-.277.86.86 0 0 1 .435-.12c.29 0 .532.097.725.29.193.188.29.432.29.73v.226h-.599v-.226a.443.443 0 0 0-.1-.296c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.278.12a.462.462 0 0 0-.094.296v2.334a.55.55 0 0 0 .088.214c.059.084.155.126.29.126.143 0 .237-.038.283-.114a.71.71 0 0 0 .082-.163.723.723 0 0 0 .013-.151v-.214h.599v.138ZM18.584 14.435h-1.802v-4.216h.605v3.612h1.197zM20.539 13.831v.604H18.73v-4.216h1.809v.554h-1.21v1.245h1.059v.573h-1.059v1.24zM20.617 14.435l.945-4.216h.523l.946 4.216h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.283-1.536-.284 1.536ZM24.882 14.435l-.939-2.561v2.561h-.605v-4.216h.574l.933 2.554v-2.554h.605v4.216zM28.299 13.831v.604H26.49v-4.216h1.809v.554h-1.21v1.245h1.059v.573h-1.059v1.24zM30.087 14.435l-.939-2.561v2.561h-.605v-4.216h.574l.932 2.554v-2.554h.605v4.216zM32.772 13.831v.604h-1.809v-4.216h1.809v.554h-1.21v1.245h1.059v.573h-1.059v1.24zM33.088 14.435v-4.216h1.059c.277 0 .51.096.7.29.192.192.29.43.29.71v.39a.99.99 0 0 1-.499.894l.643 1.932h-.643l-.567-1.806h-.378v1.806h-.605Zm1.342-2.473a.364.364 0 0 0 .076-.158.705.705 0 0 0 .025-.195v-.39a.453.453 0 0 0-.107-.314.375.375 0 0 0-.303-.126h-.428v1.315h.422c.126 0 .231-.044.315-.132ZM37.389 13.994a1.009 1.009 0 0 1-.87.478c-.16 0-.315-.037-.467-.113a1.009 1.009 0 0 1-.346-.277 1.047 1.047 0 0 1-.164-.34 1.787 1.787 0 0 1-.038-.383V11.25c0-.105.01-.21.032-.315.03-.105.107-.254.233-.447.13-.205.386-.308.769-.308.168 0 .325.04.473.12a.89.89 0 0 1 .333.295c.08.114.13.223.152.328.025.1.038.21.038.327v.176h-.6v-.176a.557.557 0 0 0-.006-.088.375.375 0 0 0-.006-.076.49.49 0 0 0-.094-.182c-.06-.084-.158-.126-.297-.126-.164 0-.273.044-.327.132a.766.766 0 0 0-.089.195.738.738 0 0 0-.012.145V13.466c0 .029.002.054.006.075a.678.678 0 0 0 .095.195c.054.088.161.132.321.132.164 0 .27-.044.315-.132.025-.046.044-.084.057-.113a.476.476 0 0 0 .025-.088.236.236 0 0 0 .013-.076v-.836h-.486v-.529h1.085v1.265c0 .088-.003.163-.007.226a.793.793 0 0 1-.076.29 1.108 1.108 0 0 1-.063.12ZM38.444 14.435v-1.813l-.819-2.403h.63l.492 1.648.498-1.648h.636l-.838 2.403v1.813zM6.435 6.685H5.153v-2.53h4.313v1.31l-2.352 8.778H5.576l2.458-8.748H6.435z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  d: "m14.95 24.829 2.714 1.564a.644.644 0 1 1-.645 1.115l-2.713-1.564a.644.644 0 1 1 .645-1.115Zm4.716-4.2 1.566 2.708a.644.644 0 1 1-1.117.644l-1.566-2.709a.644.644 0 1 1 1.117-.644Zm6.187-1.285v3.128a.643.643 0 0 1-.645.644.643.643 0 0 1-.645-.644v-3.128c0-.356.288-.643.645-.643.357 0 .645.287.645.643Zm6 1.977-1.566 2.709a.644.644 0 1 1-1.116-.644l1.566-2.709a.644.644 0 1 1 1.117.644Zm4.208 4.707-2.713 1.564a.644.644 0 1 1-.645-1.115l2.713-1.564a.644.644 0 1 1 .645 1.115Zm1.286 6.177h-3.133a.643.643 0 1 1 0-1.287h3.133a.643.643 0 1 1 0 1.287Zm-1.98 5.992-2.713-1.564a.644.644 0 1 1 .645-1.115l2.713 1.564a.644.644 0 1 1-.645 1.115Zm-4.715 4.2-1.566-2.709a.644.644 0 1 1 1.117-.644l1.566 2.71a.644.644 0 1 1-1.117.644Zm-6.187 1.284v-3.128c0-.357.288-.644.645-.644.357 0 .645.287.645.644v3.128a.643.643 0 0 1-.645.644.643.643 0 0 1-.645-.644Zm-6-1.977 1.566-2.709a.644.644 0 1 1 1.117.644l-1.567 2.709a.644.644 0 1 1-1.117-.644Zm-4.208-4.707 2.713-1.564a.644.644 0 1 1 .645 1.115l-2.713 1.564a.644.644 0 1 1-.645-1.115Zm-1.286-6.177h3.133a.643.643 0 1 1 0 1.287h-3.133a.643.643 0 1 1 0-1.287Zm12.188-6.692a7.402 7.402 0 0 0-5.23 2.163 7.379 7.379 0 0 0 0 10.443 7.404 7.404 0 0 0 10.46 0 7.379 7.379 0 0 0-2.4-12.044 7.407 7.407 0 0 0-2.83-.562Zm-.028 2.51c.242 0 .436.194.436.435v2.488a.435.435 0 1 1-.872 0v-2.488c0-.241.194-.436.436-.436Zm-1.138 1.276V29.2a2.59 2.59 0 0 0-1.426 2.312 2.586 2.586 0 0 0 2.592 2.588 2.596 2.596 0 0 0 2.395-1.598 2.585 2.585 0 0 0-1.215-3.292v-1.29a3.79 3.79 0 0 1 2.61 3.592 3.778 3.778 0 0 1-2.34 3.496 3.798 3.798 0 0 1-4.13-.82 3.782 3.782 0 0 1 1.514-6.275Z",
  fill: "currentColor"
}))), NI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0H49.72c.155 0 .279.124.279.279v49.443a.278.278 0 0 1-.279.278H.28A.278.278 0 0 1 0 49.722V.279C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M14.452 4.405c.274 0 .507.097.7.29a.92.92 0 0 1 .296.692v2.19c0 .31-.094.562-.283.755a.979.979 0 0 1-.731.29h-.94V4.404h.958Zm.398 3.172v-2.19a.383.383 0 0 0-.133-.296.432.432 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.161.46-.484ZM17.777 8.017v.604h-1.809V4.405h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM19.988 7.558c0 .134-.009.25-.025.346a.796.796 0 0 1-.126.314.89.89 0 0 1-.145.17c-.055.05-.118.097-.19.139-.067.037-.14.069-.22.094a.774.774 0 0 1-.233.038c-.19 0-.362-.04-.517-.12a.813.813 0 0 1-.334-.302 1.115 1.115 0 0 1-.139-.34 2.15 2.15 0 0 1-.025-.34v-2.17c0-.118.01-.222.032-.315a.992.992 0 0 1 .15-.308.912.912 0 0 1 .322-.277.86.86 0 0 1 .435-.12c.29 0 .532.097.725.29.193.189.29.432.29.73v.226h-.599v-.226a.443.443 0 0 0-.1-.296c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.278.12a.462.462 0 0 0-.094.296V7.72a.55.55 0 0 0 .088.214c.059.084.155.126.29.126.143 0 .237-.038.284-.113a.708.708 0 0 0 .081-.164.722.722 0 0 0 .013-.15v-.215h.599v.139ZM22.203 8.017v.604h-1.809V4.405h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM24.099 8.621 23.16 6.06v2.561h-.605V4.405h.574l.932 2.555V4.405h.605v4.216zM25.522 8.621V4.965h-.712v-.56h2.035v.56h-.724v3.656zM29.788 8.621l-.498-2.567-.485 2.567h-.561l-.611-4.216h.643l.302 2.549.485-2.549h.448l.498 2.549.302-2.549h.637l-.593 4.216zM31.33 4.802c.097-.134.22-.24.366-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.598c.034.113.05.237.05.371v2.146c0 .125-.012.237-.037.333a.947.947 0 0 1-.151.32.94.94 0 0 1-.334.303.928.928 0 0 1-.48.126 1.1 1.1 0 0 1-.29-.038 1.306 1.306 0 0 1-.258-.113 1.176 1.176 0 0 1-.214-.158.777.777 0 0 1-.139-.182c-.063-.13-.1-.235-.113-.315a1.788 1.788 0 0 1-.019-.276V5.43c0-.126.013-.237.038-.334.03-.1.078-.199.145-.295Zm1.173.333a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.063.374.374 0 0 0-.145.132.534.534 0 0 0-.05.151.79.79 0 0 0-.013.126v2.215c0 .02.002.044.006.069a.581.581 0 0 0 .101.208c.063.088.168.132.315.132a.4.4 0 0 0 .202-.05.349.349 0 0 0 .132-.126.457.457 0 0 0 .057-.139.861.861 0 0 0 .013-.163V5.43a.833.833 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM33.697 8.621V4.405h1.058a.94.94 0 0 1 .7.29c.193.193.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.932h-.643l-.567-1.806h-.378v1.806h-.605Zm1.342-2.473a.364.364 0 0 0 .076-.157.704.704 0 0 0 .025-.195v-.39a.455.455 0 0 0-.107-.315.376.376 0 0 0-.303-.126h-.428V6.28h.422c.126 0 .231-.044.315-.132ZM37.702 8.621l-.675-1.881-.334.623v1.258h-.599V4.405h.606v1.938l.901-1.938h.599l-.826 1.68.97 2.536zM38.952 8.621l.945-4.216h.523l.946 4.216h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.284-1.535-.283 1.535ZM43.218 8.621l-.939-2.561v2.561h-.605V4.405h.573l.933 2.555V4.405h.605v4.216zM45.168 4.405c.273 0 .506.097.7.29a.92.92 0 0 1 .296.692v2.19c0 .31-.095.562-.284.755a.979.979 0 0 1-.731.29h-.939V4.404h.958Zm.397 3.172v-2.19a.382.382 0 0 0-.132-.296.431.431 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.161.46-.484ZM15.303 13.831v.604h-1.808v-4.216h1.808v.554h-1.21v1.245h1.059v.573h-1.059v1.24zM17.488 13.371c0 .135-.009.25-.025.346a.795.795 0 0 1-.126.315.89.89 0 0 1-.145.17c-.055.05-.118.096-.19.138-.067.038-.14.07-.22.095a.773.773 0 0 1-.233.037c-.19 0-.362-.04-.517-.12a.812.812 0 0 1-.334-.301 1.114 1.114 0 0 1-.139-.34 2.15 2.15 0 0 1-.025-.34v-2.17c0-.118.01-.223.032-.315a.991.991 0 0 1 .15-.308.912.912 0 0 1 .322-.277.86.86 0 0 1 .435-.12c.29 0 .532.097.725.29.193.188.29.432.29.73v.226h-.599v-.226a.443.443 0 0 0-.1-.296c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.278.12a.462.462 0 0 0-.094.296v2.334a.55.55 0 0 0 .088.214c.059.084.156.126.29.126.143 0 .237-.038.284-.114a.71.71 0 0 0 .082-.163.725.725 0 0 0 .012-.151v-.214h.599v.138ZM18.107 10.615c.097-.134.219-.239.366-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.597c.033.114.05.237.05.372v2.145c0 .126-.012.237-.038.334a.948.948 0 0 1-.15.32.94.94 0 0 1-.335.303.928.928 0 0 1-.479.125c-.1 0-.197-.012-.29-.037a1.301 1.301 0 0 1-.472-.27.777.777 0 0 1-.14-.183c-.062-.13-.1-.235-.113-.315a1.788 1.788 0 0 1-.018-.277v-2.145c0-.126.012-.237.037-.334.03-.1.078-.2.145-.296Zm1.173.334a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.533.533 0 0 0-.05.15.79.79 0 0 0-.013.127v2.215c0 .02.002.043.006.069a.58.58 0 0 0 .1.207c.064.088.169.132.316.132a.4.4 0 0 0 .202-.05.35.35 0 0 0 .132-.126.46.46 0 0 0 .057-.138.861.861 0 0 0 .012-.164v-2.145a.832.832 0 0 0-.012-.177.254.254 0 0 0-.063-.12ZM21.988 14.435l-.939-2.561v2.561h-.605v-4.216h.573l.933 2.554v-2.554h.605v4.216zM23.107 10.615c.097-.134.219-.239.366-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.597c.033.114.05.237.05.372v2.145c0 .126-.013.237-.038.334a.948.948 0 0 1-.151.32.94.94 0 0 1-.334.303.928.928 0 0 1-.48.125c-.1 0-.197-.012-.289-.037a1.301 1.301 0 0 1-.473-.27.778.778 0 0 1-.138-.183 1.21 1.21 0 0 1-.114-.315 1.793 1.793 0 0 1-.019-.277v-2.145c0-.126.013-.237.038-.334.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.327-.176.42.42 0 0 0-.215.063.373.373 0 0 0-.145.132.532.532 0 0 0-.05.15.79.79 0 0 0-.013.127v2.215c0 .02.002.043.007.069a.58.58 0 0 0 .1.207c.064.088.169.132.316.132a.4.4 0 0 0 .201-.05.35.35 0 0 0 .133-.126.46.46 0 0 0 .056-.138.861.861 0 0 0 .013-.164v-2.145a.832.832 0 0 0-.013-.177.254.254 0 0 0-.063-.12ZM27.514 14.435v-2.568l-.605 1.8h-.303l-.598-1.8v2.568h-.606v-4.216h.568l.8 2.246.788-2.246h.555v4.216zM28.477 14.435v-4.216h.599v4.216zM31.567 13.371c0 .135-.008.25-.025.346a.796.796 0 0 1-.126.315.892.892 0 0 1-.145.17c-.055.05-.118.096-.189.138-.067.038-.14.07-.22.095a.773.773 0 0 1-.234.037c-.189 0-.361-.04-.517-.12a.813.813 0 0 1-.334-.301 1.115 1.115 0 0 1-.138-.34 2.15 2.15 0 0 1-.025-.34v-2.17c0-.118.01-.223.031-.315a.991.991 0 0 1 .151-.308.912.912 0 0 1 .322-.277.86.86 0 0 1 .435-.12c.29 0 .531.097.724.29.194.188.29.432.29.73v.226h-.598v-.226a.443.443 0 0 0-.101-.296c-.063-.08-.158-.12-.284-.12-.117 0-.21.04-.277.12a.462.462 0 0 0-.095.296v2.334a.55.55 0 0 0 .089.214c.058.084.155.126.29.126.142 0 .237-.038.283-.114a.71.71 0 0 0 .082-.163.723.723 0 0 0 .013-.151v-.214h.598v.138ZM34.559 13.994a1.01 1.01 0 0 1-.87.478c-.16 0-.315-.037-.466-.113a1.01 1.01 0 0 1-.347-.277 1.051 1.051 0 0 1-.164-.34 1.773 1.773 0 0 1-.037-.383V11.25c0-.105.01-.21.031-.315.03-.105.107-.254.233-.447.13-.205.387-.308.77-.308.167 0 .325.04.472.12a.89.89 0 0 1 .334.295.88.88 0 0 1 .151.328c.025.1.038.21.038.327v.176h-.599v-.176a.56.56 0 0 0-.006-.088.402.402 0 0 0-.006-.076.496.496 0 0 0-.095-.182c-.059-.084-.158-.126-.296-.126-.164 0-.273.044-.328.132a.762.762 0 0 0-.088.195.744.744 0 0 0-.013.145V13.466c0 .029.002.054.007.075a.671.671 0 0 0 .094.195c.055.088.162.132.322.132.163 0 .268-.044.315-.132.025-.046.044-.084.056-.113a.48.48 0 0 0 .026-.088.236.236 0 0 0 .012-.076v-.836h-.485v-.529h1.084v1.265c0 .088-.002.163-.006.226a.712.712 0 0 1-.076.29 1.108 1.108 0 0 1-.063.12ZM35.134 14.435v-4.216h1.06c.276 0 .51.096.699.29.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.932h-.643l-.568-1.806h-.378v1.806h-.605Zm1.343-2.473a.364.364 0 0 0 .075-.158.705.705 0 0 0 .026-.195v-.39a.453.453 0 0 0-.108-.314.375.375 0 0 0-.302-.126h-.429v1.315h.423c.126 0 .23-.044.315-.132ZM37.685 10.615c.097-.134.218-.239.366-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.597c.033.114.05.237.05.372v2.145c0 .126-.013.237-.038.334a.943.943 0 0 1-.151.32.941.941 0 0 1-.334.303.928.928 0 0 1-.48.125c-.1 0-.197-.012-.29-.037a1.313 1.313 0 0 1-.257-.114 1.186 1.186 0 0 1-.215-.157.773.773 0 0 1-.138-.182 1.2 1.2 0 0 1-.114-.315 1.764 1.764 0 0 1-.019-.277v-2.145c0-.126.013-.237.038-.334.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.063.377.377 0 0 0-.145.132.54.54 0 0 0-.05.15.783.783 0 0 0-.013.127v2.215c0 .02.002.043.007.069a.58.58 0 0 0 .1.207c.064.088.169.132.316.132a.4.4 0 0 0 .201-.05.35.35 0 0 0 .133-.126.461.461 0 0 0 .056-.138.86.86 0 0 0 .013-.164v-2.145a.832.832 0 0 0-.013-.177.256.256 0 0 0-.063-.12ZM42.009 14.435l-.498-2.568-.485 2.568h-.561l-.611-4.216h.643l.302 2.548.485-2.548h.448l.498 2.548.302-2.548h.637l-.592 4.216zM44.014 14.435v-3.656h-.712v-.56h2.036v.56h-.725v3.656zM45.634 14.435v-4.216h.599v1.799h.769v-1.799h.599v4.216h-.599v-1.882h-.769v1.882zM9.501 12.165v.105c0 .221-.05.452-.15.693-.1.24-.242.467-.423.677-.18.201-.397.367-.648.497s-.523.196-.814.196H7.42c-.21 0-.422-.03-.633-.09a2.885 2.885 0 0 1-.573-.241c-.171-.1-.322-.211-.453-.331a1.31 1.31 0 0 1-.286-.407 2.858 2.858 0 0 1-.241-.693A3.658 3.658 0 0 1 5.188 12v-1.761c0-.522.242-.964.724-1.325-.482-.362-.724-.858-.724-1.49V6.066c0-.21.036-.406.106-.587.07-.19.251-.477.543-.858.281-.372.8-.557 1.553-.557.272 0 .538.06.8.18.25.12.532.342.844.663.312.311.467.753.467 1.325v1.295c0 .582-.24 1.044-.723 1.385.482.351.723.828.723 1.43v1.822ZM7.36 5.495a.693.693 0 0 0-.528.226.696.696 0 0 0-.211.512v1.295c0 .23.06.431.181.602.13.16.312.24.543.24.251 0 .432-.074.543-.225.12-.16.18-.366.18-.617V6.233a.73.73 0 0 0-.21-.512.63.63 0 0 0-.498-.226Zm0 3.975a.71.71 0 0 0-.543.226.764.764 0 0 0-.196.542v1.761c0 .261.06.477.181.648.12.16.317.24.588.24.262 0 .438-.085.528-.255.1-.181.15-.392.15-.633v-1.761a.764.764 0 0 0-.195-.542c-.12-.15-.292-.226-.513-.226ZM36.9 18.314a.236.236 0 0 0-.065.008l-4.125 1.103a.231.231 0 0 0-.104.388l.891.89-8.808 8.8-3.506-3.5a.845.845 0 0 0-1.194 0l-7.079 7.068 1.195 1.192 6.481-6.472 3.506 3.5c.33.33.864.33 1.194 0l9.405-9.396.935.933a.233.233 0 0 0 .388-.104l1.105-4.118a.232.232 0 0 0-.22-.292ZM34.69 24.28l-5.557 5.552v13.564c0 .356.287.643.644.643h4.727a.642.642 0 0 0 .645-.643V24.737l-.459-.458Zm-14.27 6.061-6.016 6.007v7.048c0 .356.287.643.644.643h4.727a.642.642 0 0 0 .644-.643V30.34Zm7.364.838-2.5 2.497a.845.845 0 0 1-1.193 0l-2.323-2.319v12.039c0 .356.288.643.645.643h4.727a.642.642 0 0 0 .644-.643V31.178Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M36.9 18.314a.236.236 0 0 0-.065.008l-4.125 1.103a.231.231 0 0 0-.104.388l.891.89-8.808 8.8-3.506-3.5a.845.845 0 0 0-1.194 0l-7.079 7.068 1.195 1.192 6.481-6.472 3.506 3.5c.33.33.864.33 1.194 0l9.405-9.396.935.933a.233.233 0 0 0 .388-.104l1.105-4.118a.232.232 0 0 0-.22-.292Z",
  fill: "currentColor",
  fillRule: "nonzero"
}))), zI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279v49.443a.278.278 0 0 1-.28.278H.28a.278.278 0 0 1-.28-.278V.279C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M12.044 8.506V4.29h.599v4.216zM14.425 8.506l-.939-2.561v2.561h-.605V4.29h.574l.932 2.555V4.29h.606v4.216zM16.248 4.29c.273 0 .506.097.7.29a.92.92 0 0 1 .296.692v2.19c0 .31-.095.561-.284.754a.979.979 0 0 1-.73.29h-.94V4.29h.958Zm.397 3.171v-2.19a.383.383 0 0 0-.132-.295.432.432 0 0 0-.31-.12h-.314v3.09h.296c.307 0 .46-.162.46-.485ZM19.419 8.065a1.09 1.09 0 0 1-.36.346.894.894 0 0 1-.479.133.96.96 0 0 1-.264-.038 1.497 1.497 0 0 1-.24-.095 1.214 1.214 0 0 1-.202-.138.603.603 0 0 1-.132-.17 1.324 1.324 0 0 1-.126-.308 1.51 1.51 0 0 1-.025-.283V4.29h.605v3.303l.012.063a.515.515 0 0 0 .095.177c.055.075.15.113.284.113.121 0 .212-.044.27-.132a.524.524 0 0 0 .095-.302V4.29h.605v3.222c0 .1-.01.197-.031.29a.897.897 0 0 1-.107.263ZM20.403 7.455v.107c0 .03.002.055.006.076.008.041.04.102.095.182.058.084.163.126.315.126a.542.542 0 0 0 .233-.05.35.35 0 0 0 .202-.277.582.582 0 0 0 .012-.114v-.409a.384.384 0 0 0-.05-.214.645.645 0 0 0-.227-.182c-.08-.042-.223-.1-.429-.176a1.212 1.212 0 0 1-.517-.359c-.138-.163-.208-.386-.208-.667V5.31c0-.289.097-.536.29-.742a.95.95 0 0 1 .719-.315.96.96 0 0 1 .73.309c.198.205.297.455.297.748v.19h-.605v-.19a.496.496 0 0 0-.006-.081.263.263 0 0 0-.038-.145 1.444 1.444 0 0 0-.07-.107c-.058-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.113.327v.246c0 .084.012.15.037.201a.58.58 0 0 0 .202.158c.034.016.084.04.151.069.072.025.158.056.259.094.201.067.382.187.542.359.16.172.24.398.24.68v.34c0 .146-.016.27-.045.37-.025.101-.111.248-.258.44-.147.185-.393.278-.738.278-.365 0-.63-.118-.794-.353a1.288 1.288 0 0 1-.246-.736v-.151h.612v.151Z"
}), /* @__PURE__ */ z.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M22.501 8.506V4.85h-.712v-.56h2.035v.56H23.1v3.656zM23.948 8.506V4.29h1.06a.94.94 0 0 1 .699.29c.193.193.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.932h-.643L24.932 6.7h-.379v1.806h-.605Zm1.343-2.473a.366.366 0 0 0 .075-.157.707.707 0 0 0 .026-.195v-.39a.454.454 0 0 0-.107-.315.376.376 0 0 0-.303-.126h-.429v1.315h.423a.417.417 0 0 0 .315-.132ZM26.728 8.506V6.694l-.819-2.404h.63l.492 1.649.498-1.649h.636l-.838 2.404v1.812zM27.797 8.953V7.908h.605v.598zM29.32 8.506V4.29h.599v4.216zM31.773 8.506l-.939-2.561v2.561h-.605V4.29h.573l.933 2.555V4.29h.605v4.216zM34.053 8.506l-.94-2.561v2.561h-.605V4.29h.574l.933 2.555V4.29h.605v4.216zM34.988 4.687a1.02 1.02 0 0 1 .366-.315 1.012 1.012 0 0 1 .901-.025.975.975 0 0 1 .536.598c.034.113.05.237.05.37v2.146c0 .126-.012.237-.037.334a.943.943 0 0 1-.152.32.938.938 0 0 1-.334.303.928.928 0 0 1-.479.126c-.1 0-.197-.013-.29-.038a1.307 1.307 0 0 1-.258-.113 1.172 1.172 0 0 1-.214-.158.785.785 0 0 1-.139-.182 1.2 1.2 0 0 1-.113-.315 1.805 1.805 0 0 1-.02-.277V5.316c0-.126.013-.237.039-.334.029-.1.077-.199.144-.295Zm1.173.333a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.531.531 0 0 0-.05.15.824.824 0 0 0-.013.127V7.53c0 .02.002.044.006.069a.577.577 0 0 0 .101.207c.063.089.168.133.315.133a.4.4 0 0 0 .202-.05.347.347 0 0 0 .132-.127.461.461 0 0 0 .057-.138.86.86 0 0 0 .012-.164V5.316a.832.832 0 0 0-.012-.176.255.255 0 0 0-.063-.12ZM37.776 8.506l-.864-4.216h.63l.492 2.926.498-2.926h.643l-.883 4.216zM38.913 8.506l.946-4.216h.523l.945 4.216h-.649l-.17-.906h-.782l-.176.906h-.637Zm.92-1.466h.568l-.284-1.535-.284 1.535ZM41.733 8.506V4.85h-.712v-.56h2.036v.56h-.725v3.656zM43.169 8.506V4.29h.599v4.216zM44.216 4.687a1.02 1.02 0 0 1 .366-.315 1.012 1.012 0 0 1 .901-.025.975.975 0 0 1 .536.598c.034.113.05.237.05.37v2.146c0 .126-.012.237-.037.334a.943.943 0 0 1-.152.32.938.938 0 0 1-.334.303.928.928 0 0 1-.479.126c-.1 0-.197-.013-.29-.038a1.307 1.307 0 0 1-.258-.113 1.172 1.172 0 0 1-.214-.158.785.785 0 0 1-.139-.182 1.2 1.2 0 0 1-.113-.315 1.805 1.805 0 0 1-.02-.277V5.316c0-.126.013-.237.039-.334.029-.1.077-.199.144-.295Zm1.173.333a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.531.531 0 0 0-.05.15.824.824 0 0 0-.013.127V7.53c0 .02.002.044.006.069a.577.577 0 0 0 .101.207c.063.089.168.133.315.133a.4.4 0 0 0 .202-.05.347.347 0 0 0 .132-.127.461.461 0 0 0 .057-.138.856.856 0 0 0 .013-.164V5.316a.826.826 0 0 0-.013-.176.252.252 0 0 0-.063-.12ZM47.975 8.506l-.939-2.561v2.561h-.605V4.29h.573l.933 2.555V4.29h.605v4.216zM11.845 14.32l.946-4.216h.523l.945 4.215h-.65l-.17-.906h-.78l-.177.906h-.637Zm.92-1.467h.568l-.284-1.535-.284 1.535ZM15.846 14.319l-.939-2.561v2.561h-.605v-4.215h.573l.933 2.554v-2.554h.605v4.215zM17.682 10.104c.273 0 .507.096.7.29a.92.92 0 0 1 .296.691v2.19c0 .31-.094.562-.284.755a.979.979 0 0 1-.73.29h-.94v-4.216h.958Zm.397 3.17v-2.189a.383.383 0 0 0-.132-.296.432.432 0 0 0-.309-.119h-.315v3.09h.296c.307 0 .46-.162.46-.485ZM19.548 14.319v-4.215h.599v4.215zM21.98 14.319l-.939-2.561v2.561h-.605v-4.215h.574l.933 2.554v-2.554h.605v4.215zM22.737 14.319v-4.215h1.803v.566h-1.204v1.265h1.052v.566h-1.052v1.818zM24.628 14.32v-4.216h1.06a.94.94 0 0 1 .699.29c.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.642 1.931h-.642l-.568-1.805h-.378v1.805h-.605Zm1.343-2.473a.366.366 0 0 0 .075-.158.707.707 0 0 0 .026-.195v-.39a.454.454 0 0 0-.108-.315.376.376 0 0 0-.302-.125h-.429v1.315h.423a.417.417 0 0 0 .315-.132Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "m26.74 14.32.944-4.216h.524l.945 4.215h-.65l-.17-.906h-.78l-.177.906h-.637Zm.92-1.467h.566l-.283-1.535-.284 1.535ZM29.643 13.269v.107c0 .029.002.054.007.075.008.042.04.103.094.183.059.083.164.125.315.125a.542.542 0 0 0 .233-.05.35.35 0 0 0 .202-.277.582.582 0 0 0 .013-.113v-.409a.384.384 0 0 0-.05-.214.644.644 0 0 0-.228-.182c-.08-.042-.222-.101-.428-.177a1.212 1.212 0 0 1-.517-.358c-.139-.164-.208-.386-.208-.667v-.189c0-.29.097-.537.29-.742a.95.95 0 0 1 .718-.315.96.96 0 0 1 .732.308c.197.206.296.455.296.75v.188h-.605v-.189a.5.5 0 0 0-.007-.082.354.354 0 0 0-.006-.069.265.265 0 0 0-.031-.075 1.446 1.446 0 0 0-.07-.107c-.059-.084-.157-.126-.296-.126a.39.39 0 0 0-.303.132.485.485 0 0 0-.113.327v.245c0 .084.013.151.038.202a.58.58 0 0 0 .202.157c.033.017.084.04.15.07.072.024.158.056.26.094.2.067.382.186.541.358.16.172.24.399.24.68v.34c0 .146-.015.27-.044.37-.026.102-.112.248-.259.441-.147.185-.393.277-.737.277-.366 0-.63-.117-.794-.352a1.288 1.288 0 0 1-.246-.736v-.151h.611v.15Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M31.722 14.319v-3.655h-.712v-.56h2.036v.56h-.725v3.655zM33.153 14.32v-4.216h1.06c.276 0 .51.096.699.29.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.931h-.643l-.567-1.805h-.379v1.805h-.605Zm1.343-2.473a.368.368 0 0 0 .075-.158.718.718 0 0 0 .025-.195v-.39a.453.453 0 0 0-.107-.315.376.376 0 0 0-.302-.125h-.429v1.315h.423a.418.418 0 0 0 .315-.132ZM37.168 13.879a1.086 1.086 0 0 1-.36.346.894.894 0 0 1-.478.132.959.959 0 0 1-.265-.038 1.495 1.495 0 0 1-.24-.094 1.214 1.214 0 0 1-.2-.138.604.604 0 0 1-.133-.17 1.315 1.315 0 0 1-.126-.309 1.504 1.504 0 0 1-.025-.283v-3.221h.605v3.303l.012.063a.52.52 0 0 0 .095.176c.054.076.149.113.283.113.122 0 .213-.044.271-.132a.524.524 0 0 0 .095-.302v-3.221h.605v3.221c0 .1-.01.197-.031.29a.89.89 0 0 1-.108.264ZM39.601 13.256c0 .134-.008.25-.025.346a.884.884 0 0 1-.271.485 1.082 1.082 0 0 1-.41.232.773.773 0 0 1-.233.038c-.19 0-.361-.04-.517-.12a.81.81 0 0 1-.334-.301 1.11 1.11 0 0 1-.138-.34 2.14 2.14 0 0 1-.026-.34v-2.17c0-.118.01-.223.032-.315a.994.994 0 0 1 .15-.309.914.914 0 0 1 .322-.276.86.86 0 0 1 .435-.12c.29 0 .532.096.725.29.194.188.29.431.29.73v.226h-.599v-.227a.443.443 0 0 0-.1-.295c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.278.12a.463.463 0 0 0-.094.295v2.335a.549.549 0 0 0 .088.214c.06.083.156.125.29.125.143 0 .238-.037.284-.113a.71.71 0 0 0 .082-.163.721.721 0 0 0 .012-.151v-.214h.6v.138ZM40.363 14.319v-3.655h-.712v-.56h2.035v.56h-.725v3.655zM43.606 13.879a1.092 1.092 0 0 1-.359.346.894.894 0 0 1-.479.132.96.96 0 0 1-.265-.038 1.491 1.491 0 0 1-.239-.094 1.231 1.231 0 0 1-.202-.138.61.61 0 0 1-.132-.17 1.33 1.33 0 0 1-.126-.309 1.504 1.504 0 0 1-.026-.283v-3.221h.605v3.303l.013.063a.514.514 0 0 0 .095.176c.055.076.15.113.283.113.122 0 .212-.044.271-.132a.524.524 0 0 0 .095-.302v-3.221h.605v3.221c0 .1-.01.197-.032.29a.898.898 0 0 1-.107.264ZM44.035 14.32v-4.216h1.059c.277 0 .51.096.7.29.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.642 1.931h-.642l-.568-1.805h-.378v1.805h-.605Zm1.343-2.473a.365.365 0 0 0 .075-.158.705.705 0 0 0 .026-.195v-.39a.453.453 0 0 0-.108-.315.375.375 0 0 0-.302-.125h-.429v1.315h.423c.125 0 .23-.044.315-.132ZM48.072 13.715v.604h-1.809v-4.215h1.809v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM5.144 9.139a1.401 1.401 0 0 1-.136-.392 8.049 8.049 0 0 1-.015-.572V6.127c0-.22.035-.421.106-.602.04-.1.1-.22.18-.361.091-.14.207-.311.348-.512.281-.392.784-.587 1.508-.587.683 0 1.211.23 1.583.692.392.452.588.974.588 1.566v1.641c0 .392-.08.783-.241 1.175l-1.9 5.104H5.52L7.21 9.997c-.261.06-.462.09-.603.09a1.64 1.64 0 0 1-.89-.256 1.594 1.594 0 0 1-.573-.692ZM7.18 5.48c-.241 0-.422.085-.543.256a.95.95 0 0 0-.181.587v1.641c0 .251.065.457.196.618.13.16.322.24.573.24.221 0 .382-.075.483-.225.11-.161.166-.372.166-.633v-1.64c0-.252-.056-.453-.166-.603-.1-.16-.277-.241-.528-.241Z"
}), /* @__PURE__ */ z.createElement("path", {
  strokeWidth: 1.6,
  stroke: "currentColor",
  strokeLinejoin: "round",
  d: "M31.874 22.455v7.072l-6.135 3.536-6.135-3.536v-7.072l6.135-3.537zM38.056 33.091v7.072l-6.134 3.536-6.135-3.536v-7.072l6.135-3.536zM25.739 33.063v7.073l-6.135 3.536-6.135-3.536v-7.073l6.135-3.536z"
}), /* @__PURE__ */ z.createElement("path", {
  strokeWidth: 1.6,
  stroke: "currentColor",
  strokeLinejoin: "round",
  d: "M19.584 43.739V29.46l6.087-3.508 12.385 7.139-12.269 7.072-6.183-3.563-.02 7.139"
}), /* @__PURE__ */ z.createElement("path", {
  strokeWidth: 1.6,
  stroke: "currentColor",
  strokeLinejoin: "round",
  d: "M25.787 25.885v7.151"
}), /* @__PURE__ */ z.createElement("path", {
  strokeWidth: 1.6,
  stroke: "currentColor",
  className: "color stroke",
  fillRule: "nonzero",
  strokeLinejoin: "round",
  d: "m25.688 25.942 6.203-3.576-6.104-3.519-6.203 3.576zM19.583 36.611l6.203-3.575-6.104-3.519-6.203 3.576zM25.718 40.124l6.203 3.575v-7.037l-6.203-3.576z"
}))), _I = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  fillOpacity: 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279v49.443a.278.278 0 0 1-.28.278H.28a.278.278 0 0 1-.28-.278V.279C0 .124.125 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M16.14 8.506V4.29h1.06a.94.94 0 0 1 .7.29c.192.193.289.43.289.71v.39a.99.99 0 0 1-.498.894l.643 1.932h-.643L17.124 6.7h-.378v1.806h-.605Zm1.343-2.473a.366.366 0 0 0 .076-.157.707.707 0 0 0 .025-.195v-.39a.454.454 0 0 0-.107-.315.376.376 0 0 0-.303-.126h-.428v1.315h.422a.418.418 0 0 0 .315-.132ZM20.402 7.902v.604h-1.809V4.29h1.809v.554h-1.21V6.09h1.059v.572h-1.059v1.24zM21.65 4.29c.272 0 .506.097.699.29a.92.92 0 0 1 .296.692v2.19c0 .31-.094.561-.283.754a.979.979 0 0 1-.732.29h-.939V4.29h.958Zm.396 3.171v-2.19a.383.383 0 0 0-.132-.295.432.432 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.162.46-.485ZM25.08 8.065a1.09 1.09 0 0 1-.36.346.894.894 0 0 1-.479.133.96.96 0 0 1-.264-.038 1.498 1.498 0 0 1-.24-.095 1.215 1.215 0 0 1-.201-.138.603.603 0 0 1-.133-.17 1.323 1.323 0 0 1-.126-.308 1.51 1.51 0 0 1-.025-.283V4.29h.605v3.303l.013.063a.515.515 0 0 0 .094.177c.055.075.15.113.284.113.122 0 .212-.044.27-.132a.525.525 0 0 0 .095-.302V4.29h.605v3.222c0 .1-.01.197-.031.29a.896.896 0 0 1-.107.263ZM27.655 7.442c0 .135-.009.25-.025.347a.796.796 0 0 1-.126.314.892.892 0 0 1-.145.17 1.1 1.1 0 0 1-.19.138c-.067.038-.14.07-.22.095a.773.773 0 0 1-.233.038c-.19 0-.362-.04-.517-.12a.812.812 0 0 1-.334-.302 1.115 1.115 0 0 1-.139-.34 2.15 2.15 0 0 1-.025-.34v-2.17c0-.118.01-.223.032-.315a.992.992 0 0 1 .15-.308.912.912 0 0 1 .322-.277.86.86 0 0 1 .435-.12c.29 0 .532.097.725.29.193.189.29.432.29.73v.226h-.599v-.226a.443.443 0 0 0-.1-.296c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.278.12a.462.462 0 0 0-.094.296v2.334a.55.55 0 0 0 .088.214c.059.084.155.126.29.126.143 0 .237-.038.284-.113a.71.71 0 0 0 .081-.164.725.725 0 0 0 .013-.151v-.214h.599v.138ZM29.924 7.902v.604h-1.809V4.29h1.809v.554h-1.21V6.09h1.059v.572h-1.059v1.24zM31.171 4.29c.274 0 .507.097.7.29a.92.92 0 0 1 .296.692v2.19c0 .31-.094.561-.283.754a.979.979 0 0 1-.731.29h-.94V4.29h.958Zm.398 3.171v-2.19a.383.383 0 0 0-.133-.295.432.432 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.162.46-.485ZM16.228 14.319v-4.215h.599v4.215zM18.865 14.319l-.939-2.561v2.561h-.605v-4.215h.574l.932 2.554v-2.554h.605v4.215zM21.614 13.715v.604h-1.809v-4.215h1.809v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM22.058 13.992a.83.83 0 0 1-.195-.333 1.724 1.724 0 0 1-.045-.416v-2.095c0-.306.097-.562.29-.767a.979.979 0 0 1 .744-.315 1 1 0 0 1 .712.296.952.952 0 0 1 .303.704v2.177c0 .122-.007.212-.02.271a.696.696 0 0 1-.05.176l.397.334-.334.402-.378-.302a1.022 1.022 0 0 1-1.084.126 1.105 1.105 0 0 1-.34-.258Zm1.002-.906.202.157v-2.095a.519.519 0 0 0-.114-.34.378.378 0 0 0-.315-.144.394.394 0 0 0-.36.214.556.556 0 0 0-.043.138c-.005.03-.007.073-.007.132v2.14c0 .121.034.23.101.327.072.092.18.14.328.144a.397.397 0 0 0 .151-.037l-.277-.233.334-.403ZM26.173 13.879a1.09 1.09 0 0 1-.36.346.894.894 0 0 1-.478.132.96.96 0 0 1-.265-.038 1.494 1.494 0 0 1-.24-.094 1.218 1.218 0 0 1-.201-.138.603.603 0 0 1-.132-.17 1.324 1.324 0 0 1-.126-.309 1.51 1.51 0 0 1-.026-.283v-3.221h.605v3.303l.013.063a.516.516 0 0 0 .094.176c.055.076.15.113.284.113.122 0 .212-.044.271-.132a.524.524 0 0 0 .095-.302v-3.221h.605v3.221c0 .1-.01.197-.032.29a.896.896 0 0 1-.107.264ZM26.552 14.32l.945-4.216h.523l.946 4.215h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.467h.567l-.284-1.535-.283 1.535ZM31.082 14.319H29.28v-4.215h.605v3.611h1.197zM31.212 14.319v-4.215h.599v4.215zM32.912 14.319v-3.655H32.2v-.56h2.035v.56h-.724v3.655zM34.43 14.319v-4.215h.599v4.215zM37.352 13.715v.604h-1.809v-4.215h1.809v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM38.109 13.269v.107c0 .029.002.054.006.075.009.042.04.103.095.183.059.083.164.125.315.125a.543.543 0 0 0 .233-.05.378.378 0 0 0 .157-.145.346.346 0 0 0 .045-.132.578.578 0 0 0 .012-.113v-.409a.382.382 0 0 0-.05-.214c-.034-.054-.11-.115-.227-.182-.08-.042-.223-.101-.428-.177a1.213 1.213 0 0 1-.517-.358c-.14-.164-.208-.386-.208-.667v-.189c0-.29.096-.537.29-.742a.95.95 0 0 1 .718-.315.96.96 0 0 1 .731.308c.198.206.296.455.296.75v.188h-.605v-.189a.516.516 0 0 0-.006-.082.364.364 0 0 0-.006-.069.266.266 0 0 0-.032-.075 1.492 1.492 0 0 0-.07-.107c-.058-.084-.157-.126-.295-.126a.39.39 0 0 0-.303.132.485.485 0 0 0-.113.327v.245c0 .084.012.151.037.202a.58.58 0 0 0 .202.157c.034.017.084.04.151.07.072.024.158.056.259.094.201.067.382.186.542.358.16.172.24.399.24.68v.34c0 .146-.015.27-.045.37-.025.102-.111.248-.258.441-.147.185-.393.277-.738.277-.365 0-.63-.117-.794-.352a1.288 1.288 0 0 1-.246-.736v-.151h.612v.15ZM4.921 14.243V5.661L3.473 6.745V5.209l1.448-1.054h1.433v10.088zM9.857 14.273c-1.066-.19-1.684-.813-1.855-1.867v-6.49c.13-.792.478-1.324 1.04-1.595.373-.17.76-.256 1.162-.256.251 0 .513.03.784.09.362.22.654.457.875.708.221.24.372.592.452 1.054v6.459c-.14.983-.663 1.61-1.568 1.882h-.287c-.05.01-.251.015-.603.015Zm.15-1.446c.443 0 .725-.2.845-.602V6.142a2.331 2.331 0 0 0-.196-.466c-.17-.13-.337-.196-.497-.196a.53.53 0 0 0-.423.196c-.11.12-.196.276-.256.466v6.053c.06.311.236.522.528.632Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M20.422 26.906v3.172h9.524v-3.172h-9.524Zm0 5.871v3.224h9.524v-3.224h-9.524Zm4.752-14.474-4.73 4.723h9.46l-4.73-4.723Zm-8.377 8.364-4.72 4.713 4.72 4.713v-9.426Zm16.774.02v9.358l4.687-4.679-4.687-4.68ZM20.531 39.82l4.63 4.622 4.629-4.622H20.53Z",
  fill: "currentColor"
}))), II = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  "fill-transparent": 0,
  d: "M.28 0H49.72c.155 0 .279.124.279.279v49.443a.278.278 0 0 1-.279.278H.28A.278.278 0 0 1 0 49.722V.279C0 .124.125 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M14.403 7.455v.107c0 .03.002.055.006.076.008.041.04.102.094.182.06.084.164.126.316.126a.542.542 0 0 0 .233-.05.35.35 0 0 0 .202-.277.582.582 0 0 0 .012-.114v-.409a.384.384 0 0 0-.05-.214.644.644 0 0 0-.227-.182c-.08-.042-.223-.1-.429-.176a1.212 1.212 0 0 1-.517-.359c-.138-.163-.208-.386-.208-.667V5.31c0-.289.097-.536.29-.742a.95.95 0 0 1 .719-.315.96.96 0 0 1 .73.309c.198.205.297.455.297.748v.19h-.605v-.19a.5.5 0 0 0-.006-.081.351.351 0 0 0-.007-.07.265.265 0 0 0-.031-.075 1.446 1.446 0 0 0-.07-.107c-.058-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.114.327v.246c0 .084.013.15.038.201a.58.58 0 0 0 .202.158c.034.016.084.04.151.069.072.025.158.056.259.094.201.067.382.187.542.359.16.172.24.398.24.68v.34c0 .146-.016.27-.045.37-.025.101-.111.248-.258.44-.147.185-.393.278-.738.278-.365 0-.63-.118-.794-.353a1.288 1.288 0 0 1-.246-.736v-.151h.612v.151ZM18.11 8.065a1.09 1.09 0 0 1-.359.346.894.894 0 0 1-.479.133.96.96 0 0 1-.265-.038 1.497 1.497 0 0 1-.24-.095 1.214 1.214 0 0 1-.2-.138.603.603 0 0 1-.133-.17 1.323 1.323 0 0 1-.126-.308 1.51 1.51 0 0 1-.025-.283V4.29h.605v3.303l.012.063a.514.514 0 0 0 .095.177c.054.075.149.113.283.113.122 0 .213-.044.271-.132a.524.524 0 0 0 .095-.302V4.29h.605v3.222c0 .1-.01.197-.032.29a.896.896 0 0 1-.107.263ZM19.135 7.455v.107c0 .03.002.055.007.076.008.041.04.102.094.182.059.084.164.126.315.126a.542.542 0 0 0 .233-.05.35.35 0 0 0 .202-.277.584.584 0 0 0 .013-.114v-.409a.384.384 0 0 0-.05-.214.645.645 0 0 0-.228-.182 4.06 4.06 0 0 0-.428-.176 1.212 1.212 0 0 1-.517-.359c-.139-.163-.208-.386-.208-.667V5.31c0-.289.097-.536.29-.742a.95.95 0 0 1 .718-.315.96.96 0 0 1 .732.309c.197.205.296.455.296.748v.19h-.605v-.19a.5.5 0 0 0-.007-.081.351.351 0 0 0-.006-.07.265.265 0 0 0-.031-.075 1.446 1.446 0 0 0-.07-.107c-.059-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.114.327v.246c0 .084.013.15.038.201a.58.58 0 0 0 .202.158c.033.016.084.04.15.069.072.025.158.056.26.094.2.067.382.187.541.359.16.172.24.398.24.68v.34c0 .146-.015.27-.044.37-.026.101-.112.248-.259.44-.147.185-.393.278-.737.278-.366 0-.63-.118-.794-.353a1.288 1.288 0 0 1-.246-.736v-.151h.611v.151ZM21.419 8.506V4.85h-.712v-.56h2.035v.56h-.724v3.656zM22.432 8.506l.945-4.216h.523l.946 4.216h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.284-1.535-.283 1.535ZM25.154 8.506V4.29h.599v4.216zM27.749 8.506l-.939-2.561v2.561h-.605V4.29h.573l.933 2.555V4.29h.605v4.216zM28.409 8.506l.945-4.216h.523l.946 4.216h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.283-1.535-.284 1.535ZM32.044 4.29c.13 0 .252.027.366.082.126.059.254.153.384.283.139.134.208.344.208.63v.32c0 .323-.128.55-.384.68.256.15.384.386.384.704v.491a.996.996 0 0 1-.29.736.979.979 0 0 1-.73.29h-.934V4.29h.996Zm.36 1.252v-.258a.397.397 0 0 0-.416-.428h-.34V6.02h.358c.14 0 .24-.041.303-.125a.593.593 0 0 0 .094-.353Zm0 1.938v-.49a.425.425 0 0 0-.114-.315.385.385 0 0 0-.302-.12h-.34v1.353h.346a.39.39 0 0 0 .296-.12.444.444 0 0 0 .113-.308ZM35.12 8.506h-1.802V4.29h.605v3.612h1.197zM37.099 7.902v.604h-1.808V4.29h1.808v.554h-1.21V6.09h1.059v.572h-1.059v1.24zM39.833 7.442c0 .135-.009.25-.026.347a.884.884 0 0 1-.271.485 1.082 1.082 0 0 1-.41.232.773.773 0 0 1-.233.038c-.189 0-.36-.04-.516-.12a.814.814 0 0 1-.334-.302 1.117 1.117 0 0 1-.139-.34 2.14 2.14 0 0 1-.025-.34v-2.17c0-.118.01-.223.031-.315a.994.994 0 0 1 .152-.308.914.914 0 0 1 .32-.277.86.86 0 0 1 .436-.12c.29 0 .531.097.725.29.193.189.29.432.29.73v.226h-.6v-.226a.443.443 0 0 0-.1-.296c-.063-.08-.158-.12-.283-.12-.118 0-.21.04-.278.12a.463.463 0 0 0-.095.296v2.334a.549.549 0 0 0 .089.214c.059.084.155.126.29.126.142 0 .237-.038.283-.113a.71.71 0 0 0 .082-.164.721.721 0 0 0 .013-.151v-.214h.598v.138ZM40.191 8.506V4.29h.599v4.216zM41.769 8.506V4.85h-.712v-.56h2.035v.56h-.724v3.656zM43.348 8.506V4.29h.599v4.216zM46.086 7.902v.604h-1.809V4.29h1.809v.554h-1.21V6.09h1.059v.572h-1.059v1.24zM46.884 7.455v.107c0 .03.002.055.006.076.009.041.04.102.095.182.059.084.164.126.315.126a.543.543 0 0 0 .233-.05.378.378 0 0 0 .158-.145.346.346 0 0 0 .044-.132.578.578 0 0 0 .012-.114v-.409a.382.382 0 0 0-.05-.214.647.647 0 0 0-.227-.182c-.08-.042-.223-.1-.428-.176a1.213 1.213 0 0 1-.517-.359c-.139-.163-.208-.386-.208-.667V5.31c0-.289.096-.536.29-.742a.95.95 0 0 1 .718-.315.96.96 0 0 1 .731.309c.198.205.296.455.296.748v.19h-.605v-.19a.516.516 0 0 0-.006-.081.364.364 0 0 0-.006-.07.277.277 0 0 0-.032-.075 1.492 1.492 0 0 0-.07-.107c-.058-.084-.156-.126-.295-.126a.39.39 0 0 0-.303.132.485.485 0 0 0-.113.327v.246c0 .084.012.15.038.201a.58.58 0 0 0 .201.158c.034.016.084.04.151.069.072.025.158.056.26.094.2.067.381.187.541.359.16.172.24.398.24.68v.34c0 .146-.015.27-.045.37-.025.101-.11.248-.258.44-.147.185-.393.278-.738.278-.365 0-.63-.118-.794-.353a1.288 1.288 0 0 1-.245-.736v-.151h.611v.151ZM13.797 14.32l.946-4.216h.523l.945 4.215h-.65l-.17-.906h-.78l-.177.906h-.637Zm.92-1.467h.568L15 11.318l-.284 1.535ZM17.981 14.319l-.939-2.561v2.561h-.605v-4.215h.573l.933 2.554v-2.554h.605v4.215zM19.879 10.104c.273 0 .506.096.7.29a.92.92 0 0 1 .296.691v2.19c0 .31-.095.562-.284.755a.979.979 0 0 1-.731.29h-.94v-4.216h.959Zm.397 3.17v-2.189a.383.383 0 0 0-.132-.296.432.432 0 0 0-.31-.119h-.314v3.09h.296c.307 0 .46-.162.46-.485ZM23.865 13.256c0 .134-.009.25-.026.346a.796.796 0 0 1-.126.315.892.892 0 0 1-.145.17 1.1 1.1 0 0 1-.189.138c-.067.038-.14.07-.22.094a.773.773 0 0 1-.234.038c-.189 0-.36-.04-.516-.12a.812.812 0 0 1-.334-.301 1.115 1.115 0 0 1-.139-.34 2.15 2.15 0 0 1-.025-.34v-2.17c0-.118.01-.223.031-.315a.992.992 0 0 1 .152-.309.912.912 0 0 1 .321-.276.86.86 0 0 1 .435-.12c.29 0 .531.096.725.29.193.188.29.431.29.73v.226h-.6v-.227a.443.443 0 0 0-.1-.295c-.063-.08-.158-.12-.284-.12-.117 0-.21.04-.277.12a.462.462 0 0 0-.094.295v2.335a.55.55 0 0 0 .088.214c.059.083.155.125.29.125.142 0 .237-.037.283-.113a.71.71 0 0 0 .082-.163.725.725 0 0 0 .013-.151v-.214h.599v.138ZM24.443 10.5c.097-.134.219-.239.366-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.597 1.3 1.3 0 0 1 .05.371v2.146c0 .126-.013.237-.038.333a.948.948 0 0 1-.151.321.94.94 0 0 1-.334.302.928.928 0 0 1-.48.126c-.1 0-.197-.012-.289-.038a1.301 1.301 0 0 1-.473-.27.778.778 0 0 1-.138-.183 1.21 1.21 0 0 1-.114-.314 1.793 1.793 0 0 1-.019-.277v-2.146c0-.126.013-.237.038-.333.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.327-.177.42.42 0 0 0-.215.063.373.373 0 0 0-.145.132.532.532 0 0 0-.05.151.792.792 0 0 0-.013.126V13.345c0 .02.002.043.007.068a.581.581 0 0 0 .1.208c.064.088.169.132.316.132a.4.4 0 0 0 .201-.05.35.35 0 0 0 .133-.126.46.46 0 0 0 .056-.138.864.864 0 0 0 .013-.164v-2.146a.835.835 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM28.645 14.319v-2.567l-.605 1.8h-.302l-.599-1.8v2.567h-.605v-4.215h.567l.801 2.246.787-2.246h.555v4.215zM31.598 14.319v-2.567l-.605 1.8h-.302l-.599-1.8v2.567h-.605v-4.215h.567l.801 2.246.787-2.246h.555v4.215zM34.47 13.879a1.09 1.09 0 0 1-.359.346.893.893 0 0 1-.478.132.961.961 0 0 1-.265-.038 1.494 1.494 0 0 1-.24-.094 1.218 1.218 0 0 1-.201-.138.603.603 0 0 1-.133-.17 1.325 1.325 0 0 1-.126-.309 1.51 1.51 0 0 1-.025-.283v-3.221h.605v3.303l.013.063a.516.516 0 0 0 .094.176c.055.076.15.113.284.113.121 0 .212-.044.27-.132a.524.524 0 0 0 .095-.302v-3.221h.605v3.221c0 .1-.01.197-.031.29a.89.89 0 0 1-.107.264ZM36.511 14.319l-.939-2.561v2.561h-.605v-4.215h.573l.933 2.554v-2.554h.605v4.215zM37.41 14.319v-4.215h.599v4.215zM39.111 14.319v-3.655h-.713v-.56h2.036v.56h-.725v3.655zM40.567 14.319v-4.215h.599v4.215zM43.346 13.715v.604h-1.809v-4.215h1.809v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM44.062 13.269v.107c0 .029.003.054.007.075.008.042.04.103.094.183.059.083.164.125.315.125a.541.541 0 0 0 .233-.05.352.352 0 0 0 .202-.277.605.605 0 0 0 .013-.113v-.409a.385.385 0 0 0-.05-.214.647.647 0 0 0-.227-.182c-.08-.042-.223-.101-.43-.177a1.21 1.21 0 0 1-.516-.358c-.139-.164-.208-.386-.208-.667v-.189c0-.29.097-.537.29-.742a.95.95 0 0 1 .718-.315c.295 0 .538.103.732.308.197.206.296.455.296.75v.188h-.605v-.189a.478.478 0 0 0-.007-.082.257.257 0 0 0-.038-.145 1.472 1.472 0 0 0-.069-.106c-.058-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.114.327v.245c0 .084.013.151.038.202a.58.58 0 0 0 .202.157c.033.017.084.04.15.07.072.024.159.056.26.094.201.067.382.186.541.358.16.172.24.399.24.68v.34c0 .146-.015.27-.044.37-.026.102-.112.248-.259.441-.147.185-.393.277-.737.277-.366 0-.63-.117-.794-.352a1.286 1.286 0 0 1-.246-.736v-.151h.611v.15ZM5.014 14.243V5.661L3.566 6.745V5.209l1.448-1.054h1.433v10.088zM8.845 14.243V5.661L7.397 6.745V5.209l1.448-1.054h1.432v10.088zM12.676 32.962l3.54 4.642c.132.173.096.377-.185.377h-7.22c-.282 0-.318-.204-.186-.377l3.54-4.642c.172-.225.342-.222.51 0Zm22.168 1.743h7.159c.167 0 .302.135.302.303v1.266a.302.302 0 0 1-.302.302h-7.16a.302.302 0 0 1-.302-.302v-1.266c0-.168.135-.303.303-.303Zm0 2.384a.302.302 0 0 0-.303.302v7.276c0 .167.135.302.303.302h7.159a.302.302 0 0 0 .302-.302V37.39a.302.302 0 0 0-.302-.302h-7.159Zm1.048 1.098h1.83c.167 0 .302.135.302.302v.847a.302.302 0 0 1-.303.302h-1.83a.301.301 0 0 1-.3-.302v-.847c0-.167.133-.302.3-.302Zm3.363 0h1.829c.167 0 .302.135.302.302v.847a.302.302 0 0 1-.302.302h-1.829a.302.302 0 0 1-.302-.302v-.847c0-.167.134-.302.302-.302Zm-3.363 2.485h1.83c.167 0 .302.135.302.302v.846a.302.302 0 0 1-.303.302h-1.83a.301.301 0 0 1-.3-.302v-.846c0-.167.133-.302.3-.302Zm3.363 0h1.829c.167 0 .302.135.302.302v.846a.302.302 0 0 1-.302.302h-1.829a.302.302 0 0 1-.302-.302v-.846c0-.167.134-.302.302-.302ZM17.638 19.664a.302.302 0 0 0-.303.303v24.7c0 .167.135.302.303.302h6.99a.302.302 0 0 0 .303-.302v-24.7a.302.302 0 0 0-.303-.303h-6.99Zm1.365 3.456h1.068c.168 0 .303.135.303.302v1.285a.302.302 0 0 1-.303.303h-1.068a.302.302 0 0 1-.302-.303v-1.285c0-.167.135-.302.302-.302Zm3.263 0h1.067c.168 0 .303.135.303.302v1.285a.302.302 0 0 1-.303.303h-1.067a.302.302 0 0 1-.303-.303v-1.285c0-.167.135-.302.303-.302Zm-3.263 4.277h1.068c.168 0 .303.135.303.302v1.285a.302.302 0 0 1-.303.302h-1.068a.302.302 0 0 1-.302-.302V27.7c0-.167.135-.302.302-.302Zm3.263 0h1.067c.168 0 .303.135.303.302v1.285a.302.302 0 0 1-.303.302h-1.067a.302.302 0 0 1-.303-.302V27.7c0-.167.135-.302.303-.302Zm-3.263 4.276h1.068c.168 0 .303.135.303.303v1.285a.302.302 0 0 1-.303.302h-1.068a.302.302 0 0 1-.302-.302v-1.285c0-.168.135-.303.302-.303Zm3.263 0h1.067c.168 0 .303.135.303.303v1.285a.302.302 0 0 1-.303.302h-1.067a.302.302 0 0 1-.303-.302v-1.285c0-.168.135-.303.303-.303Zm-3.263 4.277h1.068c.168 0 .303.135.303.302v1.285a.302.302 0 0 1-.303.303h-1.068a.302.302 0 0 1-.302-.303v-1.285c0-.167.135-.302.302-.302Zm3.263 0h1.067c.168 0 .303.135.303.302v1.285a.302.302 0 0 1-.303.303h-1.067a.302.302 0 0 1-.303-.303v-1.285c0-.167.135-.302.303-.302Zm-3.263 4.277h1.068c.168 0 .303.135.303.302v1.286a.302.302 0 0 1-.303.302h-1.068a.302.302 0 0 1-.302-.302v-1.286c0-.167.135-.302.302-.302Zm3.263 0h1.067c.168 0 .303.135.303.302v1.286a.302.302 0 0 1-.303.302h-1.067a.302.302 0 0 1-.303-.302v-1.286c0-.167.135-.302.303-.302Zm3.857-6.38v10.82c0 .167.135.302.303.302h6.89a.302.302 0 0 0 .302-.302v-20c0-.168-.221-.4-.487-.063l-6.743 8.525c-.23.29-.265.38-.265.718Zm6.461-6.768c.123 0 .143.293.143.418v1.82a.302.302 0 0 1-.302.303h-1.409c-.18 0-.485-.076-.302-.302l1.71-2.123c.067-.082.12-.115.16-.116Zm-1.988 3.575h1.829c.167 0 .302.134.302.302v.846a.302.302 0 0 1-.302.302h-1.829a.302.302 0 0 1-.303-.302v-.846c0-.168.135-.302.303-.302Zm-1.381.668c.12-.025.15.25.15.441v2.591a.302.302 0 0 1-.303.302h-1.734c-.168 0-.422-.133-.303-.302l2.037-2.893c.062-.089.113-.13.153-.14Zm1.381 1.808h1.829c.167 0 .302.135.302.303v.846a.302.302 0 0 1-.302.302h-1.829a.302.302 0 0 1-.303-.302v-.846c0-.168.135-.303.303-.303Zm-3.268 2.485h1.734c.167 0 .302.135.302.302v.847a.302.302 0 0 1-.302.302h-1.734a.302.302 0 0 1-.303-.302v-.847c0-.167.135-.302.303-.302Zm3.268 0h1.829c.167 0 .302.135.302.302v.847a.302.302 0 0 1-.302.302h-1.829a.302.302 0 0 1-.303-.302v-.847c0-.167.135-.302.303-.302Zm-3.268 2.572h1.734c.167 0 .302.135.302.302v.847a.302.302 0 0 1-.302.302h-1.734a.302.302 0 0 1-.303-.302v-.847c0-.167.135-.302.303-.302Zm3.268 0h1.829c.167 0 .302.135.302.302v.847a.302.302 0 0 1-.302.302h-1.829a.302.302 0 0 1-.303-.302v-.847c0-.167.135-.302.303-.302Zm-3.268 2.485h1.734c.167 0 .302.135.302.302v.846a.302.302 0 0 1-.302.302h-1.734a.302.302 0 0 1-.303-.302v-.846c0-.167.135-.302.303-.302Zm3.268 0h1.829c.167 0 .302.135.302.302v.846a.302.302 0 0 1-.302.302h-1.829a.302.302 0 0 1-.303-.302v-.846c0-.167.135-.302.303-.302ZM8.715 38.667a.302.302 0 0 0-.303.302v5.698c0 .167.135.302.303.302h2.444c0-.011-.004-.022-.004-.034V41.62c0-.261.21-.47.471-.47h1.539c.26 0 .47.209.47.47v3.316c0 .012-.002.023-.003.034h2.309a.302.302 0 0 0 .303-.302v-5.698a.302.302 0 0 0-.303-.302H8.715Z",
  fill: "currentColor",
  fillRule: "nonzero"
}))), DI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  "fill-transparent": 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279v49.443a.278.278 0 0 1-.28.278H.28a.278.278 0 0 1-.28-.278V.279C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M16.09 8.506V4.29h1.059a.94.94 0 0 1 .7.29c.193.193.29.43.29.71v.39a.99.99 0 0 1-.499.894l.643 1.932h-.643L17.073 6.7h-.378v1.806h-.605Zm1.342-2.473a.366.366 0 0 0 .076-.157.707.707 0 0 0 .025-.195v-.39a.453.453 0 0 0-.107-.315.376.376 0 0 0-.302-.126h-.429v1.315h.422a.418.418 0 0 0 .315-.132ZM20.255 7.902v.604h-1.809V4.29h1.809v.554h-1.21V6.09h1.059v.572h-1.059v1.24zM20.94 7.455v.107c0 .03.002.055.006.076.008.041.04.102.094.182.06.084.164.126.315.126a.542.542 0 0 0 .234-.05.35.35 0 0 0 .202-.277.584.584 0 0 0 .012-.114v-.409a.384.384 0 0 0-.05-.214.644.644 0 0 0-.227-.182c-.08-.042-.223-.1-.429-.176a1.212 1.212 0 0 1-.517-.359c-.138-.163-.208-.386-.208-.667V5.31c0-.289.097-.536.29-.742a.95.95 0 0 1 .719-.315.96.96 0 0 1 .73.309c.198.205.297.455.297.748v.19h-.605v-.19a.496.496 0 0 0-.006-.081.354.354 0 0 0-.007-.07.265.265 0 0 0-.031-.075 1.446 1.446 0 0 0-.07-.107c-.058-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.114.327v.246c0 .084.013.15.038.201a.58.58 0 0 0 .202.158c.033.016.084.04.151.069.071.025.158.056.258.094.202.067.383.187.542.359.16.172.24.398.24.68v.34c0 .146-.015.27-.044.37-.025.101-.112.248-.259.44-.147.185-.392.278-.737.278-.366 0-.63-.118-.794-.353a1.287 1.287 0 0 1-.246-.736v-.151h.611v.151ZM22.682 8.506V4.29h1.002c.126 0 .245.027.359.082.113.05.214.117.302.201.089.084.158.18.208.29a.762.762 0 0 1 .089.327v.673a.942.942 0 0 1-.082.39.958.958 0 0 1-.523.516.951.951 0 0 1-.379.076h-.371v1.66h-.605Zm1.279-2.353a.236.236 0 0 0 .07-.12.556.556 0 0 0 .018-.157v-.623a.404.404 0 0 0-.107-.29.37.37 0 0 0-.29-.12h-.365v1.43h.315a.864.864 0 0 0 .201-.02.386.386 0 0 0 .158-.1ZM25.122 4.687c.096-.135.218-.24.365-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.598c.034.113.05.237.05.37v2.146c0 .126-.012.237-.037.334a.948.948 0 0 1-.152.32.94.94 0 0 1-.334.303.928.928 0 0 1-.479.126c-.1 0-.197-.013-.29-.038a1.301 1.301 0 0 1-.472-.27.778.778 0 0 1-.139-.183c-.063-.13-.1-.235-.113-.315a1.793 1.793 0 0 1-.02-.277V5.316c0-.126.013-.237.039-.334.03-.1.077-.199.145-.295Zm1.172.333a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.532.532 0 0 0-.05.15.793.793 0 0 0-.013.127V7.53a.42.42 0 0 0 .006.069.581.581 0 0 0 .101.207c.063.089.168.133.315.133a.4.4 0 0 0 .202-.05.35.35 0 0 0 .132-.127.459.459 0 0 0 .057-.138.861.861 0 0 0 .012-.164V5.316a.832.832 0 0 0-.012-.176.254.254 0 0 0-.063-.12ZM28.952 8.506l-.939-2.561v2.561h-.605V4.29h.573l.933 2.555V4.29h.605v4.216zM30.307 7.455v.107c0 .03.002.055.007.076.008.041.04.102.094.182.059.084.164.126.315.126a.542.542 0 0 0 .233-.05.35.35 0 0 0 .202-.277.584.584 0 0 0 .013-.114v-.409a.384.384 0 0 0-.05-.214.644.644 0 0 0-.228-.182c-.08-.042-.222-.1-.428-.176a1.212 1.212 0 0 1-.517-.359c-.139-.163-.208-.386-.208-.667V5.31c0-.289.097-.536.29-.742a.95.95 0 0 1 .718-.315.96.96 0 0 1 .731.309c.198.205.297.455.297.748v.19h-.605v-.19a.496.496 0 0 0-.007-.081.264.264 0 0 0-.038-.145 1.446 1.446 0 0 0-.069-.107c-.059-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.114.327v.246c0 .084.013.15.038.201a.58.58 0 0 0 .202.158c.033.016.084.04.15.069.072.025.158.056.26.094.2.067.382.187.541.359.16.172.24.398.24.68v.34c0 .146-.015.27-.044.37-.026.101-.112.248-.259.44-.147.185-.393.278-.737.278-.366 0-.63-.118-.794-.353a1.288 1.288 0 0 1-.246-.736v-.151h.611v.151ZM32.107 8.506V4.29h.599v4.216zM34.128 4.29c.13 0 .252.027.366.082.125.059.254.153.384.283.138.134.208.344.208.63v.32c0 .323-.128.55-.385.68.257.15.385.386.385.704v.491a.997.997 0 0 1-.29.736.979.979 0 0 1-.73.29h-.934V4.29h.996Zm.36 1.252v-.258a.416.416 0 0 0-.114-.308.397.397 0 0 0-.303-.12h-.34V6.02h.359c.139 0 .24-.041.303-.125a.593.593 0 0 0 .094-.353Zm0 1.938v-.49a.425.425 0 0 0-.114-.315.385.385 0 0 0-.303-.12h-.34v1.353h.347a.39.39 0 0 0 .296-.12.444.444 0 0 0 .113-.308ZM37.201 8.506h-1.803V4.29h.605v3.612h1.198zM39.176 7.902v.604h-1.808V4.29h1.808v.554h-1.21V6.09h1.059v.572h-1.059v1.24zM18.012 13.256c0 .134-.008.25-.025.346a.796.796 0 0 1-.126.315.892.892 0 0 1-.145.17c-.055.05-.118.096-.19.138-.066.038-.14.07-.22.094a.773.773 0 0 1-.233.038c-.189 0-.361-.04-.517-.12a.812.812 0 0 1-.334-.301 1.115 1.115 0 0 1-.138-.34 2.15 2.15 0 0 1-.026-.34v-2.17c0-.118.01-.223.032-.315a.991.991 0 0 1 .151-.309.912.912 0 0 1 .322-.276.86.86 0 0 1 .434-.12c.29 0 .532.096.725.29.193.188.29.431.29.73v.226h-.599v-.227a.443.443 0 0 0-.1-.295c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.277.12a.462.462 0 0 0-.095.295v2.335a.55.55 0 0 0 .088.214c.06.083.156.125.29.125.143 0 .238-.037.284-.113a.71.71 0 0 0 .082-.163.725.725 0 0 0 .012-.151v-.214h.6v.138ZM18.672 10.5c.096-.134.218-.239.365-.314a1.014 1.014 0 0 1 .901-.025.975.975 0 0 1 .536.597c.034.113.05.237.05.371v2.146c0 .126-.012.237-.037.333a.947.947 0 0 1-.151.321.94.94 0 0 1-.334.302.928.928 0 0 1-.48.126c-.1 0-.197-.012-.29-.038a1.303 1.303 0 0 1-.472-.27.777.777 0 0 1-.139-.183c-.063-.13-.1-.235-.113-.314a1.793 1.793 0 0 1-.019-.277v-2.146c0-.126.013-.237.038-.333.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.328-.177.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.532.532 0 0 0-.05.151.79.79 0 0 0-.013.126V13.345c0 .02.002.043.006.068a.58.58 0 0 0 .101.208c.063.088.168.132.315.132a.4.4 0 0 0 .202-.05.35.35 0 0 0 .132-.126.46.46 0 0 0 .057-.138.86.86 0 0 0 .013-.164v-2.146a.832.832 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM22.473 14.319l-.939-2.561v2.561h-.605v-4.215h.573l.933 2.554v-2.554h.605v4.215zM23.8 13.269v.107c0 .029.002.054.006.075.008.042.04.103.094.183.059.083.164.125.315.125a.542.542 0 0 0 .234-.05.35.35 0 0 0 .202-.277.584.584 0 0 0 .012-.113v-.409a.384.384 0 0 0-.05-.214.644.644 0 0 0-.228-.182c-.08-.042-.222-.101-.428-.177a1.212 1.212 0 0 1-.517-.358c-.138-.164-.208-.386-.208-.667v-.189c0-.29.097-.537.29-.742a.95.95 0 0 1 .719-.315.96.96 0 0 1 .73.308c.198.206.297.455.297.75v.188h-.605v-.189a.496.496 0 0 0-.007-.082.354.354 0 0 0-.006-.069.264.264 0 0 0-.031-.075 1.444 1.444 0 0 0-.07-.107c-.058-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.114.327v.245c0 .084.013.151.038.202a.58.58 0 0 0 .202.157c.033.017.084.04.15.07.072.024.158.056.26.094.201.067.382.186.541.358.16.172.24.399.24.68v.34c0 .146-.015.27-.044.37-.025.102-.112.248-.259.441-.147.185-.393.277-.737.277-.366 0-.63-.117-.794-.352a1.287 1.287 0 0 1-.246-.736v-.151h.611v.15ZM27.37 13.879a1.09 1.09 0 0 1-.36.346.894.894 0 0 1-.479.132.96.96 0 0 1-.265-.038 1.494 1.494 0 0 1-.24-.094 1.218 1.218 0 0 1-.2-.138.603.603 0 0 1-.133-.17 1.325 1.325 0 0 1-.126-.309 1.51 1.51 0 0 1-.025-.283v-3.221h.605v3.303l.012.063a.516.516 0 0 0 .095.176c.054.076.149.113.283.113.122 0 .212-.044.271-.132a.524.524 0 0 0 .095-.302v-3.221h.605v3.221c0 .1-.01.197-.032.29a.897.897 0 0 1-.107.264ZM29.83 14.319v-2.567l-.605 1.8h-.303l-.599-1.8v2.567h-.605v-4.215h.568l.8 2.246.788-2.246h.554v4.215zM30.848 14.32v-4.216h1.002a.82.82 0 0 1 .36.081c.113.05.214.118.302.202.088.084.157.18.208.29a.762.762 0 0 1 .088.326V11.677a.942.942 0 0 1-.082.39.958.958 0 0 1-.523.516.95.95 0 0 1-.378.075h-.372v1.661h-.605Zm1.28-2.354a.235.235 0 0 0 .069-.12.555.555 0 0 0 .019-.157v-.623a.404.404 0 0 0-.108-.29.37.37 0 0 0-.29-.119h-.365v1.429h.315a.864.864 0 0 0 .202-.02.386.386 0 0 0 .157-.1ZM33.635 14.319v-3.655h-.712v-.56h2.035v.56h-.724v3.655zM35.176 14.319v-4.215h.598v4.215zM36.396 10.5c.097-.134.219-.239.366-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.597c.033.113.05.237.05.371v2.146c0 .126-.012.237-.038.333a.943.943 0 0 1-.15.321.938.938 0 0 1-.335.302.928.928 0 0 1-.479.126c-.1 0-.197-.012-.29-.038a1.307 1.307 0 0 1-.258-.113 1.172 1.172 0 0 1-.214-.157.766.766 0 0 1-.139-.183 1.2 1.2 0 0 1-.113-.314 1.805 1.805 0 0 1-.02-.277v-2.146c0-.126.013-.237.039-.333.029-.1.077-.2.144-.296Zm1.173.334a.376.376 0 0 0-.328-.177.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.531.531 0 0 0-.05.151.783.783 0 0 0-.013.126V13.345c0 .02.002.043.006.068a.58.58 0 0 0 .1.208c.064.088.169.132.316.132a.4.4 0 0 0 .202-.05.35.35 0 0 0 .132-.126.461.461 0 0 0 .057-.138.86.86 0 0 0 .012-.164v-2.146a.832.832 0 0 0-.012-.176.253.253 0 0 0-.063-.12ZM40.255 14.319l-.939-2.561v2.561h-.605v-4.215h.573l.933 2.554v-2.554h.605v4.215zM15.861 20.133l.946-4.216h.523l.945 4.216h-.65l-.17-.906h-.78l-.177.906h-.637Zm.92-1.466h.568l-.284-1.535-.284 1.535ZM20.098 20.133l-.939-2.561v2.561h-.605v-4.216h.574l.933 2.555v-2.555h.605v4.216zM21.964 15.917c.273 0 .506.097.7.29a.92.92 0 0 1 .296.692v2.19c0 .31-.095.562-.284.754a.979.979 0 0 1-.73.29h-.94v-4.216h.958Zm.397 3.171v-2.19a.383.383 0 0 0-.132-.295.432.432 0 0 0-.31-.12h-.314v3.09h.296c.307 0 .46-.162.46-.485ZM23.966 20.133v-4.216h1.002c.126 0 .245.027.359.082.113.05.214.118.302.201a.94.94 0 0 1 .208.29.762.762 0 0 1 .089.327v.673a.941.941 0 0 1-.082.39.958.958 0 0 1-.523.516.951.951 0 0 1-.379.076h-.371v1.66h-.605Zm1.279-2.353a.235.235 0 0 0 .07-.12.556.556 0 0 0 .018-.157v-.623a.404.404 0 0 0-.107-.29.37.37 0 0 0-.29-.12h-.365v1.43h.315a.862.862 0 0 0 .201-.02.386.386 0 0 0 .158-.1ZM26.29 20.133v-4.216h1.058a.94.94 0 0 1 .7.29c.193.193.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.932h-.643l-.567-1.806h-.379v1.806h-.605Zm1.342-2.473a.366.366 0 0 0 .075-.157.707.707 0 0 0 .026-.195v-.39a.454.454 0 0 0-.108-.315.376.376 0 0 0-.302-.126h-.429v1.315h.423a.417.417 0 0 0 .315-.132ZM28.784 16.314c.097-.135.218-.24.366-.315a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.598 1.3 1.3 0 0 1 .05.37v2.146c0 .126-.013.237-.038.334a.947.947 0 0 1-.151.32.94.94 0 0 1-.334.303.928.928 0 0 1-.48.126 1.1 1.1 0 0 1-.289-.038 1.306 1.306 0 0 1-.258-.113 1.177 1.177 0 0 1-.215-.158.778.778 0 0 1-.138-.182c-.063-.13-.101-.235-.114-.315a1.792 1.792 0 0 1-.019-.277v-2.145c0-.126.013-.237.038-.334.03-.1.078-.199.145-.295Zm1.172.333a.376.376 0 0 0-.327-.176.42.42 0 0 0-.215.063.373.373 0 0 0-.145.132.533.533 0 0 0-.05.151.79.79 0 0 0-.013.126v2.215c0 .02.002.044.007.069a.58.58 0 0 0 .1.208c.063.088.169.132.316.132a.4.4 0 0 0 .201-.05.35.35 0 0 0 .133-.127.459.459 0 0 0 .056-.138.861.861 0 0 0 .013-.164v-2.145a.832.832 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM32 15.917c.272 0 .505.097.699.29a.92.92 0 0 1 .296.692v2.19c0 .31-.095.562-.284.754a.979.979 0 0 1-.73.29h-.94v-4.216H32Zm.396 3.171v-2.19a.383.383 0 0 0-.132-.295.432.432 0 0 0-.309-.12h-.315v3.09h.296c.307 0 .46-.162.46-.485ZM35.313 19.692a1.088 1.088 0 0 1-.359.347.894.894 0 0 1-.479.132.959.959 0 0 1-.264-.038 1.495 1.495 0 0 1-.24-.094 1.21 1.21 0 0 1-.202-.139.603.603 0 0 1-.132-.17 1.315 1.315 0 0 1-.126-.308 1.504 1.504 0 0 1-.025-.283v-3.222h.605v3.304l.012.063a.52.52 0 0 0 .095.176c.054.075.149.113.283.113.122 0 .213-.044.271-.132a.526.526 0 0 0 .095-.302v-3.222h.605v3.222c0 .1-.01.197-.032.29a.888.888 0 0 1-.107.263ZM37.867 19.07c0 .134-.009.25-.026.346a.791.791 0 0 1-.126.314.894.894 0 0 1-.144.17 1.11 1.11 0 0 1-.19.139 1.16 1.16 0 0 1-.22.094.772.772 0 0 1-.233.038c-.19 0-.362-.04-.517-.12a.81.81 0 0 1-.334-.302 1.11 1.11 0 0 1-.139-.34 2.14 2.14 0 0 1-.025-.34V16.9c0-.118.01-.223.032-.315a.987.987 0 0 1 .15-.308.91.91 0 0 1 .322-.277.86.86 0 0 1 .435-.12c.29 0 .532.097.725.29.193.189.29.432.29.73v.226h-.599V16.9a.443.443 0 0 0-.1-.296c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.278.12a.461.461 0 0 0-.094.296v2.334a.547.547 0 0 0 .088.214c.059.084.155.126.29.126.143 0 .237-.038.284-.113a.72.72 0 0 0 .081-.164.718.718 0 0 0 .013-.15v-.215h.599v.139ZM38.672 20.133v-3.656h-.712v-.56h2.035v.56h-.724v3.656zM40.242 20.133v-4.216h.598v4.216zM41.405 16.314c.096-.135.218-.24.365-.315a1.012 1.012 0 0 1 .901-.025.975.975 0 0 1 .536.598c.034.113.05.237.05.37v2.146c0 .126-.012.237-.037.334a.943.943 0 0 1-.151.32.941.941 0 0 1-.334.303.928.928 0 0 1-.48.126c-.1 0-.197-.013-.29-.038a1.31 1.31 0 0 1-.258-.113 1.172 1.172 0 0 1-.214-.158.766.766 0 0 1-.139-.182 1.2 1.2 0 0 1-.113-.315 1.805 1.805 0 0 1-.019-.277v-2.145c0-.126.013-.237.038-.334.03-.1.078-.199.145-.295Zm1.172.333a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.531.531 0 0 0-.05.151.784.784 0 0 0-.013.126v2.215c0 .02.002.044.007.069a.58.58 0 0 0 .1.208c.063.088.168.132.315.132a.399.399 0 0 0 .202-.05.35.35 0 0 0 .132-.127.46.46 0 0 0 .057-.138.86.86 0 0 0 .013-.164v-2.145a.832.832 0 0 0-.013-.176.256.256 0 0 0-.063-.12ZM45.205 20.133l-.939-2.561v2.561h-.605v-4.216h.574l.933 2.555v-2.555h.605v4.216zM5.164 14.243V5.661L3.717 6.745V5.209l1.447-1.054h1.433v10.088zM12.105 14.243H7.807v-1.325l2.685-5.21c.12-.24.18-.486.18-.737v-.753c0-.201-.07-.372-.21-.512a.676.676 0 0 0-.513-.226.744.744 0 0 0-.498.196.631.631 0 0 0-.21.482v.888H7.776v-.723c0-.391.146-.868.438-1.43.301-.552.904-.828 1.81-.828.572 0 1.06.216 1.462.647.412.442.618.944.618 1.506v.918c0 .412-.11.823-.331 1.235l-2.262 4.441h2.593v1.43Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  d: "m23.155 34.154-4.462 1.48a.27.27 0 0 0-.095.458l3.515 3.118a.27.27 0 0 0 .444-.147l.948-4.598a.27.27 0 0 0-.35-.31Zm9.657-9.927c-3.622 0-5.97 2.601-7.128 3.954 0 0 .886 1.831 1.38 2.104 0 0 2.304-3.732 5.748-3.732 1.215 0 2.555.398 3.555 1.293 1 .895 1.748 2.286 1.748 4.619 0 1.404-.463 2.772-1.262 3.743-.799.97-1.883 1.576-3.389 1.576-1.623 0-2.91-.464-4.146-1.452-1.238-.988-2.407-2.544-3.533-4.696-.578-1.104-1.51-2.893-2.969-4.45-1.459-1.556-3.539-2.911-6.22-2.911-1.798 0-3.666.558-5.096 1.898-1.43 1.34-2.335 3.43-2.347 6.168-.02 4.594 3.474 7.697 7.466 7.697 2.873 0 4.806-1.77 4.806-1.77l-1.561-1.726s-1.326 1.17-3.245 1.17c-2.862 0-5.153-1.88-5.137-5.36.01-2.252.687-3.616 1.612-4.483.925-.867 2.184-1.268 3.501-1.268 1.915 0 3.337.913 4.52 2.175 1.184 1.262 2.032 2.842 2.605 3.937 1.217 2.326 2.54 4.156 4.142 5.435a8.813 8.813 0 0 0 5.602 1.962c2.176 0 4-.982 5.188-2.426 1.189-1.444 1.793-3.316 1.793-5.22 0-2.86-1.022-5.006-2.523-6.35-1.502-1.344-3.396-1.887-5.11-1.887Z",
  fill: "currentColor"
}))), CI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  "fill-transparent": 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279V49.72a.278.278 0 0 1-.28.279H.28a.278.278 0 0 1-.28-.279V.28C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M17.532 7.546c0 .134-.008.25-.025.346a.796.796 0 0 1-.126.314.89.89 0 0 1-.145.17 1.1 1.1 0 0 1-.19.139c-.067.037-.14.069-.22.094a.773.773 0 0 1-.233.038c-.19 0-.361-.04-.517-.12a.812.812 0 0 1-.334-.302 1.114 1.114 0 0 1-.139-.34 2.15 2.15 0 0 1-.025-.34v-2.17c0-.118.01-.223.032-.315a.992.992 0 0 1 .151-.308.912.912 0 0 1 .321-.277.86.86 0 0 1 .435-.12c.29 0 .532.097.725.29.193.189.29.432.29.73V5.6h-.599v-.226a.443.443 0 0 0-.1-.296c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.277.12a.462.462 0 0 0-.095.296v2.334a.55.55 0 0 0 .088.214c.059.084.156.126.29.126.143 0 .238-.038.284-.113a.71.71 0 0 0 .082-.164.722.722 0 0 0 .012-.15v-.215h.599v.139ZM19.761 8.609h-1.802V4.393h.605v3.612h1.197zM19.9 8.609V4.393h.599v4.216zM23.137 8.609V6.042l-.605 1.799h-.302l-.599-1.799v2.567h-.605V4.393h.567l.8 2.247.788-2.247h.555v4.216zM23.848 8.609l.945-4.216h.524l.945 4.216h-.65l-.17-.906h-.78l-.177.906h-.637Zm.92-1.466h.567l-.283-1.535-.284 1.535ZM26.81 8.609V4.953h-.712v-.56h2.036v.56h-.725v3.656zM30.232 8.005v.604h-1.809V4.393h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM15.324 14.422l.945-4.215h.523l.946 4.215h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.284-1.535-.283 1.535ZM19.961 13.36c0 .133-.008.249-.025.345a.795.795 0 0 1-.126.315.891.891 0 0 1-.145.17 1.1 1.1 0 0 1-.189.138c-.067.038-.14.07-.22.095a.773.773 0 0 1-.234.037c-.189 0-.361-.04-.517-.12a.812.812 0 0 1-.334-.301 1.115 1.115 0 0 1-.138-.34 2.15 2.15 0 0 1-.025-.34v-2.17c0-.118.01-.223.031-.315a.991.991 0 0 1 .151-.309.912.912 0 0 1 .322-.276.86.86 0 0 1 .435-.12c.29 0 .531.097.724.29.194.188.29.432.29.73v.226h-.598v-.227a.443.443 0 0 0-.101-.295c-.063-.08-.158-.12-.284-.12-.117 0-.21.04-.277.12a.462.462 0 0 0-.095.295v2.335a.55.55 0 0 0 .089.214c.058.084.155.126.29.126.142 0 .237-.038.283-.114a.708.708 0 0 0 .082-.163.722.722 0 0 0 .013-.151v-.214h.598v.138ZM20.968 14.422v-3.655h-.712v-.56h2.035v.56h-.725v3.655zM22.595 14.422v-4.215h.599v4.215zM23.845 10.603c.097-.134.218-.239.365-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.597c.034.113.05.237.05.371v2.146c0 .126-.012.237-.037.334a.947.947 0 0 1-.151.32.94.94 0 0 1-.334.302.928.928 0 0 1-.48.126c-.1 0-.197-.012-.29-.037a1.303 1.303 0 0 1-.472-.271.777.777 0 0 1-.138-.183c-.064-.13-.101-.234-.114-.314a1.792 1.792 0 0 1-.019-.277v-2.146c0-.125.013-.237.038-.333.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.062.374.374 0 0 0-.145.133.533.533 0 0 0-.05.15.789.789 0 0 0-.013.126V13.448c0 .02.002.043.006.068a.58.58 0 0 0 .101.208c.063.088.168.132.315.132a.4.4 0 0 0 .202-.05.35.35 0 0 0 .132-.126.46.46 0 0 0 .057-.138.864.864 0 0 0 .013-.164v-2.146a.835.835 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM27.762 14.422l-.94-2.56v2.56h-.605v-4.215h.574l.933 2.554v-2.554h.605v4.215zM4.898 14.475V5.893L3.45 6.977V5.441l1.448-1.054h1.433v10.088zM11.754 12.156v.181c0 .07-.005.15-.015.24 0 .081-.015.202-.045.362-.141.482-.407.874-.8 1.175-.382.3-.829.451-1.342.451-.402 0-.784-.12-1.146-.361-.362-.251-.593-.497-.694-.738a7.36 7.36 0 0 1-.15-.346c-.03-.1-.056-.196-.076-.286a2.425 2.425 0 0 1-.045-.286v-.979h1.448v.828c.02.13.075.276.166.437.1.18.281.27.542.27.262 0 .448-.09.558-.27.111-.18.166-.407.166-.678v-1.55c-.01-.191-.05-.337-.12-.437a.504.504 0 0 0-.226-.21.582.582 0 0 0-.287-.076c-.1-.01-.191-.015-.271-.015H9.16v-1.28h.257c.603 0 .904-.281.904-.843V6.54c0-.12-.01-.22-.03-.3a.347.347 0 0 0-.045-.136.709.709 0 0 0-.136-.18.6.6 0 0 0-.482-.212c-.252 0-.438.08-.558.241-.121.15-.181.347-.181.587v.738H7.44V6.54c0-.632.206-1.164.618-1.596.402-.431.925-.647 1.569-.647.352 0 .688.09 1.01.271.332.18.573.392.724.632.16.241.266.467.317.678.05.21.075.432.075.662v1.175c0 .652-.287 1.15-.86 1.49.322.231.543.462.664.693.13.22.196.522.196.903v1.355ZM25.921 22.25c-7.287-.068-14.623 3.25-18.893 9.518 8.282 12.157 28.093 13.219 36.722 0-4.18-6.402-10.983-9.454-17.829-9.518Zm-.42 1.819c.388 0 .768.022.938.067.148.04.42.096.606.126.41.066 1.014.247 1.256.377a.81.81 0 0 0 .291.096.36.36 0 0 1 .213.1c.056.056.16.101.23.101.072 0 .13.03.13.069 0 .037.077.098.17.133.094.036.208.097.253.135.046.039.244.188.44.332.356.26 1.292 1.116 1.292 1.182 0 .019.151.226.336.461.186.235.337.46.337.498 0 .039.038.111.084.16.257.275.791 1.675.791 2.075 0 .463-.4.616-.697.265-.434-.515-.852.048-.474.638.066.105.067.158.006.238-.102.132-.62.4-.774.4-.183 0-.461.367-.51.673-.05.316.046.75.194.874.094.077.146.403.065.403-.054 0-.431-.275-.686-.5-.2-.176-.305-.356-.592-1.013a2.44 2.44 0 0 1-.126-.374c-.066-.303-.338-.533-.631-.533-.408 0-.515.12-.525.588-.006.277-.049.456-.137.577-.154.21-.169.212-.35.062-.323-.268-.45-.353-.524-.353-.043 0-.117-.045-.163-.1-.046-.056-.163-.103-.26-.106-.351-.007-.772-.279-.933-.601-.084-.166-.152-.333-.153-.37 0-.06-.615-.503-.697-.503-.018 0-.19-.104-.382-.23-.398-.263-.537-.25-.537.047 0 .17.094.297.534.72.587.564.702.796.502 1.016-.116.129-.506.328-.641.328-.033 0-.286-.229-.562-.509-.38-.386-.539-.503-.655-.487-.113.016-.16.073-.176.215-.013.106.01.225.05.265a.31.31 0 0 1 .073.191c0 .213.578.93.75.93.031 0 .134.067.23.15.226.197.177.388-.2.77-.283.286-.291.306-.327.831-.02.297-.067.576-.103.62a.868.868 0 0 0-.109.284c-.024.111-.133.304-.243.43-.115.13-.2.303-.2.406 0 .1-.044.239-.099.31a.505.505 0 0 0-.101.212c-.003.103-.299.423-.391.423-.04 0-.083.034-.097.076-.014.041-.177.09-.363.108-.306.03-.348.016-.451-.14v-.001c-.077-.117-.114-.313-.114-.602 0-.362-.026-.459-.17-.624a1 1 0 0 1-.202-.346l-.068-.324c-.024-.116-.112-.204-.269-.27-.128-.053-.233-.124-.233-.157 0-.034-.123-.189-.273-.345-.262-.272-.284-.281-.584-.24-.171.024-.362.088-.423.144-.06.055-.215.1-.341.098-.196 0-.248-.037-.348-.238a1.113 1.113 0 0 1-.119-.365c0-.071-.042-.23-.094-.35-.125-.29-.245-1.074-.286-1.851-.032-.607-.028-.63.174-.928.114-.168.206-.332.206-.364 0-.067.471-.241.573-.211.037.01.239.047.448.08a2.4 2.4 0 0 1 .571.163.929.929 0 0 0 .294.102c.055.002.16.047.231.101a.552.552 0 0 0 .282.099c.084 0 .168.027.188.058.02.032.148.076.285.099.435.07 1.03-.3 1.032-.642.002-.255-.237-.456-.542-.456-.138 0-.285-.044-.332-.1-.046-.056-.191-.101-.323-.101a.578.578 0 0 1-.389-.14c-.196-.184-.703-.21-.885-.045a.493.493 0 0 1-.28.118.898.898 0 0 0-.33.092c-.1.05-.329.113-.507.139l-.325.047.021-.19c.02-.169.055-.194.325-.231.59-.082.907-.218.932-.398.019-.144.09-.226.449-.52.037-.031.23-.11.428-.174.337-.11.389-.11.796-.008.528.132.768.088 1.061-.193.122-.116.301-.28.398-.362.204-.174.217-.237.076-.354-.17-.14-.57-.032-.797.217-.174.19-.245.22-.51.216-.37-.006-.865-.21-.918-.378-.096-.3.443-.558 1.29-.618.362-.025.69-.072.73-.104.099-.08.98-.168.977-.097-.002.032-.13.121-.286.198-.25.123-.283.165-.283.369 0 .168.032.236.121.253.143.027.666-.204.958-.424a1.1 1.1 0 0 1 .33-.178c.07-.014.157-.113.193-.222.06-.177.044-.217-.162-.398-.32-.282-.463-.514-.464-.753 0-.421-.092-.462-1.123-.505-.512-.021-.866-.044-.788-.05a.378.378 0 0 0 .228-.113.298.298 0 0 1 .197-.101.5.5 0 0 0 .244-.099.528.528 0 0 1 .255-.1c.069-.002.22-.047.337-.101.117-.055.379-.129.582-.165.204-.036.507-.096.674-.133.2-.045.594-.067.98-.067Zm-5.375 2.21c.245 0 .203.292-.072.502-.255.194-.515.227-.515.064 0-.166.414-.565.587-.565Zm-.622 1.286a.498.498 0 0 1 .11.002c.146.021.115.067-.334.494-.53.506-.616.565-.618.426 0-.05.068-.228.152-.397.146-.294.43-.504.69-.525Zm13.312 3.362c.035.008.082.046.143.113.154.17.168 1.827.014 1.827a.198.198 0 0 1-.15-.085c-.302-.48-.385-1.043-.193-1.297a.69.69 0 0 0 .101-.35c.002-.154.027-.222.085-.208Zm-5.57 1.604c.056 0 .102.012.102.026 0 .015-.046.044-.101.065-.056.022-.101.01-.101-.027 0-.035.045-.064.1-.064Zm4.238.773a.147.147 0 0 1 .073.01c.055.02.082.064.061.097-.044.07-.123.079-.184.018-.054-.054-.017-.115.05-.125Zm-7.065.503c.074 0 .027.315-.075.505-.06.11-.133.277-.162.369-.041.128-.055.076-.06-.218-.004-.302.024-.416.129-.521.074-.074.15-.135.168-.135Zm7.881.012c.077.01.138.104.204.293.08.233.079.297-.014.502-.193.426-.37.77-.5.975-.072.11-.159.266-.194.345-.035.08-.088.155-.119.168-.03.014-.142.153-.249.31-.107.157-.22.286-.252.286s-.058.045-.058.1c0 .056-.053.104-.118.108-.692.037-.818.024-.848-.09-.038-.145-.268-.155-.405-.018a.445.445 0 0 1-.274.1c-.145 0-.173-.03-.173-.187a.618.618 0 0 0-.099-.32c-.06-.078-.1-.285-.1-.519a1.265 1.265 0 0 1 .477-1.023c.152-.129 1.002-.44 1.194-.437.235.002 1.16-.353 1.368-.524.062-.051.114-.075.16-.069Zm-2.692 3.894c.098.007.167.04.191.103.024.06.035.114.025.118-.01.004-.08.046-.154.093a2.675 2.675 0 0 1-.319.166c-.102.044-.185.1-.185.127 0 .026-.089.067-.197.09a.585.585 0 0 0-.278.14c-.044.053-.124.097-.177.097a.646.646 0 0 0-.245.082c-.179.1-.595.225-1.224.368-.52.119-2.404.185-2.625.093-.075-.03-.302-.078-.505-.106-.4-.054-.469-.11-.47-.374-.001-.187.372-.601.542-.601a.577.577 0 0 0 .25-.105c.287-.2 1.765-.065 2.325.212.105.052.25.095.323.095.073 0 .215.041.315.092.234.118.622.18.76.122.06-.026.25-.165.422-.31.375-.314.93-.523 1.226-.502Z",
  fill: "currentColor",
  fillRule: "nonzero"
}))), EI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  "fill-transparent": 0,
  d: "M.28 0H49.72c.155 0 .279.124.279.279V49.72a.278.278 0 0 1-.279.279H.28A.278.278 0 0 1 0 49.721V.28C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M18.138 8.609h-1.803V4.393h.605v3.612h1.198zM18.334 8.609V4.393h.599v4.216zM19.445 8.609V4.393h1.803v.567h-1.204v1.264h1.052v.567h-1.052v1.818zM23.263 8.005v.604h-1.809V4.393h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM17.325 10.207c.13 0 .252.027.365.082.126.058.254.153.384.283.14.134.208.344.208.629v.32c0 .324-.128.55-.384.68.256.151.384.386.384.705v.49a.997.997 0 0 1-.29.737.979.979 0 0 1-.73.29h-.933v-4.216h.996Zm.359 1.252V11.2a.398.398 0 0 0-.416-.428h-.34v1.164h.359c.138 0 .24-.042.302-.126a.594.594 0 0 0 .095-.352Zm0 1.938v-.491a.425.425 0 0 0-.114-.315.385.385 0 0 0-.302-.12h-.34v1.354h.346a.39.39 0 0 0 .296-.12.444.444 0 0 0 .114-.308ZM20.686 13.818v.604h-1.809v-4.215h1.809v.553h-1.21v1.246h1.058v.573h-1.058v1.239zM22.731 14.422h-1.802v-4.215h.605v3.611h1.197zM22.98 10.603c.096-.134.218-.239.365-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.597 1.3 1.3 0 0 1 .05.371v2.146c0 .126-.012.237-.037.334a.947.947 0 0 1-.151.32.94.94 0 0 1-.334.302.928.928 0 0 1-.48.126c-.1 0-.197-.012-.29-.037a1.303 1.303 0 0 1-.472-.271.777.777 0 0 1-.139-.183c-.063-.13-.1-.234-.113-.314a1.792 1.792 0 0 1-.019-.277v-2.146c0-.125.013-.237.038-.333.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.062.373.373 0 0 0-.145.133.532.532 0 0 0-.05.15.789.789 0 0 0-.013.126V13.448c0 .02.002.043.006.068a.58.58 0 0 0 .101.208c.063.088.168.132.315.132a.4.4 0 0 0 .202-.05.35.35 0 0 0 .132-.126.458.458 0 0 0 .057-.138.86.86 0 0 0 .013-.164v-2.146a.832.832 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM27.304 14.422l-.498-2.567-.485 2.567h-.561l-.611-4.215h.642l.303 2.548.485-2.548h.448l.498 2.548.302-2.548h.637l-.593 4.215zM31.406 14.422l-.498-2.567-.486 2.567h-.56l-.612-4.215h.643l.303 2.548.485-2.548h.447l.498 2.548.303-2.548h.636l-.592 4.215zM32.43 14.422l.946-4.215h.523l.946 4.215h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.568l-.283-1.535-.284 1.535ZM35.349 14.422v-3.655h-.712v-.56h2.036v.56h-.725v3.655zM38.814 13.818v.604h-1.809v-4.215h1.809v.553h-1.21v1.246h1.058v.573h-1.058v1.239zM39.045 14.422v-4.215h1.058c.278 0 .511.096.7.29.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.931h-.643l-.567-1.805h-.378v1.805h-.605Zm1.342-2.472a.365.365 0 0 0 .076-.158.705.705 0 0 0 .025-.195v-.39a.455.455 0 0 0-.107-.314.376.376 0 0 0-.303-.126h-.428v1.315h.422c.126 0 .231-.044.315-.132ZM4.947 14.475V5.893L3.5 6.977V5.441l1.447-1.054H6.38v10.088zM10.2 14.475v-1.536H7.32v-1.355l2.096-7.197h1.523l-2.157 7.197H10.2V8.709h1.448v2.875h.709v1.355h-.709v1.536zM27.919 30.69c-3.41.08-6.755 1.878-10.074 4.335-1.46-2.505-3.387-4.288-6.456-4.297 2.933 4.358 2.344 8.24 0 11.885 3.069-.01 4.995-1.792 6.456-4.298 6.638 4.914 13.377 7.193 20.547-1.644-3.585-4.42-7.062-6.06-10.473-5.98Zm3.302 3.439a1.635 1.635 0 0 1 1.636 1.633 1.633 1.633 0 0 1-1.636 1.633 1.637 1.637 0 0 1-1.635-1.633 1.632 1.632 0 0 1 1.635-1.633Zm6.919-9.125.118 1.343c-2.546 1.748-4.437 1.054-6.137-.353-2.101 1.548-4.415 2.008-7.23-.1-2.078 1.27-4.205 2.378-7.382.05-1.658 1.29-3.32 2.562-5.986.486l-.067-1.41c2.449 1.432 4.375.616 6.204-.839 2.427 1.64 4.826 2.12 7.163.1 2.711 2.482 4.988 1.422 7.213-.066 1.63 1.042 3.132 2.378 6.104.789Zm0-4.13.118 1.343c-2.546 1.749-4.437 1.054-6.137-.352-2.101 1.547-4.415 2.008-7.23-.101-2.078 1.27-4.205 2.378-7.382.05-1.658 1.29-3.32 2.562-5.986.487l-.067-1.41c2.449 1.431 4.375.615 6.204-.84 2.427 1.64 4.826 2.12 7.163.101 2.711 2.482 4.988 1.421 7.213-.067 1.63 1.042 3.132 2.378 6.104.79Z"
}))), bI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  "fill-transparent": 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279V49.72a.278.278 0 0 1-.28.279H.28a.278.278 0 0 1-.28-.279V.28C0 .124.124 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M17.861 8.609h-1.803V4.393h.605v3.612h1.198zM17.981 8.609V4.393h.598v4.216zM18.964 8.609V4.393h1.803v.567h-1.204v1.264h1.053v.567h-1.053v1.818zM22.782 8.005v.604h-1.809V4.393h1.809v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM16.191 10.603c.097-.134.218-.239.366-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .535.597 1.3 1.3 0 0 1 .05.371v2.146c0 .126-.012.237-.037.334a.948.948 0 0 1-.151.32.94.94 0 0 1-.334.302.928.928 0 0 1-.48.126c-.1 0-.197-.012-.29-.037a1.301 1.301 0 0 1-.472-.271.778.778 0 0 1-.138-.183 1.21 1.21 0 0 1-.114-.314 1.792 1.792 0 0 1-.019-.277v-2.146c0-.125.013-.237.038-.333.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.327-.176.42.42 0 0 0-.215.062.373.373 0 0 0-.145.133.532.532 0 0 0-.05.15.789.789 0 0 0-.013.126V13.448c0 .02.002.043.007.068a.58.58 0 0 0 .1.208c.063.088.168.132.316.132a.4.4 0 0 0 .201-.05.35.35 0 0 0 .133-.126.46.46 0 0 0 .056-.138.861.861 0 0 0 .013-.164v-2.146a.833.833 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM19.963 14.422l-.939-2.56v2.56h-.605v-4.215h.574l.932 2.554v-2.554h.605v4.215zM24.067 14.422h-1.803v-4.215h.605v3.611h1.198zM24.1 14.422l.945-4.215h.523l.945 4.215h-.649l-.17-.906h-.782l-.176.906h-.637Zm.92-1.466h.567l-.284-1.535-.283 1.535ZM28.237 14.422l-.939-2.56v2.56h-.605v-4.215h.573l.933 2.554v-2.554h.605v4.215zM30.165 10.207c.273 0 .506.096.7.29a.92.92 0 0 1 .295.691v2.19c0 .31-.094.562-.283.755a.979.979 0 0 1-.731.29h-.94v-4.216h.959Zm.397 3.171v-2.19a.383.383 0 0 0-.133-.295.432.432 0 0 0-.309-.12h-.315v3.09h.297c.306 0 .46-.162.46-.485ZM4.997 14.475V5.893L3.549 6.977V5.441l1.448-1.054h1.432v10.088zM10.169 7.986c.251 0 .503.07.754.21.261.141.452.307.573.497.13.191.216.392.256.603.05.2.076.416.076.647v2.259c0 .22-.01.411-.03.572-.01.15-.066.361-.166.632s-.347.532-.74.783c-.371.25-.783.376-1.236.376-.342 0-.668-.08-.98-.24a2.106 2.106 0 0 1-1.07-1.356c-.061-.25-.091-.507-.091-.767v-.256h1.478v.557c0 .05.015.11.045.18.03.07.07.14.12.211.05.06.121.116.212.166.09.04.196.06.316.06.272 0 .453-.075.543-.226.09-.15.141-.266.151-.346.01-.09.015-.186.015-.286V10.003c0-.05-.005-.1-.015-.15 0-.05-.015-.11-.045-.18a.453.453 0 0 0-.12-.197.503.503 0 0 0-.212-.165.56.56 0 0 0-.301-.076c-.352 0-.589.181-.71.543H7.697v-5.39h4.132v1.34H8.993v2.71a1.728 1.728 0 0 1 1.176-.452ZM16.524 23.344c-3.767.26-3.374 3.914-1.542 4.955-1.548 2.428-.011 4.729 1.843 4.729h6.053c3.331 0 5.672-5.646.47-7.976 1.898-6.567-6.878-6.123-6.824-1.708ZM28.918 30.383c1.69-.782 3.749.955 3.749.955s1.765-1.64 3.695-.928c.496.183.458-.333.292-.452-.985-.706-2.218-1.387-3.934-.026-2.074-1.325-3.222-.724-4.041 0-.215.19-.14.626.24.451ZM26.353 24.308c1.335-.767 3.158.516 3.158.516s1.336-1.48 2.978-1.034c.423.115.354-.306.209-.393-.863-.51-1.93-.982-3.245.264-1.805-.942-2.708-.364-3.33.292-.163.172-.07.527.23.355ZM31.194 20.65c1.226-.181 2.212 1.316 2.212 1.316s1.437-.714 2.534.104c.282.21.355-.126.272-.233-.495-.637-1.153-1.303-2.506-.759-1.073-1.236-1.92-1.07-2.58-.762-.172.081-.207.374.068.333Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M19.787 33.972h1.256c.155 0 .279.124.279.279v3.34a.278.278 0 0 1-.28.28h-1.255a.278.278 0 0 1-.28-.28v-3.34c0-.155.125-.279.28-.279ZM13.17 39.374H37.1c.155 0 .28.124.28.278v1.189a.278.278 0 0 1-.28.279H13.17a.278.278 0 0 1-.279-.279v-1.189c0-.154.125-.278.28-.278ZM13.17 42.24H37.1c.155 0 .28.125.28.279v1.188a.278.278 0 0 1-.28.279H13.17a.278.278 0 0 1-.279-.279V42.52c0-.154.125-.279.28-.279Z",
  fill: "currentColor"
}))), AI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  "fill-transparent": 0,
  d: "M.28 0h49.44c.155 0 .28.124.28.279V49.72a.278.278 0 0 1-.28.279H.28a.278.278 0 0 1-.28-.279V.28C0 .124.125 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M15.855 8.609V4.393h1.002c.126 0 .246.028.36.082.113.05.214.118.302.201.088.084.158.18.208.29a.762.762 0 0 1 .088.327v.673a.941.941 0 0 1-.082.39.959.959 0 0 1-.523.516.951.951 0 0 1-.378.076h-.372v1.661h-.605Zm1.28-2.353a.235.235 0 0 0 .069-.12.556.556 0 0 0 .019-.157v-.623a.404.404 0 0 0-.107-.29.37.37 0 0 0-.29-.119h-.366v1.428h.315a.864.864 0 0 0 .202-.019.386.386 0 0 0 .158-.1ZM20.052 8.005v.604h-1.809V4.393h1.809v.554h-1.21v1.246H19.9v.572h-1.058v1.24zM20.225 8.609l.945-4.216h.523l.945 4.216h-.649l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.284-1.535-.283 1.535ZM24.832 7.546c0 .134-.009.25-.025.346a.796.796 0 0 1-.126.314.89.89 0 0 1-.145.17 1.1 1.1 0 0 1-.19.139c-.067.037-.14.069-.22.094a.773.773 0 0 1-.233.038c-.19 0-.362-.04-.517-.12a.812.812 0 0 1-.334-.302 1.115 1.115 0 0 1-.139-.34 2.15 2.15 0 0 1-.025-.34v-2.17c0-.118.01-.223.032-.315a.992.992 0 0 1 .15-.308.912.912 0 0 1 .322-.277.86.86 0 0 1 .435-.12c.29 0 .532.097.725.29.193.189.29.432.29.73V5.6h-.599v-.226a.443.443 0 0 0-.1-.296c-.064-.08-.158-.12-.284-.12-.118 0-.21.04-.278.12a.462.462 0 0 0-.094.296v2.334a.55.55 0 0 0 .088.214c.059.084.155.126.29.126.143 0 .237-.038.284-.113a.707.707 0 0 0 .081-.164.722.722 0 0 0 .013-.15v-.215h.599v.139ZM27.071 8.005v.604h-1.808V4.393h1.808v.554h-1.21v1.246h1.059v.572h-1.059v1.24zM27.365 9.056V8.011h.605v.598zM30.73 8.187c-.093.139-.212.25-.36.334a.927.927 0 0 1-.466.126c-.16 0-.31-.034-.454-.101a1.292 1.292 0 0 1-.371-.29l.466-.377c.1.105.216.157.347.157.176 0 .285-.046.327-.138a.781.781 0 0 0 .076-.201c.004-.038.006-.082.006-.133v-3.17h.593v3.114c0 .197-.013.335-.038.415a.82.82 0 0 1-.126.264ZM33.273 8.169a1.09 1.09 0 0 1-.36.346.894.894 0 0 1-.478.132.962.962 0 0 1-.265-.038 1.497 1.497 0 0 1-.24-.094 1.216 1.216 0 0 1-.201-.139.603.603 0 0 1-.132-.17 1.323 1.323 0 0 1-.126-.308 1.51 1.51 0 0 1-.026-.283V4.393h.605v3.304l.013.062a.515.515 0 0 0 .094.177c.055.075.15.113.284.113.122 0 .212-.044.271-.132a.524.524 0 0 0 .095-.302V4.393h.605v3.222c0 .1-.01.197-.032.29a.897.897 0 0 1-.107.264ZM34.412 7.558v.107c0 .03.002.055.007.076.008.042.04.102.094.182.059.084.164.126.315.126a.542.542 0 0 0 .233-.05.352.352 0 0 0 .202-.277.579.579 0 0 0 .012-.114V7.2a.385.385 0 0 0-.05-.214.647.647 0 0 0-.227-.183c-.08-.042-.223-.1-.428-.176a1.214 1.214 0 0 1-.517-.359c-.139-.163-.208-.386-.208-.667v-.188c0-.29.097-.537.29-.743a.95.95 0 0 1 .718-.314.96.96 0 0 1 .731.308c.198.205.297.455.297.749V5.6h-.606v-.188a.515.515 0 0 0-.006-.082.365.365 0 0 0-.006-.07.277.277 0 0 0-.031-.075 1.492 1.492 0 0 0-.07-.107c-.059-.084-.158-.126-.296-.126a.39.39 0 0 0-.303.132.485.485 0 0 0-.113.328v.245c0 .084.012.15.038.201a.58.58 0 0 0 .201.158c.034.016.084.04.152.069.071.025.157.056.258.094.202.067.382.187.542.359.16.172.24.398.24.68v.34c0 .146-.015.27-.044.37-.026.101-.112.248-.259.44-.147.185-.393.278-.737.278-.366 0-.63-.118-.794-.353a1.289 1.289 0 0 1-.246-.736v-.15h.611v.15ZM36.657 8.609V4.953h-.712v-.56h2.036v.56h-.725v3.656zM38.309 8.609V4.393h.599v4.216zM41.36 7.546c0 .134-.009.25-.025.346a.797.797 0 0 1-.127.314.892.892 0 0 1-.145.17c-.054.05-.117.097-.189.139-.067.037-.14.069-.22.094a.775.775 0 0 1-.233.038c-.19 0-.362-.04-.517-.12a.813.813 0 0 1-.334-.302 1.127 1.127 0 0 1-.139-.34 2.183 2.183 0 0 1-.025-.34v-2.17c0-.118.01-.223.031-.315a.995.995 0 0 1 .152-.308.911.911 0 0 1 .321-.277.86.86 0 0 1 .435-.12c.29 0 .531.097.725.29.193.189.29.432.29.73V5.6h-.6v-.226a.443.443 0 0 0-.1-.296c-.063-.08-.157-.12-.284-.12-.117 0-.21.04-.277.12a.461.461 0 0 0-.094.296v2.334a.552.552 0 0 0 .088.214c.059.084.155.126.29.126.143 0 .237-.038.283-.113a.71.71 0 0 0 .082-.164.721.721 0 0 0 .013-.15v-.215h.598v.139ZM43.629 8.005v.604H41.82V4.393h1.809v.554h-1.21v1.246h1.058v.572h-1.058v1.24zM15.655 14.422l.945-4.215h.523l.946 4.215h-.65l-.17-.906h-.781l-.177.906h-.636Zm.92-1.466h.567l-.284-1.535-.283 1.535ZM19.92 14.422l-.939-2.56v2.56h-.605v-4.215h.574l.932 2.554v-2.554h.605v4.215zM21.892 10.207c.273 0 .506.096.7.29a.92.92 0 0 1 .296.691v2.19c0 .31-.095.562-.284.755a.979.979 0 0 1-.73.29h-.94v-4.216h.958Zm.397 3.171v-2.19a.383.383 0 0 0-.132-.295.432.432 0 0 0-.31-.12h-.314v3.09h.296c.307 0 .46-.162.46-.485ZM24.548 13.372v.107c0 .03.002.054.006.075.008.042.04.103.095.183.058.084.164.126.315.126a.542.542 0 0 0 .233-.05.35.35 0 0 0 .202-.277.582.582 0 0 0 .012-.114v-.409a.383.383 0 0 0-.05-.214.644.644 0 0 0-.227-.182c-.08-.042-.223-.101-.429-.176a1.212 1.212 0 0 1-.516-.36c-.14-.163-.208-.385-.208-.666v-.189c0-.29.096-.537.29-.742a.95.95 0 0 1 .718-.315.96.96 0 0 1 .731.308c.198.206.296.455.296.75v.188h-.605v-.189a.495.495 0 0 0-.006-.082.352.352 0 0 0-.006-.069.264.264 0 0 0-.032-.075 1.439 1.439 0 0 0-.07-.107c-.058-.084-.157-.126-.295-.126a.39.39 0 0 0-.303.132.485.485 0 0 0-.113.327v.246c0 .083.012.15.037.2a.58.58 0 0 0 .202.158c.034.017.084.04.151.07.072.025.158.056.259.094.201.067.382.186.542.358.16.172.24.399.24.68v.34c0 .147-.015.27-.045.371-.025.1-.111.247-.258.44-.147.185-.393.277-.738.277-.365 0-.63-.117-.794-.352a1.288 1.288 0 0 1-.246-.736v-.151h.612v.15ZM26.884 14.422v-3.655h-.712v-.56h2.036v.56h-.725v3.655zM28.47 14.422v-4.215h1.058a.94.94 0 0 1 .7.29c.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.931h-.643l-.567-1.805h-.379v1.805h-.605Zm1.342-2.472a.366.366 0 0 0 .075-.158.707.707 0 0 0 .026-.195v-.39a.454.454 0 0 0-.108-.314.376.376 0 0 0-.302-.126h-.429v1.315h.423a.417.417 0 0 0 .315-.132ZM31.042 10.603c.096-.134.218-.239.365-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.597c.034.113.05.237.05.371v2.146c0 .126-.012.237-.037.334a.948.948 0 0 1-.151.32.94.94 0 0 1-.334.302.928.928 0 0 1-.48.126c-.1 0-.197-.012-.29-.037a1.301 1.301 0 0 1-.472-.271.778.778 0 0 1-.139-.183 1.21 1.21 0 0 1-.113-.314 1.793 1.793 0 0 1-.019-.277v-2.146c0-.125.013-.237.038-.333.03-.1.078-.2.145-.296Zm1.172.334a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.062.373.373 0 0 0-.145.133.531.531 0 0 0-.05.15.789.789 0 0 0-.013.126V13.448c0 .02.002.043.006.068a.581.581 0 0 0 .101.208c.063.088.168.132.315.132a.4.4 0 0 0 .202-.05.35.35 0 0 0 .132-.126.46.46 0 0 0 .057-.138.861.861 0 0 0 .013-.164v-2.146a.833.833 0 0 0-.013-.176.254.254 0 0 0-.063-.12ZM34.954 14.422l-.939-2.56v2.56h-.605v-4.215h.573l.933 2.554v-2.554h.605v4.215zM37.778 13.982a1.008 1.008 0 0 1-.87.478c-.16 0-.315-.037-.467-.113a1.012 1.012 0 0 1-.346-.277 1.054 1.054 0 0 1-.164-.34 1.788 1.788 0 0 1-.038-.383v-2.108c0-.105.01-.21.032-.315a1.83 1.83 0 0 1 .233-.447c.13-.205.386-.308.769-.308.168 0 .325.04.472.12a.89.89 0 0 1 .334.295c.08.114.13.223.152.328.025.1.037.21.037.327v.176h-.598v-.176a.52.52 0 0 0-.007-.088.375.375 0 0 0-.006-.076.485.485 0 0 0-.095-.182c-.058-.084-.157-.126-.296-.126-.163 0-.273.044-.327.132a.767.767 0 0 0-.089.195.74.74 0 0 0-.012.145V13.454c0 .029.002.054.006.075a.677.677 0 0 0 .095.195c.054.088.162.132.321.132.164 0 .27-.044.315-.132.025-.046.044-.084.057-.113a.477.477 0 0 0 .025-.088.237.237 0 0 0 .013-.076v-.837h-.486v-.528h1.084v1.265c0 .088-.002.163-.006.226a.714.714 0 0 1-.076.29 1.098 1.098 0 0 1-.062.12ZM15.855 20.236V16.02h.599v4.216zM18.504 20.236l-.939-2.561v2.561h-.605V16.02h.573l.933 2.555V16.02h.605v4.216zM19.934 19.185v.107c0 .03.003.055.007.076.008.042.04.102.094.182.06.084.164.126.315.126a.541.541 0 0 0 .234-.05.35.35 0 0 0 .202-.277.582.582 0 0 0 .012-.113v-.409a.384.384 0 0 0-.05-.214.645.645 0 0 0-.227-.183 4.06 4.06 0 0 0-.429-.176 1.212 1.212 0 0 1-.517-.359c-.138-.163-.208-.386-.208-.667v-.188c0-.29.097-.537.29-.743a.95.95 0 0 1 .719-.314.96.96 0 0 1 .73.308c.198.205.297.455.297.749v.188h-.605v-.188a.499.499 0 0 0-.006-.082.264.264 0 0 0-.038-.145 1.446 1.446 0 0 0-.07-.107c-.058-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.114.328v.245c0 .084.013.151.038.201a.58.58 0 0 0 .202.158c.033.016.084.04.151.069l.258.094c.202.067.383.187.542.359.16.172.24.398.24.68v.34c0 .146-.015.27-.044.37-.025.101-.112.248-.259.44-.147.185-.392.278-.737.278-.366 0-.63-.118-.794-.353a1.288 1.288 0 0 1-.246-.736v-.15h.611v.15ZM22.24 20.236V16.58h-.712v-.56h2.036v.56h-.725v3.656zM23.862 20.236V16.02h.599v4.216zM25.481 20.236V16.58h-.712v-.56h2.036v.56h-.725v3.656zM28.962 19.796a1.09 1.09 0 0 1-.36.346.894.894 0 0 1-.479.132.962.962 0 0 1-.264-.038 1.497 1.497 0 0 1-.24-.094 1.215 1.215 0 0 1-.201-.139.603.603 0 0 1-.133-.17 1.325 1.325 0 0 1-.126-.308 1.51 1.51 0 0 1-.025-.283V16.02h.605v3.304l.013.063a.515.515 0 0 0 .094.176c.055.075.15.113.284.113.122 0 .212-.044.27-.132a.525.525 0 0 0 .095-.302V16.02h.605v3.222c0 .1-.01.197-.031.29a.898.898 0 0 1-.107.264ZM30.077 20.236V16.58h-.712v-.56H31.4v.56h-.724v3.656zM31.699 20.236V16.02h.599v4.216zM33.002 16.417c.097-.135.219-.24.366-.315a1.013 1.013 0 0 1 .901-.025.976.976 0 0 1 .536.598c.033.113.05.237.05.37v2.146c0 .126-.012.238-.038.334a.943.943 0 0 1-.15.32.941.941 0 0 1-.335.303.928.928 0 0 1-.479.126c-.1 0-.197-.013-.29-.038a1.302 1.302 0 0 1-.258-.113 1.174 1.174 0 0 1-.214-.158.778.778 0 0 1-.14-.182 1.21 1.21 0 0 1-.113-.315 1.793 1.793 0 0 1-.018-.277v-2.145c0-.126.012-.237.037-.334.03-.1.078-.199.145-.295Zm1.172.333a.376.376 0 0 0-.327-.176.42.42 0 0 0-.214.063.373.373 0 0 0-.145.132.528.528 0 0 0-.05.151.79.79 0 0 0-.013.126v2.215c0 .02.002.044.006.069a.584.584 0 0 0 .1.208c.064.088.169.132.316.132a.4.4 0 0 0 .202-.05.35.35 0 0 0 .132-.126.46.46 0 0 0 .057-.139.86.86 0 0 0 .012-.164v-2.145a.832.832 0 0 0-.012-.176.253.253 0 0 0-.064-.12ZM36.854 20.236l-.939-2.561v2.561h-.605V16.02h.573l.933 2.555V16.02h.605v4.216zM38.315 19.185v.107c0 .03.002.055.007.076.008.042.04.102.094.182.059.084.164.126.315.126a.541.541 0 0 0 .233-.05.351.351 0 0 0 .202-.277.581.581 0 0 0 .013-.113v-.409a.382.382 0 0 0-.05-.214c-.034-.055-.11-.116-.228-.183-.08-.042-.222-.1-.428-.176a1.213 1.213 0 0 1-.517-.359c-.139-.163-.208-.386-.208-.667v-.188c0-.29.097-.537.29-.743a.95.95 0 0 1 .718-.314.96.96 0 0 1 .731.308c.198.205.297.455.297.749v.188h-.605v-.188a.514.514 0 0 0-.007-.082.257.257 0 0 0-.038-.145 1.472 1.472 0 0 0-.069-.107c-.059-.084-.157-.126-.296-.126a.39.39 0 0 0-.303.132.485.485 0 0 0-.113.328v.245c0 .084.013.151.038.201.03.046.097.099.202.158.033.016.084.04.15.069l.26.094c.2.067.381.187.541.359.16.172.24.398.24.68v.34c0 .146-.015.27-.044.37-.026.101-.112.248-.259.44-.147.185-.393.278-.737.278-.366 0-.63-.118-.794-.353a1.286 1.286 0 0 1-.246-.736v-.15h.611v.15ZM5.405 14.475V5.893L3.957 6.977V5.441l1.448-1.054h1.433v10.088zM12.166 9.31c.08.141.13.287.15.437.03.15.046.337.046.557v1.928c0 .23-.025.461-.075.692-.05.221-.202.532-.453.934-.261.411-.754.647-1.478.707a2.67 2.67 0 0 1-1.236-.286c-.362-.2-.619-.436-.77-.707a3.08 3.08 0 0 1-.271-.708 4.061 4.061 0 0 1-.045-.632V10.65c0-.221.005-.377.015-.467.01-.1.045-.23.105-.391l2.006-5.406h1.629L10.16 8.618c.181-.07.397-.105.649-.105h.135c.553.08.96.346 1.222.798Zm-1.373.769a.717.717 0 0 0-.603-.301.604.604 0 0 0-.512.24c-.121.161-.181.372-.181.633v1.58c0 .211.05.412.15.603.111.18.297.27.558.27h.09c.262 0 .433-.09.514-.27.08-.18.12-.382.12-.602V10.65c0-.13-.01-.236-.03-.316a.517.517 0 0 0-.105-.256Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M36.385 22.4c-1.144-.01-1.317.648-1.341 1.41 1.144.01 1.317-.648 1.34-1.41Zm-3.075.18c-.663.931-.22 1.45.391 1.904.663-.93.22-1.45-.391-1.904Zm-1.335 1.394c-.658.934-.213 1.45.4 1.903.66-.934.215-1.45-.4-1.903Zm2.643.183a.152.152 0 0 0-.106.042c-.895.82-1.67 1.687-2.095 2.678a4.26 4.26 0 0 0-.235.72c-.596-.593-.812-1.226-1.58-1.213-1.842.033-2.8 2.891-5.358 2.909-3.616.025-3.33-4.356-10.132-4.391 4.075 3.256-.058 6.247 5.978 8.558-2.562.477-2.618 2.664-5.996 1.58 1.574.611 3.272 2.596 6.442 2.71v2.374c-3.608-.107-7.106-.253-7.106-.253v1.506s8.418-.363 12.647-.363c1.399 0 2.562.282 3.062.425v.953c0 .349.282.63.632.63h3.561a.63.63 0 0 0 .632-.63v-3.517a.63.63 0 0 0-.632-.63h-3.561a.63.63 0 0 0-.632.63v.934c-.5.143-1.663.426-3.062.426-.95 0-2.125-.02-3.356-.048V37.65c6.173-.711 5.963-4.644 5.94-5.542-.073-2.989 1.32-3.63 2.426-3.799-.028.606.075 1.251.357 1.943a.152.152 0 0 0 .281-.115c-.274-.675-.37-1.288-.335-1.86.269-.025.517-.035.693-.053a2.97 2.97 0 0 1-.64-.39c.054-.288.137-.567.253-.838.398-.926 1.14-1.766 2.021-2.574a.152.152 0 0 0 .042-.166.153.153 0 0 0-.141-.099Zm.866.608c-.365.02-.68.267-.982.572.83.786 1.408.422 1.944-.12-.363-.344-.678-.467-.962-.452Zm-1.21 1.45c-.32 0-.637.17-.952.385.667.929 1.302.68 1.932.25-.334-.465-.659-.635-.98-.635Zm-3.927 10.298a.63.63 0 0 0-.631.63v.129c0 .349.282.63.631.63h4.38c.35 0 .63-.281.63-.63v-.129a.63.63 0 0 0-.63-.63h-4.38Zm-7.322 1.2v2.457c-.266-.007-.524-.017-.792-.025v-2.393c.273-.007.538-.02.792-.038Zm-9.852 1.711a.63.63 0 0 0-.631.63v1.067c0 .35.282.63.631.63h.178a.63.63 0 0 0 .631-.63v-1.067c0-.349-.28-.63-.63-.63h-.179Zm17.174 3.845a.63.63 0 0 0-.631.63v.129c0 .349.282.63.631.63h4.38a.63.63 0 0 0 .63-.63v-.129a.63.63 0 0 0-.63-.63h-4.38Z",
  fill: "currentColor"
}))), jI = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 50,
  height: 50,
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ z.createElement("path", {
  "fill-transparent": 0,
  d: "M.28 0H49.72c.155 0 .279.124.279.279V49.72a.278.278 0 0 1-.279.279H.28A.278.278 0 0 1 0 49.721V.28C0 .124.125 0 .28 0Z"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M16.28 8.609V4.393h1.002c.126 0 .246.028.36.082.113.05.214.118.302.201.088.084.157.18.208.29a.762.762 0 0 1 .088.327v.673a.941.941 0 0 1-.082.39.958.958 0 0 1-.523.516.951.951 0 0 1-.378.076h-.372v1.661h-.605Zm1.28-2.353a.236.236 0 0 0 .069-.12.556.556 0 0 0 .019-.157v-.623a.404.404 0 0 0-.108-.29.37.37 0 0 0-.29-.119h-.365v1.428h.315a.865.865 0 0 0 .202-.019.386.386 0 0 0 .157-.1ZM18.286 8.609l.945-4.216h.523L20.7 8.61h-.65l-.17-.906H19.1l-.177.906h-.636Zm.92-1.466h.567l-.283-1.535-.284 1.535ZM21.001 8.609V4.393h1.06a.94.94 0 0 1 .699.29c.193.193.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.932h-.643l-.567-1.806h-.379V8.61h-.605Zm1.343-2.473a.366.366 0 0 0 .075-.157.707.707 0 0 0 .026-.195v-.39a.453.453 0 0 0-.107-.315.376.376 0 0 0-.303-.126h-.429v1.315h.423a.418.418 0 0 0 .315-.132ZM23.891 8.609V4.953h-.712v-.56h2.036v.56h-.725v3.656zM26.996 8.609l-.939-2.561v2.561h-.605V4.393h.573l.933 2.555V4.393h.605v4.216zM29.728 8.005v.604h-1.809V4.393h1.809v.554h-1.21v1.246h1.058v.572h-1.058v1.24zM30.004 8.609V4.393h1.059a.94.94 0 0 1 .7.29c.193.193.29.43.29.71v.39a.99.99 0 0 1-.499.894l.643 1.932h-.643l-.567-1.806h-.378V8.61h-.605Zm1.342-2.473a.366.366 0 0 0 .076-.157.707.707 0 0 0 .025-.195v-.39a.453.453 0 0 0-.107-.315.376.376 0 0 0-.302-.126h-.429v1.315h.422a.418.418 0 0 0 .315-.132ZM32.886 7.558v.107c0 .03.002.055.006.076.008.042.04.102.095.182.058.084.163.126.315.126a.542.542 0 0 0 .233-.05.378.378 0 0 0 .157-.145.346.346 0 0 0 .045-.132.579.579 0 0 0 .012-.114V7.2a.382.382 0 0 0-.05-.214.647.647 0 0 0-.227-.183c-.08-.042-.223-.1-.429-.176a1.212 1.212 0 0 1-.517-.359c-.138-.163-.207-.386-.207-.667v-.188c0-.29.096-.537.29-.743a.95.95 0 0 1 .718-.314.96.96 0 0 1 .73.308c.198.205.297.455.297.749V5.6h-.605v-.188a.515.515 0 0 0-.006-.082.365.365 0 0 0-.006-.07.277.277 0 0 0-.032-.075 1.492 1.492 0 0 0-.07-.107c-.058-.084-.157-.126-.296-.126a.39.39 0 0 0-.302.132.485.485 0 0 0-.113.328v.245c0 .084.012.15.037.201a.58.58 0 0 0 .202.158c.034.016.084.04.151.069.072.025.158.056.259.094.201.067.382.187.542.359.16.172.239.398.239.68v.34c0 .146-.014.27-.044.37-.025.101-.111.248-.258.44-.147.185-.393.278-.738.278-.365 0-.63-.118-.794-.353a1.288 1.288 0 0 1-.246-.736v-.15h.612v.15ZM34.706 8.609V4.393h.599v1.8h.769v-1.8h.599v4.216h-.599V6.728h-.769v1.881zM37.267 8.609V4.393h.599v4.216zM38.372 8.609V4.393h1.002a.82.82 0 0 1 .36.082c.113.05.214.118.302.201.088.084.157.18.208.29a.759.759 0 0 1 .088.327v.673a.94.94 0 0 1-.082.39.969.969 0 0 1-.901.592h-.372v1.661h-.605Zm1.28-2.353a.236.236 0 0 0 .069-.12.56.56 0 0 0 .019-.157v-.623a.404.404 0 0 0-.108-.29.37.37 0 0 0-.29-.119h-.365v1.428h.315a.868.868 0 0 0 .202-.019.386.386 0 0 0 .157-.1ZM41.238 7.558v.107c0 .03.002.055.006.076.009.042.04.102.095.182.059.084.164.126.315.126a.542.542 0 0 0 .233-.05.351.351 0 0 0 .202-.277.581.581 0 0 0 .013-.114V7.2a.382.382 0 0 0-.051-.214c-.034-.055-.11-.116-.227-.183-.08-.042-.222-.1-.428-.176a1.213 1.213 0 0 1-.517-.359c-.139-.163-.208-.386-.208-.667v-.188c0-.29.097-.537.29-.743a.95.95 0 0 1 .718-.314.96.96 0 0 1 .731.308c.198.205.297.455.297.749V5.6h-.605v-.188a.514.514 0 0 0-.007-.082.257.257 0 0 0-.038-.145 1.472 1.472 0 0 0-.069-.107c-.059-.084-.158-.126-.296-.126a.39.39 0 0 0-.303.132.485.485 0 0 0-.113.328v.245c0 .084.013.15.038.201.029.046.096.099.201.158.034.016.085.04.152.069.07.025.157.056.258.094.202.067.382.187.542.359.16.172.24.398.24.68v.34c0 .146-.015.27-.045.37-.025.101-.111.248-.258.44-.147.185-.393.278-.737.278-.366 0-.63-.118-.794-.353a1.286 1.286 0 0 1-.246-.736v-.15h.61v.15ZM16.28 14.422v-4.215h1.802v.566h-1.203v1.265h1.052v.566h-1.052v1.818zM18.382 10.603c.097-.134.219-.239.366-.314a1.013 1.013 0 0 1 .901-.025.975.975 0 0 1 .536.597 1.3 1.3 0 0 1 .05.371v2.146c0 .126-.012.237-.038.334a.947.947 0 0 1-.15.32.94.94 0 0 1-.335.302.928.928 0 0 1-.479.126c-.1 0-.197-.012-.29-.037a1.303 1.303 0 0 1-.472-.271.777.777 0 0 1-.14-.183c-.062-.13-.1-.234-.113-.314a1.792 1.792 0 0 1-.018-.277v-2.146c0-.125.012-.237.037-.333.03-.1.078-.2.145-.296Zm1.173.334a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.062.373.373 0 0 0-.145.133.532.532 0 0 0-.05.15.789.789 0 0 0-.013.126V13.448c0 .02.002.043.006.068a.58.58 0 0 0 .1.208c.064.088.169.132.316.132a.4.4 0 0 0 .201-.05.35.35 0 0 0 .133-.126.46.46 0 0 0 .057-.138.861.861 0 0 0 .012-.164v-2.146a.833.833 0 0 0-.012-.176.254.254 0 0 0-.063-.12ZM20.744 14.422v-4.215h1.058a.94.94 0 0 1 .7.29c.193.192.29.43.29.71v.39a.99.99 0 0 1-.498.894l.643 1.931h-.643l-.567-1.805h-.378v1.805h-.605Zm1.342-2.472a.366.366 0 0 0 .076-.158.707.707 0 0 0 .025-.195v-.39a.454.454 0 0 0-.107-.314.376.376 0 0 0-.303-.126h-.428v1.315h.422a.418.418 0 0 0 .315-.132ZM24.33 14.422v-3.655h-.713v-.56h2.036v.56h-.725v3.655zM25.89 14.422v-4.215h.599v1.799h.769v-1.799h.599v4.215h-.599v-1.881h-.769v1.881zM30.231 13.818v.604h-1.809v-4.215h1.809v.553h-1.21v1.246h1.059v.573h-1.059v1.239zM33.02 13.982a1.01 1.01 0 0 1-.87.478c-.16 0-.315-.037-.466-.113a1.01 1.01 0 0 1-.347-.277 1.051 1.051 0 0 1-.164-.34 1.773 1.773 0 0 1-.037-.383v-2.108c0-.105.01-.21.031-.315.03-.105.107-.254.233-.447.13-.205.387-.308.77-.308.167 0 .325.04.472.12a.89.89 0 0 1 .334.295c.08.114.13.223.151.328.025.1.038.21.038.327v.176h-.599v-.176a.539.539 0 0 0-.006-.088.392.392 0 0 0-.006-.076.492.492 0 0 0-.095-.182c-.059-.084-.158-.126-.296-.126-.164 0-.273.044-.328.132a.762.762 0 0 0-.088.195.745.745 0 0 0-.013.145V13.454c0 .029.002.054.007.075a.67.67 0 0 0 .094.195c.055.088.162.132.321.132.164 0 .27-.044.316-.132.025-.046.044-.084.056-.113a.485.485 0 0 0 .026-.088.237.237 0 0 0 .012-.076v-.837h-.485v-.528h1.084v1.265c0 .088-.002.163-.006.226a.715.715 0 0 1-.076.29 1.108 1.108 0 0 1-.063.12ZM33.843 10.603c.096-.134.218-.239.365-.314a1.012 1.012 0 0 1 .901-.025.975.975 0 0 1 .536.597c.034.113.05.237.05.371v2.146c0 .126-.012.237-.037.334a.943.943 0 0 1-.152.32.941.941 0 0 1-.334.302.928.928 0 0 1-.479.126 1.1 1.1 0 0 1-.29-.037 1.313 1.313 0 0 1-.258-.114 1.186 1.186 0 0 1-.214-.157.773.773 0 0 1-.139-.183 1.2 1.2 0 0 1-.113-.314 1.763 1.763 0 0 1-.02-.277v-2.146c0-.125.013-.237.039-.333.03-.1.077-.2.145-.296Zm1.172.334a.376.376 0 0 0-.328-.176.42.42 0 0 0-.214.062.377.377 0 0 0-.145.133.54.54 0 0 0-.05.15.783.783 0 0 0-.013.126V13.448c0 .02.002.043.006.068a.58.58 0 0 0 .1.208c.064.088.17.132.316.132a.399.399 0 0 0 .202-.05.35.35 0 0 0 .132-.126.46.46 0 0 0 .057-.138.86.86 0 0 0 .012-.164v-2.146a.832.832 0 0 0-.012-.176.256.256 0 0 0-.063-.12ZM35.95 14.422l.945-4.215h.523l.945 4.215h-.649l-.17-.906h-.782l-.176.906h-.637Zm.92-1.466h.567l-.284-1.535-.284 1.535ZM40.45 14.422h-1.803v-4.215h.605v3.611h1.198zM41.08 13.372v.107c0 .03.003.054.007.075.009.042.04.103.095.183.059.084.164.126.315.126a.541.541 0 0 0 .233-.05.352.352 0 0 0 .202-.277.605.605 0 0 0 .013-.114v-.409a.382.382 0 0 0-.051-.214c-.034-.054-.11-.115-.227-.182-.08-.042-.222-.101-.428-.176a1.213 1.213 0 0 1-.517-.36c-.139-.163-.208-.385-.208-.666v-.189c0-.29.097-.537.29-.742a.95.95 0 0 1 .718-.315.96.96 0 0 1 .731.308c.198.206.297.455.297.75v.188h-.605v-.189a.477.477 0 0 0-.007-.082A.257.257 0 0 0 41.9 11a1.465 1.465 0 0 0-.069-.106c-.059-.084-.158-.126-.296-.126a.391.391 0 0 0-.303.132.485.485 0 0 0-.113.327v.246c0 .083.013.15.038.2.03.047.096.1.201.158.034.017.085.04.152.07.07.025.157.056.258.094.202.067.383.186.542.358.16.172.24.399.24.68v.34c0 .147-.015.27-.045.371-.025.1-.111.247-.258.44-.147.185-.393.277-.737.277-.366 0-.63-.117-.794-.352a1.286 1.286 0 0 1-.246-.736v-.151h.61v.15ZM5.958 14.475V5.893L4.51 6.977V5.441l1.448-1.054h1.433v10.088zM9.566 6.917H8.284v-2.53h4.313v1.31l-2.352 8.778H8.707l2.458-8.748H9.566z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M25.276 30.49a5.83 5.83 0 0 1-1.713 4.128 5.844 5.844 0 0 1-4.136 1.71 5.853 5.853 0 0 1-4.135-1.71 5.834 5.834 0 0 1 0-8.258 5.853 5.853 0 0 1 8.271 0 5.834 5.834 0 0 1 1.713 4.13h0Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M31.204 26.178a5.834 5.834 0 0 1-1.713 4.129 5.853 5.853 0 0 1-8.271 0 5.834 5.834 0 0 1 1.897-9.523 5.857 5.857 0 0 1 6.374 1.265 5.834 5.834 0 0 1 1.713 4.129h0Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M34.813 37.363a5.834 5.834 0 0 1-1.713 4.129 5.853 5.853 0 0 1-9.54-1.894 5.832 5.832 0 0 1 1.269-6.364 5.853 5.853 0 0 1 8.27 0 5.834 5.834 0 0 1 1.714 4.13h0Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M37.069 30.42a5.828 5.828 0 0 1-1.714 4.128 5.842 5.842 0 0 1-4.135 1.71 5.854 5.854 0 0 1-5.403-3.604 5.83 5.83 0 0 1 1.267-6.363 5.85 5.85 0 0 1 6.374-1.266 5.847 5.847 0 0 1 3.165 3.16c.294.708.446 1.468.446 2.234h0Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M27.52 37.4a5.831 5.831 0 0 1-1.714 4.13 5.855 5.855 0 0 1-9.539-1.895 5.831 5.831 0 0 1 3.166-7.629 5.857 5.857 0 0 1 6.373 1.266 5.84 5.84 0 0 1 1.713 4.129Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), en = [
  {
    id: 1,
    color: "#EC1B2E",
    number: 1,
    icon: /* @__PURE__ */ u.createElement(vI, null),
    iconActive: "/images/sdg/sdg1-active.png",
    title: "No poverty"
  },
  {
    id: 2,
    color: "#D2A028",
    number: 2,
    icon: /* @__PURE__ */ u.createElement(MI, null),
    iconActive: "/images/sdg/sdg2-active.png",
    title: "Zero hunger"
  },
  {
    id: 3,
    color: "#269B47",
    number: 3,
    icon: /* @__PURE__ */ u.createElement(gI, null),
    iconActive: "/images/sdg/sdg3-active.png",
    title: "Good health and well-being"
  },
  {
    id: 4,
    color: "#C32033",
    number: 4,
    icon: /* @__PURE__ */ u.createElement(pI, null),
    iconActive: "/images/sdg/sdg4-active.png",
    title: "Quality education"
  },
  {
    id: 5,
    color: "#EF3F2C",
    number: 5,
    icon: /* @__PURE__ */ u.createElement(hI, null),
    iconActive: "/images/sdg/sdg5-active.png",
    title: "Gender equality"
  },
  {
    id: 6,
    color: "#07AED9",
    number: 6,
    icon: /* @__PURE__ */ u.createElement(mI, null),
    iconActive: "/images/sdg/sdg6-active.png",
    title: "Clean water and sanitaion"
  },
  {
    id: 7,
    color: "#FEB814",
    number: 7,
    icon: /* @__PURE__ */ u.createElement(yI, null),
    iconActive: "/images/sdg/sdg7-active.png",
    title: "Affordable and clean energy"
  },
  {
    id: 8,
    color: "#8E1738",
    number: 8,
    icon: /* @__PURE__ */ u.createElement(NI, null),
    iconActive: "/images/sdg/sdg8-active.png",
    title: "Decent work and economic growth"
  },
  {
    id: 9,
    color: "#F36D26",
    number: 9,
    icon: /* @__PURE__ */ u.createElement(zI, null),
    iconActive: "/images/sdg/sdg9-active.png",
    title: "Industry, innovation and infrastructure"
  },
  {
    id: 10,
    color: "#E11584",
    number: 10,
    icon: /* @__PURE__ */ u.createElement(_I, null),
    iconActive: "/images/sdg/sdg10-active.png",
    title: "Reduced inequalities"
  },
  {
    id: 11,
    color: "#F99D25",
    number: 11,
    icon: /* @__PURE__ */ u.createElement(II, null),
    iconActive: "/images/sdg/sdg11-active.png",
    title: "Sustainable cities and communities"
  },
  {
    id: 12,
    color: "#CE8D2A",
    number: 12,
    icon: /* @__PURE__ */ u.createElement(DI, null),
    iconActive: "/images/sdg/sdg12-active.png",
    title: "Responsible consumption and production"
  },
  {
    id: 13,
    color: "#48773E",
    number: 13,
    icon: /* @__PURE__ */ u.createElement(CI, null),
    iconActive: "/images/sdg/sdg13-active.png",
    title: "Climate action"
  },
  {
    id: 14,
    color: "#007DBC",
    number: 14,
    icon: /* @__PURE__ */ u.createElement(EI, null),
    iconActive: "/images/sdg/sdg14-active.png",
    title: "Life below water"
  },
  {
    id: 15,
    color: "#3EB149",
    number: 15,
    icon: /* @__PURE__ */ u.createElement(bI, null),
    iconActive: "/images/sdg/sdg15-active.png",
    title: "Life and land"
  },
  {
    id: 16,
    color: "#03558B",
    number: 16,
    icon: /* @__PURE__ */ u.createElement(AI, null),
    iconActive: "/images/sdg/sdg16-active.png",
    title: "Peace, justice and strong institutions"
  },
  {
    id: 17,
    color: "#193569",
    number: 17,
    icon: /* @__PURE__ */ u.createElement(jI, null),
    iconActive: "/images/sdg/sdg17-active.png",
    title: "Partnerships for the goals"
  }
], xI = "_intro_pons3_5", wI = "_close_pons3_10", OI = "_counter_pons3_13", TI = "_drawer_pons3_24", co = {
  intro: xI,
  close: wI,
  counter: OI,
  drawer: TI
}, SI = "_tabs_66iap_5", LI = {
  tabs: SI
}, kI = ({ className: e, ...t }) => /* @__PURE__ */ u.createElement(Wu, {
  ...t,
  className: Y(LI.tabs, e)
}), Un = kI;
Un.TabPane = Wu.TabPane;
const PI = "_drawer_19nd8_5", RI = "_drawer__icon_19nd8_42", QI = "_drawer__title_19nd8_46", n1 = {
  drawer: PI,
  drawer__icon: RI,
  drawer__title: QI
}, z5 = u.forwardRef(
  ({ className: e, icon: t, closeIcon: r, children: n, title: a, onClose: i, ...o }, l) => {
    const c = Le(null);
    return A0(
      l,
      () => c.current ? c.current.parentNode : c.current,
      [c.current]
    ), /* @__PURE__ */ u.createElement(Dd, {
      ...o,
      className: Y(n1.drawer, e),
      onClose: i,
      closeIcon: r === null ? null : /* @__PURE__ */ u.createElement(la, null),
      title: r === null ? null : /* @__PURE__ */ u.createElement(u.Fragment, null, /* @__PURE__ */ u.createElement("span", {
        className: n1.drawer__icon
      }, t), /* @__PURE__ */ u.createElement("span", {
        className: n1.drawer__title
      }, a))
    }, /* @__PURE__ */ u.createElement("div", {
      ref: c
    }), n);
  }
), qa = {
  "space--block": "_space--block_179b1_5",
  "space--equal-grow": "_space--equal-grow_179b1_8",
  "justifyContent--end": "_justifyContent--end_179b1_11",
  "justifyContent--center": "_justifyContent--center_179b1_14",
  "justifyContent--start": "_justifyContent--start_179b1_17",
  "justifyContent--space-between": "_justifyContent--space-between_179b1_20",
  "justifyContent--space-around": "_justifyContent--space-around_179b1_23"
}, ze = ({ block: e, justifyContent: t, className: r, size: n, equalGrow: a, ...i }) => /* @__PURE__ */ u.createElement(sn, {
  ...i,
  size: n || 0,
  className: Y(
    qa.space,
    { [qa["space--block"]]: e },
    { [qa[`justifyContent--${t}`]]: t },
    { [qa["space--equal-grow"]]: a },
    r
  )
}), VI = "_container_1yj0g_1", UI = "_dropzone_1yj0g_8", xu = {
  container: VI,
  dropzone: UI
}, FI = "_upload_1avl4_5", wu = {
  upload: FI,
  "upload--empty": "_upload--empty_1avl4_59"
}, $I = ({ onSuccess: e, onError: t, ...r }) => /* @__PURE__ */ u.createElement(Mo.Dragger, {
  ...r
}), pi = ({ className: e, onChange: t, defaultFileList: r, ...n }) => {
  const [a, i] = de(!(r != null && r.length)), o = ({ fileList: l, ...c }) => {
    i(l.length === 0), t == null || t({
      fileList: l,
      ...c
    });
  };
  return /* @__PURE__ */ u.createElement(Mo, {
    className: Y(e, wu.upload, a && wu["upload--empty"]),
    showUploadList: {
      showRemoveIcon: !0,
      removeIcon: /* @__PURE__ */ u.createElement(la, null)
    },
    onChange: o,
    defaultFileList: r,
    ...n
  });
};
pi.Dragger = $I;
pi.LIST_IGNORE = Mo.LIST_IGNORE;
const ZI = "_container_17f95_1", YI = {
  container: ZI
}, pa = u.createContext({}), wA = ({ children: e, context: t }) => /* @__PURE__ */ u.createElement(pa.Provider, {
  value: t
}, e), Ol = {
  EXTERNAL: Symbol("external"),
  FILE: Symbol("file"),
  RECENT: Symbol("recent")
}, Jn = {
  NETWORK: Symbol("network"),
  CLIENT: Symbol("client")
}, HI = {
  [Jn.NETWORK]: "Network error",
  [Jn.CLIENT]: "Validation error"
}, WI = (e) => {
  var n, a, i, o, l;
  const t = e.status || "error";
  let r;
  if (t === "error") {
    const c = e.status === "error" ? Jn.NETWORK : Jn.CLIENT;
    r = {
      type: c,
      message: HI[c]
    };
  }
  return {
    uid: e.uid,
    data: {
      docId: (a = (n = e.response) == null ? void 0 : n.doc) == null ? void 0 : a.docId,
      url: (o = (i = e.response) == null ? void 0 : i.doc) == null ? void 0 : o.url,
      name: ((l = e.response) == null ? void 0 : l.name) || e.name
    },
    status: t,
    type: Ol.FILE,
    error: r
  };
}, Ou = 4, _5 = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/pdf",
  "application/vnd.ms-excel"
];
function BI(e) {
  const t = _5.includes(e.type);
  t || Jl.error("Wrong file type, should be one of PDF, DOC, XLSX");
  const r = e.size / 1024 / 1024 < Ou;
  return r || Jl.error(`Wrong file size (max ${Ou}MB)`), t && r;
}
const qI = (e) => new Promise((t, r) => {
  const n = new FileReader();
  n.readAsDataURL(e), n.onload = () => t(n.result), n.onerror = (a) => r(a);
}), GI = ({ onChange: e }) => {
  const { uploadFile: t } = xe(pa), [r, n] = de([]), a = (s, d) => {
    n(d);
    const M = WI(s);
    e(M);
  }, i = ({ file: s, error: d }) => {
    const M = r.findIndex((v) => v.uid === s.uid);
    if (M === -1)
      return;
    const f = {
      ...r[M],
      error: d,
      status: "error"
    };
    a(f, [
      ...r.slice(0, M),
      f,
      ...r.slice(M + 1)
    ]);
  }, o = ({
    doc: s
  }, d) => {
    console.log("success");
    const M = r.findIndex((v) => v.uid === d.uid);
    if (M === -1)
      return;
    const f = {
      ...r[M],
      data: s,
      status: "done"
    };
    a(f, [
      ...r.slice(0, M),
      f,
      ...r.slice(M + 1)
    ]);
  }, l = ({
    file: s,
    fileList: d
  }) => {
    a(s, [...d]);
  }, c = async ({ onError: s, onSuccess: d, file: M }) => {
    try {
      const f = await qI(M);
      if (t) {
        const { data: v, error: g } = await t({
          base64str: f,
          docname: M.name,
          filename: M.name,
          mimetype: M.type
        });
        if (g)
          throw new Error(g);
        d == null || d({
          doc: {
            docId: v.upload_file_base64.doc_id,
            url: v.upload_file_base64.url,
            name: M.name
          }
        });
      }
    } catch (f) {
      s == null || s(new Error(), { file: M, error: f });
    }
  };
  return /* @__PURE__ */ u.createElement("div", {
    className: YI.container
  }, /* @__PURE__ */ u.createElement(pi.Dragger, {
    accept: _5.join(","),
    onChange: l,
    showUploadList: !1,
    multiple: !0,
    maxCount: 10,
    onSuccess: o,
    onError: i,
    customRequest: c,
    fileList: r,
    beforeUpload: BI
  }, /* @__PURE__ */ u.createElement(sn, {
    direction: "vertical",
    size: 10
  }, /* @__PURE__ */ u.createElement(ve, {
    type: "secondary"
  }, "Drag and drop PDF, DOC, XLSX here ", /* @__PURE__ */ u.createElement("br", null), " or"), /* @__PURE__ */ u.createElement(_e, {
    icon: /* @__PURE__ */ u.createElement(Bn, null),
    size: "large"
  }, "Browse file"))));
}, KI = "_container_1e38e_1", XI = "_content_1e38e_4", JI = "_header_1e38e_12", eD = "_list_1e38e_16", Ga = {
  container: KI,
  content: XI,
  header: JI,
  list: eD
}, tD = "_container_nm3ab_5", rD = "_leftPart_nm3ab_21", nD = "_rightPart_nm3ab_29", aD = "_fileIcon_nm3ab_32", iD = "_fileName_nm3ab_37", oD = "_errorIcon_nm3ab_66", lD = "_loadingSpinner_nm3ab_70", cD = "_actionsDots_nm3ab_78", uD = "_hidden_nm3ab_81", sD = "_actionsWrapper_nm3ab_86", St = {
  container: tD,
  leftPart: rD,
  rightPart: nD,
  fileIcon: aD,
  fileName: iD,
  errorIcon: oD,
  loadingSpinner: lD,
  actionsDots: cD,
  hidden: uD,
  actionsWrapper: sD
}, dD = "_menu_1ylfu_5", fD = "_menuItem_1ylfu_11", Tu = {
  menu: dD,
  menuItem: fD
}, vD = ({ actions: e, onMenuClick: t }) => /* @__PURE__ */ u.createElement(ec, {
  onClick: t,
  className: Tu.menu,
  "data-cy": "activity-actions"
}, e.map(({ type: r, label: n, onClick: a, icon: i, disabled: o }) => /* @__PURE__ */ u.createElement(ec.Item, {
  key: r,
  onClick: () => a(),
  icon: i,
  disabled: o,
  className: Tu.menuItem
}, n))), MD = ({
  actions: e,
  disabled: t,
  children: r,
  placement: n = "bottomRight"
}) => {
  const [a, i] = de(!1);
  return /* @__PURE__ */ u.createElement("div", {
    role: "none",
    onClick: (o) => o.stopPropagation()
  }, /* @__PURE__ */ u.createElement(na, {
    overlay: /* @__PURE__ */ u.createElement(vD, {
      actions: e,
      onMenuClick: () => i(!1)
    }),
    destroyPopupOnHide: !0,
    placement: n,
    open: a && !t,
    disabled: t,
    trigger: ["click"],
    onOpenChange: (o) => i(o)
  }, r));
}, Ka = ({
  name: e,
  disabledSelection: t,
  hideSelection: r,
  selected: n,
  onSelectedChange: a,
  actions: i = [],
  lastColumn: o,
  loading: l,
  editable: c,
  onChangeName: s
}) => /* @__PURE__ */ u.createElement("div", {
  className: St.container
}, /* @__PURE__ */ u.createElement("div", {
  className: St.leftPart
}, /* @__PURE__ */ u.createElement(j0, {
  checked: n,
  onChange: (d) => {
    a == null || a(d.target.checked), d.stopPropagation();
  },
  disabled: t || r,
  className: r ? St.hidden : void 0
}), /* @__PURE__ */ u.createElement(No, {
  className: St.fileIcon
}), /* @__PURE__ */ u.createElement(ve, {
  ellipsis: { tooltip: e },
  size: "small",
  className: St.fileName,
  editable: {
    editing: c,
    enterIcon: null,
    icon: /* @__PURE__ */ u.createElement("span", null),
    tooltip: !1,
    autoSize: !1,
    onChange: s
  }
}, e)), /* @__PURE__ */ u.createElement("div", {
  className: St.rightPart
}, /* @__PURE__ */ u.createElement(sn, {
  size: 10
}, o && /* @__PURE__ */ u.createElement("div", {
  className: St.lastColumn
}, o), /* @__PURE__ */ u.createElement("div", {
  className: St.actionsWrapper
}, l && /* @__PURE__ */ u.createElement("div", {
  className: St.loadingSpinner
}, /* @__PURE__ */ u.createElement(Xu, {
  spin: !0
})), /* @__PURE__ */ u.createElement("div", {
  className: l || !i.length ? St.hidden : ""
}, /* @__PURE__ */ u.createElement(MD, {
  actions: i,
  disabled: l
}, /* @__PURE__ */ u.createElement(Ld, null)))))));
var I5 = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(jr, function() {
    var r = 1e3, n = 6e4, a = 36e5, i = "millisecond", o = "second", l = "minute", c = "hour", s = "day", d = "week", M = "month", f = "quarter", v = "year", g = "date", m = "Invalid Date", p = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, N = function(E, _, b) {
      var O = String(E);
      return !O || O.length >= _ ? E : "" + Array(_ + 1 - O.length).join(b) + E;
    }, I = { s: N, z: function(E) {
      var _ = -E.utcOffset(), b = Math.abs(_), O = Math.floor(b / 60), S = b % 60;
      return (_ <= 0 ? "+" : "-") + N(O, 2, "0") + ":" + N(S, 2, "0");
    }, m: function E(_, b) {
      if (_.date() < b.date())
        return -E(b, _);
      var O = 12 * (b.year() - _.year()) + (b.month() - _.month()), S = _.clone().add(O, M), R = b - S < 0, V = _.clone().add(O + (R ? -1 : 1), M);
      return +(-(O + (b - S) / (R ? S - V : V - S)) || 0);
    }, a: function(E) {
      return E < 0 ? Math.ceil(E) || 0 : Math.floor(E);
    }, p: function(E) {
      return { M, y: v, w: d, d: s, D: g, h: c, m: l, s: o, ms: i, Q: f }[E] || String(E || "").toLowerCase().replace(/s$/, "");
    }, u: function(E) {
      return E === void 0;
    } }, D = "en", A = {};
    A[D] = y;
    var k = function(E) {
      return E instanceof j;
    }, L = function E(_, b, O) {
      var S;
      if (!_)
        return D;
      if (typeof _ == "string") {
        var R = _.toLowerCase();
        A[R] && (S = R), b && (A[R] = b, S = R);
        var V = _.split("-");
        if (!S && V.length > 1)
          return E(V[0]);
      } else {
        var Q = _.name;
        A[Q] = _, S = Q;
      }
      return !O && S && (D = S), S || !O && D;
    }, T = function(E, _) {
      if (k(E))
        return E.clone();
      var b = typeof _ == "object" ? _ : {};
      return b.date = E, b.args = arguments, new j(b);
    }, C = I;
    C.l = L, C.i = k, C.w = function(E, _) {
      return T(E, { locale: _.$L, utc: _.$u, x: _.$x, $offset: _.$offset });
    };
    var j = function() {
      function E(b) {
        this.$L = L(b.locale, null, !0), this.parse(b);
      }
      var _ = E.prototype;
      return _.parse = function(b) {
        this.$d = function(O) {
          var S = O.date, R = O.utc;
          if (S === null)
            return new Date(NaN);
          if (C.u(S))
            return new Date();
          if (S instanceof Date)
            return new Date(S);
          if (typeof S == "string" && !/Z$/i.test(S)) {
            var V = S.match(p);
            if (V) {
              var Q = V[2] - 1 || 0, x = (V[7] || "0").substring(0, 3);
              return R ? new Date(Date.UTC(V[1], Q, V[3] || 1, V[4] || 0, V[5] || 0, V[6] || 0, x)) : new Date(V[1], Q, V[3] || 1, V[4] || 0, V[5] || 0, V[6] || 0, x);
            }
          }
          return new Date(S);
        }(b), this.$x = b.x || {}, this.init();
      }, _.init = function() {
        var b = this.$d;
        this.$y = b.getFullYear(), this.$M = b.getMonth(), this.$D = b.getDate(), this.$W = b.getDay(), this.$H = b.getHours(), this.$m = b.getMinutes(), this.$s = b.getSeconds(), this.$ms = b.getMilliseconds();
      }, _.$utils = function() {
        return C;
      }, _.isValid = function() {
        return this.$d.toString() !== m;
      }, _.isSame = function(b, O) {
        var S = T(b);
        return this.startOf(O) <= S && S <= this.endOf(O);
      }, _.isAfter = function(b, O) {
        return T(b) < this.startOf(O);
      }, _.isBefore = function(b, O) {
        return this.endOf(O) < T(b);
      }, _.$g = function(b, O, S) {
        return C.u(b) ? this[O] : this.set(S, b);
      }, _.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, _.valueOf = function() {
        return this.$d.getTime();
      }, _.startOf = function(b, O) {
        var S = this, R = !!C.u(O) || O, V = C.p(b), Q = function(J, q) {
          var B = C.w(S.$u ? Date.UTC(S.$y, q, J) : new Date(S.$y, q, J), S);
          return R ? B : B.endOf(s);
        }, x = function(J, q) {
          return C.w(S.toDate()[J].apply(S.toDate("s"), (R ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(q)), S);
        }, P = this.$W, U = this.$M, F = this.$D, $ = "set" + (this.$u ? "UTC" : "");
        switch (V) {
          case v:
            return R ? Q(1, 0) : Q(31, 11);
          case M:
            return R ? Q(1, U) : Q(0, U + 1);
          case d:
            var W = this.$locale().weekStart || 0, te = (P < W ? P + 7 : P) - W;
            return Q(R ? F - te : F + (6 - te), U);
          case s:
          case g:
            return x($ + "Hours", 0);
          case c:
            return x($ + "Minutes", 1);
          case l:
            return x($ + "Seconds", 2);
          case o:
            return x($ + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, _.endOf = function(b) {
        return this.startOf(b, !1);
      }, _.$set = function(b, O) {
        var S, R = C.p(b), V = "set" + (this.$u ? "UTC" : ""), Q = (S = {}, S[s] = V + "Date", S[g] = V + "Date", S[M] = V + "Month", S[v] = V + "FullYear", S[c] = V + "Hours", S[l] = V + "Minutes", S[o] = V + "Seconds", S[i] = V + "Milliseconds", S)[R], x = R === s ? this.$D + (O - this.$W) : O;
        if (R === M || R === v) {
          var P = this.clone().set(g, 1);
          P.$d[Q](x), P.init(), this.$d = P.set(g, Math.min(this.$D, P.daysInMonth())).$d;
        } else
          Q && this.$d[Q](x);
        return this.init(), this;
      }, _.set = function(b, O) {
        return this.clone().$set(b, O);
      }, _.get = function(b) {
        return this[C.p(b)]();
      }, _.add = function(b, O) {
        var S, R = this;
        b = Number(b);
        var V = C.p(O), Q = function(U) {
          var F = T(R);
          return C.w(F.date(F.date() + Math.round(U * b)), R);
        };
        if (V === M)
          return this.set(M, this.$M + b);
        if (V === v)
          return this.set(v, this.$y + b);
        if (V === s)
          return Q(1);
        if (V === d)
          return Q(7);
        var x = (S = {}, S[l] = n, S[c] = a, S[o] = r, S)[V] || 1, P = this.$d.getTime() + b * x;
        return C.w(P, this);
      }, _.subtract = function(b, O) {
        return this.add(-1 * b, O);
      }, _.format = function(b) {
        var O = this, S = this.$locale();
        if (!this.isValid())
          return S.invalidDate || m;
        var R = b || "YYYY-MM-DDTHH:mm:ssZ", V = C.z(this), Q = this.$H, x = this.$m, P = this.$M, U = S.weekdays, F = S.months, $ = function(q, B, G, Z) {
          return q && (q[B] || q(O, R)) || G[B].slice(0, Z);
        }, W = function(q) {
          return C.s(Q % 12 || 12, q, "0");
        }, te = S.meridiem || function(q, B, G) {
          var Z = q < 12 ? "AM" : "PM";
          return G ? Z.toLowerCase() : Z;
        }, J = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: P + 1, MM: C.s(P + 1, 2, "0"), MMM: $(S.monthsShort, P, F, 3), MMMM: $(F, P), D: this.$D, DD: C.s(this.$D, 2, "0"), d: String(this.$W), dd: $(S.weekdaysMin, this.$W, U, 2), ddd: $(S.weekdaysShort, this.$W, U, 3), dddd: U[this.$W], H: String(Q), HH: C.s(Q, 2, "0"), h: W(1), hh: W(2), a: te(Q, x, !0), A: te(Q, x, !1), m: String(x), mm: C.s(x, 2, "0"), s: String(this.$s), ss: C.s(this.$s, 2, "0"), SSS: C.s(this.$ms, 3, "0"), Z: V };
        return R.replace(h, function(q, B) {
          return B || J[q] || V.replace(":", "");
        });
      }, _.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, _.diff = function(b, O, S) {
        var R, V = C.p(O), Q = T(b), x = (Q.utcOffset() - this.utcOffset()) * n, P = this - Q, U = C.m(this, Q);
        return U = (R = {}, R[v] = U / 12, R[M] = U, R[f] = U / 3, R[d] = (P - x) / 6048e5, R[s] = (P - x) / 864e5, R[c] = P / a, R[l] = P / n, R[o] = P / r, R)[V] || P, S ? U : C.a(U);
      }, _.daysInMonth = function() {
        return this.endOf(M).$D;
      }, _.$locale = function() {
        return A[this.$L];
      }, _.locale = function(b, O) {
        if (!b)
          return this.$L;
        var S = this.clone(), R = L(b, O, !0);
        return R && (S.$L = R), S;
      }, _.clone = function() {
        return C.w(this.$d, this);
      }, _.toDate = function() {
        return new Date(this.valueOf());
      }, _.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, _.toISOString = function() {
        return this.$d.toISOString();
      }, _.toString = function() {
        return this.$d.toUTCString();
      }, E;
    }(), w = j.prototype;
    return T.prototype = w, [["$ms", i], ["$s", o], ["$m", l], ["$H", c], ["$W", s], ["$M", M], ["$y", v], ["$D", g]].forEach(function(E) {
      w[E[1]] = function(_) {
        return this.$g(_, E[0], E[1]);
      };
    }), T.extend = function(E, _) {
      return E.$i || (E(_, j, T), E.$i = !0), T;
    }, T.locale = L, T.isDayjs = k, T.unix = function(E) {
      return T(1e3 * E);
    }, T.en = A[D], T.Ls = A, T.p = {}, T;
  });
})(I5);
const _n = I5.exports, Su = ({ date: e }) => /* @__PURE__ */ u.createElement(ve, {
  ellipsis: !0,
  size: "small",
  type: "secondary"
}, e && _n(e).format("dd.MM.yyyy")), gD = ({ message: e }) => /* @__PURE__ */ u.createElement(sn, {
  size: 5,
  align: "center"
}, /* @__PURE__ */ u.createElement(O0, {
  className: St.errorIcon
}), /* @__PURE__ */ u.createElement(ve, {
  type: "danger"
}, e)), pD = ({
  name: e,
  createdDate: t,
  type: r,
  selected: n,
  onSelectedChange: a,
  error: i,
  onDelete: o,
  onChangeName: l,
  onRetry: c
}) => {
  const [s, d] = de(!1), M = (v) => {
    v.length && v !== e && (l == null || l(v)), d(!1);
  }, f = {
    edit: {
      type: "edit",
      label: "Edit",
      onClick: () => d(!0),
      icon: /* @__PURE__ */ u.createElement(T0, null)
    },
    delete: {
      type: "delete",
      label: "Delete",
      onClick: o,
      icon: /* @__PURE__ */ u.createElement(Qr, null),
      theme: "danger"
    },
    retry: {
      type: "retry",
      label: "Retry",
      onClick: c,
      icon: /* @__PURE__ */ u.createElement(Ju, null)
    }
  };
  switch (r) {
    case "default":
      return /* @__PURE__ */ u.createElement(Ka, {
        name: e,
        disabledSelection: !1,
        lastColumn: t && /* @__PURE__ */ u.createElement(Su, {
          date: t
        }),
        selected: n,
        onSelectedChange: a,
        actions: [f.edit, f.delete],
        editable: s,
        onChangeName: M
      });
    case "loading":
      return /* @__PURE__ */ u.createElement(Ka, {
        name: e,
        disabledSelection: !0,
        loading: !0
      });
    case "error":
      return /* @__PURE__ */ u.createElement(Ka, {
        name: e,
        hideSelection: !0,
        lastColumn: /* @__PURE__ */ u.createElement(gD, {
          message: i == null ? void 0 : i.message
        }),
        actions: (i == null ? void 0 : i.type) === Jn.NETWORK ? [f.retry, f.delete] : []
      });
    case "added":
      return /* @__PURE__ */ u.createElement(Ka, {
        name: e,
        disabledSelection: !0,
        selected: !0,
        lastColumn: /* @__PURE__ */ u.createElement(sn, null, /* @__PURE__ */ u.createElement(go, {
          color: "success"
        }, "Added"), t && /* @__PURE__ */ u.createElement(Su, {
          date: t
        })),
        editable: s,
        actions: [f.edit, f.delete],
        onChangeName: M
      });
    default:
      return null;
  }
}, hD = {
  success: "default",
  done: "default",
  error: "error",
  uploading: "loading",
  removed: "default"
}, mD = ({
  data: {
    docs: e,
    attachedFilesIds: t,
    onRetryDoc: r,
    onDeleteDoc: n,
    onChangeDocName: a,
    onSelectChangeDoc: i,
    selectedDocIds: o
  },
  index: l,
  style: c
}) => {
  var v;
  const s = e[l], d = Qe(() => o.includes(s.uid), [s, o]), f = Qe(
    () => {
      var g;
      return ((g = s.data) == null ? void 0 : g.docId) && (t == null ? void 0 : t.includes(s.data.docId));
    },
    [s, t]
  ) ? "added" : s.status && hD[s.status] || "default";
  return /* @__PURE__ */ u.createElement("div", {
    style: c
  }, /* @__PURE__ */ u.createElement(pD, {
    key: s.uid,
    name: (v = s.data) == null ? void 0 : v.name,
    createdDate: s.createdDate,
    onDelete: () => n(s.uid),
    onChangeName: (g) => a(s.uid, g),
    onRetry: () => r(s.uid),
    selected: d,
    onSelectedChange: () => i(s.uid),
    error: s.error,
    type: f
  }));
}, Tl = ({
  docs: e,
  onUpdateDoc: t,
  attachedFilesIds: r,
  onDeleteDoc: n,
  onRetryDoc: a,
  onSelectChangeDoc: i,
  selectedDocIds: o
}) => {
  const { deleteDoc: l, updateDoc: c } = xe(pa), s = Qe(
    () => e.sort((v, g) => v.createdDate && g.createdDate ? new Date(g.createdDate).getDate() - new Date(v.createdDate).getDate() : 0),
    [e]
  ), d = async (v, g) => {
    var h;
    const m = e.findIndex((y) => y.uid === v), p = e[m];
    if (!((h = p == null ? void 0 : p.data) != null && h.docId)) {
      t0.error({
        message: "Error edit file",
        description: "Please try again later."
      });
      return;
    }
    try {
      t == null || t(p.uid, { name: g });
      const y = await (c == null ? void 0 : c(p.data.docId, { name: g }));
      if (y.error)
        throw new Error(y.error);
    } catch {
      t0.error({
        message: "Error edit file",
        description: "Please try again later."
      }), t == null || t(p.uid, { name: p.data.name });
    }
  }, M = async (v) => {
    var p;
    const g = v.status;
    if (t == null || t(v.uid, { status: "uploading" }), !((p = v.data) != null && p.docId))
      throw new Error("Doc was not uploaded");
    if ((await (l == null ? void 0 : l(v.data.docId))).error) {
      t0.error({
        message: "Error delete file",
        description: "Please try again later."
      }), t == null || t(v.uid, { status: g });
      return;
    }
    n == null || n(v.uid);
  }, f = (v) => {
    const g = e.findIndex((p) => p.uid === v);
    if (g === -1)
      return;
    const m = e[g];
    m.status === "done" ? M(m) : m.status === "error" && (n == null || n(m.uid));
  };
  return /* @__PURE__ */ u.createElement("div", {
    className: Ga.container
  }, /* @__PURE__ */ u.createElement("div", {
    className: Ga.content
  }, /* @__PURE__ */ u.createElement("div", {
    className: Ga.header
  }, /* @__PURE__ */ u.createElement(ve, {
    type: "secondary"
  }, "Attached files")), /* @__PURE__ */ u.createElement("div", {
    className: Ga.list
  }, /* @__PURE__ */ u.createElement(Gd, null, ({ height: v, width: g }) => /* @__PURE__ */ u.createElement(Kd, {
    height: v,
    itemCount: e.length,
    itemSize: 36,
    width: g,
    itemKey: (m, p) => p.docs[m].uid,
    itemData: {
      docs: s,
      attachedFilesIds: r,
      onRetryDoc: a,
      onDeleteDoc: f,
      onChangeDocName: d,
      onSelectChangeDoc: i,
      selectedDocIds: o
    }
  }, mD)))));
}, yD = ({
  docs: e,
  selectedDocIds: t,
  onCreateDoc: r,
  onDeleteDoc: n,
  onRetryDoc: a,
  onUpdateDoc: i,
  onSelectChangeDoc: o
}) => {
  const l = (c) => {
    var d, M, f, v;
    const s = e.findIndex((g) => g.uid === c.uid);
    s === -1 ? r({
      ...c,
      createdDate: new Date().toISOString()
    }) : i(c.uid, {
      status: c.status,
      docId: (d = c.data) == null ? void 0 : d.docId,
      name: (M = c.data) == null ? void 0 : M.name,
      url: (f = c.data) == null ? void 0 : f.url,
      error: c.error
    }), c.status === "done" && ((v = e[s]) == null ? void 0 : v.status) !== "done" && !t.includes(c.uid) && o(c.uid);
  };
  return /* @__PURE__ */ u.createElement("div", {
    className: xu.container
  }, /* @__PURE__ */ u.createElement("div", {
    className: xu.dropzone
  }, /* @__PURE__ */ u.createElement(GI, {
    onChange: l
  })), !!e.length && /* @__PURE__ */ u.createElement(Tl, {
    docs: e,
    onDeleteDoc: n,
    onRetryDoc: a,
    onSelectChangeDoc: o,
    selectedDocIds: t,
    onUpdateDoc: i
  }));
}, ND = {
  "application/pdf": "PDF",
  "application/msword": "Microsoft Word",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Microsoft Word",
  "application/vnd.ms-excel": "Microsoft Excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Microsoft Excel",
  "application/vnd.ms-powerpoint": "Microsoft PowerPoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": "Microsoft PowerPoint",
  "text/csv": "CSV",
  "image/png": "Image .png",
  "application/x-7z-compressed": "7-zip archive",
  "application/zip": "ZIP archive",
  "image/jpeg": "JPEG image",
  "application/vnd.rar": "RAR archive"
}, zD = (e) => ND[e] || "unknown", _D = "_submitBtn_78r2h_1", ID = {
  submitBtn: _D
}, DD = (e) => ({
  docId: e.id,
  url: e.url,
  name: e.name,
  format: zD(e.mimetype)
}), CD = (e) => {
  var t, r, n;
  return {
    uid: e.uid,
    data: {
      docId: (t = e.data) == null ? void 0 : t.docId,
      url: (r = e.data) == null ? void 0 : r.url,
      name: (n = e.data) == null ? void 0 : n.name
    },
    type: Ol.EXTERNAL,
    status: "done"
  };
}, ED = ({ onCreateDoc: e }) => {
  const [t, r] = de([]), [n, a] = de(!1), { createDoc: i, loading: o } = xe(pa), l = (d) => {
    r([...t, d]);
    const M = CD(d);
    e({
      ...M,
      createdDate: new Date().toISOString()
    });
  }, c = async (d) => {
    try {
      const M = await (i == null ? void 0 : i({
        name: d.name,
        url: d.url
      }));
      if (M.error)
        throw new Error(M.error);
      const f = M.data.insert_docs_one;
      l == null || l({
        uid: ns("file-from-cloud-"),
        data: DD(f),
        createdDate: new Date().toISOString()
      }), s.resetFields(), a(!1);
    } catch (M) {
      console.log({ error: M }), t0.error({
        message: "Error save file from cloud",
        description: "Please try again later."
      });
    }
  }, [s] = Ne.useForm();
  return /* @__PURE__ */ u.createElement(Ne, {
    autoComplete: "off",
    layout: "vertical",
    size: "large",
    onValuesChange: (d, { url: M }) => {
      a(!!M.length);
    },
    onFinish: c,
    form: s
  }, /* @__PURE__ */ u.createElement(Ne.Item, {
    label: "File from cloud",
    name: "url",
    rules: [{ required: !0, message: "Required" }],
    style: n ? {} : { marginBottom: 0 }
  }, /* @__PURE__ */ u.createElement(Lr, null)), n && /* @__PURE__ */ u.createElement(u.Fragment, null, /* @__PURE__ */ u.createElement(Ne.Item, {
    label: "File name",
    name: "name",
    rules: [{ required: !0, message: "Required" }]
  }, /* @__PURE__ */ u.createElement(Lr, null)), /* @__PURE__ */ u.createElement(_e, {
    type: "primary",
    htmlType: "submit",
    size: "small",
    className: ID.submitBtn,
    loading: o
  }, "Save")));
}, bD = "_container_1dfy2_1", AD = "_header_1dfy2_8", Lu = {
  container: bD,
  header: AD
}, jD = ({
  docs: e,
  selectedDocIds: t,
  onCreateDoc: r,
  onDeleteDoc: n,
  onRetryDoc: a,
  onUpdateDoc: i,
  onSelectChangeDoc: o
}) => /* @__PURE__ */ u.createElement("div", {
  className: Lu.container
}, /* @__PURE__ */ u.createElement("div", {
  className: Lu.header
}, /* @__PURE__ */ u.createElement(ED, {
  onCreateDoc: r
})), !!e.length && /* @__PURE__ */ u.createElement(Tl, {
  docs: e,
  onDeleteDoc: n,
  onRetryDoc: a,
  onSelectChangeDoc: o,
  selectedDocIds: t,
  onUpdateDoc: i
})), xD = (e) => {
  const t = new Date();
  return t.setSeconds(t.getSeconds() - Math.floor(Math.random() * 200 * 86400) - 86400), {
    uid: ns("recent-file-"),
    data: {
      docId: e.id,
      url: e.url,
      name: e.name
    },
    type: Ol.RECENT,
    createdDate: e.created_at,
    status: "done"
  };
}, wD = ({
  docs: e,
  selectedDocIds: t,
  attachedFilesIds: r,
  onCreateDoc: n,
  onDeleteDoc: a,
  onRetryDoc: i,
  onSelectChangeDoc: o,
  onUpdateDoc: l
}) => {
  const { recentDocs: c } = xe(pa);
  if (!(c != null && c.length))
    return /* @__PURE__ */ u.createElement(i1, {
      image: i1.PRESENTED_IMAGE_SIMPLE
    });
  const s = Qe(() => e.filter((v) => v.status === "done"), [e]), d = Qe(() => c.map(xD), [c]), M = Qe(
    () => d.reduce((v, g) => {
      const m = s.find((p) => {
        var h, y;
        return ((h = p.data) == null ? void 0 : h.docId) === ((y = g.data) == null ? void 0 : y.docId);
      });
      return [...v, m || g];
    }, []),
    [d, s]
  ), f = (v) => {
    if (s.find((m) => m.uid === v))
      o(v);
    else {
      const m = d.find((p) => p.uid === v);
      m && n(m);
    }
  };
  return /* @__PURE__ */ u.createElement("div", {
    style: { height: "100%" }
  }, /* @__PURE__ */ u.createElement(Tl, {
    docs: M,
    attachedFilesIds: r,
    onDeleteDoc: a,
    onRetryDoc: i,
    onSelectChangeDoc: f,
    selectedDocIds: t,
    onUpdateDoc: l
  }));
}, OD = ({ count: e, onAttach: t, loading: r }) => /* @__PURE__ */ u.createElement(ze, {
  align: "end",
  direction: "vertical"
}, /* @__PURE__ */ u.createElement(_e, {
  "data-cy": "btn-save-attach",
  type: "primary",
  size: "large",
  disabled: !e,
  onClick: () => t(),
  loading: r
}, /* @__PURE__ */ u.createElement(ze, {
  size: 12,
  align: "center"
}, "Attach", !!e && /* @__PURE__ */ u.createElement("span", {
  className: co.counter
}, e)))), TD = ({
  isVisible: e,
  attachedFilesIds: t,
  handleClose: r,
  onAttach: n
}) => {
  const [a, i] = de([]), [o, l] = de([]), c = Qe(() => a.some((p) => p.status === "uploading"), [a]), s = (p) => {
    !a.find((h) => h.uid === p) || (o.includes(p) ? l((h) => h.filter((y) => y !== p)) : l((h) => [...h, p]));
  }, d = () => {
    i([]), l([]), r();
  }, M = () => {
    const p = o.map((h) => {
      var y;
      return (y = a.find((N) => N.uid === h)) == null ? void 0 : y.data;
    }).filter((h) => h !== void 0);
    n(p), d();
  }, f = (p) => {
    i((h) => h.filter((y) => y.uid !== p)), l(
      (h) => h.filter((y) => y !== p)
    );
  }, v = (p) => {
    console.log(`Retry doc: ${p}`);
  }, g = (p, h = !0) => {
    i([...a, p]), h && p.status === "done" && !o.includes(p.uid) && l([...o, p.uid]);
  }, m = (p, h) => {
    var I, D, A;
    const y = a.findIndex((k) => k.uid === p);
    if (y === -1)
      return;
    const N = a[y];
    i([
      ...a.slice(0, y),
      {
        ...N,
        data: {
          ...N.data,
          name: "name" in h ? h.name : (I = N.data) == null ? void 0 : I.name,
          docId: "docId" in h ? h.docId : (D = N.data) == null ? void 0 : D.docId,
          url: "url" in h ? h.url : (A = N.data) == null ? void 0 : A.url
        },
        status: "status" in h ? h.status : N.status,
        error: "error" in h ? h.error : N.error
      },
      ...a.slice(y + 1)
    ]);
  };
  return /* @__PURE__ */ u.createElement(z5, {
    "data-cy": "drawer-attach",
    footer: /* @__PURE__ */ u.createElement(OD, {
      count: o.length,
      onAttach: M,
      loading: c
    }),
    onClose: d,
    placement: "right",
    title: "Add a file",
    open: e,
    width: 480,
    headerStyle: { borderBottom: 0 },
    className: co.drawer,
    keyboard: !1,
    destroyOnClose: !0
  }, /* @__PURE__ */ u.createElement(ve, {
    type: "secondary",
    className: co.intro
  }, "Use our built-in cloud to\xA0store your important files or\xA0upload it\xA0from your\xA0PC or\xA0cloud storage."), /* @__PURE__ */ u.createElement(Un, {
    defaultActiveKey: "1",
    destroyInactiveTabPane: !0
  }, /* @__PURE__ */ u.createElement(Un.TabPane, {
    tab: /* @__PURE__ */ u.createElement("span", null, /* @__PURE__ */ u.createElement(es, null), " Upload files"),
    key: "1"
  }, /* @__PURE__ */ u.createElement(yD, {
    docs: a,
    selectedDocIds: o,
    onCreateDoc: g,
    onDeleteDoc: f,
    onRetryDoc: v,
    onSelectChangeDoc: s,
    onUpdateDoc: m
  })), /* @__PURE__ */ u.createElement(Un.TabPane, {
    tab: /* @__PURE__ */ u.createElement("span", null, /* @__PURE__ */ u.createElement(kd, null), " From cloud"),
    key: "2"
  }, /* @__PURE__ */ u.createElement(jD, {
    docs: a,
    selectedDocIds: o,
    onCreateDoc: g,
    onDeleteDoc: f,
    onRetryDoc: v,
    onSelectChangeDoc: s,
    onUpdateDoc: m
  })), /* @__PURE__ */ u.createElement(Un.TabPane, {
    tab: /* @__PURE__ */ u.createElement("span", null, /* @__PURE__ */ u.createElement(Pd, null), "File storage"),
    key: "3"
  }, /* @__PURE__ */ u.createElement(wD, {
    docs: a,
    selectedDocIds: o,
    attachedFilesIds: t,
    onCreateDoc: g,
    onDeleteDoc: f,
    onRetryDoc: v,
    onSelectChangeDoc: s,
    onUpdateDoc: m
  }))));
}, SD = [], OA = ({
  value: e = SD,
  onChange: t,
  disabled: r,
  text: n,
  className: a
}) => {
  const [i, o] = de(!1), [l, c] = de(e), s = Qe(() => e.map((g) => g.docId), [e]), d = Le();
  d.current = t, rc(() => {
    c((g) => rs(e, g) ? g : e);
  }, [e]), rc(() => {
    var g;
    (g = d.current) == null || g.call(d, l);
  }, [l]);
  const M = () => {
    o(!0);
  }, f = () => {
    o(!1);
  }, v = (g) => {
    c((m) => [...m, ...g]);
  };
  return /* @__PURE__ */ u.createElement("div", {
    className: a
  }, /* @__PURE__ */ u.createElement(_e, {
    "data-cy": "btn-attach",
    icon: /* @__PURE__ */ u.createElement(es, null),
    type: "dashed",
    onClick: M,
    disabled: r
  }, n || "Attach file"), /* @__PURE__ */ u.createElement(TD, {
    isVisible: i,
    handleClose: f,
    onAttach: v,
    attachedFilesIds: s
  }));
}, LD = "_colorIcon_hwt8e_5", kD = "_copyIcon_hwt8e_8", PD = "_close_hwt8e_11", RD = "_tooltip_hwt8e_14", QD = "_fileTag_hwt8e_22", VD = "_fileName_hwt8e_54", Fn = {
  colorIcon: LD,
  copyIcon: kD,
  close: PD,
  tooltip: RD,
  fileTag: QD,
  fileName: VD
}, { Text: D5 } = ra, UD = ({ fileName: e }) => /* @__PURE__ */ u.createElement("div", {
  className: Fn.tooltip
}, /* @__PURE__ */ u.createElement(D5, {
  style: { width: "auto" },
  copyable: !0
}, e)), FD = ({ name: e, onClose: t, onClick: r }) => /* @__PURE__ */ u.createElement(go, {
  className: Fn.fileTag,
  icon: /* @__PURE__ */ u.createElement(No, {
    className: Fn.colorIcon
  }),
  closable: !0,
  closeIcon: /* @__PURE__ */ u.createElement(la, {
    className: Fn.close
  }),
  onClose: t,
  onClick: r
}, /* @__PURE__ */ u.createElement(D5, {
  className: Fn.fileName,
  ellipsis: { tooltip: /* @__PURE__ */ u.createElement(UD, {
    fileName: e
  }) }
}, e)), $D = "_list_1ovv6_1", ZD = {
  list: $D
}, TA = ({ value: e = [], onChange: t }) => {
  const r = (n) => {
    const a = e.filter((i) => i.docId !== n);
    rs(a, e) || t == null || t(a);
  };
  return e.length ? /* @__PURE__ */ u.createElement("div", {
    className: ZD.list
  }, e.map((n) => /* @__PURE__ */ u.createElement(FD, {
    key: n.docId,
    name: n.name,
    onClose: () => r(n.docId)
  }))) : null;
}, YD = "_layout_n1he5_5", ku = {
  layout: YD,
  "layout--personal": "_layout--personal_n1he5_9",
  "layout--internal": "_layout--internal_n1he5_17",
  "layout--dialog": "_layout--dialog_n1he5_33"
}, HD = "_sider_xbmpk_5", WD = "_sider__logo_xbmpk_12", BD = "_sider__items_xbmpk_16", Xa = {
  sider: HD,
  sider__logo: WD,
  sider__items: BD,
  "sider--personal": "_sider--personal_xbmpk_21"
}, qD = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 19,
  height: 28,
  viewBox: "0 0 19 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  style: {
    mixBlendMode: "darken"
  }
}, /* @__PURE__ */ z.createElement("rect", {
  width: 19,
  height: 28,
  fill: "url(#pattern0)"
})), /* @__PURE__ */ z.createElement("defs", null, /* @__PURE__ */ z.createElement("pattern", {
  id: "pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /* @__PURE__ */ z.createElement("use", {
  xlinkHref: "#image0_5777_8512",
  transform: "translate(-0.202851 -0.142857) scale(0.00877193 0.00556948)"
})), /* @__PURE__ */ z.createElement("image", {
  id: "image0_5777_8512",
  width: 146,
  height: 228,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAADkCAYAAABzAH1SAAAMPmlDQ1BJQ0MgUHJvZmlsZQAASImVVwdYU8kWnltSIbTQpYTeBJEaQEoILYD0ItgISYBQYgwEEXtZVHDtYgEbuiqi2AGxoIidRbD3xYKCsi4W7MqbFNB1X/nefN/c+e8/Z/5z5ty5d+4AoH6SKxbnohoA5IkKJHGhgYwxKakM0lNAASYABXTgwuXli1kxMZEAlsH27+XdDYDI2quOMq1/9v/XoskX5PMAQGIgTufn8/IgPgQAXskTSwoAIMp4iykFYhmGFWhLYIAQL5ThTAWulOF0Bd4nt0mIY0PcAgBZlcuVZAKg1g55RiEvE2qo9UHsLOILRQCoMyD2y8ubxIc4DWJbaCOGWKbPTP9BJ/NvmulDmlxu5hBWzEVeyEHCfHEud+r/mY7/XfJypYM+rGFVzZKExcnmDPN2K2dShAyrQtwrSo+KhlgL4g9CvtweYpSaJQ1LVNijRrx8NswZ0IXYmc8NioDYCOIQUW5UpJJPzxCGcCCGKwQtEhZwEiDWh3ihID84XmmzWTIpTukLrcuQsFlK/jxXIvcr8/VAmpPIUuq/zhJwlPqYWnFWQjLEVIgtC4VJURCrQeyUnxMfobQZVZzFjhq0kUjjZPFbQhwnEIUGKvSxwgxJSJzSvjQvf3C+2OYsISdKiQ8UZCWEKfKDtfC48vjhXLB2gYiVOKgjyB8TOTgXviAoWDF3rFsgSoxX6nwQFwTGKcbiVHFujNIeNxfkhsp4c4jd8gvjlWPxpAK4IBX6eIa4ICZBESdenM0Nj1HEgy8DkYANggADSGFNB5NANhC29db3wjtFTwjgAgnIBALgqGQGRyTLe0TwGg+KwZ8QCUD+0LhAea8AFEL+6xCruDqCDHlvoXxEDngKcR6IALnwXiofJRrylgSeQEb4D+9cWHkw3lxYZf3/nh9kvzMsyEQqGemgR4b6oCUxmBhEDCOGEO1wQ9wP98Ej4TUAVheciXsNzuO7PeEpoYPwiHCd0Em4PVE4V/JTlKNBJ9QPUeYi/cdc4NZQ0x0PxH2hOlTGdXFD4Ii7QT8s3B96docsWxm3LCuMn7T/NoMfnobSjuJMQSl6lACK7c8j1ezV3IdUZLn+MT+KWNOH8s0e6vnZP/uH7PNhG/GzJbYQO4idw05hF7BjWD1gYE1YA9aKHZfhodX1RL66Br3FyePJgTrCf/gbfLKyTOY71zj3OH9R9BUIimTfaMCeJJ4qEWZmFTBYcEcQMDgintNwhouziwsAsv1F8fl6EyvfNxDd1u/cvD8A8G0aGBg4+p0LbwJgvyd8/Y9852yZcOtQAeD8EZ5UUqjgcNmFAL8S6vBNM4D7lwWwhfNxAR7ABwSAYBAOokECSAETYPRZcJ1LwBQwHcwBJaAMLAOrwXqwCWwFO8EecADUg2PgFDgLLoF2cB3chaunC7wAfeAd+IwgCAmhIXTEADFFrBAHxAVhIn5IMBKJxCEpSBqSiYgQKTIdmYeUISuQ9cgWpBrZjxxBTiEXkA7kNvIQ6UFeI59QDFVFtVFj1BodgTJRFhqBJqDj0Ux0MlqMzkeXoGvRKnQ3WoeeQi+h19FO9AXajwFMBdPFzDBHjImxsWgsFcvAJNhMrBQrx6qwWqwRPuerWCfWi33EiTgdZ+COcAWH4Yk4D5+Mz8QX4+vxnXgd3oJfxR/iffg3Ao1gRHAgeBM4hDGETMIUQgmhnLCdcJhwBr5LXYR3RCJRl2hD9ITvYgoxmziNuJi4gbiXeJLYQXxM7CeRSAYkB5IvKZrEJRWQSkjrSLtJTaQrpC7SB7IK2ZTsQg4hp5JF5LnkcvIu8gnyFfIz8meKBsWK4k2JpvApUylLKdsojZTLlC7KZ6om1YbqS02gZlPnUNdSa6lnqPeob1RUVMxVvFRiVYQqs1XWquxTOa/yUOWjqpaqvSpbdZyqVHWJ6g7Vk6q3Vd/QaDRrWgAtlVZAW0Krpp2mPaB9UKOrOalx1Phqs9Qq1OrUrqi9VKeoW6mz1CeoF6uXqx9Uv6zeq0HRsNZga3A1ZmpUaBzRuKnRr0nXHKkZrZmnuVhzl+YFzW4tkpa1VrAWX2u+1lat01qP6Rjdgs6m8+jz6NvoZ+hd2kRtG22OdrZ2mfYe7TbtPh0tHTedJJ0inQqd4zqdupiutS5HN1d3qe4B3Ru6n/SM9Vh6Ar1FerV6V/Te6w/TD9AX6Jfq79W/rv/JgGEQbJBjsNyg3uC+IW5obxhrOMVwo+EZw95h2sN8hvGGlQ47MOyOEWpkbxRnNM1oq1GrUb+xiXGosdh4nfFp414TXZMAk2yTVSYnTHpM6aZ+pkLTVaZNps8ZOgwWI5exltHC6DMzMgszk5ptMWsz+2xuY55oPtd8r/l9C6oF0yLDYpVFs0WfpanlaMvpljWWd6woVkyrLKs1Vues3lvbWCdbL7Cut+620bfh2BTb1Njcs6XZ+ttOtq2yvWZHtGPa5dhtsGu3R+3d7bPsK+wvO6AOHg5Chw0OHcMJw72Gi4ZXDb/pqOrIcix0rHF86KTrFOk016ne6eUIyxGpI5aPODfim7O7c67zNue7I7VGho+cO7Jx5GsXexeeS4XLNVeaa4jrLNcG11duDm4Ct41ut9zp7qPdF7g3u3/18PSQeNR69HhaeqZ5VnreZGozY5iLmee9CF6BXrO8jnl99PbwLvA+4P2Xj6NPjs8un+5RNqMEo7aNeuxr7sv13eLb6cfwS/Pb7Nfpb+bP9a/yfxRgEcAP2B7wjGXHymbtZr0MdA6UBB4OfM/2Zs9gnwzCgkKDSoPagrWCE4PXBz8IMQ/JDKkJ6Qt1D50WejKMEBYRtjzsJseYw+NUc/rCPcNnhLdEqEbER6yPeBRpHymJbByNjg4fvXL0vSirKFFUfTSI5kSvjL4fYxMzOeZoLDE2JrYi9mncyLjpcefi6fET43fFv0sITFiacDfRNlGa2JyknjQuqTrpfXJQ8orkzjEjxswYcynFMEWY0pBKSk1K3Z7aPzZ47OqxXePcx5WMuzHeZnzR+AsTDCfkTjg+UX0id+LBNEJactqutC/caG4Vtz+dk16Z3sdj89bwXvAD+Kv4PQJfwQrBswzfjBUZ3Zm+mSsze7L8s8qzeoVs4Xrhq+yw7E3Z73Oic3bkDOQm5+7NI+el5R0RaYlyRC2TTCYVTeoQO4hLxJ2TvSevntwniZBsz0fyx+c3FGjDH/lWqa30F+nDQr/CisIPU5KmHCzSLBIVtU61n7po6rPikOLfpuHTeNOap5tNnzP94QzWjC0zkZnpM5tnWcyaP6trdujsnXOoc3Lm/D7Xee6KuW/nJc9rnG88f/b8x7+E/lJTolYiKbm5wGfBpoX4QuHCtkWui9Yt+lbKL71Y5lxWXvZlMW/xxV9H/rr214ElGUvalnos3biMuEy07MZy/+U7V2iuKF7xeOXolXWrGKtKV71dPXH1hXK38k1rqGukazrXRq5tWGe5btm6L+uz1l+vCKzYW2lUuajy/Qb+hisbAzbWbjLeVLbp02bh5ltbQrfUVVlXlW8lbi3c+nRb0rZzvzF/q95uuL1s+9cdoh2dO+N2tlR7VlfvMtq1tAatkdb07B63u31P0J6GWsfaLXt195btA/uk+57vT9t/40DEgeaDzIO1h6wOVR6mHy6tQ+qm1vXVZ9V3NqQ0dBwJP9Lc6NN4+KjT0R3HzI5VHNc5vvQE9cT8EwNNxU39J8Une09lnnrcPLH57ukxp6+1xLa0nYk4c/5syNnT51jnms77nj92wfvCkYvMi/WXPC7Vtbq3Hv7d/ffDbR5tdZc9Lze0e7U3dozqOHHF/8qpq0FXz17jXLt0Pep6x43EG7dujrvZeYt/q/t27u1XdwrvfL47+x7hXul9jfvlD4weVP1h98feTo/O4w+DHrY+in909zHv8Ysn+U++dM1/Snta/sz0WXW3S/exnpCe9udjn3e9EL/43Fvyp+aflS9tXx76K+Cv1r4xfV2vJK8GXi9+Y/Bmx1u3t839Mf0P3uW9+/y+9IPBh50fmR/PfUr+9OzzlC+kL2u/2n1t/Bbx7d5A3sCAmCvhyn8FMFjRjAwAXu8AgJYCAB2ez6hjFec/eUEUZ1Y5Av8JK86I8uIBQC38f4/thX83NwHYtw0ev6C++jgAYmgAJHgB1NV1qA6e1eTnSlkhwnPA5uCv6Xnp4N8UxZnzh7h/boFM1Q383P4LDkZ8awxSapwAAACKZVhJZk1NACoAAAAIAAQBGgAFAAAAAQAAAD4BGwAFAAAAAQAAAEYBKAADAAAAAQACAACHaQAEAAAAAQAAAE4AAAAAAAAAkAAAAAEAAACQAAAAAQADkoYABwAAABIAAAB4oAIABAAAAAEAAACSoAMABAAAAAEAAADkAAAAAEFTQ0lJAAAAU2NyZWVuc2hvdMh/G+gAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAHWaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA2LjAuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOmV4aWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vZXhpZi8xLjAvIj4KICAgICAgICAgPGV4aWY6UGl4ZWxZRGltZW5zaW9uPjIyODwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj4xNDY8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpVc2VyQ29tbWVudD5TY3JlZW5zaG90PC9leGlmOlVzZXJDb21tZW50PgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KZkvWKAAAABxpRE9UAAAAAgAAAAAAAAByAAAAKAAAAHIAAAByAAASQ0Hj0aQAABIPSURBVHgB7F0HfBRVGv8nm82mkN42CQrCKUU0HsIhRZCgnsKpKNwBETAUD44mnUDoIEUDSEeaBVCQQxHBQwSkHSgIyiERRQgkgSSEVNI35b4XDWy2ZWd2Nruz+77fD3Yy8+ab97757/vqe+tSRQROXAIWSsCFA8lCCfLbqyXAgcSBIIkEOJAkESNnwoHEMSCJBDiQJBEjZ8KBxDEgiQQ4kCQRI2fCgcQxIIkEOJAkESNnwoHEMSCJBDiQJBEjZ8KBxDEgiQQ4kCQRI2fCgcQxIIkEOJAkESNnwoHEMSCJBDiQJBEjZ8KBxDEgiQQ4kCQRI2fCgcQxIIkEOJAkESNnwoHEMSCJBDiQJBEjZ8KBxDEgiQQ4kCQRI2fCgeTEGLhVXAV3V8Bf5WKxFDiQLBahfBlsSKxAmBfwYmOFxYPgQLJYhPJkkF1ShZHHyxHuCSztpLR4EBxIFotQngxW/K8cx25WVnf+rQ5KNPG1TL1xIMkTBxb1en9yJTYmlt/l8XwjBYa0sEy9cSDdFadzHFzMrsTcM+Wo0NrMyMfdBZu6KuFqwaTEgeQc+Kke5dEblVhHBrZGG0V/jH9jtDv83cULgwNJvOxkc2cZAWf7b5XYk1RhtM8JHZVo7CN+SuJAMipa+V+oJPV1lAzqHZcrcJu8NFM0o40SUcEcSKZk5HTXskuBE2kVOJxaidQC0wCqEc7oR93QJYKikyKJz0giBWdPtxWVV+FKXhUu07/ztyuRmFMFoTuDxjZX4G8WBCY5kLQQwVRBflkVcukbXWLAINVqWm+HVXABs3HKKOSjoX8lBBo242QVVyKrBGBpjhs065g37xjv9lRSbY+H8BnJuIQMXEkvrMLpjN+nfRbhzS39HTx5BCIGJmcjZhltfsYdvhQGEEtOMSOxaT4pvwrfpVfgO7Idku84IVpMICSygStWdrXA9yfeDg0kpgZ2/1aBQ9fJayEVwMmwBKLvV2B0a8vybQ4JJDYDnbhRgQ8uaDiADGOn1tnpHVRooxZvHzFmDgekpLxKbPixDInkvXCqWwJt1ApM76iqu2EdLRwGSExxbftJg12XNE5pMNfxng1edle4YOVfPaD2Fm9k1zB2CCAxT2vNmVIcuHovo10zQP5pXAIxrZTo28oyI7uGu+yBVE4abMnJEpxINp5Hqhks/7wngTYRCkzr7AGlZabRXYayBlIpYWfB0RKcvclnortv1IyDZ/+kxMh2KpBmk4xkDaT53xTj2xQOIiFoiIlSISZKGnWm/VzZAumryxqsIJXGyTwJ+Hu6YkgbFaKbuJl3g8BWsgRS2p1KjPysgPJOAkfrhM39PFzQ+xEVerRQwsPNtC47fEWDNg3d4CtieZLsgMQ8tEl7C5GYwY1rU98LXwLQK+SRvfiwOzyVpgHE+GhInEN3FmDA4yo8/aDwKLfsgLTzx1JsPs1Vmi6ImOHcLMwNUeEKPBbphhZ0rBRQz7/7QinePVWC9o2VmPksLXYTSLICUhl9a/pvyUN+HdV+AmUgm+ZsZmEzjZ+HK3w92acLAr1c0YrA80i4G7xEZu/vkDyH7shHHuUjVaT+Pon1o09hYpEVkL5MLMPyI0XCRmiiNZvwHwpVoAWlCZrTNzjE2xU+9JK8yKmpWxmYYCzxJRfqDOuXu4AZxtwulGiqMPULMhXS7xmc77ziUy0Tc3mwdrIBEkuB/HNbHpJzLM+hedM3t3srFbo/rEKEn0QROSFSt5O25VQwN+vLQnx/XVOrR3HPeqPrQ8JCBLIB0plrGsTvKag1YDF/PPGAEmOivREsQX5JzPPt5Z4iKuJLOFiEE7+V6XVpSAdP9GnjoXfe1AnZAGn65wU4naQ/aFOD0732WntPvNqOFrs7ObEZaNnBQmRSGMUQ9aBwwRvdvA1dMnpOFkBirunLq7NRSoVqYqn/E554rYNwb0Ts8+zxvtScCnx8uhgHLjKv17gV2L6pO+a+5CNoCLIA0oXUcozfnidoYNqNH6UgW0IfPzCj1dmI2UEnKdC493wJfqSZyJyvYreWKsR1byBIVLIA0rZTRXj/uDhvTUG29LrYADQOtoLLI0jU1m/MQJJLCxuuZ5Xjp1QN2Bcw8YYGzDMTQr3bemJYVwdUbZNpNjpHxrYY6tJchRk9TU/TLH5y5moZUrPtO1rOSogr6L9KMm3YTFNEJmNRaWX15638CmTkVZD6FyOl2vcM7eKNvmRPCiG7mpEqSEBsBtEmVm/Uc8ltwd+qGh7TSNdHP2zcA9l0pBDbacZjL4nT7xKY2MMHz0UZl5khOdkNkHZ/X4zONHsE0tIYbcqgGuyYlVnap8w+diNWn00IhpeRJOQNmoEGr8sGAyunexJYMzgAzSKEhbbtAkiJpM/HfZCLzycFw0MnzP9rWjn+tSH73igFHKn9Fdg2JsjoHfvOFWPp3jtGrzvjhYgABT4cFUiOiTDPxOZAyi2sxPB3s5FFMY0DM0P1PKszv5Uibqs4j63lfUqsHBJgFA/Hfy7F7B3ieBtlKvML/Tt7YxAFbIWSTYHE7JLJH+TgHBm6DSiX9Pm0EL3+HzxfjIW78vXOm3OiUwsV5vTzN9r0YooGY0TOdkaZyvzC5lFBaBQqTK2xIdsUSOeulGLSeznVog/1U+DjSfpA2nWyEGu+FKd+2j2kwoKBxmck5v0MWJaJdArUcQKaN1Ri9XDjpoApGdkUSNM+zMG3l2hrDSL2LXhvbLBeXz86WoiNX4kD0v0hCrw/Th+c2g/ZfqwQ6/eL46/NR+7HKipRWTsyCI1FzEZs7DYDUkpmOWKXZN6NtLYge2b1SH0gffFdEZZ9Js6O8SDh7Jur1rO7tF96fhF5hYszq+Mx2ued7XhCLz/0aCs+hWQzIL3zWT72nCq8+75aNXbHihH60+qxCyWYveV39Xe3sYCDpTRVP9bEdEnEgbPFWLQjVwBXx2oa/ZgnpscYtyXNGa1NgKSh6OtLM9NRwnaP+oOY2797jhruOvXF58mOGrdWXByJse7yqCdmmbCTap6/8ONcfH1WXBqmhoccP5uEK7GcVJo3OTuWkE2AdPFaGUavuK3X74R/BaH1g7U3NEijoOGr8zP02pp7gkXKt8aHIYziI6aoiDbbGkGGd/ItCXIMph5kJ9dYmOiljt4Y9oIvmH1kKdkESLuOFmC1Abun39M+eP1vvnpj6jM7HZm54j2rqD+psGREMFzr+NLlFlQifkMWfr5uWd2T3gDs7ESQrwKTYgLwF8okSEU2AdK897PxzTl9NfIQGdzrJoXpjW3hlmx8fUa/vV5DEydiu/ti4HP6INW9hanbee9l41R1zY7uVfn/3YlU/YR+AfCj+nQpySZAipmZhgwDmXY23e5aGA6/BrXV0H8olpTwkXiDmwlMQet1Zg4ORKeourPaFbR47uMDd/DJoQIU0qafcqcmkUp0+bMnnmrthYYi3fu6ZFDvQMq9U4FeU24a7deMIUF46vHabmgeqZy+8TdRJrCuRvchbgSm+MFB6ExCNYfyCyuwnQC1m1RxKdU4y4keiHSvBk+X1p64Xy18waPQsdY7kJLTNRg0J91oP7uTATihf6De9YSt2fjPf++FC/QamHmCGd9xsUGIFhAzyaU84AXK+V29UYYkKhRLuqlBMRnntiIVebiBZOcE+LgikDIC/n98Bvgoqs8HU7I6pA7nQuq+1zuQfiGPbcQC40DyokV/H86PQAAJSpuS6CW+Pjddkroh5qMMeMEPA+mf5f6Kdi+d97jegfTDpRJMTLhlUuIvPNUAYw3MSvErM/EtJXGloo6k4uJIlXpZGEORqj9y5lPvQDr5QxFmEiBMETOM188JR6OI2ro9ndIqQ8lQL6HyUqmoMRmiM0eE4H4KzHESL4F6B9JBSossWq8fjNQdQjvyrt4cG6p7Gjv35+PdHZZ5cLpMmc0x6tVAPN9Z2MoJXT7O/He9A+nId4V4c43pGanmhbw1RY0/t6xdO8xKP96Yn4ZLlDqRmro+4Y2xsVSaSxs0cBImgXoH0vmfyUYyYWxrd79pI3esnRehl72/nVOOUbPSkGWFOqJwirPEDQ9BS51UjXa/+LG+BOodSMnkPg+ZnKrfEyNnJg0LwbMGVM4vV0sxYV6aVeI7zEZ7tacfYl7yrw5kGukaP60lgXoH0h0KLvZ6/bpWF0wfNqBQ/qo3IxFB287o0pFTBVi06jat87JOTKclVVjGjQqFOkT/2bp9cfa/6x1IrE67R/8klAtYx9+ooTuWU2zJizbU1KWDxwqQsDbTamBizxw9JBjdnuSGuK7stf+udyCxhw8ckYwMcuWFUPs23pg1OUzPXmI8Dh69gyVrrDczsWd06+yDUUMp5mQAzOy6s5NNgPTmkgwcOyl8r6N+vQIQG6OfPmEv8ciJAry98pagmU7oyw8n9Ro3To3m3BDXE51NgPTpnjysf6/uWJJub1l1wNQJYejc0bCa+fFCMeYvzkABJVutRW60x+KAvoH4xyv+BmdHaz3X3vnaBEiXfinBuCnme27aQvSgdMaShZFo8oDhoqxryaWYRd7cLYGqU/sZ5hxHPeKJSWPDEBTEDXEmL5sASUPlIL37XkGZyNKM0FAlEhY3REiw4ZeYlV2O+QsoaEmAtSb5UmJ5/BthaPcX4StTrdkvW/C2CZDYQCdSLCkxUXwCNixMiQXzIxFuJEfGwLpq9S18fVDcKl1zXwZTty++4I/Bg4KhlKD22dzn2ls7mwFp164cbN4k3E7SFmAgqZUFCyJx333Glxt98UUeNm7ItKoRzvr04IMemBKnNgps7X474rHNgJSdVYHYAVctjv/4UWHXvAUN0aSpYZuJvbQL/yvCWwvTkUOpFWuSNwVPJ04JR1snVHU2AxJ7oTOmpuKHs5ZXPTagGu/ZFP1u3sJ4CW02bYe3aP5NJF4Ur07NASFTdQMHhaB3H7Y1jDl3OEYbmwLpyKF88sDSJJGkJ/2Uwox5kXgkqna9tzbzCpqQNq+/hT2fSluGov2MmuNnnvPDqPFhtATKOdBkUyCVUt3zwN6XUUzr76Ugd9qZbWJ8BJ7oaHrPyOPf5GPV0nTJnmus708+5YvxU8OhqOPnrYzdL6fzNgUSE9TWTZn4ZKv4Jdm6wmbqpM+AYPR7LRgu+qm5u81TKd60ePZNXE+Svq7p7kPo4MmuPpg4I9Lh1ZzNgVTEdmyLuYK8XGkN4bYdGmD89Eh4mVgIyGbEdUvTcHi/uN1OtAFj6jhmcAj6ELAdmWwOJCbcvf/Oxsbl4tf3G3tBERQWmEoe3X2NjXt07N5DX+Zi/bIMlJZIo2J1+8PspPhFDfF4e8OpHd32cvzbLoBUTsHD0f2vIJ2WHElNzAgfw+ymLqaXa6eQint7RipSrllH1alpweKKrU0dNmhpF0Bi4PmesvcLJidLjaNqfsxu6kWqpe/QUJMbSZTQ8uyNZIQf3medvZIGjAjDy/3194CyyqDrmandAImNe0NCGvaTmrMWNaNE65hZDaGmQjlTdOwrqk5YfFNyr86HVsBu2tfMIct37QpIGkriTh10FdcuWy/Z6umlQOx4Nbq9aHqHsrSUMiyLT8FVWtApJc1Y2QhR7RzPVrIrILEXxl5g/OCryJfYi9MFQ1uymYZPi4BfoOEKAtaeAXvbqgzs235bkqXijOczLwdiGD3X0cjugMQE/CvlxuYMT0KZlTdq8Kek7zAKEbShMlpTdPb4HayZcwP5EuTqmrb0xKItTU09TpbX7BJITJKnKfq8bFKKxUldc95KdM8A9B+rhrfOxhXa9+ZQodyq6Sn46YxlucGAENpM7Ktm2qwd4thugcSke5y8pzUzGJisL2v/YCVem6hGh+cM206sD59uyMDOtaY3wKirpyymtPXMww5ncNs1kNhLOUVR55VTk1FpvTLsWu/+sU4+GExxp1CK+9RQ+vVSrJmeil/PW7b9IOPnSrv1bDnTyuHyb3YPJCb80wfzsCouBRoJdyFhfI2RipYc9R6hxvMU8zm0MwsfLUtHqURbAIY3UtEvMnHVZkz2Vj//y7lCLBmdhAILdrcV2skGVDRXQL/KKCW1poqAiasfkJKlXfCSxYxUI6k0Sl+8PSwJGZS5lysNmdsQ0X93vOi2rIDEwFNA8aXVE5Jx4b/y+yEaH4pZLT/cAu4OuEOc7IDEwFRJPwz873fSsZe8KDn9Fm2vMWr0HKlmQ3A4+j8AAAD//zaO5qUAABbJSURBVO1dCXgVRbb+s5CEbJCF1WwkYRdEWRRFGRkXQOTTecMuoKADKvMURUEQFBB5iIiAgAqoyKC4II+HoGwCgkQdGFlEWRIgQAiEQPbtZnvn9L2du3XfJJ17O7m3u0io7qrqWv+cc+rUqSqvSnJwU3d4Rw5WT7+AgpzyBt+C6PYBeH1jOzTy927wdVVSQS93BhI3+HqaASueO4/k3wqUtF+Vbxg8r29qh6j2jVUprz4KcXsgcadVEEHatDgdWz+4Ss8Ni8B6eQHjF8Sgz98jrMY3OaUEiQn+VmHu/OIRQBIH4MyhfKx64TyuXTSIQfXuj5gZhQfGNbeqR15+BebMu4yF86Oswt35xaOAxANRlF+Oz2dfwoGvrtf7uPxtSmsMmtTSrh5r1mZi23e52Lgh3i7OXQM8DkjiQBzdnYO1U1ORk1EqBqnme/t6YfS8GNwzItKuzMzrZRj/dCoMxZX4cn08QkI8Q/j2WCDxCKadKsIbg06itLjCbkBdFRAQ7IMJy+PRpV+oZBFL37+G777PIcEOWLY42mPkJI8F0uFtWVg3lVQDWWWSA+qKwFZtA/D0hwlgX8qlXS7FhOcuoryUUEQ/82a3xm23BkoldbswjwNSMQmyG2al4uCX6spIPQaHY+zCOPgHSbOqtPRSvDInHRlXSkGdLgBp9qut0KtXkNuBRqrCHgWk1KOF+HBiCjJTS6Ta6pIw/0BvDJ1D0/uR9vKQWODZVAOmz01HFlFHL6JEIpBmTmuJO+8MFpO5te8RQOI/8D1rrmLjXGYb6umRojsHYtyKeGJl8orGP06X4NX56SggSomKSisgTZvSEn3v0YHUIP6CCnPK8Onz53D0+2zV6sNKxn5PtcQjM6Lg60cvMu7QsSLMeScDxUXlAoBsgfTS5Bbod2+IzNfuFezWFCn9dBHeH3sG186px8qCwnwxZinNyu5v4nCkf/y1APOXX0O5geUhIyUSfZG1zZ3VCj166DKSw450deTx7dn4+JlklDDLUMnF9wrGuA8SEdbaz2GJ2/bmY8nH11FRVmFFiWyB9B5N/xM8ZJnELSnS9ncv49sFaaikv3Q1nJe3F+4nDfWgqVFgZaOcKzFUYPn6LGzbmycJIFsgfba2DcLCfOSyc6twtwISL8h+NS0VB9ZeVa2TgyN8MXp5Ajr1a+qwzFTSEc1deQ3nL5Em3YaV2b4za2MlwZZvEuBNIPUE5zZAKiupxCcTknFs6w3V+j3xzlCMJVbWpGUjh2V+fzAfy9Zno4SEajCRrAGQ4qL9sHJZjMN83SnSLYBUQguxH4w8hZSkXHX6lojE/c/dhIHVsLIiAveSz7OwMykfIAx5MautIZAG9W+CZyc2U6c9KpTS4IFkKCQQDVMPREHhvhi1IhGd7nPMylLSiJWtzsTFK7QEwwCqJZCmvUg6pLs9Q4fEOG3QQOLF1g9HnMSZ/epQorgewRi7ui3CohwbnG35qQArvs6GoYRmjCYKVFsgrVsdh8hIXxVohTpFNFggsYZ69WOn8OdudRSNfSe2wsOzoknBKL1WxsORV1SBdzZkY9+RInixJaYFK6sNkNrF+2Hpomh1RlilUhoskL6YfBZJ6zJc3g28yDp8SQJufcTaFNa24GNnDXiTpvYZZE/EVKguQHr+mWbof7+0mYltue7y3iCBtGdFOjbTCr6rXQtaI3vik7Zo2V7elKOcuNfanXn4bHceKRipRiYqpBRIwQHeWL8mDgEBnjHtF8eowQHpxI4srBl92uVG/N0GR2AELXX4kyGanEu/UY55G7Lwx3mjbohtiOoKpMEPhuLZf3jObE3suwYFpKxLBrzV9yiKXLhPzZtw8/CsWPzlmVbgxVc5t4vkoHc356KQ5KIqANURSAGkjlq1JAbNm3mOkC32X4MBEmutlz/yp0t1RYG84PphIjrcKz+1LyTd0LtbcrGbgFQpAsfWVygjjR8ZjqGPypctDoo7+g0GSDvfScPWNy+6rA9bdmiMJ9e1R2QbaTNYLvgPWt6Y93UOrhBLYxbmTCDFtmqElW+T2YmDtTqXNV6FjBsEkC4eLcC7/X93mVFal4HheGxFgqw8xIZxX/xciI9256NcFKidCCTqZCyc2RpdO8uDWIWxdmkR9Q4k/qtnEKX+h5YZXODun0xLHa9EgVfwpVwR2Qu9vTUPe0+QTRPPyKrYmPMo0lMjwjBksGeyNLFP6x1IP5OuaAPpjJztfMhycdiiePQaIT9DSssqx2sbc3E+o0yCjTkHSAPuCcELE+TtuZ3d7vrKr16BVEjG8PNuP4KCG8xPnOdYqB73STsk3iWv9Ps5xYAF3+YL2mppeajuQOra3h8LyMDfU+UiyxGrVyBtfOU89q+6YlmfOj9HxPpj4pcd0SxBWh5h7rWe5KF/HSwSdFWiQC36zmJtncnycd6LLRAssz2pzg1tYBnUG5ByaH/XG91/QykvfDrJtaZdHRO/7IDQFtKmsAUkDy34Ph9JyXTIhEkWEgEk+mK4NJWiijIS6ceRZvuuWxtjOpmI+DvYGOCkJjeYbOoNSFtmX8DuZZed1hHMxnh6HxAqralOpSn97K0FuERrZYKJrouA9DDtCvnnqHCyfHRa09wio3oBEu+seK3rf5Cf6ZwDHroMDMOYVW1lT0PbT/LQol0FKOTNJsK03jw7EymR6CulSN6U5ZOkbBw2QF4ucwtEKKxkvQDp+Hc3hPU0hXW2+qwbrdqPXpkIn0bS0/vtJw1YvKcQlaQ5F8HibIoUHuyNGeMj0K2DtFxmVWEPfakXIH02KQW/brhW5y7tMSQSI99LBK+fSbkdp0qxeG+BcKKbpczjTCDd0tYfM8ZFIKKJTCWkKuaBYeoDiVjAjPaH6jzlZ/3QCLIj8pKRRXaeJhDtK5ScmTkDSN7EIof9NQTjBofCR0bZ6YF4kW2S6kC6fKKQVviPyVaoJhHMzsbQ7g5vH2l2tvM0sbP9xSZ2ZsnSKHcnyEghjb0xbWRT9O4iv+e/Ju3wpDSqA+nAR1fx9cvnFPdh5wfCMG5tO1mZaFcyUaL9rCMyg8YsG5nDRKHaNk4Mt2SF5jCgY3QjzBobjhbh2mZltgOoOpB4OYSXRZQ43mc28asO8JU5q3p3CoHoQLENO3MORaKOwn/1CcZTD4WgkYeu4CsZE/Eb1YG0+AFlC7ThMf54cVcX8HYhKffD2TICEVEi0g+xDGSmNJbP9KUC1hZMisWXhzZFn5u1OyuT6nPLMNWBNL3tIfAaW21cI5JJnv+uM266Wfrkjj3nCEQHS4gSVQgAciaQElv4YPbocLTSWZnDIVMVSMW55ZgW/2+HFZKKHLY4Hr1HW59VLab77Uo5Xt9TjHLT9iCmRM4C0oO01PEczcr8ZXRUYh10X+UNkhnJRXjzjqO16ve2fULxzKZOkvbVxUTYJn1XiKt5zL5YW21kY3UFUiNSKUwaEIxBPeV3l9SqERpIrCpFOvdLHpY8dKLG3dqItu5M3d9V1jz2oyOl+F/SXItUyBlAiiQt9eyhTdAhyvHBETVuhEYSqgqkkz9k4/2hJ2vctQ++dBMGTJXekZqcVYEpu8wzNGdQpMTmvnhjeCiaySz81rjiGkyoKpBqs8bGxmkzD3dD41D7WRqLQ1N+KEbKdRKILNiZ5XNtZ223J/jh1UdD0VhDph/OxLu6QNpGi7VjTteo/oNmRuM+OlpGyn1zmg4gPW6wUDoaBWylQHq0Ox20fl8w9JUOqd6uWZiqQDq5h1jbkOpZG+uKXjtyG/zoDGtbl15QieeIpRnKKp0CpNF3BmJMH12otu3n2r6rCqSaCtu8C/aRObF2bSGOhtd+MuDYVVr/IE2zeRlEGUUadXsAHr9bWjdlV7ge4LAHVAVSTRZseRv1K0nd0DzRXov8w8VyLDtcapzq1xFII3o2xri7q6dE2QUV+JNO7j9NmydL+KhjKlcwtWVU8y87Vj3QD3Wm0ecwjhPfK71McXRMMv+jcI4S6C1/R0k5zIu/EZ7pPzGeHjjcizpGSCPGczg9e/P//K0YTs8hJF/GdmyMKLoTxY9mvmo4qhs3SR1XmF2G6YmHHBbGJrOTNneyS1NMrOwfuwzIo+uphBkaVVspRRrc1R+T+jmmRMdTS7GE9v6fSyf1gmkBuGrxlgfWpAAVAMNAojS1OfqP8+L0fKUEA1EAC+XJYDHGmeLpXUhDwWy6IqTlb+lR/F4AmBBmTCu++xKGWrXxF0AVQ8CKJZv2aPKDZZaZ7Dq9FgGqAonr9Ur8IRTlyi+RDHm7De56vIVdE07QDG0msbUqnZFCIHVo7oNFQ2jhVcYEpYQP+NqZj01JZoO4KgCZBp3B4w5AEgAlAo594bcSES398MCE5vjrOOpnJmVOcKoD6e17j+PS8QLZqrOQHRZlvwtkU0o51p1gtkaUnP8yFQApiKb2K0lP1CJUmtyXEtV7eV0OjvFNAlSGqELwNCAJF+vQX0Onu0Px+OI4NCVg1dWpDiRHZiStOgYKmmypRi04VIpfLpfXCUizBgThLtIXSTnmKAuIle08UiyASAtAYgoVTCbCoxbE4baHw6S6pcZhqgPJ0RZtudkat2b8rhJkFZrX0mpLkbq19sGCR+QvkNlAGyZX7coT5BMGkVaAJLK/O+gW8KHzYkkBrMxgT3UgXT1ThPm9pRduRy1PRM9h9vvkM4oq8fQPLPQqB9Kbg4LQPUZ6/ewGzcwee+8GSnizpigHaYC1iTKT0QciaH1xAh2FGCVjruOIPKkOJK7M/DuP4irdbGTr2HAtupv9bOoAsbTFv9HGRoVASojwwXISsOXceztIuP6V6iNQIkqlQYokgInkpqhOgXh5R2f41NIKtF6AtG3+RexYlGY9rjR7WHC+J13laU9aP/mzDFvOknykEEiT/xKIBztIy0bX6Xalx5bfgIEvDNSBJMzshrwRg750H11tXL0A6TpdFcqnkFTQLEl0gU198WZyD/HVyp+eVIpTN8j6USGQ3vt7CBIj7QHKhXx/rBhvf5snMUPz/FmbLWvzIorEYYF0hfyrB29BaHNpUcBqcEwv9QIkLvtfTyfj0FeZVXUKiWyEuSe7V72LD3wh9ZidJbS2RjN+BUBiKrNpfBMEyFg5Ltyaj+1Hpc6L1C6QCBToRZtP+Vaomrp6A1JGSjEW0v42viaCXSjdQDTnd3sgpeRUYupBkyJSAZCaBXrh08fk9+M/sSoLF6+57qCtKs21SYgXdDisa6B3UTPNYBeoA7WPB9EYZ4qnd6Wabc5LyFfMn7IWwrhsE/WpSsNxFmGsafvvzR2R0Fu+74SBM/1H+XDN68f9+OEVfDP9vFB4aAsC0gl7IF0gM9oXDigHUttIbyz9m7yg/eTqbDqxzajo1GUkE/BMALyJ9Hov7ekiuyXeEjX1CiT6A8Bn/zSeA8CLtf9zjoRtmwPUc2mhdNxu5UBqFkQUaZT8X9WUz3Nw5Jwxfx1I1kDi1ZOp+7qgNc3kqnP1CySqHS93bH4tFfs+uEJbjm5GbHfrq6eYXg7fXoIythxRwNp8ibb/35NNJTcPcOes+6kQa/cV6MK2DWsTWCL1z1g6l/y2RyO4qxy6egeSWLs0OhOAQRXVxV6PNGGPAZms1VYAJM7z/aEhiJPZl8Z3jTy/jq6JuEjSPKXVskLSUkYSgfTg5NYYOD1aHCZZv8EASbaGFMHCdnKWciCN7RmAEWROK+fyyTQl6UwJDtOBXGfoQj/erSuAinBlBS7xXfAt0jDZFM1IuBACpFFANvmCYE3hLHtw3pyefqqEbQ7nd0HY5njOwxTPArDwjcmMhL/lOPF79k35cpiQL73z0YpsZWGdziIt5yt+K/gUZxtG2XXt3xTj6SS86pxbAGnF8TLsvqBcIRlHN1mvJKrk6O6R6jrK3eIZb5lpBmxanI6kb66bQFN7IDWjw11fPdSt2ua7BZB+uVqBt2j1XylrY3OQl/oF4j4Z7Xa1veTmCT6edgH7N2SaKRBTNFvqw1TJNoza7U1ki1cc/AKlFbpi17gFkPjy6sd3lKCUljGU2iNFNvbCCrJFakK+1twNsvKc0vt3RUBitvnCzpsRc6v1JMi2D90CSFzp138mo/8M8yERtTUjYbmlA22AfOvRYE3u5Z/Y8QhKCysITEaZy476yFAkTj95u/1s2m2BtOVcOT4+XjcLSaZmXVr5YsbAIIRr5CB1HvCsKwa8eIcyimRkbb0kt4ZZgsltKNJ1skl6lmyS2KZaqamtaDrblK4BfZosAvq286PzsD2f1a2dcQH71iuTkZrFkbD9bw8RtkXkr/m9FN8ms7kt0WEiuUp3kQjfE3WKauqNgV0D0LONH2LJOsDTZnW5dDj9xkWXBUG7SmVQS9Z2y0N01CLd61KdcxuKxA3JptsdJ5LQXcy2Q04AEstNIpXyp10l4bScEkLHCrJ+h/MX4sgXlJSiTwBkJ+wi4TD6EXVNwnccybMiTid+Q774zj7LHfydqB8S9E7CO+t26EH41hjP75b6ISEt50HZC+VVPdO7KS37WemlyCaWVlc90gA6yKP/y1HcKoeOyuSau4/79EQZvqHzs50NJBFQwiAykCxAZg6jfhJARoNGykPxWfBFhST3JqURQCLj80AbwWaRjoKMCkkxzggUARwmYNV2X5vwLefL9WBf+DWWWVNhezyZ3nZ9KLxagLgdkHJNVKnQUFFn1sYDLgJI9M2gMceZw7QHpJkkH0WSnFSdczsgcYN+pK3b7/zKZ0bSiwkMRrnHOPj8LALD+llMb/yrF7+19M2gMedhDjN+L7AlDVCkm9h+e8/NsrdvUm9UObcEEtd+zbFSbD5JLE4HklE2YlmJZSRbXylroz5+/ttOiO8lb8tVhSJ6cFsglRGAZv1owO9XjNaNOkVyLpB6D2+GkUvjLbHi8NltgcStyqZV+8nbi5BJZybpQHIekIKb+gjG/8ER9qflyaHJrYHEjbqYW0nHIxfRybZE0y3YnC4jmYClgLUNfysWfcbaH+QhByIOd3sgcSNyiDLN2VuEUxnmswF0ICkDUtwtQZhCh+PL3TrF/S3lPAJI3DA+CpBP///xLK/HmWdc1s+UUIjTZ21SeqQwWod8Zn178Gytts5jgMQNJ3hgw1EDvjhSIqzJiaAxUydKoAPJOLOj3qpSUFLHdR8UjhELYxFEG1WVOI8CktgBLC+tPWzA3tOka7KiTjqQaMCtgNSYDqgfPjcGdwy1P7xD7M+a+B4JJLHhyZnlWJVUhCMmw34zZdJZG7O2tj1D8MSSOETSzVN1dR4NJLFzjlwqA9+0nZRMu1GIWhlVBRQrQa3MWmyznGUOM37j7prtALptauCzLdGffuVu4RT7rqa+JoAkdgbLUGfoaOWDySU4eMaA87RV23KZhYFlBo1nACmUTriNowNIYzrRYaT0G0MHkrZoE1DrWZnYh3K+poBk2wmsHc8iZeaNvHLw8TZZ+ZW4TleBFfJ5BIQpwS6C/2MEir8MNnJGExDjswBAMV7wjYJs1TcmuUR8Z7YiPAvLGZy3MR9heYMjKJw9GhwuShCKq945SIgzxZuehTD+j36C6DSR2A4MnECE05kKajhNA0mNDtZKGTqQtDLSLm6nDiQXd7BWsteBpJWRdnE7dSC5uIO1kr0OJK2MtIvbqQPJxR2slex1IGllpF3cTh1ILu5grWSvA0krI+3idupAcnEHayV7HUhaGWkXt1MHkos7WCvZ60DSyki7uJ06kFzcwVrJXgeSVkbaxe3UgeTiDtZK9jqQtDLSLm6nDiQXd7BWsteBpJWRdnE7dSC5uIO1kr0OJK2MtIvbqQPJxR2slez/H5H4pXHFZcmaAAAAAElFTkSuQmCC"
}))), C5 = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 88,
  height: 28,
  viewBox: "0 0 88 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  clipPath: "url(#clip0_5340_75806)"
}, /* @__PURE__ */ z.createElement("mask", {
  id: "mask0_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 14,
  width: 16,
  height: 14
}, /* @__PURE__ */ z.createElement("path", {
  d: "M2.39209 23.625C2.39209 25.9194 4.17652 28 6.88259 28H14.5105C18.7265 28 18.7853 21.875 14.4909 21.875C13.6674 21.875 11.53 21.8556 7.74539 21.8556C6.35314 21.8556 5.37268 24.4222 6.74532 24.4222H14.6086C15.491 24.4222 15.491 25.5889 14.6086 25.5889H6.76493C5.8433 25.5889 4.92167 24.9278 4.92167 23.7222C4.92167 22.0889 6.98063 20.8833 9.15725 19.1917C10.8632 17.8694 11.275 16.1778 10.9221 14.1361C10.5887 16.4111 2.39209 19.1722 2.39209 23.625Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask0_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M18.7853 14.1361H2.39209V28H18.7853V14.1361Z",
  fill: "url(#paint0_linear_5340_75806)"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask1_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: -1,
  width: 17,
  height: 26
}, /* @__PURE__ */ z.createElement("path", {
  d: "M12.452 1.80837H7.02022C3.78471 1.80837 2.35324 4.18059 2.35324 6.43615C2.35324 8.24448 3.47096 9.27503 5.03969 10.5195C6.05937 11.3167 6.80452 11.8611 7.98107 12.6973C7.74576 12.8723 7.51045 13.0278 7.27514 13.1834C4.90243 11.7639 0.764897 8.88615 1.51005 5.58059C0.000140548 7.03892 0.294278 10.0917 1.412 11.7834C2.23558 13.0278 3.66705 14 4.8436 14.7973C3.17682 15.925 1.86301 16.9945 0.921771 18.725C0.529588 19.4445 0.333496 20.4167 0.333496 21.3306V21.3695C0.333496 22.7111 0.764897 23.9556 1.54926 24.2473C1.1963 22.9834 1.96106 21.1361 2.86308 20.1445C4.05924 18.8611 5.47109 17.7139 8.29481 15.6528C9.07918 15.0695 10.6871 14.0973 10.6871 12.8528C10.6871 11.4334 9.51058 10.7139 8.35364 9.87781C6.07898 8.20559 4.76516 7.56392 4.76516 6.22226C4.76516 4.80281 5.82406 4.20004 6.94178 4.20004H12.6677C15.8051 4.20004 17.4327 2.31392 16.2365 -0.0194092C15.7267 1.3417 14.3148 1.80837 12.452 1.80837Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask1_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M17.4129 0H0V24.2472H17.4129V0Z",
  fill: "url(#paint1_linear_5340_75806)"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask2_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 6,
  y: 3,
  width: 12,
  height: 5
}, /* @__PURE__ */ z.createElement("path", {
  d: "M12.7457 5.36668H6.56886C5.23544 5.36668 6.51004 7.95279 8.27486 7.95279H13.2164C17.3343 7.95279 17.4912 5.11391 16.8441 3.55835C16.1185 5.42502 13.9419 5.36668 12.7457 5.36668Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask2_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M17.4911 3.55835H5.21582V7.95279H17.4911V3.55835Z",
  fill: "url(#paint2_linear_5340_75806)"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask3_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 88,
  height: 28
}, /* @__PURE__ */ z.createElement("path", {
  d: "M87.5746 0H0.333496V28H87.5746V0Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask3_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M28.7666 14.7583C28.7666 11.7639 27.0214 9.37219 23.982 9.37219C21.1386 9.37219 19.0601 11.725 19.0601 14.6805C19.0601 17.85 21.3543 19.9889 24.178 19.9889C26.1194 19.9889 27.3743 19.2111 28.4136 18.0833L27.4528 17.2472C26.6096 18.1222 25.6291 18.6861 24.2173 18.6861C22.4132 18.6861 20.8249 17.4416 20.6092 15.3027H28.747C28.7666 15.05 28.7666 14.8944 28.7666 14.7583ZM20.6288 14.0583C20.8445 12.0944 22.1975 10.6361 23.9623 10.6361C25.9821 10.6361 27.0606 12.2111 27.2371 14.0583H20.6288Z",
  fill: "#00202E"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask4_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 88,
  height: 28
}, /* @__PURE__ */ z.createElement("path", {
  d: "M87.5746 0H0.333496V28H87.5746V0Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask4_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M34.1985 17.5194C34.1201 17.6944 33.8652 17.6944 33.7867 17.5194L30.5316 9.58606H28.8452L33.2965 19.8333H34.6495L39.1204 9.58606H37.4732L34.1985 17.5194Z",
  fill: "#00202E"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask5_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 88,
  height: 28
}, /* @__PURE__ */ z.createElement("path", {
  d: "M87.5746 0H0.333496V28H87.5746V0Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask5_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M48.8857 14.7583C48.8857 11.7639 47.1405 9.37219 44.1011 9.37219C41.2578 9.37219 39.1792 11.725 39.1792 14.6805C39.1792 17.85 41.4735 19.9889 44.2972 19.9889C46.2385 19.9889 47.4935 19.2111 48.5328 18.0833L47.5719 17.2472C46.7287 18.1222 45.7483 18.6861 44.3364 18.6861C42.5324 18.6861 40.944 17.4416 40.7283 15.3027H48.8661C48.8857 15.05 48.8857 14.8944 48.8857 14.7583ZM40.7283 14.0583C40.944 12.0944 42.2971 10.6361 44.0619 10.6361C46.0816 10.6361 47.1601 12.2111 47.3366 14.0583H40.7283Z",
  fill: "#00202E"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask6_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 88,
  height: 28
}, /* @__PURE__ */ z.createElement("path", {
  d: "M87.5746 0H0.333496V28H87.5746V0Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask6_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M61.6905 18.6277C59.5531 18.6277 57.9256 16.8777 57.9256 14.6805V14.6416C57.9256 12.4639 59.5139 10.7139 61.5925 10.7139C62.9848 10.7139 63.8868 11.3944 64.7104 12.25L65.73 11.1805C64.7692 10.1694 63.573 9.37219 61.6317 9.37219C58.6315 9.37219 56.3765 11.8027 56.3765 14.6805V14.7194C56.3765 17.5777 58.6315 19.9889 61.6317 19.9889C63.5534 19.9889 64.7888 19.1722 65.8085 18.025L64.828 17.1111C64.0044 17.9861 63.0044 18.6277 61.6905 18.6277Z",
  fill: "#00202E"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask7_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 88,
  height: 28
}, /* @__PURE__ */ z.createElement("path", {
  d: "M87.5746 0H0.333496V28H87.5746V0Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask7_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M68.8869 9.58606H67.3574V19.7555H68.8869V9.58606Z",
  fill: "#00202E"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask8_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 88,
  height: 28
}, /* @__PURE__ */ z.createElement("path", {
  d: "M87.5746 0H0.333496V28H87.5746V0Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask8_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M68.1618 5.67773H68.103C67.6323 5.67773 67.2598 6.04718 67.2598 6.51385C67.2598 6.98051 67.6323 7.34996 68.103 7.34996H68.1618C68.6324 7.34996 69.005 6.98051 69.005 6.51385C69.005 6.04718 68.6324 5.67773 68.1618 5.67773Z",
  fill: "#00202E"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask9_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 88,
  height: 28
}, /* @__PURE__ */ z.createElement("path", {
  d: "M87.5746 0H0.333496V28H87.5746V0Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask9_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M76.9271 10.9278L76.4761 9.91669C76.378 9.70281 76.1623 9.56669 75.9466 9.56669H73.417V6.51392H71.8875V9.58614H70.4561V10.9278H71.8875V17.0723C71.8875 19.1334 73.1425 19.95 74.7897 19.95C75.5152 19.95 76.1035 19.7945 76.6329 19.5223V18.2195C76.1035 18.4722 75.6525 18.5695 75.1426 18.5695C74.1034 18.5695 73.417 18.1223 73.417 16.8778V10.9278H76.9271Z",
  fill: "#00202E"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask10_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 88,
  height: 28
}, /* @__PURE__ */ z.createElement("path", {
  d: "M87.5746 0H0.333496V28H87.5746V0Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask10_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M86.3001 9.58606C86.0844 9.58606 85.8883 9.72217 85.8098 9.91662L83.0253 17.0916C82.7508 17.7333 82.5351 17.7333 82.2214 17.1111L79.0839 9.99439C78.9662 9.74162 78.7309 9.58606 78.4368 9.58606H77.2603L77.8485 10.9277L81.888 19.7166C81.2801 21.1555 80.6919 21.6222 79.7898 21.6222C79.1427 21.6222 78.6721 21.5055 78.1819 21.2527L77.672 22.4583C78.3584 22.7888 79.0055 22.9638 79.8487 22.9638C81.3978 22.9638 82.3782 22.2055 83.2607 20.0861L87.5551 9.58606H86.3001Z",
  fill: "#00202E"
})), /* @__PURE__ */ z.createElement("mask", {
  id: "mask11_5340_75806",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 88,
  height: 28
}, /* @__PURE__ */ z.createElement("path", {
  d: "M87.5746 0H0.333496V28H87.5746V0Z",
  fill: "white"
})), /* @__PURE__ */ z.createElement("g", {
  mask: "url(#mask11_5340_75806)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M56.847 9.93612C56.3764 11.2389 55.141 11.025 53.9645 11.5889C53.337 11.8806 52.9252 12.4639 52.6507 12.9694C52.6114 13.0472 52.5722 13.1056 52.5526 13.1639C52.4938 13.2806 52.435 13.3972 52.3957 13.5333C52.3369 13.6889 52.2977 13.8056 52.2977 13.8056C52.1212 14.35 52.0232 14.9917 52.0232 15.7111V19.7556H50.4937V9.58612H52.0232V12.25C52.4153 11.3556 53.0232 10.5972 53.7684 10.0917C53.788 10.0917 53.788 10.0722 53.8076 10.0722C54.0429 9.93612 54.4547 9.72223 55.1018 9.50834C56.0234 9.21667 56.7098 9.00278 56.9058 8.53612V8.51667C56.9058 8.49723 56.9255 8.49723 56.9255 8.47778V8.49723C57.0235 8.84723 57.0627 9.33334 56.847 9.93612Z",
  fill: "#00202E"
}))), /* @__PURE__ */ z.createElement("defs", null, /* @__PURE__ */ z.createElement("linearGradient", {
  id: "paint0_linear_5340_75806",
  x1: 2.39418,
  y1: 21.0592,
  x2: 17.6879,
  y2: 21.0592,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ z.createElement("stop", {
  stopColor: "#00BAFF"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 128142e-8,
  stopColor: "#00BAFF"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 0.3012,
  stopColor: "#277EF0"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 0.7818,
  stopColor: "#6224D8"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 0.9995,
  stopColor: "#7A00CF"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 1,
  stopColor: "#7A00CF"
})), /* @__PURE__ */ z.createElement("linearGradient", {
  id: "paint1_linear_5340_75806",
  x1: 8.71495,
  y1: 1.65683,
  x2: 8.71495,
  y2: 16.7631,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ z.createElement("stop", {
  stopColor: "#00BAFF"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 128142e-8,
  stopColor: "#00BAFF"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 0.3012,
  stopColor: "#277EF0"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 0.7818,
  stopColor: "#6224D8"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 0.9995,
  stopColor: "#7A00CF"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 1,
  stopColor: "#7A00CF"
})), /* @__PURE__ */ z.createElement("linearGradient", {
  id: "paint2_linear_5340_75806",
  x1: 11.3591,
  y1: 1.65685,
  x2: 11.3591,
  y2: 16.7631,
  gradientUnits: "userSpaceOnUse"
}, /* @__PURE__ */ z.createElement("stop", {
  stopColor: "#00BAFF"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 128142e-8,
  stopColor: "#00BAFF"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 0.3012,
  stopColor: "#277EF0"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 0.7818,
  stopColor: "#6224D8"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 0.9995,
  stopColor: "#7A00CF"
}), /* @__PURE__ */ z.createElement("stop", {
  offset: 1,
  stopColor: "#7A00CF"
})), /* @__PURE__ */ z.createElement("clipPath", {
  id: "clip0_5340_75806"
}, /* @__PURE__ */ z.createElement("rect", {
  width: 87.5745,
  height: 28,
  fill: "white"
})))), GD = "_item_ty2hd_5", KD = "_icon_ty2hd_35", XD = "_tooltip_ty2hd_43", JD = "_lockIcon_ty2hd_54", Wr = {
  item: GD,
  "item--open": "_item--open_ty2hd_14",
  "item--active": "_item--active_ty2hd_14",
  "item--disabled": "_item--disabled_ty2hd_29",
  icon: KD,
  tooltip: XD,
  lockIcon: JD
}, Sl = u.createContext({
  components: {
    NavLink: null,
    Link: null
  }
}), eC = "evercity-ui", SA = ({ config: e, children: t }) => /* @__PURE__ */ u.createElement(aa, {
  prefixCls: eC
}, /* @__PURE__ */ u.createElement(Sl.Provider, {
  value: e
}, t)), tC = {
  "link--disabled": "_link--disabled_1qcwr_5",
  "link--noMargin": "_link--noMargin_1qcwr_8",
  "link--size-large": "_link--size-large_1qcwr_11",
  "link--size-small": "_link--size-small_1qcwr_14",
  "link--size-extra-large": "_link--size-extra-large_1qcwr_17",
  "link--size-extra-small": "_link--size-extra-small_1qcwr_20",
  "link--theme-secondary": "_link--theme-secondary_1qcwr_23",
  "link--theme-button": "_link--theme-button_1qcwr_29"
}, E5 = ({ activeClassName: e, className: t, disabled: r, ...n }) => {
  const { components: a } = xe(Sl), i = a.NavLink;
  if (i === null)
    throw new Error("Not was provide router library");
  return /* @__PURE__ */ u.createElement(i, {
    ...n,
    className: ({ isActive: o }) => o ? Y(e, t) : Y(
      {
        [tC["link--disabled"]]: r
      },
      t
    )
  });
}, rC = ({ to: e, disabled: t, icon: r, name: n }) => /* @__PURE__ */ u.createElement(uo.Consumer, null, ({ collapsed: a }) => /* @__PURE__ */ u.createElement(x0, {
  key: n,
  title: /* @__PURE__ */ u.createElement(u.Fragment, null, t && /* @__PURE__ */ u.createElement(Gu, {
    className: Wr.lockIcon
  }), n),
  placement: "right",
  overlayClassName: Wr.tooltip
}, /* @__PURE__ */ u.createElement(E5, {
  to: e,
  activeClassName: Wr["item--active"],
  disabled: t,
  className: Y(
    Wr.item,
    { [Wr["item--open"]]: !a },
    { [Wr["item--disabled"]]: t }
  )
}, r, !a && n))), uo = u.createContext({ collapsed: !0 }), nC = ({
  items: e,
  children: t,
  className: r,
  siderLogo: n = /* @__PURE__ */ u.createElement(C5, null),
  siderLogoCollapsed: a = /* @__PURE__ */ u.createElement(qD, null),
  ...i
}) => {
  const [o, l] = de(!0);
  return /* @__PURE__ */ u.createElement(hi.Consumer, null, ({ variant: c }) => /* @__PURE__ */ u.createElement(ia.Sider, {
    ...i,
    collapsible: !1,
    collapsed: o,
    className: Y(Xa.sider, Xa[`sider--${c}`], r),
    collapsedWidth: 60,
    width: 230,
    onCollapse: (s) => {
      l(s);
    }
  }, /* @__PURE__ */ u.createElement(uo.Provider, {
    value: { collapsed: o }
  }, c === "personal" && /* @__PURE__ */ u.createElement("div", {
    className: Xa.sider__logo
  }, /* @__PURE__ */ u.createElement(uo.Consumer, null, ({ collapsed: s }) => s ? a : n)), /* @__PURE__ */ u.createElement("div", {
    className: Xa.sider__items
  }, e == null ? void 0 : e.map((s) => /* @__PURE__ */ u.createElement(rC, {
    key: s.name,
    ...s
  }))), t)));
}, aC = "_header_1orfr_5", iC = "_breadcrumb_1orfr_30", oC = "_actionsWrapper_1orfr_35", lC = "_logoWrapper_1orfr_40", cC = "_common_1orfr_47", uC = "_content_1orfr_48", sC = "_titleWrapper_1orfr_57", dC = "_title_1orfr_57", Ft = {
  header: aC,
  "header--public": "_header--public_1orfr_8",
  "header--personal": "_header--personal_1orfr_9",
  "header--dialog": "_header--dialog_1orfr_23",
  breadcrumb: iC,
  actionsWrapper: oC,
  logoWrapper: lC,
  "logoWrapper--disabled": "_logoWrapper--disabled_1orfr_43",
  common: cC,
  content: uC,
  titleWrapper: sC,
  title: dC,
  "title-onBack": "_title-onBack_1orfr_68"
}, b5 = ({ icon: e, className: t, children: r, type: n, ...a }) => {
  const { components: i } = xe(Sl), { getPrefixCls: o } = xe(aa.ConfigContext), l = i.Link, c = Y(
    {
      [o("btn")]: n === "btn" || n === "btn-primary",
      [o("btn-primary")]: n === "btn-primary"
    },
    t
  );
  if (l === null)
    throw new Error("Not was provide router library");
  return /* @__PURE__ */ u.createElement(l, {
    ...a,
    className: c
  }, e, /* @__PURE__ */ u.createElement("span", null, r));
}, fC = ({ ...e }) => /* @__PURE__ */ u.createElement(po, {
  ...e,
  itemRender: (t, r, n) => n.indexOf(t) === n.length - 1 ? /* @__PURE__ */ u.createElement("span", null, t.breadcrumbName) : /* @__PURE__ */ u.createElement(b5, {
    to: t.path
  }, t.breadcrumbName)
}), Ll = fC;
Ll.Item = po.Item;
Ll.Separator = po.Separator;
const vC = ({
  breadcrumb: e,
  logoDisabled: t,
  title: r,
  actions: n,
  children: a,
  className: i,
  onBack: o,
  tag: l,
  logo: c = /* @__PURE__ */ u.createElement(C5, null),
  ...s
}) => {
  const d = Nd(() => r && o ? /* @__PURE__ */ u.createElement(ta, {
    className: Y(Ft.title, Ft["title-onBack"]),
    icon: /* @__PURE__ */ u.createElement(Rd, null),
    type: "text",
    onClick: o
  }, r) : r && !o ? /* @__PURE__ */ u.createElement(fn, {
    className: Y(Ft.title),
    level: 1
  }, r) : /* @__PURE__ */ u.createElement(Ll, {
    ...e,
    className: Ft.breadcrumb
  }), [e, r, o]);
  return /* @__PURE__ */ u.createElement(hi.Consumer, null, ({ variant: M }) => /* @__PURE__ */ u.createElement(ia.Header, {
    className: Y(Ft.header, Ft[`header--${M}`], i),
    ...s
  }, /* @__PURE__ */ u.createElement("div", {
    className: Ft.common
  }, ["public", "dialog"].includes(M) && /* @__PURE__ */ u.createElement(b5, {
    to: "/"
  }, c), /* @__PURE__ */ u.createElement("div", {
    className: Ft.titleWrapper
  }, d(), l), /* @__PURE__ */ u.createElement("div", {
    className: Ft.actionsWrapper
  }, n)), M === "personal" && a && /* @__PURE__ */ u.createElement("div", {
    className: Ft.content
  }, a)));
}, MC = "_footer_kas05_5", gC = {
  footer: MC
}, pC = ({ children: e, className: t, brand: r = "Evercity", ...n }) => {
  const a = Qe(() => _n().year().toString(), []);
  return /* @__PURE__ */ u.createElement(ia.Footer, {
    ...n,
    className: Y(gC.footer, t)
  }, /* @__PURE__ */ u.createElement("span", null, r, " \xA9 ", a, " All rights reserved"), e);
}, Pu = {
  "content--internal": "_content--internal_1nboe_5",
  "content--dialog": "_content--dialog_1nboe_10"
}, hC = ({ children: e, className: t }) => /* @__PURE__ */ u.createElement(hi.Consumer, null, ({ variant: r }) => /* @__PURE__ */ u.createElement(ia.Content, {
  className: t || Y(Pu.content, { [Pu[`content--${r}`]]: !!r }, t)
}, e)), hi = u.createContext({ variant: "internal" }), mC = ({ children: e, className: t, variant: r = "internal", ...n }) => /* @__PURE__ */ u.createElement(hi.Provider, {
  value: { variant: r }
}, /* @__PURE__ */ u.createElement(ia, {
  ...n,
  className: Y(
    ku.layout,
    { [ku[`layout--${r}`]]: !!r },
    t
  )
}, e)), mi = mC;
mi.Header = vC;
mi.Content = hC;
mi.Footer = pC;
mi.Sider = nC;
const yC = "_table_14sgg_5", NC = "_actions_14sgg_43", A5 = {
  table: yC,
  actions: NC
}, zC = ({ icon: e, actions: t, className: r }) => /* @__PURE__ */ u.createElement(na, {
  className: Y(A5.actions, r),
  trigger: ["click"],
  placement: "bottomRight",
  menu: {
    items: t,
    onClick: ({ domEvent: n }) => {
      n.stopPropagation();
    }
  }
}, /* @__PURE__ */ u.createElement(ta, {
  onClick: (n) => n.stopPropagation(),
  size: "small",
  icon: e || /* @__PURE__ */ u.createElement(zo, null)
})), Hn = ({ children: e, color: t }) => /* @__PURE__ */ u.createElement(yi, {
  type: "outlined",
  style: {
    borderColor: t,
    color: t,
    lineHeight: "0.9rem"
  }
}, e), _C = "_actions_1kz05_5", IC = "_goal_1kz05_8", DC = "_drawer_1kz05_12", CC = "_drawer__label_1kz05_29", EC = "_drawer__description_1kz05_36", bC = "_drawer__textarea_1kz05_43", AC = "_drawer__select_1kz05_53", jC = "_table_1kz05_65", xC = "_target_1kz05_68", wC = "_target__popup_1kz05_74", OC = "_indicator__title_1kz05_77", TC = "_indicator__text_1kz05_82", SC = "_indicator__more_1kz05_92", LC = "_indicator__actions_1kz05_97", ke = {
  actions: _C,
  goal: IC,
  drawer: DC,
  drawer__label: CC,
  "drawer__info-icon": "_drawer__info-icon_1kz05_33",
  drawer__description: EC,
  drawer__textarea: bC,
  "drawer__search-container": "_drawer__search-container_1kz05_46",
  drawer__select: AC,
  "drawer__close-icon": "_drawer__close-icon_1kz05_56",
  table: jC,
  target: xC,
  target__popup: wC,
  "target__popup-text": "_target__popup-text_1kz05_74",
  indicator__title: OC,
  indicator__text: TC,
  "indicator__text--compact": "_indicator__text--compact_1kz05_85",
  indicator__more: SC,
  indicator__actions: LC
}, kC = [
  {
    text: "Strengthen domestic resource mobilization, including through international support to developing countries, to improve domestic capacity for tax and other revenue collection.",
    color: "#203565",
    number: "17.1"
  },
  {
    text: "Developed countries to implement fully their official development assistance commitments, including the commitment by many developed countries to achieve the target of 0.7 per cent of ODA/GNI to developing countries, and 0.15 to 0.20 per cent of ODA/GNI to least developed countries; ODA providers are encouraged to consider setting a target to provide at least 0.20 per cent of ODA/GNI to least developed countries.",
    color: "#203565",
    number: "17.2"
  }
], PC = [
  {
    title: "Recovery, recirculation and valorization of biodegradable waste and/or by-products",
    text: "Protecting remaining high conservation value lands and securing a regional trail network within 30 years with The King County Land Conservation Initiative. Increase the involvement of the local stakeholders in the decision-making process by offering them a platform to express their concerns and needs. Make it easier for them to participate in the process of shaping the future of the local community. Allow them to contribute to the planning of the activities and the local development strategy.",
    tag: {
      text: "IRIS",
      color: "#810048"
    }
  },
  {
    title: "Recovery, recirculation and valorization of biodegradable waste and/or by-products",
    text: "Protecting remaining high conservation value lands and securing a r",
    tag: {
      text: "IRIS",
      color: "#810048"
    }
  },
  {
    title: "Recovery, recirculation and valorization of biodegradable waste and/or by-products",
    text: "Protecting remaining high conservation value lands and securing a regional trail network within 30 years with The King County Land Conservation Initiative. Increase the involvement of the local stakeholders ",
    tag: {
      text: "ICMA",
      color: "#072048"
    }
  }
], RC = ({ title: e, text: t, tag: r, onAdd: n }) => {
  const a = (t == null ? void 0 : t.length) > 200, [i, o] = de(a), l = i ? "Read more" : "Show less", c = () => o(!i);
  return /* @__PURE__ */ u.createElement(Ni, null, /* @__PURE__ */ u.createElement(ze, {
    direction: "vertical",
    size: 8
  }, r && /* @__PURE__ */ u.createElement(Hn, {
    color: r.color
  }, r.text), /* @__PURE__ */ u.createElement(fn, {
    size: "medium",
    className: ke.indicator__title
  }, e), /* @__PURE__ */ u.createElement("div", null, /* @__PURE__ */ u.createElement(ve, {
    className: Y(ke.indicator__text, {
      [ke["indicator__text--compact"]]: i
    })
  }, t), a && /* @__PURE__ */ u.createElement("div", null, /* @__PURE__ */ u.createElement(_e, {
    type: "link",
    className: ke.indicator__more,
    onClick: c
  }, l))), /* @__PURE__ */ u.createElement(ze, {
    size: 12,
    className: ke.indicator__actions
  }, /* @__PURE__ */ u.createElement(_e, {
    type: "primary",
    icon: /* @__PURE__ */ u.createElement(Bn, null),
    onClick: n
  }, "Add indicator"), /* @__PURE__ */ u.createElement(_e, {
    icon: /* @__PURE__ */ u.createElement(Vd, null)
  }, "Key indicator"))));
}, QC = ({ onChange: e }) => {
  const [t] = Ne.useForm(), r = Ne.useWatch("standard", t), n = Ne.useWatch("category", t);
  return /* @__PURE__ */ u.createElement(Ne, {
    form: t,
    layout: "vertical"
  }, /* @__PURE__ */ u.createElement(ze, {
    block: !0,
    direction: "vertical",
    size: 2
  }, /* @__PURE__ */ u.createElement(ve, {
    className: ke.drawer__label
  }, "Indicators"), /* @__PURE__ */ u.createElement(ve, {
    className: ke.drawer__description
  }, "Choose indicators to measure your results")), /* @__PURE__ */ u.createElement(Ne.Item, {
    shouldUpdate: !0,
    className: ke["drawer__search-container"],
    name: "query"
  }, /* @__PURE__ */ u.createElement(_o, {
    allowClear: !0,
    size: "large",
    bordered: !1,
    prefix: /* @__PURE__ */ u.createElement(Qd, null),
    placeholder: "Search by indicators"
  })), /* @__PURE__ */ u.createElement(ze, {
    block: !0,
    direction: "vertical",
    size: 12
  }, /* @__PURE__ */ u.createElement(Ne.Item, {
    shouldUpdate: !0,
    name: "standard",
    label: /* @__PURE__ */ u.createElement(ze, {
      size: 4,
      align: "center"
    }, /* @__PURE__ */ u.createElement(ve, {
      size: "large"
    }, "Standard"), /* @__PURE__ */ u.createElement(rE, {
      title: "Standard"
    }, /* @__PURE__ */ u.createElement(ts, {
      className: ke["drawer__info-icon"]
    })))
  }, /* @__PURE__ */ u.createElement(bt, {
    allowClear: !0,
    size: "large",
    options: [
      "IRIS",
      "Gold Standard",
      "ICMA",
      "The Climate, Community & Biodiversity Standards"
    ],
    placeholder: "Select"
  })), r ? /* @__PURE__ */ u.createElement(Ne.Item, {
    name: "category",
    shouldUpdate: !0,
    label: /* @__PURE__ */ u.createElement(ve, {
      size: "large"
    }, "Category")
  }, /* @__PURE__ */ u.createElement(bt, {
    allowClear: !0,
    size: "large",
    options: [
      "Renewable Energy",
      "Energy Efficiency",
      "Sustainable Water and Wastewater Management",
      "Waste Management and Resource Efficiency",
      "Clean Transportation",
      "Green Buildings"
    ],
    placeholder: "Select"
  })) : null, n ? /* @__PURE__ */ u.createElement(Ne.Item, {
    name: "subcategory",
    label: /* @__PURE__ */ u.createElement(ve, {
      size: "large"
    }, "Subcategory")
  }, /* @__PURE__ */ u.createElement(bt, {
    allowClear: !0,
    size: "large",
    options: [
      "Waste prevented, minimized, reused or recycled",
      "Energy recovered from waste",
      "Waste collected and treated or disposed",
      "Resource efficiency/reduction in raw materials used in manufacturing",
      "Improved access to municipal waste collection (including separation)",
      "Improved and regular access to street sweeping"
    ],
    placeholder: "Select"
  })) : null), /* @__PURE__ */ u.createElement(ve, {
    className: ke.drawer__description
  }, "356 indicators"), /* @__PURE__ */ u.createElement(ze, {
    block: !0,
    direction: "vertical",
    size: 16
  }, PC.map((a) => /* @__PURE__ */ u.createElement(RC, {
    ...a,
    key: a.title,
    onAdd: e
  }))));
}, { Option: VC } = bt, UC = ({ onClose: e, open: t = !1 }) => {
  const [r] = Ne.useForm(), n = Ne.useWatch("achieve", r), a = Ne.useWatch("target", r);
  return /* @__PURE__ */ u.createElement(z5, {
    placement: "right",
    onClose: e,
    open: t,
    width: 580,
    closable: !1,
    className: ke.drawer,
    footer: /* @__PURE__ */ u.createElement(ze, {
      size: 12
    }, /* @__PURE__ */ u.createElement(_e, {
      onClick: e
    }, "Close"), /* @__PURE__ */ u.createElement(_e, {
      type: "primary"
    }, "Save"), /* @__PURE__ */ u.createElement(_e, {
      onClick: e,
      className: ke["drawer__close-icon"],
      icon: /* @__PURE__ */ u.createElement(la, null),
      type: "text",
      shape: "circle",
      size: "large"
    }))
  }, /* @__PURE__ */ u.createElement(Ne, {
    form: r,
    layout: "vertical"
  }, /* @__PURE__ */ u.createElement(fn, {
    level: 2
  }, "Specify your target"), /* @__PURE__ */ u.createElement(ze, {
    direction: "vertical",
    block: !0,
    size: 16
  }, /* @__PURE__ */ u.createElement(Ne.Item, {
    label: /* @__PURE__ */ u.createElement(ve, {
      className: ke.drawer__label
    }, "SDG")
  }, /* @__PURE__ */ u.createElement(bt, {
    placeholder: "Select",
    defaultValue: 1,
    className: ke.drawer__select,
    options: en.map((i) => ({
      value: i.id,
      label: /* @__PURE__ */ u.createElement(ze, {
        align: "center",
        size: 8
      }, u.cloneElement(i.icon, {
        width: 40,
        height: 40,
        color: i.color
      }), i.title)
    }))
  })), /* @__PURE__ */ u.createElement(Ne.Item, {
    name: "target",
    label: /* @__PURE__ */ u.createElement(ve, {
      className: ke.drawer__label
    }, "Target")
  }, /* @__PURE__ */ u.createElement(bt, {
    size: "large",
    placeholder: "Select",
    childrenMode: !0,
    className: ke.target,
    popupClassName: ke.target__popup
  }, kC.map((i) => /* @__PURE__ */ u.createElement(VC, {
    value: i.number,
    key: i.number
  }, /* @__PURE__ */ u.createElement(ze, {
    size: 8,
    align: "start"
  }, /* @__PURE__ */ u.createElement(Hn, {
    color: i.color
  }, i.number), /* @__PURE__ */ u.createElement(ve, {
    className: ke["target__popup-text"]
  }, i.text)))))), Boolean(a) && /* @__PURE__ */ u.createElement(Ne.Item, {
    name: "achieve",
    label: /* @__PURE__ */ u.createElement(ve, {
      className: ke.drawer__label
    }, "How you plan to achieve it")
  }, /* @__PURE__ */ u.createElement(Xs, {
    className: ke.drawer__textarea,
    characterLimit: 300,
    showCount: !0,
    placeholder: "Describe what you're planning to do and how you make this target happen."
  })), Boolean(n) && /* @__PURE__ */ u.createElement(QC, {
    onChange: () => {
    }
  }))));
}, FC = [
  {
    key: "1",
    target: /* @__PURE__ */ u.createElement("span", null, /* @__PURE__ */ u.createElement(Hn, {
      color: en[12].color
    }, "13.1"), "Strengthen resilience and adaptive capacity to climate-related hazards Strengthen resilience and adaptive capacity to climate-related hazards"),
    sdg: /* @__PURE__ */ u.createElement("img", {
      src: en[12].iconActive,
      alt: en[1].title,
      width: 48
    }),
    achieve: "Increase the involvement of the local stakeholders in the decision-making process by offering them a platform to express their concerns and needs. Make it easier for them to participate in the process of shaping the futu...",
    standard: /* @__PURE__ */ u.createElement(Hn, {
      color: "#810048"
    }, "IRIS"),
    indicators: "Number of deaths, missing persons and directly affected persons attributed to disasters per 100,000 population"
  },
  {
    key: "2",
    target: /* @__PURE__ */ u.createElement("span", null, /* @__PURE__ */ u.createElement(Hn, {
      color: en[12].color
    }, "13.2"), "Integrate climate change measures into national policies, strategies and planning"),
    achieve: "Protecting remaining high conservation value lands and securing a regional trail network within 30 years with The King County Land Conservation Initiative. Increase the involvement of the local stakeholders in the decis..."
  }
], $C = ({
  title: e,
  description: t,
  goals: r = [],
  dataSource: n = FC,
  onAdd: a,
  onEdit: i,
  onDelete: o
}) => {
  const l = [
    {
      title: "SDG",
      dataIndex: "sdg",
      key: "sdg",
      width: 65
    },
    {
      title: "Target",
      dataIndex: "target",
      key: "target"
    },
    {
      title: "How we plan to achieve it",
      dataIndex: "achieve",
      key: "achieve"
    },
    {
      title: "Standard",
      dataIndex: "standard",
      key: "standard",
      width: 65,
      verticalAlign: "top"
    },
    {
      title: "Indicators",
      dataIndex: "indicators",
      key: "indicators"
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 65,
      render: () => /* @__PURE__ */ u.createElement(ze, {
        size: 4
      }, /* @__PURE__ */ u.createElement(_e, {
        icon: /* @__PURE__ */ u.createElement(Ku, null)
      }), /* @__PURE__ */ u.createElement(na, {
        trigger: ["click"],
        menu: {
          items: [
            {
              label: "Edit",
              key: "edit",
              icon: /* @__PURE__ */ u.createElement(T0, null),
              onClick: i
            },
            {
              label: "Delete",
              key: "delete",
              danger: !0,
              icon: /* @__PURE__ */ u.createElement(Qr, null),
              onClick: o
            }
          ]
        },
        placement: "bottomRight"
      }, /* @__PURE__ */ u.createElement(_e, {
        icon: /* @__PURE__ */ u.createElement(zo, null)
      })))
    }
  ];
  return /* @__PURE__ */ u.createElement(ze, {
    block: !0,
    size: 32,
    direction: "vertical"
  }, /* @__PURE__ */ u.createElement(ze, {
    block: !0,
    size: 8,
    direction: "vertical"
  }, /* @__PURE__ */ u.createElement(ze, {
    size: 24,
    align: "center"
  }, /* @__PURE__ */ u.createElement(fn, {
    level: 3,
    style: { margin: 0 }
  }, e), /* @__PURE__ */ u.createElement(ze, {
    size: 8
  }, r.map((c) => /* @__PURE__ */ u.createElement("span", {
    className: ke.goal,
    key: c.id,
    style: { color: c.color }
  }, c.icon)))), /* @__PURE__ */ u.createElement(ze, {
    block: !0,
    justifyContent: "space-between"
  }, /* @__PURE__ */ u.createElement(Fo, {
    type: "secondary",
    size: "large",
    style: { margin: 0 }
  }, t), /* @__PURE__ */ u.createElement(_e, {
    type: "primary",
    icon: /* @__PURE__ */ u.createElement(Bn, null),
    onClick: a
  }, "Add ", e, " SDG"))), /* @__PURE__ */ u.createElement(In, {
    columns: l,
    dataSource: n,
    className: ke.table,
    emptyText: /* @__PURE__ */ u.createElement(_e, {
      icon: /* @__PURE__ */ u.createElement(Bn, null),
      onClick: a
    }, "New SDG")
  }));
}, j5 = $C;
j5.Drawer = UC;
const ZC = ({
  className: e,
  pagination: t = !1,
  emptyText: r,
  ...n
}) => /* @__PURE__ */ u.createElement(ho, {
  ...n,
  className: Y(A5.table, e),
  pagination: t,
  locale: { emptyText: /* @__PURE__ */ u.createElement(i1, null, r) }
}), In = ZC;
In.Actions = zC;
In.Column = ho.Column;
In.Summary = ho.Summary;
In.SDG = j5;
const YC = ({ ...e }) => /* @__PURE__ */ u.createElement(mo, {
  ...e
}), ha = YC;
ha.confirm = mo.confirm;
ha.useModal = mo.useModal;
const HC = "_container_hcg8m_1", f0 = {
  container: HC,
  "container-no-gaps": "_container-no-gaps_hcg8m_7",
  "aside--sticky": "_aside--sticky_hcg8m_10"
}, WC = {
  large: {
    span: 18,
    push: 2
  },
  off: {
    span: 24,
    push: 0
  },
  "small-symmetrical": {
    span: 22,
    push: 1
  }
}, BC = ({ children: e, gaps: t }) => {
  const r = WC[t];
  return /* @__PURE__ */ u.createElement($o, {
    className: f0.container
  }, /* @__PURE__ */ u.createElement(Gn, {
    span: r.span,
    push: r.push
  }, e));
}, qC = ({
  children: e,
  aside: t,
  rowProps: r,
  mainColProps: n,
  asideColProps: a
}) => /* @__PURE__ */ u.createElement($o, {
  wrap: !1,
  className: f0.container,
  ...r
}, /* @__PURE__ */ u.createElement(Gn, {
  flex: "auto",
  ...n
}, e), /* @__PURE__ */ u.createElement(Gn, {
  offset: 1,
  flex: "326px",
  ...a,
  className: Y(f0.aside, a == null ? void 0 : a.className, {
    [f0["aside--sticky"]]: a == null ? void 0 : a.sticky
  })
}, t)), GC = BC;
GC.Aside = qC;
const LA = ({ ...e }) => /* @__PURE__ */ u.createElement(Cd, {
  ...e
}), KC = "_card_fhppv_5", XC = "_title_fhppv_16", JC = "_header_fhppv_19", eE = "_subtitle_fhppv_22", tE = "_footer_fhppv_26", Br = {
  card: KC,
  "card--with-footer": "_card--with-footer_fhppv_13",
  title: XC,
  header: JC,
  subtitle: eE,
  footer: tE
}, kA = ({ className: e, title: t, subtitle: r, children: n, footer: a, ...i }) => /* @__PURE__ */ u.createElement(oa, {
  ...i,
  className: Y(Br.card, { [Br["card--with-footer"]]: !!a }, e)
}, (t || r) && /* @__PURE__ */ u.createElement("div", {
  className: Br.header
}, /* @__PURE__ */ u.createElement(u.Fragment, null, t && /* @__PURE__ */ u.createElement(fn, {
  level: 2,
  size: "large",
  className: Br.title
}, t), r && /* @__PURE__ */ u.createElement(ve, {
  className: Br.subtitle
}, r))), n && /* @__PURE__ */ u.createElement(u.Fragment, null, n), a && /* @__PURE__ */ u.createElement("div", {
  className: Br.footer
}, a)), PA = ({ ...e }) => /* @__PURE__ */ u.createElement(Ed, {
  ...e
}), RA = ({ ...e }) => /* @__PURE__ */ u.createElement(bd, {
  ...e
}), rE = ({ ...e }) => /* @__PURE__ */ u.createElement(x0, {
  ...e
}), QA = ({ text: e, ...t }) => {
  const r = Le(), [n, a] = de(!1), i = () => {
    window.clearTimeout(r.current);
  }, o = () => {
    a(!0), i(), window.navigator.clipboard.writeText(e).then(() => {
      r.current = window.setTimeout(() => {
        a(!1);
      }, 3e3);
    });
  };
  return lt(() => i, []), /* @__PURE__ */ u.createElement(_e, {
    ...t,
    icon: n ? /* @__PURE__ */ u.createElement(yo, null) : /* @__PURE__ */ u.createElement(Ud, null),
    onClick: o
  });
}, nE = "_container_11z7n_1", aE = "_overlay_11z7n_4", Ru = {
  container: nE,
  overlay: aE
}, VA = ({ overlay: e, loading: t, ...r }) => /* @__PURE__ */ u.createElement("div", {
  className: Ru.container
}, e && t && /* @__PURE__ */ u.createElement("div", {
  className: Ru.overlay
}, e), /* @__PURE__ */ u.createElement(Ad, {
  ...r,
  loading: t
})), iE = "_avatar_ofea0_5", oE = "_group_ofea0_9", x5 = {
  avatar: iE,
  group: oE
}, lE = ({ ...e }) => /* @__PURE__ */ u.createElement(Bu.Group, {
  ...e,
  className: x5.group
}), ea = ({ children: e, name: t, icon: r, ...n }) => {
  var a;
  return /* @__PURE__ */ u.createElement(Bu, {
    ...n,
    icon: r || !t && /* @__PURE__ */ u.createElement(Fd, null),
    className: x5.avatar
  }, ((a = t == null ? void 0 : t[0]) == null ? void 0 : a.toUpperCase()) || e);
};
ea.Group = lE;
const cE = "_container_a5fld_5", uE = "_tabs_a5fld_8", sE = "_tab_a5fld_8", dE = "_progress_a5fld_93", Yt = {
  container: cE,
  tabs: uE,
  tab: sE,
  "tab--error": "_tab--error_a5fld_42",
  "tab--warning": "_tab--warning_a5fld_43",
  "tab--success": "_tab--success_a5fld_44",
  "tab--disabled": "_tab--disabled_a5fld_68",
  "tab--active": "_tab--active_a5fld_71",
  progress: dE,
  "progress--1": "_progress--1_a5fld_99",
  "progress--2": "_progress--2_a5fld_102",
  "progress--3": "_progress--3_a5fld_105",
  "progress--4": "_progress--4_a5fld_108",
  "progress--5": "_progress--5_a5fld_111",
  "progress--6": "_progress--6_a5fld_114",
  "progress--7": "_progress--7_a5fld_117",
  "progress--8": "_progress--8_a5fld_120",
  "progress--9": "_progress--9_a5fld_123",
  "progress--10": "_progress--10_a5fld_126",
  "progress--11": "_progress--11_a5fld_129",
  "progress--12": "_progress--12_a5fld_132",
  "progress--13": "_progress--13_a5fld_135",
  "progress--14": "_progress--14_a5fld_138",
  "progress--15": "_progress--15_a5fld_141",
  "progress--16": "_progress--16_a5fld_144",
  "progress--17": "_progress--17_a5fld_147",
  "progress--18": "_progress--18_a5fld_150",
  "progress--19": "_progress--19_a5fld_153",
  "progress--20": "_progress--20_a5fld_156",
  "progress--stochastic": "_progress--stochastic_a5fld_159"
}, fE = "_badge_1nmch_5", Qu = {
  badge: fE,
  "badge--filled": "_badge--filled_1nmch_8",
  "badge--outlined": "_badge--outlined_1nmch_18"
}, vE = ({ type: e = "filled", ...t }) => /* @__PURE__ */ u.createElement(jd, {
  ...t,
  className: Y(Qu.badge, Qu[`badge--${e}`])
}), ME = ({
  path: e,
  label: t,
  count: r,
  status: n,
  disabled: a,
  stochastic: i,
  ...o
}) => /* @__PURE__ */ u.createElement(E5, {
  ...o,
  end: !0,
  disabled: a,
  className: Y(Yt.tab, {
    [Yt[`tab--${n}`]]: n,
    [Yt["tab--disabled"]]: a,
    [Yt["tab--stochastic"]]: i
  }),
  activeClassName: Yt["tab--active"],
  to: e
}, /* @__PURE__ */ u.createElement(vE, {
  type: "outlined",
  count: r,
  "data-text": t
}, t)), gE = ({
  tabs: e,
  data: t,
  progress: r
}) => Qe(
  () => e.map((n) => {
    var i, o;
    if (!t)
      return n;
    let a = (i = t[n.key]) == null ? void 0 : i.status;
    return a || (a = (r == null ? void 0 : r[n.key]) === 100 ? "success" : "progress"), {
      ...n,
      count: (o = t[n.key]) == null ? void 0 : o.count,
      status: a
    };
  }),
  [e, t]
), pE = 600, hE = ({ items: e, stochastic: t, progress: r = 0 }) => {
  const n = Le(null);
  return lt(() => {
    if (n.current) {
      const { unwrapGrid: a } = Xd(n.current, { duration: pE });
      return a;
    }
  }, [n]), /* @__PURE__ */ u.createElement("div", {
    className: Yt.container
  }, /* @__PURE__ */ u.createElement("div", {
    ref: n,
    className: Yt.tabs
  }, e.map((a) => /* @__PURE__ */ u.createElement(ME, {
    ...a,
    key: a.label,
    stochastic: t
  })), /* @__PURE__ */ u.createElement("div", {
    className: Y(
      Yt.progress,
      { [Yt["progress--stochastic"]]: t },
      Yt[`progress--${r + 1}`]
    ),
    style: {
      width: r === 0 ? 0 : "auto"
    }
  })));
};
hE.useFillStatus = gE;
const mE = "_banner_14n6x_5", yE = "_banner__button_14n6x_25", NE = "_shape_14n6x_40", zE = "_hashpack_14n6x_72", _E = "_hashpack__text_14n6x_82", Et = {
  banner: mE,
  "banner-header__title": "_banner-header__title_14n6x_10",
  "banner-header__text": "_banner-header__text_14n6x_17",
  banner__button: yE,
  "banner--colored": "_banner--colored_14n6x_28",
  shape: NE,
  "banner--middle": "_banner--middle_14n6x_53",
  "banner-header": "_banner-header_14n6x_10",
  "banner--large": "_banner--large_14n6x_56",
  "banner--small": "_banner--small_14n6x_59",
  hashpack: zE,
  hashpack__text: _E
}, IE = (e) => /* @__PURE__ */ z.createElement("svg", {
  width: 126,
  height: 24,
  viewBox: "0 0 126 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  ...e
}, /* @__PURE__ */ z.createElement("g", {
  clipPath: "url(#clip0_1_17)"
}, /* @__PURE__ */ z.createElement("path", {
  d: "M83.8353 5.3562C85.1029 5.3562 86.2029 5.56011 87.1367 5.96793C88.0838 6.37574 88.808 6.96027 89.3095 7.72152C89.8109 8.48277 90.0617 9.38679 90.0617 10.4335C90.0617 11.4667 89.8109 12.3706 89.3095 13.1455C88.808 13.9068 88.0838 14.4913 87.1367 14.8991C86.2029 15.3069 85.1029 15.5108 83.8353 15.5108H80.5339V19.6298H77.8178V5.3562H83.8353ZM83.7096 13.2678C84.8941 13.2678 85.7923 13.0231 86.4055 12.5338C87.018 12.0444 87.3246 11.3443 87.3246 10.4335C87.3246 9.52274 87.018 8.82265 86.4055 8.33324C85.7923 7.8439 84.8941 7.5992 83.7096 7.5992H80.5339V13.2678H83.7096Z",
  fill: "white"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M95.6386 8.61914C97.2826 8.61914 98.5363 9.00655 99.3995 9.78144C100.277 10.5427 100.716 11.6982 100.716 13.2479V19.6302H98.2506V18.3048C97.9301 18.7806 97.4705 19.1476 96.8713 19.4059C96.2867 19.6506 95.5764 19.7729 94.7404 19.7729C93.9044 19.7729 93.1732 19.637 92.5467 19.3651C91.9195 19.0797 91.432 18.6923 91.0842 18.2028C90.7497 17.6999 90.5827 17.1357 90.5827 16.5104C90.5827 15.5316 90.9515 14.75 91.6897 14.1655C92.4419 13.5673 93.6194 13.2683 95.2209 13.2683H98.104V13.1052C98.104 12.3439 97.8672 11.7593 97.3937 11.3515C96.9341 10.9437 96.2448 10.7398 95.3257 10.7398C94.6985 10.7398 94.079 10.835 93.4658 11.0253C92.8673 11.2156 92.3588 11.4807 91.9405 11.8205L90.9166 9.96498C91.5019 9.52991 92.2052 9.19691 93.0272 8.96578C93.8492 8.73471 94.7194 8.61914 95.6386 8.61914ZM95.2838 17.9174C95.9382 17.9174 96.5165 17.7747 97.0179 17.4892C97.5334 17.1901 97.8951 16.7687 98.104 16.225V14.9607H95.4088C93.9044 14.9607 93.1522 15.4433 93.1522 16.4084C93.1522 16.8706 93.3408 17.2377 93.7165 17.5096C94.093 17.7814 94.6154 17.9174 95.2838 17.9174Z",
  fill: "white"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M108.244 19.7729C107.088 19.7729 106.05 19.535 105.131 19.0593C104.212 18.5835 103.494 17.9242 102.979 17.0813C102.463 16.225 102.206 15.2598 102.206 14.1858C102.206 13.1119 102.463 12.1535 102.979 11.3108C103.494 10.4679 104.205 9.80864 105.11 9.33287C106.029 8.85703 107.074 8.61914 108.244 8.61914C109.344 8.61914 110.305 8.83664 111.127 9.27164C111.963 9.70664 112.59 10.332 113.007 11.1476L111.002 12.2895C110.682 11.7865 110.277 11.4127 109.79 11.168C109.316 10.9097 108.794 10.7806 108.223 10.7806C107.248 10.7806 106.44 11.0933 105.799 11.7185C105.159 12.3303 104.838 13.1527 104.838 14.1858C104.838 15.219 105.152 16.0482 105.778 16.6735C106.419 17.2853 107.234 17.5911 108.223 17.5911C108.794 17.5911 109.316 17.4688 109.79 17.2241C110.277 16.9658 110.682 16.5852 111.002 16.0822L113.007 17.2241C112.576 18.0397 111.942 18.6718 111.106 19.1204C110.284 19.5554 109.33 19.7729 108.244 19.7729Z",
  fill: "white"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M118.673 14.9605L116.73 16.7549V19.63H114.119V4.5H116.73V13.6351L122.141 8.74132H125.276L120.617 13.3088L125.714 19.63H122.539L118.673 14.9605Z",
  fill: "white"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M40.9322 5.3562V19.6298H38.216V13.5125H30.6527V19.6298H27.9365V5.3562H30.6527V11.2492H38.216V5.3562H40.9322Z",
  fill: "white"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M47.6224 8.61914C49.266 8.61914 50.5197 9.00655 51.3833 9.78144C52.2607 10.5427 52.6995 11.6982 52.6995 13.2479V19.6302H50.2341V18.3048C49.9137 18.7806 49.4541 19.1476 48.8551 19.4059C48.2701 19.6506 47.5597 19.7729 46.724 19.7729C45.8883 19.7729 45.157 19.637 44.5302 19.3651C43.9034 19.0797 43.4159 18.6923 43.0677 18.2028C42.7334 17.6999 42.5662 17.1357 42.5662 16.5104C42.5662 15.5316 42.9353 14.75 43.6736 14.1655C44.4257 13.5673 45.6028 13.2683 47.2046 13.2683H50.0878V13.1052C50.0878 12.3439 49.8511 11.7593 49.3775 11.3515C48.9178 10.9437 48.2283 10.7398 47.309 10.7398C46.6822 10.7398 46.0624 10.835 45.4495 11.0253C44.8506 11.2156 44.3422 11.4807 43.9243 11.8205L42.9005 9.96498C43.4855 9.52991 44.189 9.19691 45.0107 8.96578C45.8325 8.73471 46.7031 8.61914 47.6224 8.61914ZM47.2672 17.9174C47.9219 17.9174 48.4999 17.7747 49.0014 17.4892C49.5167 17.1901 49.8789 16.7687 50.0878 16.225V14.9607H47.3926C45.8883 14.9607 45.1361 15.4433 45.1361 16.4084C45.1361 16.8706 45.3242 17.2377 45.7003 17.5096C46.0763 17.7814 46.5986 17.9174 47.2672 17.9174Z",
  fill: "white"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M58.6496 19.7729C57.7442 19.7729 56.8597 19.6574 55.9961 19.4263C55.1325 19.1952 54.443 18.9029 53.9277 18.5495L54.9306 16.6124C55.432 16.9386 56.0309 17.2037 56.7274 17.4076C57.4377 17.5979 58.1342 17.693 58.8167 17.693C60.3767 17.693 61.1568 17.2921 61.1568 16.49C61.1568 16.1094 60.9548 15.8443 60.5508 15.6948C60.1609 15.5453 59.5271 15.4025 58.6496 15.2666C57.7302 15.1306 56.9781 14.9743 56.3931 14.7976C55.822 14.6208 55.3206 14.315 54.8887 13.88C54.4709 13.4314 54.262 12.8129 54.262 12.0244C54.262 10.9913 54.7007 10.1688 55.5782 9.55712C56.4697 8.93182 57.6676 8.61914 59.1719 8.61914C59.938 8.61914 60.7041 8.7075 61.4702 8.88423C62.2363 9.04739 62.8631 9.27164 63.3506 9.55712L62.3477 11.4942C61.4005 10.9505 60.335 10.6786 59.151 10.6786C58.3849 10.6786 57.7999 10.7942 57.396 11.0253C57.006 11.2428 56.811 11.5351 56.811 11.9021C56.811 12.3099 57.0199 12.6022 57.4377 12.7789C57.8696 12.942 58.5312 13.0983 59.4226 13.2479C60.3141 13.3838 61.0453 13.5402 61.6164 13.7169C62.1875 13.8935 62.675 14.1927 63.079 14.614C63.4968 15.0355 63.7058 15.6336 63.7058 16.4084C63.7058 17.428 63.2531 18.2436 62.3477 18.8553C61.4423 19.4671 60.2096 19.7729 58.6496 19.7729Z",
  fill: "white"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M71.2409 8.61893C72.6475 8.61893 73.7762 9.01998 74.6254 9.822C75.4754 10.624 75.9 11.8135 75.9 13.3904V19.63H73.2887V13.7167C73.2887 12.7651 73.0589 12.0514 72.5993 11.5756C72.1391 11.0862 71.4847 10.8415 70.6347 10.8415C69.674 10.8415 68.9148 11.127 68.3577 11.698C67.8005 12.2553 67.5219 13.0641 67.5219 14.1245V19.63H64.9102V4.5H67.5219V10.0055C67.9537 9.55691 68.483 9.21709 69.1099 8.98595C69.7506 8.74132 70.4608 8.61893 71.2409 8.61893Z",
  fill: "white"
}), /* @__PURE__ */ z.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.1143 3.81818C20.1143 9.24061 15.6115 13.6364 10.0571 13.6364C4.50274 13.6364 0 9.24061 0 3.81818C0 1.70946 1.75107 0 3.91111 0C6.07116 0 7.82222 1.70946 7.82222 3.81818V11.1383C9.27157 11.5594 10.8427 11.5594 12.2921 11.1383V3.81818C12.2921 1.70946 14.0431 0 16.2032 0C18.3632 0 20.1143 1.70946 20.1143 3.81818ZM3.91111 2.18182C4.83684 2.18182 5.5873 2.91445 5.5873 3.81818V10.0858C3.56081 8.70586 2.23492 6.41317 2.23492 3.81818C2.23492 2.91445 2.98538 2.18182 3.91111 2.18182ZM14.527 3.81818V10.0858C16.5535 8.70586 17.8794 6.41317 17.8794 3.81818C17.8794 2.91445 17.1289 2.18182 16.2032 2.18182C15.2774 2.18182 14.527 2.91445 14.527 3.81818Z",
  fill: "#7A7AB8"
}), /* @__PURE__ */ z.createElement("path", {
  d: "M14.527 20.1821V15.0004C11.6782 16.0867 8.43382 16.0858 5.5873 15.0004V20.1821C5.5873 21.0858 4.83684 21.8184 3.91111 21.8184C2.98538 21.8184 2.23492 21.0858 2.23492 20.1821V13.0755C1.38692 12.3918 0.63446 11.5993 0 10.7197V20.1821C0 22.2908 1.75107 24.0002 3.91111 24.0002C6.07116 24.0002 7.82222 22.2908 7.82222 20.1821V17.8335C9.3002 18.0562 10.8141 18.0562 12.2921 17.8335V20.1821C12.2921 22.2908 14.0431 24.0002 16.2032 24.0002C18.3632 24.0002 20.1143 22.2908 20.1143 20.1821V10.7197C19.4798 11.5993 18.7274 12.3918 17.8794 13.0755V20.1821C17.8794 21.0858 17.1289 21.8184 16.2032 21.8184C15.2774 21.8184 14.527 21.0858 14.527 20.1821Z",
  fill: "#7A7AB8"
})), /* @__PURE__ */ z.createElement("defs", null, /* @__PURE__ */ z.createElement("clipPath", {
  id: "clip0_1_17"
}, /* @__PURE__ */ z.createElement("rect", {
  width: 125.714,
  height: 24,
  fill: "white"
})))), DE = "data:image/svg+xml;base64,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", CE = ({ button: e, text: t }) => /* @__PURE__ */ u.createElement("div", {
  className: Et.hashpack
}, /* @__PURE__ */ u.createElement("div", {
  className: Et.hashpack__left
}, /* @__PURE__ */ u.createElement(IE, null), t && /* @__PURE__ */ u.createElement("p", {
  className: Et.hashpack__text
}, t)), /* @__PURE__ */ u.createElement(_e, {
  type: "default",
  className: Et.hashpack__button,
  ...e
}, e.text)), UA = ({
  title: e,
  text: t,
  size: r = "middle",
  colored: n,
  className: a,
  button: i,
  hashPack: o,
  ...l
}) => {
  if (o)
    return /* @__PURE__ */ u.createElement(CE, {
      button: i,
      text: t
    });
  const c = n ? "default" : "primary";
  return /* @__PURE__ */ u.createElement("div", {
    className: Y(Et.banner, Et[`banner--${r}`], a, {
      [Et["banner--colored"]]: n
    }),
    ...l
  }, n && /* @__PURE__ */ u.createElement("img", {
    className: Et.shape,
    src: DE,
    alt: "",
    role: "presentation"
  }), /* @__PURE__ */ u.createElement("div", {
    className: Et["banner-header"]
  }, /* @__PURE__ */ u.createElement("h2", {
    className: Et["banner-header__title"]
  }, e), t && /* @__PURE__ */ u.createElement("p", {
    className: Et["banner-header__text"]
  }, t)), /* @__PURE__ */ u.createElement(_e, {
    type: c,
    className: Et.banner__button,
    ...i
  }, i.text));
}, EE = "_text_h77my_5", bE = "_container_h77my_8", AE = "_container__danger_h77my_16", jE = "_button_h77my_28", xE = "_button__icon_h77my_32", wE = "_loading_h77my_36", OE = "_loading__icon_h77my_43", Cr = {
  text: EE,
  container: bE,
  container__danger: AE,
  button: jE,
  button__icon: xE,
  loading: wE,
  loading__icon: OE
}, w5 = (e) => {
  const { acceptedMimeTypes: t, loading: r, onChange: n, errorElement: a, ...i } = e, [o, l] = de(r), c = (...M) => {
    const [f] = M, { fileList: v } = f;
    l(v.some((g) => g.status === "uploading")), n == null || n(...M);
  }, s = () => a || (o ? /* @__PURE__ */ u.createElement("div", {
    className: Cr.loading
  }, /* @__PURE__ */ u.createElement(Xu, {
    spin: !0,
    className: Cr.loading__icon
  })) : /* @__PURE__ */ u.createElement(ve, {
    type: "secondary",
    className: Cr.text
  }, "Drag and drop ", t == null ? void 0 : t.map(({ label: M }) => M).join(", "), " here ", /* @__PURE__ */ u.createElement("br", null), " or")), d = Boolean(a);
  return /* @__PURE__ */ u.createElement("div", {
    className: Y(Cr.container, {
      [Cr.container__danger]: d
    })
  }, /* @__PURE__ */ u.createElement(pi.Dragger, {
    showUploadList: !1,
    accept: t == null ? void 0 : t.map(({ mime: M }) => M).join(","),
    onChange: c,
    ...i
  }, /* @__PURE__ */ u.createElement(sn, {
    direction: "vertical",
    size: 10,
    align: "center"
  }, s(), /* @__PURE__ */ u.createElement(_e, {
    className: Cr.button,
    icon: /* @__PURE__ */ u.createElement(Bn, {
      className: Cr.button__icon
    }),
    size: "middle",
    danger: d
  }, "Browse file"))));
}, TE = "_uploaded_vyqs5_5", SE = "_uploaded__image_vyqs5_11", LE = "_action_vyqs5_16", kE = "_action__btn_vyqs5_23", PE = "_dialog_vyqs5_26", RE = "_dialog__icon_vyqs5_29", QE = "_dialog__title_vyqs5_33", VE = "_dialog__text_vyqs5_39", Xt = {
  uploaded: TE,
  uploaded__image: SE,
  action: LE,
  action__btn: kE,
  dialog: PE,
  dialog__icon: RE,
  dialog__title: QE,
  dialog__text: VE
}, FA = ({
  value: e = null,
  upload: t,
  onChange: r,
  ...n
}) => {
  const [a, i] = de(e), [o, l] = de(!1), [c, s] = de(!1), d = Le(null), M = async ({
    onSuccess: p,
    onError: h,
    file: y
  }) => {
    try {
      l(!0);
      const N = await t(y);
      i(N), p == null || p(N), r == null || r(N);
    } catch (N) {
      h == null || h(new Error(), { file: y, error: N });
    } finally {
      l(!1);
    }
  }, f = () => {
    var h;
    const p = (h = d.current) == null ? void 0 : h.querySelector("input[type=file]");
    !p || p.click();
  }, v = () => s(!0), g = () => s(!1), m = () => {
    i(null), r == null || r(null), g();
  };
  return /* @__PURE__ */ u.createElement("div", null, /* @__PURE__ */ u.createElement("div", {
    ref: d,
    style: {
      display: a ? "none" : ""
    }
  }, /* @__PURE__ */ u.createElement(w5, {
    ...n,
    customRequest: M
  })), a && /* @__PURE__ */ u.createElement("div", {
    className: Xt.uploaded
  }, /* @__PURE__ */ u.createElement("img", {
    className: Xt.uploaded__image,
    src: a,
    alt: ""
  }), /* @__PURE__ */ u.createElement("div", {
    className: Xt.action
  }, /* @__PURE__ */ u.createElement(_e, {
    loading: o,
    className: Xt.action__btn,
    onClick: f,
    icon: /* @__PURE__ */ u.createElement(T0, null)
  }), /* @__PURE__ */ u.createElement(_e, {
    className: Xt.action__btn,
    onClick: v,
    icon: /* @__PURE__ */ u.createElement(Qr, null)
  }))), /* @__PURE__ */ u.createElement(ha, {
    wrapClassName: Xt.dialog,
    open: c,
    closable: !1,
    centered: !0,
    mask: !1,
    onOk: m,
    onCancel: g,
    okText: "Delete"
  }, /* @__PURE__ */ u.createElement(ze, {
    size: 16,
    align: "start"
  }, /* @__PURE__ */ u.createElement("span", {
    className: Xt.dialog__icon
  }, /* @__PURE__ */ u.createElement(O0, null)), /* @__PURE__ */ u.createElement(ze, {
    direction: "vertical"
  }, /* @__PURE__ */ u.createElement(ve, {
    className: Xt.dialog__title
  }, "Are you sure to delete this picture?"), /* @__PURE__ */ u.createElement(ve, {
    className: Xt.dialog__text
  }, "This action cannot be undone.")))));
}, UE = "_tag_16ll4_5", a1 = {
  tag: UE,
  "tag-default": "_tag-default_16ll4_12",
  "tag--outlined": "_tag--outlined_16ll4_12",
  "tag--filled": "_tag--filled_16ll4_19",
  "tag--saturated": "_tag--saturated_16ll4_20",
  "tag-pink": "_tag-pink_16ll4_29",
  "tag-magenta": "_tag-magenta_16ll4_32",
  "tag-red": "_tag-red_16ll4_35",
  "tag-volcano": "_tag-volcano_16ll4_38",
  "tag-orange": "_tag-orange_16ll4_41",
  "tag-yellow": "_tag-yellow_16ll4_44",
  "tag-gold": "_tag-gold_16ll4_47",
  "tag-cyan": "_tag-cyan_16ll4_50",
  "tag-lime": "_tag-lime_16ll4_53",
  "tag-green": "_tag-green_16ll4_56",
  "tag-blue": "_tag-blue_16ll4_59",
  "tag-geekblue": "_tag-geekblue_16ll4_62",
  "tag-purple": "_tag-purple_16ll4_65",
  "tag-success": "_tag-success_16ll4_68",
  "tag-processing": "_tag-processing_16ll4_71",
  "tag-error": "_tag-error_16ll4_74",
  "tag-warning": "_tag-warning_16ll4_77"
}, yi = ({ className: e, type: t = "outlined", color: r = "default", ...n }) => /* @__PURE__ */ u.createElement(go, {
  ...n,
  className: Y(a1.tag, a1[`tag--${t}`], a1[`tag-${r}`], e),
  color: r
}), FE = ({ children: e, color: t, ...r }) => /* @__PURE__ */ u.createElement(yi, {
  type: "outlined",
  style: {
    borderColor: t,
    color: t,
    lineHeight: "0.9rem"
  },
  ...r
}, e);
yi.SDG = FE;
const $E = "_wrapper_uae3t_5", ZE = "_row_uae3t_19", YE = "_fileIcon_uae3t_25", HE = "_dialog_uae3t_29", WE = "_dialog__icon_uae3t_32", BE = "_dialog__title_uae3t_36", qE = "_dialog__text_uae3t_42", dr = {
  wrapper: $E,
  row: ZE,
  fileIcon: YE,
  dialog: HE,
  dialog__icon: WE,
  dialog__title: BE,
  dialog__text: qE
}, GE = ({ status: e }) => {
  const t = e === "verified" ? "green" : "blue";
  return /* @__PURE__ */ u.createElement(yi, {
    color: t,
    type: "filled",
    key: e
  }, e);
}, $A = ({
  initialValue: e = [],
  upload: t,
  onChange: r,
  ...n
}) => {
  const [a, i] = de(e), [o, l] = de(!1), [c, s] = de(null), d = async ({
    onSuccess: m,
    onError: p,
    file: h
  }) => {
    try {
      l(!0);
      const y = await t(h);
      i((N) => {
        const I = [...N, y];
        return queueMicrotask(() => {
          m == null || m(I), r == null || r(I);
        }), I;
      });
    } catch (y) {
      p == null || p(new Error(), { file: h, error: y });
    } finally {
      l(!1);
    }
  }, M = (m) => s(m), f = () => s(null), v = [
    {
      title: "File name",
      dataIndex: "name",
      render: (m) => /* @__PURE__ */ u.createElement(ze, {
        size: 6
      }, /* @__PURE__ */ u.createElement(No, {
        className: dr.fileIcon
      }), /* @__PURE__ */ u.createElement(ve, {
        weight: "bold"
      }, m))
    },
    {
      title: "Upload date",
      dataIndex: "date",
      width: 140
    },
    {
      title: "Size",
      dataIndex: "size",
      width: 100
    },
    {
      title: "Verification",
      dataIndex: "status",
      width: 180,
      render: (m) => /* @__PURE__ */ u.createElement(GE, {
        status: m
      })
    },
    {
      title: "Visibility",
      dataIndex: "visibility",
      width: 300,
      render: (m) => /* @__PURE__ */ u.createElement(bt, {
        defaultValue: m,
        options: [
          {
            value: "My company",
            label: "My company"
          },
          {
            value: "Public",
            label: "Public"
          }
        ]
      })
    },
    {
      title: "Actions",
      width: 100,
      dataIndex: "key",
      render: (m) => /* @__PURE__ */ u.createElement(ze, {
        block: !0,
        justifyContent: "end"
      }, /* @__PURE__ */ u.createElement(_e, {
        className: dr.action__btn,
        icon: /* @__PURE__ */ u.createElement(Qr, null),
        onClick: () => M(m)
      }))
    }
  ], g = () => {
    const m = c;
    i((p) => {
      const h = p.filter(({ key: y }) => m !== y);
      return r == null || r(h), h;
    }), s(null);
  };
  return /* @__PURE__ */ u.createElement("div", {
    className: dr.wrapper
  }, /* @__PURE__ */ u.createElement(In, {
    dataSource: a,
    columns: v,
    rowClassName: dr.row
  }), /* @__PURE__ */ u.createElement(w5, {
    ...n,
    multiple: !0,
    loading: o,
    customRequest: d
  }), /* @__PURE__ */ u.createElement(ha, {
    wrapClassName: dr.dialog,
    open: Boolean(c),
    closable: !1,
    centered: !0,
    mask: !1,
    onOk: g,
    onCancel: f,
    okText: "Delete"
  }, /* @__PURE__ */ u.createElement(ze, {
    size: 16,
    align: "start"
  }, /* @__PURE__ */ u.createElement("span", {
    className: dr.dialog__icon
  }, /* @__PURE__ */ u.createElement(O0, null)), /* @__PURE__ */ u.createElement(ze, {
    direction: "vertical"
  }, /* @__PURE__ */ u.createElement(ve, {
    className: dr.dialog__title
  }, "Are you sure to delete this Document?"), /* @__PURE__ */ u.createElement(ve, {
    className: dr.dialog__text
  }, "This action cannot be undone.")))));
}, KE = "_stage_j2b94_5", XE = "_stage__year_j2b94_47", JE = "_stage__quarter_j2b94_48", eb = "_stage__action_j2b94_51", tb = "_addNote_j2b94_54", tr = {
  stage: KE,
  "holder-icon": "_holder-icon_j2b94_8",
  "index-icon": "_index-icon_j2b94_24",
  stage__year: XE,
  stage__quarter: JE,
  stage__action: eb,
  addNote: tb,
  "addNote--hide-tail": "_addNote--hide-tail_j2b94_60"
}, rb = ({ stepNumber: e, title: t, year: r, quarter: n }) => {
  const { getPrefixCls: a } = xe(aa.ConfigContext), { onNodeDrop: i, onNodeDragStart: o, onNodeDragEnd: l, onDeleteNode: c, onUpdateNode: s, disabled: d } = xe(O5) || {}, M = a("steps"), f = () => {
    i == null || i(e);
  }, v = () => {
    o == null || o(e);
  }, g = () => {
    l == null || l(e);
  }, m = (I) => {
    I.preventDefault(), I.stopPropagation();
  }, p = () => {
    c == null || c(e);
  }, h = (I) => {
    s == null || s(e, { title: I.target.value });
  }, y = (I) => {
    s == null || s(e, { year: I });
  }, N = (I) => {
    s == null || s(e, { quarter: I });
  };
  return /* @__PURE__ */ u.createElement("div", {
    draggable: !d,
    onDrop: f,
    onDragStart: v,
    onDragEnd: g,
    onDragOver: m,
    className: Y(tr.stage, `${M}-item`)
  }, /* @__PURE__ */ u.createElement("div", {
    className: Y(`${M}-item-container`)
  }, /* @__PURE__ */ u.createElement("div", {
    className: `${M}-item-tail`
  }), /* @__PURE__ */ u.createElement("div", {
    className: Y(tr["index-icon"], `${M}-item-icon`)
  }, /* @__PURE__ */ u.createElement("span", {
    className: `${M}-icon`
  }, e)), /* @__PURE__ */ u.createElement("div", {
    className: Y(tr["holder-icon"], `${M}-item-icon`)
  }, /* @__PURE__ */ u.createElement("span", {
    className: `${M}-icon`
  }, /* @__PURE__ */ u.createElement("span", {
    "aria-label": "holder",
    className: Y("anticon", "anticon-holder"),
    role: "img"
  }, /* @__PURE__ */ u.createElement($d, null)))), /* @__PURE__ */ u.createElement("div", {
    className: `${M}-item-content`
  }, /* @__PURE__ */ u.createElement(Lr, {
    className: tr.stage__title,
    disabled: d,
    value: t,
    onChange: h,
    placeholder: "Stage"
  }), /* @__PURE__ */ u.createElement(bt, {
    disabled: d,
    showSearch: !0,
    className: tr.stage__year,
    onChange: y,
    placeholder: "Year",
    value: r,
    options: ef(2020, 2100)
  }), /* @__PURE__ */ u.createElement(bt, {
    className: tr.stage__quarter,
    disabled: d,
    placeholder: "Quarter",
    onChange: N,
    value: n,
    options: [
      { label: "Q1", value: 1 },
      { label: "Q2", value: 2 },
      { label: "Q3", value: 3 },
      { label: "Q4", value: 4 }
    ]
  }), /* @__PURE__ */ u.createElement(_e, {
    disabled: d,
    icon: /* @__PURE__ */ u.createElement(Qr, null),
    onClick: p,
    danger: !0,
    className: tr.stage__action
  }))));
}, nb = ({ onAdd: e, hideTail: t }) => {
  const { getPrefixCls: r } = xe(aa.ConfigContext), n = r("steps");
  return /* @__PURE__ */ u.createElement("div", {
    onClick: () => e(),
    className: Y(`${n}-item`, tr.addNote, {
      [tr["addNote--hide-tail"]]: t
    })
  }, /* @__PURE__ */ u.createElement("div", {
    className: `${n}-item-container`
  }, /* @__PURE__ */ u.createElement("div", {
    className: Y(`${n}-item-icon`)
  }, /* @__PURE__ */ u.createElement("span", {
    className: `${n}-icon`
  }, /* @__PURE__ */ u.createElement(w0, null))), /* @__PURE__ */ u.createElement("div", {
    className: `${n}-item-content`
  }, "Add new")));
}, O5 = u.createContext(null), ZA = ({ disabled: e, value: t, defaultValue: r, onChange: n, className: a }) => {
  const [i, o] = Ao([], {
    value: t,
    defaultValue: r
  }), [l, c] = de(null), { getPrefixCls: s } = xe(aa.ConfigContext), d = s("steps"), M = (y) => {
    c(y);
  }, f = (y) => {
    if (l === null)
      throw new Error("Not found draggable element!");
    const N = i.map((I) => I.stepNumber === l ? {
      ...I,
      stepNumber: y
    } : I.stepNumber === y ? {
      ...I,
      stepNumber: l
    } : { ...I });
    o(N), n == null || n(N);
  }, v = () => {
    c(null);
  }, g = () => {
    var N;
    const y = [
      ...i,
      {
        stepNumber: ((N = i[i.length - 1]) == null ? void 0 : N.stepNumber) + 1 || 1
      }
    ];
    o(y), n == null || n(y);
  }, m = (y, N) => {
    const I = i.map((D) => D.stepNumber === y ? {
      ...D,
      ...N
    } : { ...D });
    o(I), n == null || n(I);
  }, p = (y) => {
    const N = i.filter((I) => I.stepNumber !== y).map((I) => I.stepNumber > y ? {
      ...I,
      stepNumber: I.stepNumber - 1
    } : { ...I });
    o(N), n == null || n(N);
  }, h = Qe(
    () => i.sort((y, N) => y.stepNumber - N.stepNumber),
    [i]
  );
  return /* @__PURE__ */ u.createElement(O5.Provider, {
    value: {
      disabled: e,
      onNodeDragStart: M,
      onNodeDrop: f,
      onNodeDragEnd: v,
      onUpdateNode: m,
      onDeleteNode: p
    }
  }, /* @__PURE__ */ u.createElement(Jd, {
    className: a,
    prefixCls: d,
    direction: "vertical",
    items: h,
    itemRender: (y) => /* @__PURE__ */ u.createElement(rb, {
      ...y
    })
  }), /* @__PURE__ */ u.createElement(nb, {
    onAdd: g,
    hideTail: i.length === 0
  }));
}, ab = "_card_1dc2d_5", ib = {
  card: ab
}, ob = ({ className: e, ...t }) => /* @__PURE__ */ u.createElement(oa, {
  ...t,
  className: Y(ib.card, e)
}), Ni = ({ ...e }) => /* @__PURE__ */ u.createElement(oa, {
  ...e
});
Ni.Meta = oa.Meta;
Ni.Grid = oa.Grid;
Ni.Info = ob;
const lb = "_icon_y4st4_5", cb = "_overlay_y4st4_21", Vu = {
  icon: lb,
  overlay: cb
}, YA = ({ title: e, children: t }) => /* @__PURE__ */ u.createElement(u.Fragment, null, t, /* @__PURE__ */ u.createElement(x0, {
  title: e,
  placement: "bottom",
  overlayClassName: Vu.overlay
}, /* @__PURE__ */ u.createElement(ts, {
  className: Vu.icon
}))), ub = "_list_1darh_1", sb = "_marker_1darh_9", Uu = {
  list: ub,
  marker: sb
}, T5 = ({ items: e, className: t, marker: r, ...n }) => /* @__PURE__ */ u.createElement("ul", {
  className: Y(Uu.list, t),
  ...n
}, e == null ? void 0 : e.map((a) => /* @__PURE__ */ u.createElement("li", {
  key: a
}, r && /* @__PURE__ */ u.createElement("span", {
  className: Uu.marker
}, r), a)));
T5.AntList = qu;
T5.AntItem = qu.Item;
const db = "_container_18rqd_5", fb = "_caption_18rqd_6", vb = "_title_18rqd_23", Mb = "_subtitle_18rqd_26", qr = {
  container: db,
  caption: fb,
  "container--right": "_container--right_18rqd_16",
  title: vb,
  subtitle: Mb
}, HA = ({
  title: e,
  requiredPercent: t,
  subtitle: r,
  percent: n,
  size: a,
  width: i,
  placement: o = "bottom",
  ...l
}) => /* @__PURE__ */ u.createElement("div", {
  className: Y(qr.container, qr[`container--${o}`])
}, /* @__PURE__ */ u.createElement(Hu, {
  ...l,
  className: qr.progres,
  format: (c, s) => `${s}%`,
  percent: t,
  strokeColor: "#EFEAFB",
  width: i || (a === "small" ? 63 : void 0),
  size: a,
  success: { percent: n, strokeColor: "#6F13C7" }
}), /* @__PURE__ */ u.createElement("div", {
  className: qr.caption
}, e && /* @__PURE__ */ u.createElement(ve, {
  weight: "bold",
  size: "large",
  className: qr.title
}, e), r && /* @__PURE__ */ u.createElement(ve, {
  type: "secondary",
  className: qr.subtitle
}, r)));
var Fe = /* @__PURE__ */ ((e) => (e.OPEN = "open", e.SUBMITTED = "submitted", e.RESOLVED = "resolved", e))(Fe || {});
const gb = "_thread_16oov_5", pb = "_thread_compact_16oov_14", hb = "_thread__input_16oov_18", mb = "_thread__actions_16oov_23", yb = "_thread__divider_16oov_31", Er = {
  thread: gb,
  thread_compact: pb,
  thread__input: hb,
  thread__actions: mb,
  thread__divider: yb,
  "thread--active": "_thread--active_16oov_37",
  "thread--with-pointer": "_thread--with-pointer_16oov_37",
  "thread-submitted": "_thread-submitted_16oov_51",
  "thread-open": "_thread-open_16oov_54",
  "thread-resolved": "_thread-resolved_16oov_57"
};
var S5 = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(jr, function() {
    return function(r, n, a) {
      r = r || {};
      var i = n.prototype, o = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function l(s, d, M, f) {
        return i.fromToBase(s, d, M, f);
      }
      a.en.relativeTime = o, i.fromToBase = function(s, d, M, f, v) {
        for (var g, m, p, h = M.$locale().relativeTime || o, y = r.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], N = y.length, I = 0; I < N; I += 1) {
          var D = y[I];
          D.d && (g = f ? a(s).diff(M, D.d, !0) : M.diff(s, D.d, !0));
          var A = (r.rounding || Math.round)(Math.abs(g));
          if (p = g > 0, A <= D.r || !D.r) {
            A <= 1 && I > 0 && (D = y[I - 1]);
            var k = h[D.l];
            v && (A = v("" + A)), m = typeof k == "string" ? k.replace("%d", A) : k(A, d, D.l, p);
            break;
          }
        }
        if (d)
          return m;
        var L = p ? h.future : h.past;
        return typeof L == "function" ? L(m) : L.replace("%s", m);
      }, i.to = function(s, d) {
        return l(s, d, this, !0);
      }, i.from = function(s, d) {
        return l(s, d, this);
      };
      var c = function(s) {
        return s.$u ? a.utc() : a();
      };
      i.toNow = function(s) {
        return this.to(c(this), s);
      }, i.fromNow = function(s) {
        return this.from(c(this), s);
      };
    };
  });
})(S5);
const Nb = S5.exports;
var L5 = { exports: {} };
(function(e, t) {
  (function(r, n) {
    e.exports = n();
  })(jr, function() {
    return function(r, n, a) {
      a.updateLocale = function(i, o) {
        var l = a.Ls[i];
        if (l)
          return (o ? Object.keys(o) : []).forEach(function(c) {
            l[c] = o[c];
          }), l;
      };
    };
  });
})(L5);
const zb = L5.exports, _b = "_comment__header_1p0ms_5", Ib = "_comment__time_1p0ms_12", Db = "_comment__text_1p0ms_15", Cb = "_comment__menu_1p0ms_19", Pn = {
  comment__header: _b,
  comment__time: Ib,
  comment__text: Db,
  comment__menu: Cb
}, Eb = "_comment_compact_16lf0_5", bb = "_comment__input_16lf0_5", Ab = "_comment__actions_16lf0_9", jb = "_comment__input_closable_16lf0_19", xb = "_comment__avatar_16lf0_38", Gr = {
  comment_compact: Eb,
  comment__input: bb,
  comment__actions: Ab,
  comment__input_closable: jb,
  comment__avatar: xb
}, wb = () => /* @__PURE__ */ u.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ u.createElement("path", {
  d: "M7.99995 10.8C9.54635 10.8 10.8 9.54635 10.8 7.99995C10.8 6.45355 9.54635 5.19995 7.99995 5.19995C6.45355 5.19995 5.19995 6.45355 5.19995 7.99995C5.19995 9.54635 6.45355 10.8 7.99995 10.8Z",
  stroke: "currentColor",
  strokeWidth: "1.4"
}), /* @__PURE__ */ u.createElement("path", {
  d: "M15 8C15 4.1339 11.8661 1 8 1C4.1339 1 1 4.1339 1 8C1 11.8661 4.1339 15 8 15C9.5764 15 11.031 14.4792 12.2007 13.6",
  stroke: "currentColor",
  strokeWidth: "1.4",
  strokeLinecap: "square"
}), /* @__PURE__ */ u.createElement("path", {
  d: "M10.8 5.19995V7.99995C10.8 8.69995 11.22 10.1 12.9 10.1C14.58 10.1 15 8.69995 15 7.99995",
  stroke: "currentColor",
  strokeWidth: "1.4",
  strokeLinecap: "square"
})), Ob = (e) => /* @__PURE__ */ u.createElement(xd, {
  component: wb,
  ...e
}), k5 = ({
  showAvatar: e,
  closable: t,
  disabled: r,
  autoFocus: n,
  defaultValue: a,
  onClose: i,
  onChange: o
}) => {
  const { mentionOptions: l, currentUser: c } = xe(lr), [s] = Ne.useForm(), d = ({ text: f }) => {
    o({
      text: f,
      mentions: tc.getMentions(f).map((v) => v.value)
    }), t && i && i(), s.resetFields();
  }, M = (f) => {
    !f.shiftKey && f.key === "Enter" && (f.preventDefault(), s.submit());
  };
  return /* @__PURE__ */ u.createElement(Ne, {
    form: s,
    initialValues: {
      text: a
    },
    disabled: r,
    onFinish: d,
    onKeyDown: M
  }, /* @__PURE__ */ u.createElement($o, {
    className: Y(Gr.comment, {
      [Gr.comment_compact]: !e
    }),
    wrap: !1
  }, e && /* @__PURE__ */ u.createElement(Gn, {
    className: Gr.comment__avatar
  }, /* @__PURE__ */ u.createElement(ea, {
    name: c == null ? void 0 : c.name,
    size: "small"
  })), /* @__PURE__ */ u.createElement(Gn, {
    flex: 1
  }, /* @__PURE__ */ u.createElement(Ne.Item, {
    name: "text",
    noStyle: !0
  }, /* @__PURE__ */ u.createElement(tc, {
    autoFocus: n,
    options: l,
    className: Y(Gr.comment__input, {
      [Gr.comment__input_closable]: t
    }),
    placeholder: "Enter your comment",
    autoSize: !0
  })), /* @__PURE__ */ u.createElement(ze, {
    size: 0,
    align: "center",
    className: Gr.comment__actions
  }, /* @__PURE__ */ u.createElement(Ne.Item, {
    shouldUpdate: !0,
    noStyle: !0
  }, ({ setFieldsValue: f, getFieldValue: v }) => /* @__PURE__ */ u.createElement(na, {
    trigger: ["click"],
    menu: {
      items: l == null ? void 0 : l.map((g) => ({
        onClick: () => {
          var m;
          return f({
            text: `${((m = v("text")) == null ? void 0 : m.trim()) || ""} @${g.value}`
          });
        },
        key: g.value,
        label: g.label
      }))
    },
    placement: "bottomRight"
  }, /* @__PURE__ */ u.createElement(_e, {
    type: "text",
    shape: "circle",
    icon: /* @__PURE__ */ u.createElement(Ob, null)
  }))), t && /* @__PURE__ */ u.createElement(_e, {
    onClick: i,
    type: "text",
    shape: "circle",
    icon: /* @__PURE__ */ u.createElement(la, null)
  }), /* @__PURE__ */ u.createElement(Ne.Item, {
    shouldUpdate: !0,
    noStyle: !0
  }, (f) => /* @__PURE__ */ u.createElement(_e, {
    disabled: !f.getFieldValue("text"),
    htmlType: "submit",
    type: "text",
    shape: "circle",
    icon: /* @__PURE__ */ u.createElement(Zd, null)
  }))))));
};
_n.extend(zb);
_n.updateLocale("en", {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: "a few seconds",
    m: "a minute",
    mm: "%dm",
    h: "an hour",
    hh: "%dh",
    d: "a day",
    dd: "%dd",
    M: "a month",
    MM: "%dm",
    y: "a year",
    yy: "%dy"
  }
});
_n.extend(Nb);
const Tb = ({
  id: e,
  author: t,
  createdAt: r,
  text: n,
  mainAction: a,
  onDelete: i,
  isMain: o = !1
}) => {
  const [l, c] = de(!1), s = () => c(!0), { currentUser: d, onChangeComment: M, onCopyLink: f, onDeleteMentions: v, onCreateMentions: g } = xe(lr), { id: m, author: p, status: h } = xe(Dn);
  if (l)
    return /* @__PURE__ */ u.createElement("div", {
      className: Pn.comment
    }, /* @__PURE__ */ u.createElement(k5, {
      showAvatar: !0,
      autoFocus: !0,
      closable: !0,
      onChange: async ({ text: D, mentions: A }) => {
        v(e), await M(e, D), A.length && g(A, e);
      },
      onClose: () => c(!1),
      defaultValue: n
    }));
  const y = d && d.id === t.id && m && (h !== Fe.RESOLVED || p.id === d.id), N = h !== Fe.RESOLVED, I = [
    {
      label: "Copy link",
      key: "copy",
      icon: /* @__PURE__ */ u.createElement(Yd, null),
      onClick: () => f({ threadId: m, commentId: e, isMain: o })
    },
    {
      danger: !0,
      label: o ? "Delete discussion" : "Delete",
      key: "delete",
      icon: /* @__PURE__ */ u.createElement(Qr, null),
      onClick: () => i(e)
    }
  ];
  return N && I.unshift({
    label: "Edit",
    key: "edit",
    icon: /* @__PURE__ */ u.createElement(T0, null),
    onClick: () => s()
  }), /* @__PURE__ */ u.createElement("div", {
    className: Pn.comment
  }, /* @__PURE__ */ u.createElement(ze, {
    block: !0,
    size: 12,
    direction: "vertical"
  }, /* @__PURE__ */ u.createElement("div", {
    className: Pn.comment__header
  }, /* @__PURE__ */ u.createElement(ea, {
    src: t.avatar,
    size: "small",
    name: t.name
  }), /* @__PURE__ */ u.createElement(ve, {
    title: t.name,
    size: "large",
    ellipsis: { tooltip: t.name }
  }, t.name), /* @__PURE__ */ u.createElement(ve, {
    size: "small",
    className: Pn.comment__time
  }, _n(r).fromNow()), /* @__PURE__ */ u.createElement(ze, {
    size: 6
  }, o && a, y && /* @__PURE__ */ u.createElement(na, {
    trigger: ["click"],
    menu: {
      items: I
    },
    placement: "bottomRight"
  }, /* @__PURE__ */ u.createElement(_e, {
    size: "small",
    type: "text",
    icon: /* @__PURE__ */ u.createElement(zo, null)
  })))), /* @__PURE__ */ u.createElement("p", {
    className: Pn.comment__text
  }, n)));
}, Fu = {
  "compact-comments": "_compact-comments_1sopc_5",
  "compact-comments__avatars": "_compact-comments__avatars_1sopc_8"
}, Sb = ({ authors: e = [], onShow: t, children: r }) => /* @__PURE__ */ u.createElement(_e, {
  type: "link",
  onClick: () => t(),
  block: !0,
  className: Fu["compact-comments"]
}, /* @__PURE__ */ u.createElement(ze, {
  block: !0
}, /* @__PURE__ */ u.createElement("div", {
  className: Fu["compact-comments__avatars"]
}, /* @__PURE__ */ u.createElement(ea.Group, {
  size: "small",
  maxCount: 3
}, e.map((n) => /* @__PURE__ */ u.createElement(ea, {
  key: n.id,
  name: n.name,
  size: "small"
})))), r)), Lb = "_dialog_1n2a1_5", kb = "_dialog__icon_1n2a1_8", Pb = "_dialog__title_1n2a1_12", Rb = "_dialog__text_1n2a1_18", Ja = {
  dialog: Lb,
  dialog__icon: kb,
  dialog__title: Pb,
  dialog__text: Rb
}, Qb = ({ deleteCommentId: e, onClose: t, mode: r }) => {
  const { onDeleteComment: n, onDeleteThread: a } = xe(lr), { id: i } = xe(Dn), o = () => {
    e && n(e), r === "discussion" && i && a(i), t();
  };
  return /* @__PURE__ */ u.createElement(ha, {
    width: 558,
    open: !!e,
    closable: !1,
    centered: !0,
    okText: "Delete",
    onOk: o,
    wrapClassName: Ja.dialog,
    onCancel: () => t(),
    mask: !1,
    maskClosable: !0
  }, /* @__PURE__ */ u.createElement(ze, {
    size: 16,
    align: "start"
  }, /* @__PURE__ */ u.createElement("span", {
    className: Ja.dialog__icon
  }, /* @__PURE__ */ u.createElement(O0, null)), /* @__PURE__ */ u.createElement(ze, {
    direction: "vertical"
  }, /* @__PURE__ */ u.createElement(ve, {
    className: Ja.dialog__title
  }, "Are you sure you want to delete this ", r, "?"), /* @__PURE__ */ u.createElement(ve, {
    className: Ja.dialog__text
  }, "This action cannot be undone."))));
}, Vb = ({ threadId: e }) => {
  const { currentUser: t, onChangeThreadStatus: r } = xe(lr), { author: n } = xe(Dn);
  return (t == null ? void 0 : t.id) !== n.id ? null : /* @__PURE__ */ u.createElement(_e, {
    type: "default",
    icon: /* @__PURE__ */ u.createElement(yo, null),
    size: "small",
    appearance: "green",
    onClick: () => r({ status: Fe.RESOLVED, id: e })
  }, "Resolve");
}, Ub = ({ threadId: e }) => {
  const { currentUser: t, onChangeThreadStatus: r } = xe(lr), { author: n } = xe(Dn);
  return (t == null ? void 0 : t.id) !== n.id ? null : /* @__PURE__ */ u.createElement(_e, {
    appearance: "gray-alpha",
    size: "small",
    icon: /* @__PURE__ */ u.createElement(Ju, null),
    onClick: () => r({ status: Fe.OPEN, id: e })
  }, "Re-open");
}, Fb = ({ threadId: e }) => {
  const { currentUser: t, onChangeThreadStatus: r } = xe(lr), { author: n } = xe(Dn);
  return /* @__PURE__ */ u.createElement(_e, {
    disabled: !n || n.id === (t == null ? void 0 : t.id),
    type: "primary",
    appearance: "orange",
    size: "small",
    icon: /* @__PURE__ */ u.createElement(Hd, null),
    onClick: () => r({ status: Fe.SUBMITTED, id: e })
  }, "Submit");
}, Dn = u.createContext({
  topic: "",
  status: Fe.OPEN,
  author: {
    id: "",
    name: "",
    avatar: ""
  }
}), so = ({
  topic: e,
  status: t,
  id: r,
  comments: n,
  onClose: a,
  active: i,
  author: o,
  property: l,
  index: c
}) => {
  const { onChangeThreadStatus: s, onCreateComment: d, onCreateThread: M, currentUser: f, onCreateMentions: v } = xe(lr), [g, m] = de(null), [p, h] = de(!1), y = !(n != null && n.length), N = () => {
    if (!r)
      return null;
    switch (t) {
      case Fe.OPEN:
        return /* @__PURE__ */ u.createElement(Fb, {
          threadId: r
        });
      case Fe.SUBMITTED:
        return /* @__PURE__ */ u.createElement(Vb, {
          threadId: r
        });
      case Fe.RESOLVED:
        return /* @__PURE__ */ u.createElement(Ub, {
          threadId: r
        });
      default:
        return null;
    }
  }, I = (T) => m(T), D = () => {
    const T = (C, j, w) => /* @__PURE__ */ u.createElement(u.Fragment, null, /* @__PURE__ */ u.createElement(Tb, {
      isMain: j === 0,
      createdAt: C.createdAt,
      id: C.id,
      key: C.id,
      text: C.text,
      author: C.author,
      onDelete: I,
      mainAction: j === 0 && N()
    }), n && j !== (n == null ? void 0 : n.length) - 1 && w && /* @__PURE__ */ u.createElement("hr", {
      className: Er.thread__divider,
      key: `divider_${C.id}`
    }));
    if (n && (n == null ? void 0 : n.length) > 5 && !p) {
      const [C, j] = [n == null ? void 0 : n.slice(0, 3), n == null ? void 0 : n.slice(3, -1)], w = C.map(
        (_, b) => T(_, b, !1)
      ), E = T(n[n.length - 1], 1, !1);
      return /* @__PURE__ */ u.createElement(u.Fragment, null, w, /* @__PURE__ */ u.createElement(Sb, {
        authors: j.map((_) => _.author),
        onShow: () => h(!0)
      }, `${j.length} more comments`), /* @__PURE__ */ u.createElement("hr", {
        className: Er.thread__divider
      }), E);
    }
    return /* @__PURE__ */ u.createElement(u.Fragment, null, n == null ? void 0 : n.map((C, j) => T(C, j, !1)));
  }, A = () => m(null), k = Qe(() => t !== Fe.RESOLVED, [t]), L = Qe(
    () => k && /* @__PURE__ */ u.createElement("div", {
      key: "footer"
    }, /* @__PURE__ */ u.createElement(k5, {
      autoFocus: !r,
      closable: y,
      onClose: a,
      onChange: async ({ text: T, mentions: C }) => {
        let j = r;
        if (!f)
          throw new Error("Not currentUser");
        j || (j = await M({
          author: f.id,
          property: l,
          topic: e,
          status: t
        }));
        const w = await d({ text: T, threadId: j, author: f.id });
        C.length && v(C, w), t === Fe.SUBMITTED && f.id === o.id && s({ status: Fe.OPEN, id: j });
      },
      showAvatar: !y
    })),
    [k, y, f]
  );
  return /* @__PURE__ */ u.createElement(Dn.Provider, {
    value: { id: r, topic: e, status: t, active: i, author: o }
  }, /* @__PURE__ */ u.createElement("div", {
    "data-thread": r,
    className: Y(Er.thread, {
      [Er[`thread-${t}`]]: t,
      [Er.thread_compact]: y,
      [Er["thread--active"]]: i,
      [Er["thread--with-pointer"]]: c === 0
    })
  }, /* @__PURE__ */ u.createElement(ze, {
    size: 12,
    direction: "vertical",
    block: !0
  }, D(), L)), /* @__PURE__ */ u.createElement(Qb, {
    deleteCommentId: g,
    onClose: A,
    mode: n && n.length > 1 ? "comment" : "discussion"
  }));
}, $b = "_title_3pnga_5", P5 = {
  title: $b
}, Zb = ({ groupedThreads: e, title: t, currentStatus: r, property: n }) => {
  const { onClickTopic: a, currentTopic: i, currentProperty: o, currentThread: l, currentUser: c, onChangeState: s } = xe(lr), [d, M] = de(!1), f = () => {
    M(!0), s({ currentTopic: t, currentProperty: n });
  };
  return c === null ? null : /* @__PURE__ */ u.createElement("div", {
    "data-topic": t
  }, /* @__PURE__ */ u.createElement(ze, {
    size: 10,
    block: !0,
    direction: "vertical"
  }, t && t !== "null" && /* @__PURE__ */ u.createElement(Fo, {
    className: P5.title,
    title: t,
    ellipsis: {
      tooltip: t,
      rows: 2
    },
    size: "large",
    weight: "bold",
    onClick: (v) => a(v, { topic: t, property: e[0].property })
  }, t), e.map(({ id: v, comments: g, property: m, author: p }, h) => /* @__PURE__ */ u.createElement(so, {
    index: h,
    property: m,
    author: p,
    active: v === l || t === i,
    topic: t,
    status: r,
    comments: g,
    id: v,
    key: v
  })), d && o === n && /* @__PURE__ */ u.createElement(so, {
    index: 0,
    property: e[0].property,
    author: c,
    onClose: () => M(!1),
    topic: t,
    status: Fe.OPEN
  }), r === "open" && /* @__PURE__ */ u.createElement(_e, {
    type: "primary",
    icon: /* @__PURE__ */ u.createElement(w0, null),
    disabled: d && o === n,
    onClick: f
  }, "Open new discussion")));
}, Yb = "_topics_57hjf_5", Hb = "_title_57hjf_10", Wb = {
  topics: Yb,
  title: Hb
};
function Bb(e, t) {
  const r = e.split(" ")[0].split("."), n = t.split(" ")[0].split(".");
  for (let a = 0; a < Math.min(r.length, n.length); a++)
    if (parseInt(r[a]) !== parseInt(n[a]))
      return parseInt(r[a]) - parseInt(n[a]);
  return r.length - n.length;
}
function qb(e) {
  switch (e) {
    case Fe.OPEN:
      return "No open comments yet";
    case Fe.SUBMITTED:
      return "No comments on review yet";
    case Fe.RESOLVED:
      return "No resolved comments yet";
    default:
      return "No comments yet";
  }
}
const lr = u.createContext({
  mentionOptions: [],
  currentUser: null,
  currentTopic: null,
  currentThread: null,
  currentProperty: null,
  onClickTopic: () => {
  },
  onCopyLink: () => {
  },
  onDeleteComment: () => {
  },
  onCreateComment: () => new Promise((e, t) => t()),
  onCreateMentions: () => {
  },
  onDeleteMentions: () => {
  },
  onChangeComment: () => {
  },
  onChangeThreadStatus: () => {
  },
  onDeleteThread: () => {
  },
  onCreateThread: () => new Promise((e, t) => t()),
  onChangeState: () => {
  }
}), WA = u.forwardRef(
  ({
    threads: e,
    currentTopic: t,
    currentStatus: r,
    mentionOptions: n,
    currentUser: a,
    onDeleteComment: i,
    onChangeComment: o,
    onCreateComment: l,
    onChangeThreadStatus: c,
    onDeleteThread: s,
    onCreateThread: d,
    onCreateMentions: M,
    onDeleteMentions: f,
    onClickTopic: v,
    onCopyLink: g,
    currentThread: m,
    currentProperty: p,
    onChangeState: h
  }, y) => {
    const N = Qe(() => {
      if (a === null)
        return;
      const A = Object.entries(tf(e, (k) => k.topic)).sort(
        ([k], [L]) => Bb(k, L)
      ).map(([k, L]) => /* @__PURE__ */ u.createElement(Zb, {
        property: L[0].property,
        title: k,
        currentStatus: r,
        key: k,
        groupedThreads: L
      }));
      return p && !e.find(({ property: k }) => k === p) && r === Fe.OPEN && A.unshift(
        /* @__PURE__ */ u.createElement(ze, {
          size: 10,
          direction: "vertical",
          block: !0
        }, /* @__PURE__ */ u.createElement(Fo, {
          className: P5.title,
          ellipsis: {
            tooltip: t,
            rows: 2
          },
          onClick: (k) => v(k, { topic: t, property: p }),
          title: t,
          size: "large",
          weight: "bold"
        }, t), /* @__PURE__ */ u.createElement(so, {
          index: 0,
          onClose: () => h({ currentTopic: null, currentThread: null, currentProperty: null }),
          property: p,
          author: a,
          topic: t,
          status: Fe.OPEN,
          active: !0
        }))
      ), A;
    }, [e, t, r, p]), I = () => !(e != null && e.length) && !p ? /* @__PURE__ */ u.createElement(u.Fragment, null, qb(r)) : N;
    return /* @__PURE__ */ u.createElement(lr.Provider, {
      value: {
        onClickTopic: v,
        currentTopic: t,
        mentionOptions: n,
        currentUser: a,
        currentThread: m,
        currentProperty: p,
        onDeleteComment: i,
        onChangeComment: o,
        onCreateComment: l,
        onChangeThreadStatus: c,
        onDeleteThread: s,
        onCreateMentions: M,
        onDeleteMentions: f,
        onCreateThread: d,
        onCopyLink: g,
        onChangeState: h
      }
    }, /* @__PURE__ */ u.createElement("div", {
      ref: y,
      className: Wb.topics
    }, I()));
  }
), Gb = "_items_6sld1_5", Kb = "_item_6sld1_5", R5 = {
  items: Gb,
  item: Kb
}, Xb = ({ children: e, className: t, ...r }) => /* @__PURE__ */ u.createElement("ul", {
  ...r,
  className: Y(R5.items, t)
}, e), Jb = ({ children: e, className: t, ...r }) => /* @__PURE__ */ u.createElement("li", {
  ...r,
  className: Y(R5.item, t)
}, e);
Xb.Item = Jb;
const eA = "_list_18yxx_5", tA = "_item_18yxx_19", rA = "_item__image_18yxx_24", nA = "_icon_18yxx_33", Wn = {
  list: eA,
  "list--vertical": "_list--vertical_18yxx_12",
  "list--horizontal": "_list--horizontal_18yxx_15",
  item: tA,
  item__image: rA,
  icon: nA
}, aA = ({ id: e, name: t, type: r = "image", className: n, ...a }) => {
  const i = Qe(() => en.find((o) => o.id === e), [e]);
  return i ? /* @__PURE__ */ u.createElement("span", {
    ...a,
    className: Y(Wn.item, n)
  }, r === "image" ? /* @__PURE__ */ u.createElement("span", {
    className: Wn.item__image,
    style: { color: i.color }
  }, u.cloneElement(i.icon, {
    width: "16px",
    height: "16px",
    viewBox: "0 0 50 50"
  })) : /* @__PURE__ */ u.createElement("span", {
    className: Wn.icon,
    style: {
      backgroundColor: i.color
    }
  }, e), t && /* @__PURE__ */ u.createElement(ve, null, t), r === "text" && /* @__PURE__ */ u.createElement(ve, {
    style: { whiteSpace: "nowrap" }
  }, "SDG ", e)) : null;
}, BA = ({ ids: e, direction: t = "vertical" }) => /* @__PURE__ */ u.createElement("ul", {
  className: Y(Wn.list, Wn[`list-${t}`])
}, e.map((r) => /* @__PURE__ */ u.createElement("li", {
  key: r
}, /* @__PURE__ */ u.createElement(aA, {
  id: r
})))), qA = (e, t = !1) => (e == null ? void 0 : e.map((r) => ({
  ...r,
  label: r.name,
  value: (t ? r.id : r.value) || r.name
}))) || [];
export {
  XA as Affix,
  JA as Alert,
  ej as Anchor,
  OA as AttachFileInput,
  wA as AttachFileProvider,
  tj as AutoComplete,
  ea as Avatar,
  rj as BackTop,
  vE as Badge,
  UA as Banner,
  Ll as Breadcrumb,
  _A as BulletedList,
  _e as Button,
  nj as Calendar,
  Ni as Card,
  aj as Carousel,
  ij as Cascader,
  i8 as Checkbox,
  Gn as Col,
  oj as Collapse,
  lj as ConfigProvider,
  GC as ContentLayout,
  QA as CopyButton,
  C8 as DatePicker,
  cj as Descriptions,
  WA as Discussion,
  uj as Divider,
  w5 as DragAndDrop,
  FA as DragAndDropPicture,
  $A as DragAndDropTable,
  z5 as Drawer,
  sj as Dropdown,
  DA as EditableSelect,
  dj as Empty,
  jA as ExternalLink,
  TA as FilesTagsListInput,
  Ne as Form,
  kA as FormCard,
  aA as Goal,
  BA as GoalList,
  fj as Grid,
  vC as Header,
  YA as Help,
  xA as Hint,
  vj as Image,
  AA as InlineNote,
  _o as Input,
  zA as InputNumber,
  Xb as Items,
  mi as Layout,
  b5 as Link,
  T5 as List,
  Mj as Mentions,
  gj as Menu,
  ha as Modal,
  IA as MultipleSelect,
  E5 as NavLink,
  hE as NavigationTabs,
  pj as PageHeader,
  hj as Pagination,
  Fo as Paragraph,
  RA as Popconfirm,
  mj as Popover,
  HA as Progress,
  EA as Question,
  P0 as Radio,
  yj as Rate,
  Nj as Result,
  ZA as RoadMap,
  $o as Row,
  en as SDGs,
  CA as Section,
  zj as Segmented,
  bt as Select,
  VA as Skeleton,
  _j as Slider,
  ze as Space,
  Ij as Spin,
  Dj as Statistic,
  bA as Steps,
  LA as Switch,
  In as Table,
  Un as Tabs,
  yi as Tag,
  ve as Text,
  Xs as TextArea,
  n3 as ThreadProvider,
  Cj as TimePicker,
  Ej as Timeline,
  fn as Title,
  rE as Tooltip,
  bj as Transfer,
  Aj as Tree,
  PA as TreeSelect,
  SA as UIProvider,
  jj as Upload,
  qA as adapterOptions,
  xj as message,
  wj as notification,
  kj as prettyBytes,
  Oj as theme,
  t3 as useThreads,
  Tj as version
};
//# sourceMappingURL=evercity-ui.js.map
